(function () {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4c53"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4c53"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cnCS2", function(module, exports) {

module.exports = (parcelRequire("4WKyX"))($parcel$resolve("clwvD")).then(()=>parcelRequire('S0nQY'));

});
parcelRegister("4WKyX", function(module, exports) {
"use strict";

var $2prpb = parcelRequire("2prpb");
module.exports = $2prpb(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("2prpb", function(module, exports) {
"use strict";
var $1c132cac09cd18d9$var$cachedBundles = {};
var $1c132cac09cd18d9$var$cachedPreloads = {};
var $1c132cac09cd18d9$var$cachedPrefetches = {};
function $1c132cac09cd18d9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $1c132cac09cd18d9$var$cachedPreloads;
        case 'prefetch':
            return $1c132cac09cd18d9$var$cachedPrefetches;
        default:
            return $1c132cac09cd18d9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1c132cac09cd18d9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $6697e6e436eb0e32$exports = {};
$parcel$extendImportMap({
    "clwvD": "tinymce.min.560c202f.js"
});

class $8f658dda969a7982$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.listeners = [];
    }
    connectedCallback() {}
    /**
     * If the custom element is getting removed of the dom, all listeners
     * are getting removed of the element.
     */ disconnectedCallback() {
        this.listeners.forEach((item)=>{
            item.element.removeEventListener(item.event, item.action);
        });
    }
    /**
     * Here you can push a listener object directly to the listener array
     *
     * @param {Listener} {}
     */ pushListener({ event: event, element: element, action: action }) {
        const existing = this.listeners.find((listener)=>listener.element === element && listener.event === event);
        if (existing) {
            existing.element.removeEventListener(existing.event, existing.action);
            this.listeners = this.listeners.filter((listener)=>!(listener.element === element && listener.event === event));
        }
        this.listeners.push({
            event: event,
            element: element,
            action: action
        });
        element.addEventListener(event, action);
    }
    /**
     * Removes the given element from the listener array and removes the
     * EventListener from the element and returns the listener object.
     * If the element was not found, undefined is returned.
     *
     * @param {Element} element
     * @returns {Listener | undefined}
     */ removeListener(element) {
        const foundElement = this.listeners.find((item)=>item.element === element);
        if (!foundElement) return;
        foundElement?.element.removeEventListener(foundElement.event, foundElement.action);
        const newList = this.listeners.filter((item)=>item.element !== element);
        this.listeners = newList;
        return foundElement;
    }
    /**
     * Removes all registered event listeners that were previously added
     * using the `pushListener()` method. This ensures that no dangling
     * or duplicate event handlers remain active on DOM elements.
     *
     * This method should be called before re-rendering or updating the DOM
     * to avoid memory leaks and unintended behavior caused by multiple bindings.
     *
     * @example
     * this.clearListeners();
     * this.render(); // safe to re-bind new listeners after rendering
     */ clearListeners() {
        this.listeners.forEach(({ element: element, event: event, action: action })=>{
            element.removeEventListener(event, action);
        });
        this.listeners = [];
    }
    /**
     * Retrieves a data attribute from the element with the specified name.
     * If the attribute is not present, the provided default value is returned.
     *
     * @protected
     * @param {string} name - The name of the data attribute (without the `data-tk-` prefix).
     * @param {string} defaultValue - The default value to return if the attribute is not found.
     * @returns {string} - The value of the data attribute or the default value.
     */ getDataAttribute(name, defaultValue) {
        return this.getAttribute(`data-tk-${name}`) || defaultValue;
    }
}


var $588d148f2c9ac202$export$4120f82005ec4b2d = /*#__PURE__*/ function(TrackerPushTypes) {
    TrackerPushTypes["BASKET_UPDATE"] = "basket-update";
    TrackerPushTypes["FAVORITE_UPDATE"] = "favorite-update";
    return TrackerPushTypes;
}({});
class $588d148f2c9ac202$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static{
        this.registry = {};
    }
    constructor(){
        super(), this.trackers = [];
        this.ready = new CustomEvent('tk-tracker-ready');
    }
    static registerTracker(name, factory) {
        this.registry[name] = factory;
    }
    async connectedCallback() {
        this.getTrackingIds();
        if (!this.trackerIds || this.trackerIds.length === 0) throw new Error('Trackier is not defined');
        await this.initTrackers();
        this.registerTrackingListener();
        this.dispatchEvent(this.ready);
    }
    registerTrackingListener() {
        const onTracking = this.handleTracking.bind(this);
        this.pushListener({
            event: 'tk-tracking-push',
            element: this,
            action: onTracking
        });
    }
    getTrackingIds() {
        try {
            this.trackerIds = JSON.parse(this.getAttribute('data-tk-trackers') || '[]');
        } catch (error) {
            console.error('Error parsing json', error);
        }
    }
    async initTrackers() {
        if (!this.trackerIds) return;
        for (const item of this.trackerIds)try {
            const createTracker = $588d148f2c9ac202$export$2e2bcd8739ae039.registry[item.name];
            if (createTracker) {
                const instance = await createTracker(item.key, {
                    endpoint: item.endpoint
                });
                await instance.init();
                this.trackers.push({
                    name: item.name,
                    instance: instance
                });
            } else console.warn(`Tracker "${item.name}" nicht gefunden.`);
        } catch (error) {
            console.error(`This tracker ${item.name} could not be initialized:` + error);
        }
    }
    handleTracking(event) {
        const { trackerType: trackerType, type: type, item: item } = event.detail;
        this.trackers.filter((trackerItem)=>!trackerType || trackerItem.name.toLowerCase() === trackerType.toLowerCase()).forEach((trackerItem)=>{
            if (type === "basket-update") trackerItem.instance.pushBasket(item);
            else if (type === "favorite-update") trackerItem.instance.pushFavorite(item);
            else trackerItem.instance.push(item);
        });
    }
}


class $26efcff9bda53fd7$export$2e2bcd8739ae039 {
    constructor(trackingId, tracker, defaultEndpoint, options){
        this.trackingId = trackingId;
        this.tracker = tracker;
        this.endpoint = options?.endpoint || defaultEndpoint;
        this.url = this.endpoint.replace(/%KEY/g, trackingId);
        this.basketEventMap = options?.basketEventMap || {
            added: 'add_to_cart',
            deleted: 'remove_from_cart',
            changed: 'update_cart'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'add_from_wishlist',
            deleted: 'remove_from_wishlist'
        };
        this.favoriteActionMap = options?.favoriteActionMap || {
            added: 'add',
            deleted: 'delete'
        };
    }
    loadScript() {
        return new Promise((resolve, reject)=>{
            const script = document.createElement('script');
            script.async = true;
            script.src = this.url;
            script.onload = ()=>resolve(script);
            script.onerror = ()=>reject(new Error(`Failed to load script: ${this.url}`));
            document.head.appendChild(script);
        });
    }
}


class $4fa2285174eed561$export$2e2bcd8739ae039 extends (0, $26efcff9bda53fd7$export$2e2bcd8739ae039) {
    constructor(trackingId, options){
        super(trackingId, window.dataLayer || [], `https://www.googletagmanager.com/gtm.js?id=%KEY`, options);
        this.basketEventMap = options?.basketEventMap || {
            added: 'add_to_cart',
            deleted: 'remove_from_cart',
            changed: 'update_cart'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'add_from_wishlist',
            deleted: 'remove_from_wishlist'
        };
    }
    init() {
        return new Promise((resolve, reject)=>{
            try {
                this.initGTM();
                this.loadScript().then(()=>{
                    console.log('Google Tag Manager successfully loaded');
                    resolve();
                }).catch((error)=>{
                    console.error('Error loading Google Tag Manager', error);
                    reject(error);
                });
            } catch (error) {
                console.error('Google Tag Manager initialization failed', error);
                reject(error);
            }
        });
    }
    initGTM() {
        this.tracker.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
    }
    push(item) {
        const { event: event, ...rest } = item;
        this.tracker.push({
            event: event,
            ecommerce: {
                ...rest
            }
        });
    }
    pushBasket(item) {
        this.tracker.push({
            event: this.basketEventMap[item.event],
            ecommerce: {
                currencyCode: item.currency,
                value: item.value,
                items: item.items.map((item)=>({
                        item_id: item.sku,
                        item_name: item.name,
                        price: item.price,
                        quantity: item.quantity
                    }))
            }
        });
    }
    pushFavorite(item) {
        this.tracker.push({
            event: this.favoriteEventMap[item.action],
            ecommerce: {
                category: item.category,
                action: this.favoriteActionMap[item.action],
                name: item.name,
                value: item.value
            }
        });
    }
}



class $30ee64c4b301d5a8$export$2e2bcd8739ae039 extends (0, $26efcff9bda53fd7$export$2e2bcd8739ae039) {
    constructor(trackingId, options){
        super(trackingId, window._mtm || [], `https://matomo01.opacc.net/js/container_%KEY.js`, options);
        this.basketEventMap = options?.basketEventMap || {
            added: 'opc_cart_add',
            deleted: 'opc_cart_remove',
            changed: 'opc_cart_update'
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'opc_wishlist_add',
            deleted: 'opc_wishlist_remove'
        };
    }
    async init() {
        await this.loadScript();
        this.initMatomo();
        console.log('Matomo Tag Manager successfully loaded');
    }
    initMatomo() {
        this.tracker.push({
            'mtm.startTime': new Date().getTime(),
            event: 'mtm.Start'
        });
    }
    push(item) {
        this.tracker.push(item);
    }
    pushBasket(item) {
        this.tracker.push({
            event: this.basketEventMap[item.event],
            location: item.location,
            currency: item.currency,
            value: item.value,
            items: item.items
        });
    }
    pushFavorite(item) {
        this.tracker.push({
            event: this.favoriteEventMap[item.action],
            location: window.location.href,
            category: item.category,
            action: this.favoriteActionMap[item.action],
            name: item.name,
            value: item.value
        });
    }
}


// Registry of tracker
(0, $588d148f2c9ac202$export$2e2bcd8739ae039).registerTracker('google', async (trackingId, options)=>new (0, $4fa2285174eed561$export$2e2bcd8739ae039)(trackingId, options));
(0, $588d148f2c9ac202$export$2e2bcd8739ae039).registerTracker('matomo', async (trackingId, options)=>new (0, $30ee64c4b301d5a8$export$2e2bcd8739ae039)(trackingId, options));


class $e31d2de11bbf216d$export$2e2bcd8739ae039 {
    constructor(list){
        this.customElementList = list;
        this.init();
    }
    init() {
        this.customElementList.forEach((item)=>{
            !customElements.get(item.name) && customElements.define(item.name, item.constructor);
        });
    }
}



const $86b3c5b6d66bd808$var$globalFormErrorMessages = {
    badInput: 'Please enter a number.',
    patternMismatch: 'Please match the requested format.',
    rangeOverflow: 'Please select a value that is no more than {max}.',
    rangeUnderflow: 'Please select a value that is no less than {min}.',
    stepMismatch: 'Please select a value that is a multiple from {step}.',
    tooLong: 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.',
    tooShort: 'Please lengthen this text to {minLength} characters or more. You are currently using {length} characters.',
    typeMismatch: 'The value you have entered for this field is invalid.',
    valueMissing: 'Please fill out this field.',
    // These properties must be empty.
    valid: '',
    customError: ''
};
const $86b3c5b6d66bd808$var$globalFormPasswordValidityMessages = {
    passwordNotMatching: 'The password does not match the one above.'
};
const $86b3c5b6d66bd808$var$globalFormExpandErrorMessages = {
    stepAdjust: 'The value you entered for this field is invalid. The value has been changed from {currentValue} to {newValue}',
    existigName: 'This name {currentValue} already exists.'
};
const $86b3c5b6d66bd808$var$globalBasketMessages = {
    messageEmptyBasket: {
        code: '1-6-6220',
        text: 'Shopping cart is empty'
    },
    messageAddedToBasket: {
        code: '1-6-6221',
        text: 'added to the shopping cart'
    },
    quickOrderMessageTooShort: {
        code: '1-6-6222',
        text: 'At least %1 characters are required for a search.'
    }
};
const $86b3c5b6d66bd808$var$globalDeliveryMessages = {
    messageDeliveryTypeGeneral: {
        code: '1-6-6226',
        text: 'Delivery method changed'
    }
};
const $86b3c5b6d66bd808$var$globalPaymentMessages = {
    messagePaymentTypeCreditCard: {
        code: '1-6-6227',
        text: 'Payment type credit card'
    },
    messagePaymentTypeInvoice: {
        code: '1-6-6227',
        text: 'Payment type invoice'
    },
    messagePaymentTypeInAdvance: {
        code: '1-6-6227',
        text: 'Payment type advance payment'
    },
    messagePaymentTypeOnDelivery: {
        code: '1-6-6227',
        text: 'Payment type cash on delivery'
    },
    messagePaymentTypeGeneral: {
        code: '1-6-6227',
        text: 'Payment type changed'
    }
};
const $86b3c5b6d66bd808$var$globalCompareMessages = {
    messageHint: {
        code: '1-6-6240',
        text: ''
    },
    allRemoved: {
        code: '1-6-6240',
        text: 'All items removed'
    },
    empty: {
        code: '1-6-6240',
        text: 'Your article comparison is empty.'
    },
    importantTitle: {
        code: '1-6-6240',
        text: 'The most important information'
    },
    removed: {
        code: '1-6-6240',
        text: 'The article was successfully removed.'
    },
    added: {
        code: '1-6-6240',
        text: 'The article was successfully added.'
    },
    noAttributesFound: {
        code: '1-6-6240',
        text: 'No comparison attributes were found.'
    }
};
const $86b3c5b6d66bd808$var$globalFavoriteMessages = {
    messageInvalidName: {
        code: '2-6-6270',
        text: 'Unable to create the wish list; the name is invalid.'
    },
    messageMaxLists: {
        code: '2-6-6277',
        text: 'Max. number of wish lists reached!'
    },
    messageMaxPositions: {
        code: '2-6-6278',
        text: 'Max. number of positions reached!'
    },
    messageDeleteConfirmation: {
        code: '2-6-6273',
        text: 'Do you really want to delete the wish list?'
    }
};
const $86b3c5b6d66bd808$var$globalAutocompleteMessages = {
    messageNoValueFound: {
        code: '1-6-6290',
        text: 'No match found!'
    }
};
const $86b3c5b6d66bd808$var$globalAccountMessages = {
    messageDelete: {
        code: '1-6-6200',
        text: 'Do you really want to delete this address?'
    },
    messageChangeSuccess: {
        code: '1-6-6200',
        text: 'Address successfully modified.'
    }
};
const $86b3c5b6d66bd808$var$globalGeneralMessages = {
    messageEmptyText: {
        code: '1-6-6290',
        text: 'The output was suppressed due to an empty text.'
    },
    messageOk: {
        code: '1-6-6290',
        text: 'Yes'
    },
    messageCancel: {
        code: '1-6-6290',
        text: 'No'
    },
    messageChange: {
        code: '1-6-6290',
        text: 'The selection was changed'
    },
    messageDefault: {
        code: '1-6-0000',
        text: ''
    },
    messageDefaultInfo: {
        code: '1-6-0000',
        text: ''
    },
    messageDefaultWarning: {
        code: '2-6-0000',
        text: ''
    },
    messageDefaultError: {
        code: '3-6-0000',
        text: ''
    },
    messageDefaultDebug: {
        code: '4-6-0000',
        text: ''
    },
    messageClipboard: {
        code: '1-6-6290',
        text: 'The text has been successfully saved to the clipboard.'
    }
};
const $86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages = {
    messageTooShort: {
        code: '1-6-6260',
        text: 'At least 3 characters!'
    },
    messageResultEmpty: {
        code: '1-6-6260',
        text: 'No items found!'
    },
    messageDangerousString: {
        code: '1-6-6260',
        text: 'invalid character <.'
    },
    messageDisallowedCharacter: {
        code: '1-6-6260',
        text: 'Invalid character: %1'
    }
};
const $86b3c5b6d66bd808$var$globalFileuploadAreaMessages = {
    defaultMessage: {
        code: '1-6-2002',
        text: 'Store the files here to upload them'
    },
    fallbackMessage: {
        code: '2-6-2002',
        text: 'Your browser does not support drag&drop file uploads'
    },
    fallbackText: {
        code: '2-6-2002',
        text: 'Use the form to upload your files'
    },
    fileTooBig: {
        code: '2-6-2002',
        text: 'The file is too large. The maximum file size is {{maxFileSize}} MB'
    },
    invalidFileType: {
        code: '2-6-2002',
        text: 'Unable to upload files of this type'
    },
    responseError: {
        code: '3-6-2002',
        text: 'The server rejected your request with status {{statusCode}}'
    },
    cancelUpload: {
        code: '1-6-2002',
        text: 'Cancel upload'
    },
    cancelUploadConfirmation: {
        code: '1-6-2002',
        text: 'Cancel upload?'
    },
    removeFile: {
        code: '1-6-2002',
        text: 'Remove file'
    },
    maxFilesExceeded: {
        code: '2-6-2002',
        text: 'You are not allowed to upload any more files'
    },
    buttonBrowse: {
        code: '1-6-2002',
        text: 'Select files to upload'
    },
    uploadHint: {
        code: '1-6-2002',
        text: 'Drag files and folders here'
    }
};
const $86b3c5b6d66bd808$var$globalFilterMessages = {
    emptyResult: {
        code: '1-1-6280',
        text: 'Keine Ergebnisse gefunden.'
    }
};
const $86b3c5b6d66bd808$var$globalCheckoutMessages = {
    missingTerms: {
        code: '3-6-6230',
        text: 'Please accept the General terms and conditions.'
    },
    loadingCheckoutTitle: {
        code: '1-6-6260',
        text: 'Almost done!'
    },
    loadingCheckoutText: {
        code: '1-6-6261',
        text: 'The order is carried out. This can take a moment!'
    }
};
const $86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages = {
    htmlErrorGeneral: {
        code: '3-6-6000',
        text: 'Something has gone wrong!'
    },
    htmlError401: {
        code: '3-6-6000',
        text: 'A valid authentication is required to process the request.'
    },
    htmlError403: {
        code: '3-6-6000',
        text: 'The request could not be processed due to missing authorization of the client.'
    },
    htmlError404: {
        code: '3-6-6000',
        text: 'The requested site does not exist.'
    },
    htmlError413: {
        code: '3-6-6000',
        text: 'The file is too large.'
    },
    htmlError415: {
        code: '3-6-6000',
        text: 'This media type is not supported.'
    },
    htmlError422: {
        code: '3-6-6000',
        text: 'Unable to display the requested site correctly.'
    },
    htmlError500: {
        code: '3-6-6000',
        text: 'Internal server error'
    },
    htmlError503: {
        code: '3-6-6000',
        text: 'The server is temporarily unavailable.'
    }
};
if (!window.opacc) window.opacc = {};
const $86b3c5b6d66bd808$export$7ea287b8bcd34b91 = {
    ...$86b3c5b6d66bd808$var$globalFormErrorMessages,
    ...$86b3c5b6d66bd808$var$globalFormPasswordValidityMessages,
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormValidityMessages,
    ...window.opacc.tkFormPasswordValidityMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormValidityMessages,
    ...window.opacc.projectFormPasswordValidityMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$35e6ad2b040b8403 = {
    ...$86b3c5b6d66bd808$var$globalFormExpandErrorMessages,
    ...window.opacc.tkFormExpandErrorMessages,
    ...window.opacc.projectFormExpandErrorMessages
};
const $86b3c5b6d66bd808$export$287bafa924522a4d = {
    ...$86b3c5b6d66bd808$var$globalBasketMessages,
    ...window.opacc.tkBasketMessages,
    ...window.opacc.projectBasketMessages
};
const $86b3c5b6d66bd808$export$ad480231e1cfb49 = {
    ...$86b3c5b6d66bd808$var$globalCompareMessages,
    ...window.opacc.tkCompareMessages,
    ...window.opacc.projectCompareMessages
};
const $86b3c5b6d66bd808$export$329e838a9ba51357 = {
    ...$86b3c5b6d66bd808$var$globalFavoriteMessages,
    ...window.opacc.tkFavoriteMessages,
    ...window.opacc.projectFavoriteMessages
};
const $86b3c5b6d66bd808$export$39227038979f1988 = {
    ...$86b3c5b6d66bd808$var$globalGeneralMessages,
    ...window.opacc.tkGeneralMessages,
    ...window.opacc.projectGeneralMessages
};
const $86b3c5b6d66bd808$export$f625b980042672da = {
    ...$86b3c5b6d66bd808$var$globalDirectSearchSuggestMessages,
    ...window.opacc.tkDirectSearchSuggestMessages,
    ...window.opacc.projectDirectSearchSuggestMessages
};
const $86b3c5b6d66bd808$export$fe24ead06f0313ff = {
    ...$86b3c5b6d66bd808$var$globalFileuploadAreaMessages,
    ...window.opacc.tkFileUploadAreaMessages,
    ...window.opacc.projectFileUploadAreaMessages
};
const $86b3c5b6d66bd808$export$1c7f7f3bbe522ebc = {
    ...$86b3c5b6d66bd808$var$globalFilterMessages,
    ...window.opacc.tkFilterMessages,
    ...window.opacc.projectFilterMessages
};
const $86b3c5b6d66bd808$export$fbedd73e1269236f = {
    ...$86b3c5b6d66bd808$var$globalAutocompleteMessages,
    ...window.opacc.tkAutocompleteMessages,
    ...window.opacc.projectAutocompleteMessages
};
const $86b3c5b6d66bd808$export$389a1ce21906c656 = {
    ...$86b3c5b6d66bd808$var$globalPaymentMessages,
    ...window.opacc.tkPaymentMessages,
    ...window.opacc.projectPaymentMessages
};
const $86b3c5b6d66bd808$export$36d5448025feaaa9 = {
    ...$86b3c5b6d66bd808$var$globalDeliveryMessages,
    ...window.opacc.tkDeliveryMessages,
    ...window.opacc.projectDeliveryMessages
};
const $86b3c5b6d66bd808$export$efd88ea7bc399322 = {
    ...$86b3c5b6d66bd808$var$globalAccountMessages,
    ...window.opacc.tkAccountMessages,
    ...window.opacc.projectAccountMessages
};
const $86b3c5b6d66bd808$export$4705307fe5270e12 = {
    ...$86b3c5b6d66bd808$var$globalCheckoutMessages,
    ...window.opacc.tkCheckoutMessages,
    ...window.opacc.projectCheckoutMessages
};
const $86b3c5b6d66bd808$export$6e7e78d2cde281b0 = {
    ...$86b3c5b6d66bd808$var$globalHtmlErrorCodeMessages,
    ...window.opacc.tkHtmlErrorCodeMessages,
    ...window.opacc.projectHtmlErrorCodeMessages
};
const $86b3c5b6d66bd808$export$97a703132b664051 = {
    ...window.opacc.tkZipCityMessages
};


/**
 * @param {string} html representing any number of sibling elements
 * @return {NodeListOf<ChildNode>}
 */ const $2d540709c75492d4$var$render = (html, isBody = false, shouldDecode = false)=>{
    if (!html) $2d540709c75492d4$var$render('<div></div>');
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    if (shouldDecode) return $2d540709c75492d4$var$render(doc.documentElement.textContent || '');
    return isBody ? doc.body : doc.body.children.item(0);
};
var $2d540709c75492d4$export$2e2bcd8739ae039 = $2d540709c75492d4$var$render;


var $1221feb2184dfefe$export$9130146a86a85749 = /*#__PURE__*/ function(NotificationType) {
    NotificationType["SUCCESS"] = "Success";
    NotificationType["WARNING"] = "Warning";
    NotificationType["ERROR"] = "Error";
    NotificationType["INFO"] = "Info";
    return NotificationType;
}({});
const $1221feb2184dfefe$var$mapMessageCodeToText = (response, messages)=>{
    let textMessage;
    if (!response.pluginId) return '';
    if (response.pluginId === 'paymentType') {
        const paymentMessages = {
            0: messages.messagePaymentTypeGeneral.text,
            1: messages.messagePaymentTypeCreditCard.text,
            2: messages.messagePaymentTypeInvoice.text,
            5: messages.messagePaymentTypeInAdvance.text,
            6: messages.messagePaymentTypeOnDelivery.text
        };
        textMessage = paymentMessages[Number(response.paymentType) || 0];
    } else if (response.pluginId === 'deliveryType') textMessage = messages.messageDeliveryTypeGeneral.text;
    else if (response.pluginId === 'checkoutAdressChange') textMessage = messages.messageChangeSuccess.text;
    return textMessage;
};
const $1221feb2184dfefe$var$getConsoleStyle = (backgroundColor, textColor = 'white')=>[
        `background: ${backgroundColor}`,
        `color: ${textColor}`,
        'display: block'
    ].join(';');
const $1221feb2184dfefe$var$logToConsole = (message, type)=>{
    const consoleHandler = {
        ["Success"] () {
            console.info(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('green'));
        },
        ["Warning"] () {
            console.warn(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('yellow', 'black'));
        },
        ["Error"] () {
            console.log(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('red'));
        },
        ["Info"] () {
            console.debug(`%c ${message}`, $1221feb2184dfefe$var$getConsoleStyle('blue'));
        }
    };
    consoleHandler[type]();
};
const $1221feb2184dfefe$var$renderMessageContainer = (parentElement)=>{
    let messageContainer = parentElement.querySelector('[data-tk-message-container]');
    if (!messageContainer) {
        messageContainer = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="tk-message__container" data-tk-message-container></div>');
        parentElement.insertAdjacentElement('beforeend', messageContainer);
    }
    return messageContainer;
};
const $1221feb2184dfefe$export$3a57e165650c636f = (type, message, wait = 2.5, options = {})=>{
    if (!message) return;
    const dialogs = document.querySelectorAll('dialog[open]');
    let messageContainer;
    if (dialogs.length === 0) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
    else {
        const lastDialog = Array.from(dialogs).at(-1);
        if (!lastDialog) messageContainer = $1221feb2184dfefe$var$renderMessageContainer(document.body);
        else messageContainer = $1221feb2184dfefe$var$renderMessageContainer(lastDialog);
    }
    const toast = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
        <div class="tk-message tk-message--toast tk-message--${type.toLowerCase()}">
            <span class="tk-message__icon"><i class="tk-icon-${type.toLowerCase()}"></i></span>
            <span class="tk-message__label">${message}</span>
        </div>
    `);
    toast.style.animation = `fadein .5s, fadeout .5s ${wait}s`;
    toast.classList.add('tk-message--show');
    messageContainer.appendChild(toast);
    toast.addEventListener('animationend', (event)=>{
        if (event.animationName !== 'fadeout') return;
        messageContainer.removeChild(toast);
    });
    options.consoleMessage ? $1221feb2184dfefe$var$logToConsole(options.consoleMessage, type) : $1221feb2184dfefe$var$logToConsole(message, type);
};
const $1221feb2184dfefe$export$146c7c7e50ed1bd2 = (item, messageOverride)=>{
    const type = item.code.substring(0, 1);
    const message = messageOverride || item.text;
    const typeHandler = {
        1: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Success", message, item.wait),
        2: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Warning", message, item.wait),
        3: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Error", message, item.wait),
        4: ()=>$1221feb2184dfefe$export$3a57e165650c636f("Info", message, item.wait)
    };
    typeHandler[type]();
};
const $1221feb2184dfefe$export$5b256beea4c7e9b5 = (items, response)=>{
    const messages = {
        ...(0, $86b3c5b6d66bd808$export$39227038979f1988),
        ...(0, $86b3c5b6d66bd808$export$efd88ea7bc399322),
        ...(0, $86b3c5b6d66bd808$export$389a1ce21906c656),
        ...(0, $86b3c5b6d66bd808$export$36d5448025feaaa9)
    };
    items.forEach((item)=>{
        $1221feb2184dfefe$export$146c7c7e50ed1bd2(item, $1221feb2184dfefe$var$mapMessageCodeToText(response, messages));
    });
};


class $aa35ef9547ba682e$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.eventName = this.getAttribute('data-tk-event-name') || 'event-purchase';
        this.basketId = this.querySelector('[data-tk-otm-basket-id]') || undefined;
        this.messageContainerSelector = this.getAttribute('data-tk-message-container-selector') || '[id^="wp_messages_container_"]';
        this.sessionTimeoutWrapper = this.querySelector('[data-tk-session-timeout-wrapper]') || undefined;
        this.sessionTime = Number(this.sessionTimeoutWrapper?.getAttribute('data-tk-session-time') || 0);
        this.firstItemToScrollInto = this.querySelector('[data-tk-scroll-into]') || undefined;
    }
    connectedCallback() {
        this.processNotification();
        this.sessionTimeoutWrapper && this.showSessionTimeout();
        this.firstItemToScrollInto && this.scrollToElement();
        if (!this.basketId || !window.dataLayer) return;
        const data = this.getPurchaseData();
        data && window.dataLayer.push(data);
    }
    processNotification() {
        const messageContainer = document.querySelector(this.messageContainerSelector);
        if (!messageContainer || !messageContainer.hasChildNodes()) return;
        const infoMessage = messageContainer.querySelectorAll('.Info');
        const errorMessage = messageContainer.querySelectorAll('.Error');
        const warningMessage = messageContainer.querySelectorAll('.Warning');
        const debugMessage = messageContainer.querySelectorAll('.Debug');
        const messageList = Array.from([
            ...infoMessage,
            ...errorMessage,
            ...warningMessage,
            ...debugMessage
        ]);
        const types = {
            Info: (0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS,
            Error: (0, $1221feb2184dfefe$export$9130146a86a85749).ERROR,
            Warning: (0, $1221feb2184dfefe$export$9130146a86a85749).WARNING,
            Debug: (0, $1221feb2184dfefe$export$9130146a86a85749).INFO
        };
        messageList.forEach((item)=>{
            const type = types[item.className];
            const childList = Array.from(item.firstChild?.childNodes || []);
            const message = childList.find((item)=>item instanceof Text)?.textContent || '';
            const code = item.querySelector('.was-message-code')?.textContent || '';
            const addition = item.querySelector('.was-message-addition')?.textContent || '';
            const wait = Number(item.querySelector('.was-message-wait')?.textContent) || undefined;
            const consoleMessage = `${code}: ${message}} (wait: ${wait} sec.${addition})`;
            (0, $1221feb2184dfefe$export$3a57e165650c636f)(type, message, wait, {
                consoleMessage: consoleMessage
            });
        });
        messageContainer.remove();
    }
    showSessionTimeout() {
        setTimeout(()=>{
            this.sessionTimeoutWrapper.hidden = false;
        }, this.sessionTime);
    }
    getPurchaseData() {
        return {
            event: 'event-purchase',
            ecommerce: {
                purchase: {
                    actionField: this.getActionData(),
                    products: this.getProductData()
                }
            }
        };
    }
    getActionData() {
        const affiliation = this.querySelector('[data-tk-otm-affiliation]');
        const revenue = this.querySelector('[data-tk-otm-revenue]');
        const tax = this.querySelector('[data-tk-otm-tax]');
        const shipping = this.querySelector('[data-tk-otm-shipping]');
        return {
            id: this.basketId.innerText,
            affiliation: affiliation ? affiliation.innerText : '',
            revenue: revenue ? revenue.innerText : '',
            tax: tax ? tax.innerText : '',
            shipping: shipping ? shipping.innerText : ''
        };
    }
    getProductData() {
        const data = [];
        const items = this.querySelectorAll('[data-tk-otm-item]');
        Array.from(items).forEach((item)=>{
            const id = item.querySelector('.otm-id');
            const name = item.querySelector('.otm-name');
            const brand = item.querySelector('.otm-brand');
            const category = item.querySelector('.otm-category');
            const price = item.querySelector('.otm-price');
            const quantity = item.querySelector('.otm-quantity');
            const position = item.querySelector('.otm-position');
            data.push({
                id: id ? id.innerText : '',
                name: name ? name.innerText : '',
                brand: brand ? brand.innerText : '',
                category: category ? category.innerText : '',
                price: price ? price.innerText : '',
                quantity: quantity ? quantity.innerText : '',
                position: position ? position.innerText : ''
            });
        });
        return data;
    }
    scrollToElement() {
        const { top: top } = this.firstItemToScrollInto.getBoundingClientRect();
        const offset = Number(this.firstItemToScrollInto?.getAttribute('data-tk-scroll-into-offset')) || 16;
        const mainContainer = this.querySelector('main');
        const mainRect = mainContainer?.getBoundingClientRect();
        const mainRectTop = mainRect?.top || 0;
        const scrollY = top - mainRectTop - offset;
        setTimeout(()=>{
            window.scrollTo({
                top: scrollY,
                behavior: 'smooth'
            });
        }, 0);
    }
}


function $7e8cc8975b3fe464$export$60d21ef256fe91e0(point, rectangle, offset) {
    return point.x < rectangle.left + (offset?.left || 0) || point.x > rectangle.right + (offset?.right || 0) || point.y < rectangle.top + (offset?.top || 0) || point.y > rectangle.bottom + (offset?.bottom || 0);
}
function $7e8cc8975b3fe464$export$dcbd32acb1a13bc6(event, rectangles) {
    const point = {
        x: event.clientX,
        y: event.clientY
    };
    return rectangles.every((item)=>$7e8cc8975b3fe464$export$60d21ef256fe91e0(point, item.rectangle, item.offset));
}


class $9d20cb2aef3a6ec2$export$2e2bcd8739ae039 extends HTMLElement {
    constructor(){
        super();
        this.dialog = this.querySelector('dialog') || undefined;
        this.button = this.querySelector('button') || undefined;
        this.selectedClassName = this.getAttribute('data-selected-class-name') || 'tk-button__account--selected';
        this.alignedRightClassName = this.getAttribute('data-aligned-right-class-name') || 'tk-button__account--right';
        this.onShowEvent = ()=>{};
        this.onCloseEvent = ()=>{};
    }
    disconnectedCallback() {
        this.removeEventListener('mouseenter', this.onShowEvent);
        this.dialog?.removeEventListener('mouseleave', this.onCloseEvent);
    }
    connectedCallback() {
        this.registerOpenListener();
    }
    registerOpenListener() {
        this.onShowEvent = this.show.bind(this);
        this.addEventListener('mouseenter', this.onShowEvent);
    }
    registerCloseListener() {
        this.onCloseEvent = this.close.bind(this);
        this.addEventListener('mouseleave', this.onCloseEvent);
        this.dialog?.addEventListener('mouseleave', this.onCloseEvent);
    }
    show() {
        if (!this.dialog || !this.button) return;
        this.dialog.show();
        this.button.classList.add(this.selectedClassName);
        const { left: left } = this.button.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        if (window.outerWidth <= this.dialog.clientWidth + leftPosition) this.dialog.classList.add(this.alignedRightClassName);
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    close(event) {
        if (!this.dialog || !this.button) return;
        const dialogDimensions = this.dialog.getBoundingClientRect();
        const buttonDimensions = this.button.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: dialogDimensions
            },
            {
                rectangle: buttonDimensions,
                offset: {
                    bottom: dialogDimensions.top - buttonDimensions.bottom
                }
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.button.classList.remove(this.selectedClassName);
            this.dialog.close();
        }
    }
}



class $87c9f038bb9cd227$export$2e2bcd8739ae039 extends (0, $9d20cb2aef3a6ec2$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    registerOpenListener() {
        this.onShowEvent = this.show.bind(this);
        this.addEventListener('click', this.onShowEvent);
    }
    registerCloseListener() {
        this.onCloseEvent = this.close.bind(this);
        window.addEventListener('click', this.onCloseEvent);
    }
    show() {
        if (!this.dialog) return;
        this.dialog.show();
        this.classList.add(this.selectedClassName);
        const { left: left } = this.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        if (window.outerWidth <= this.dialog.clientWidth + leftPosition) this.dialog.classList.add(this.alignedRightClassName);
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    close(event) {
        if (!this.dialog) return;
        const dialogDimensions = this.dialog.getBoundingClientRect();
        const buttonDimensions = this.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: dialogDimensions
            },
            {
                rectangle: buttonDimensions,
                offset: {
                    bottom: dialogDimensions.top - buttonDimensions.bottom
                }
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.classList.remove(this.selectedClassName);
            this.dialog.close();
        }
    }
}





const $fbcf93c2a0aa5bcb$export$37cc283d8fbd3462 = (value)=>{
    const bytes = new TextEncoder().encode(value);
    return btoa(String.fromCharCode(...bytes));
};
const $fbcf93c2a0aa5bcb$export$c537b38001c583b7 = (base64)=>{
    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (char)=>char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
};
const $fbcf93c2a0aa5bcb$var$isBase64 = (value)=>{
    try {
        return $fbcf93c2a0aa5bcb$export$37cc283d8fbd3462($fbcf93c2a0aa5bcb$export$c537b38001c583b7(value)) === value;
    } catch  {
        return false;
    }
};
var $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039 = $fbcf93c2a0aa5bcb$var$isBase64;


const $1653b55d89a7adce$var$getDefaultErrorFnc = (error)=>{
    throw new Error(`Request failed: ${error}`);
};
const $1653b55d89a7adce$export$a4101276b4831ec4 = (checkForReadOnlyContext = false)=>{
    const asyncUrl = '/WebPortal/async.aspx';
    if (!window.opacc || !window.opacc.systemUrls || !checkForReadOnlyContext || !window.opacc.systemUrls.asyncReadOnly) return asyncUrl;
    return window.opacc.systemUrls.asyncReadOnly;
};
const $1653b55d89a7adce$var$prepareJsonResponse = (response, showMessages)=>{
    const data = (0, $fbcf93c2a0aa5bcb$export$c537b38001c583b7)(response.data);
    const html = document.createElement('div');
    html.innerHTML = data;
    const json = response.contentType === 'application/json' && html.innerText !== '' ? JSON.parse(html.innerText) : {};
    showMessages && (0, $1221feb2184dfefe$export$5b256beea4c7e9b5)(response.messages, json);
    return {
        status: response.status,
        messages: response.messages,
        dataAsBase64: response.data,
        contentType: response,
        success: response.status === 'ok',
        dataAsHtml: response.contentType === 'text/html' ? html.innerText : '',
        dataAsJson: json,
        data: data
    };
};
const $1653b55d89a7adce$var$recordToURLSearchParams = (data)=>{
    const searchParams = new URLSearchParams();
    Object.entries(data).forEach(([key, value])=>{
        searchParams.append(key, value || '');
    });
    return searchParams;
};
const $1653b55d89a7adce$var$formDataToURLSearchParams = (formData)=>{
    const searchParams = new URLSearchParams();
    formData.forEach((value, key)=>{
        searchParams.append(key, value);
    });
    return searchParams;
};
const $1653b55d89a7adce$export$d5a8517da06db2d = async ({ requestURL: requestURL, resolveHandler: resolveHandler, rejectHandler: rejectHandler = $1653b55d89a7adce$var$getDefaultErrorFnc, payload: payload, decodeJSONResponse: decodeJSONResponse = true, cache: cache = 'default', showMessages: showMessages = true, signal: signal })=>{
    const headers = new Headers({
        'x-requested-with': 'XMLHttpRequest',
        'response-type': 'json'
    });
    let body;
    if (payload) {
        headers.set('content-type', 'application/x-www-form-urlencoded; charset=UTF-8');
        if (payload instanceof URLSearchParams) body = payload;
        else if (payload instanceof FormData) body = $1653b55d89a7adce$var$formDataToURLSearchParams(payload);
        else if (payload instanceof Object) body = $1653b55d89a7adce$var$recordToURLSearchParams(payload);
    }
    const init = {
        method: payload ? 'POST' : 'GET',
        headers: headers,
        cache: cache,
        credentials: 'include',
        body: body,
        signal: signal
    };
    try {
        const response = await fetch(requestURL, init);
        const contentType = response.headers.get('content-type');
        const data = contentType?.includes('application/json') ? await response.json() : await response.text();
        const preparedData = decodeJSONResponse ? $1653b55d89a7adce$var$prepareJsonResponse(data, showMessages) : data;
        resolveHandler(preparedData);
    } catch (error) {
        if (error instanceof Error && error.name === 'AbortError') return;
        rejectHandler(error);
    }
};
const $1653b55d89a7adce$export$24835cb787452b46 = async (params)=>{
    const requestManager = document.querySelector('[data-tk-request-manager]');
    if (requestManager) return requestManager.addRequest(params);
    return $1653b55d89a7adce$export$d5a8517da06db2d(params);
};
const $1653b55d89a7adce$export$38e06f4bcf141755 = async (params)=>{
    return new Promise((resolve, reject)=>{
        $1653b55d89a7adce$export$d5a8517da06db2d({
            ...params,
            resolveHandler: (response)=>{
                resolve(response.dataAsJson);
            },
            rejectHandler: reject
        });
    });
};


class $40898dd22403025f$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.pages = [];
        this.navigationWrapper = document.querySelector('[data-tk-nav-wrapper]') || undefined;
        this.wrapper = this.querySelector('[data-tk-wrapper]') || undefined;
        this.openButton = document.querySelector(`[data-tk-nav-open="${this.id}"]`) || undefined;
        this.closeButton = document.querySelector(`[data-tk-nav-close="${this.id}"]`) || undefined;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'viewport__navigation--open';
        this.currentMenuId = this.getAttribute('data-tk-current-menu-id') || undefined;
        this.hasChildrenClassName = this.getAttribute('data-tk-has-children-class-name') || 'tk-nav-burger-item--has-children';
        this.asyncTemplateName = this.getAttribute('data-tk-nav-async-template-name') || 'tk-navigation-burgerlist';
        this.desktopMinWidth = Number(this.getAttribute('data-tk-desktop-min-width')) || 1200;
        this.overlayClassName = this.getAttribute('data-tk-overlay-class-name') || 'viewport__overlay';
        this.isMobile = window.viewport.clientWidth < this.desktopMinWidth;
        this.isMobileActive = false;
        this.overlay = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class="${this.overlayClassName}"></div>`);
    }
    connectedCallback() {
        if (!this.currentMenuId) throw new Error('Current menu id is missing!');
        this.registerViewportListener();
        this.registerButtonListener();
        this.registerClickListener();
        this.isMobile && this.switchToMobile();
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        this.isMobile = customEvent.detail.width < this.desktopMinWidth;
        this.isMobile ? this.switchToMobile() : this.switchToDesktop();
    }
    registerButtonListener() {
        this.openButton?.addEventListener('click', this.openNavigation.bind(this));
        this.closeButton?.addEventListener('click', this.closeNavigation.bind(this));
    }
    registerClickListener() {
        this.addEventListener('click', this.handleClickLink.bind(this));
    }
    openNavigation() {
        this.navigationWrapper ? this.navigationWrapper.classList.add(this.openClassName) : this.classList.add(this.openClassName);
        document.body.insertAdjacentElement('beforeend', this.overlay);
    }
    closeNavigation() {
        this.navigationWrapper ? this.navigationWrapper.classList.remove(this.openClassName) : this.classList.remove(this.openClassName);
        const overlay = document.querySelector(`.${this.overlayClassName}`);
        overlay?.remove();
    }
    async handleClickLink(event) {
        if (!this.isMobile) return;
        event.preventDefault();
        const target = event.target;
        let element;
        if (target.hasAttribute('data-tk-nav-id')) element = target;
        else element = target.closest('[data-tk-nav-id]');
        if (!element) return;
        if (!element.parentElement?.classList.contains(this.hasChildrenClassName) && !element.parentElement?.hasAttribute('data-tk-nav-page')) {
            window.location.href = element.href;
            this.closeNavigation();
            return;
        }
        const id = element.getAttribute('data-tk-nav-id');
        if (!id) return;
        if (this.existPage(id)) {
            const page = this.getPage(id);
            if (!page) return;
            this.insertPage(page.element);
            $40898dd22403025f$export$2e2bcd8739ae039.jumpToPage(page.element);
            this.removeLastPageFromDOM();
        } else {
            const response = await this.getTemplate(id);
            this.responseNextLevel(response);
        }
    }
    getTemplate(id) {
        const url = window.opacc.systemUrls?.async || '/WebPortal/async.aspx';
        const data = {
            type: 'navigation',
            navigationid: id,
            template: this.asyncTemplateName
        };
        return new Promise((resolve, reject)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: (response)=>resolve(response),
                rejectHandler: (error)=>reject(error),
                payload: data
            });
        });
    }
    responseNextLevel(response) {
        if (!response.success) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsJson.showItems);
        if (!html) return;
        const navigation = html.querySelector('[data-tk-nav-page]');
        if (!navigation) return;
        this.addPage(navigation);
        this.insertPage(navigation);
        $40898dd22403025f$export$2e2bcd8739ae039.jumpToPage(navigation);
        this.removeLastPageFromDOM();
    }
    insertPage(element) {
        const pages = this.querySelector('[data-tk-nav-pages]');
        if (!pages) return;
        pages.insertAdjacentElement('afterbegin', element);
    }
    addPage(element) {
        const id = element.getAttribute('data-tk-nav-page') || '';
        !this.existPage(id) && this.pages.push({
            id: id,
            element: element
        });
    }
    getPage(id) {
        return this.pages.find((page)=>page.id === id);
    }
    existPage(id) {
        if (id === '') return false;
        const foundPage = this.pages.filter((page)=>page.id === id);
        return foundPage.length > 0;
    }
    removeLastPageFromDOM() {
        const pages = this.querySelector('[data-tk-nav-pages]');
        if (!pages) return;
        const pageList = Array.from(pages.children);
        const oldPages = pageList.filter((element)=>element !== pages.firstElementChild);
        oldPages.forEach((element)=>element.remove());
    }
    async switchToMobile() {
        if (this.isMobileActive) return;
        this.isMobileActive = true;
        this.closeButton && (this.closeButton.hidden = false);
        if (!this.wrapper) return;
        this.desktopView = this.wrapper.innerHTML;
        if (!this.mobileView) {
            const response = await this.getTemplate(this.currentMenuId);
            const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsJson.showItems);
            if (!html) throw new Error('Burgerlist: Root Element is missing!');
            this.wrapper.replaceChildren(html);
            const navigation = html.querySelector('[data-tk-nav-page]');
            navigation && this.addPage(navigation);
        } else {
            this.wrapper.innerHTML = '';
            this.wrapper.insertAdjacentHTML('afterbegin', this.mobileView);
        }
    }
    async switchToDesktop() {
        if (!this.isMobileActive) return;
        this.isMobileActive = false;
        this.closeButton && (this.closeButton.hidden = true);
        if (!this.wrapper) return;
        this.mobileView = this.wrapper.innerHTML;
        if (!this.desktopView) return;
        this.wrapper.innerHTML = '';
        this.wrapper.insertAdjacentHTML('afterbegin', this.desktopView);
    }
    static jumpToPage(element) {
        element.scrollIntoView(false);
    }
}



class $1352bbad447b1dc9$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.lastScrollPosY = 0, this.scrollWay = 0;
        this.header = this.querySelector('header') || undefined;
        if (!this.header) throw new Error('Header: Header is missing!');
        this.disableScrolldownBreakpoint = this.getAttribute('data-tk-disable-scrolldown-breakpoint') || 's';
        this.minWidthBreakpoint = window.viewport.breakpoints.get(this.disableScrolldownBreakpoint) || 0;
        this.elementToScrollWith = this.querySelector('[data-tk-to-scroll-with]') || undefined;
        if (!this.elementToScrollWith) throw new Error('Header: Element to scroll with is missing! Use the [data-tk-to-scroll-with] selector.');
        this.maxHeightScrollWith = this.getMaxHeight();
        this.scrollDeltaY = Number(this.getAttribute('data-tk-scroll-delta-y')) || 1;
    }
    connectedCallback() {
        this.registerViewportListener();
        window.viewport.clientWidth < this.minWidthBreakpoint && this.registerScrollListener();
    }
    registerScrollListener() {
        if (!this.elementToScrollWith) return;
        const onScrolldown = this.handleScrolldown.bind(this);
        this.maxHeightScrollWith = this.getMaxHeight();
        this.pushListener({
            event: 'scroll',
            element: window,
            action: onScrolldown
        });
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        if (customEvent.detail.width < this.minWidthBreakpoint) this.registerScrollListener();
        else this.removeListener(window);
    }
    handleScrolldown(event) {
        if (!(this.header && this.elementToScrollWith)) return;
        const { scrollY: scrollY } = event.currentTarget;
        if (scrollY > this.lastScrollPosY) {
            if (scrollY <= this.maxHeightScrollWith) this.scrollWay = scrollY;
            else this.scrollWay = this.maxHeightScrollWith;
        } else if (this.scrollWay > this.scrollDeltaY) this.scrollWay = this.lastScrollPosY - scrollY >= this.maxHeightScrollWith ? 0 : this.lastScrollPosY - scrollY;
        else this.scrollWay = 0;
        this.elementToScrollWith.style.transform = `translateY(-${this.scrollWay}px)`;
        this.lastScrollPosY = scrollY;
    }
    getMaxHeight() {
        if (!this.elementToScrollWith) return 0;
        const { paddingBottom: paddingBottom } = window.getComputedStyle(this.elementToScrollWith);
        const { height: height } = this.elementToScrollWith.getBoundingClientRect();
        return height - parseInt(paddingBottom, 10);
    }
}



class $49fab39bf1404505$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.resizeEventName = this.getAttribute('data-tk-resize-event-name') || 'tk-viewport-resize';
        this.resizeObserver = new ResizeObserver(this.checkSize.bind(this));
        // * These breakpoints must match the CSS breakpoints, otherwise conflicts may occur.
        this.breakpoints = new Map([
            [
                'xs',
                576
            ],
            [
                's',
                768
            ],
            [
                'm',
                992
            ],
            [
                'l',
                1200
            ],
            [
                'xl',
                1440
            ]
        ]);
        this.currentBreakpoint = this.getCurrentBreakpoint(this.clientWidth);
    }
    connectedCallback() {
        this.resizeObserver.observe(this);
        window.viewport = this;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.unobserve(this);
    }
    checkSize(entries) {
        entries.forEach(()=>{
            const currentWidth = window.innerWidth;
            const currentBreakpoint = this.getCurrentBreakpoint(currentWidth);
            if (this.currentBreakpoint !== currentBreakpoint) {
                const event = new CustomEvent(this.resizeEventName, {
                    bubbles: true,
                    detail: {
                        width: currentWidth,
                        breakpoint: currentBreakpoint
                    }
                });
                this.currentBreakpoint = currentBreakpoint;
                this.dispatchEvent(event);
            }
        });
    }
    getCurrentBreakpoint(width) {
        let currentBreakpoint = 'xs';
        this.breakpoints.forEach((value, key)=>{
            if (width >= value) currentBreakpoint = key;
        });
        return currentBreakpoint;
    }
}


class $9ada6dd3e169a5cf$export$2e2bcd8739ae039 extends (0, $49fab39bf1404505$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.breakpoints = new Map([
            [
                'xs',
                576
            ],
            [
                's',
                768
            ],
            [
                'm',
                992
            ],
            [
                'l',
                1200
            ],
            [
                'xl',
                1920
            ]
        ]);
    }
}






var $011e7dbf949e9361$var$MessageType = /*#__PURE__*/ function(MessageType) {
    MessageType[MessageType["tooShort"] = 1] = "tooShort";
    MessageType[MessageType["dangerousString"] = 2] = "dangerousString";
    MessageType[MessageType["disallowedCharacters"] = 3] = "disallowedCharacters";
    return MessageType;
}($011e7dbf949e9361$var$MessageType || {});
const $011e7dbf949e9361$var$ALLOWED_CHARACTERS = /[^a-zA-Z0-9 äÄãÃåÅáÁàÀâÂéÉèÈêÊëËöÖóÓòÒôÔõÕüÜúÚùÙûÛìÌíÍîÎïÏñÑøØçÇß',-_.]+/;
class $011e7dbf949e9361$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorSearch = '[data-tk-search]', this.selectorSearchBackButton = '[data-tk-search-back]', this.selectorSearchResetButton = '[data-tk-search-reset]', this.selectorSearchSubmitButton = '[data-tk-search-submit]', this.selectorSearchFilterElement = '[data-tk-search-filter]', this.selectorSearchResult = '[data-tk-search-result]', this.attributeSearchMinLength = '[data-tk-search-min-input-length]', this.directSearchInputObj = {}, this.timerID = 0, this.searchTermAsUrlParam = true, this.disallowedCharacters = '';
        this.directSearchForm = this.querySelector(this.selectorSearch) || undefined;
        this.directSearchBackButton = this.querySelector(this.selectorSearchBackButton) || undefined;
        this.directSearchResetButton = this.querySelector(this.selectorSearchResetButton) || undefined;
        this.directSearchSubmitButton = this.querySelector(this.selectorSearchSubmitButton) || undefined;
        this.directSearchFilterElement = this.querySelector(this.selectorSearchFilterElement) || undefined;
        this.directSearchResult = this.querySelector(this.selectorSearchResult) || undefined;
        this.directSearchMinLength = Number(this.getAttribute(this.attributeSearchMinLength)) || 3;
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-search--active';
        this.activeResultClassName = this.getAttribute('data-tk-active-result-class-name') || 'tk-search--has-data';
        this.tooShortClassName = this.getAttribute('data-tk-too-short-class-name') || 'tk-search__result--too-short';
        this.loadingClassName = this.getAttribute('data-tk-loading-class-name') || 'tk-search__result--loading';
        this.allowedCharactersRegex = RegExp(this.getAttribute('data-tk-allowed-characters') || $011e7dbf949e9361$var$ALLOWED_CHARACTERS);
        if (!this.directSearchForm) throw new Error('TK: Missing Direct-Search');
        this.directSearchInputElement = this.directSearchForm.querySelector('input') || undefined;
        if (!this.directSearchInputElement) throw new Error('TK: Missing Direct-Search-Input');
        if (!this.directSearchResult) throw new Error('TK: Missing Direct-Search Result Wrapper');
        $011e7dbf949e9361$export$2e2bcd8739ae039.replaceToActionUrl();
    }
    connectedCallback() {
        this.registerListener();
    }
    registerListener() {
        if (this.directSearchInputElement) {
            const keyUpEventHandler = this.getSuggest.bind(this);
            const setClassEventHandler = this.setActiveClass.bind(this);
            const submitEventHandler = this.submitSearch.bind(this);
            const focusOutEventHandler = this.focusOut.bind(this);
            this.pushListener({
                event: 'submit',
                element: this.directSearchForm,
                action: submitEventHandler
            });
            this.pushListener({
                event: 'input',
                element: this.directSearchInputElement,
                action: keyUpEventHandler
            });
            this.pushListener({
                event: 'focusin',
                element: this.directSearchInputElement,
                action: setClassEventHandler
            });
            this.pushListener({
                event: 'click',
                element: window,
                action: focusOutEventHandler
            });
        }
        if (this.directSearchBackButton) {
            const navigateBackEventHandler = this.navigateBack.bind(this);
            this.pushListener({
                event: 'click',
                element: this.directSearchBackButton,
                action: navigateBackEventHandler
            });
        }
        if (this.directSearchResetButton) {
            const resetEventHandler = this.resetSearch.bind(this);
            this.pushListener({
                event: 'click',
                element: this.directSearchResetButton,
                action: resetEventHandler
            });
        }
        if (this.directSearchFilterElement) {
            const selectboxEventHandler = this.getSuggest.bind(this);
            this.pushListener({
                event: 'change',
                element: this.directSearchFilterElement,
                action: selectboxEventHandler
            });
        }
    }
    setActiveClass() {
        this.classList.add(this.activeClassName);
    }
    submitSearch(event) {
        if (!this.directSearchForm) return;
        event.preventDefault();
        this.directSearchInputObj = this.validateSearchInput();
        this.modifyDOM();
        if (!this.directSearchInputObj.valid) {
            this.classList.add(this.activeResultClassName);
            if (this.directSearchInputObj.hasDangerousString) this.setErrorMessage(2);
            else if (this.directSearchInputObj.hasDisallowedChars) this.setErrorMessage(3);
            else this.setErrorMessage(1);
            return;
        }
        this.directSearchForm.submit();
    }
    focusOut(event) {
        if (event.pointerId === -1) return;
        const fieldElement = this.directSearchInputElement;
        const resultElement = this.directSearchResult;
        if (!fieldElement || !resultElement) return;
        const fieldElementRect = fieldElement.getBoundingClientRect();
        const resultRect = resultElement.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: fieldElementRect
            },
            {
                rectangle: resultRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.classList.remove(this.activeClassName);
            this.resetSearch();
        }
    }
    setProgressBar() {
        const progressBarTpl = `
        <div class="tk-progress tk-progress--infinite tk-progress--breakout">
            <div class="tk-progress__bar"></div>
        </div>`;
        this.directSearchResult?.insertAdjacentHTML('beforeend', progressBarTpl);
    }
    setErrorMessage(msgType) {
        let message = '';
        switch(msgType){
            case 1:
                message = (0, $86b3c5b6d66bd808$export$f625b980042672da).messageTooShort.text.replace('%1', String(this.directSearchMinLength));
                break;
            case 2:
                message = (0, $86b3c5b6d66bd808$export$f625b980042672da).messageDangerousString.text;
                break;
            case 3:
                message = (0, $86b3c5b6d66bd808$export$f625b980042672da).messageDisallowedCharacter.text.replace('%1', String(this.disallowedCharacters));
                break;
            default:
                break;
        }
        const msgTpl = `
        <div class="tk-message tk-message--info tk-message--breakout">
            <span class="tk-message__icon">
                <i class="tk-icon-info"></i>
            </span>
            <span class="tk-message__label">
                ${message}
            </span>
        </div>`;
        this.directSearchResult?.insertAdjacentHTML('beforeend', msgTpl);
    }
    setMessageTooShort() {
        const msgTpl = `
        <div class="tk-message tk-message--info tk-message--breakout">
            <span class="tk-message__icon">
                <i class="tk-icon-info"></i>
            </span>
            <span class="tk-message__label">
                ${(0, $86b3c5b6d66bd808$export$f625b980042672da).messageTooShort.text.replace('%1', String(this.directSearchMinLength))}
            </span>
        </div>`;
        this.directSearchResult?.insertAdjacentHTML('beforeend', msgTpl);
    }
    getSuggest() {
        if (!this.directSearchResult) return;
        this.directSearchInputObj = this.validateSearchInput();
        this.modifyDOM();
        if (!this.directSearchInputObj.valid) {
            this.classList.add(this.activeResultClassName);
            if (this.directSearchInputObj.hasDangerousString) this.setErrorMessage(2);
            else if (this.directSearchInputObj.hasDisallowedChars) this.setErrorMessage(3);
            else this.setErrorMessage(1);
            return;
        }
        this.resetResultList();
        this.timerID && clearTimeout(this.timerID);
        this.timerID = window.setTimeout(()=>{
            // append Progress-Bar
            this.setProgressBar();
            // Validate again to prevent submitting empty search in the case of rapid backspace deletions.
            this.directSearchInputObj = this.validateSearchInput();
            if (!this.directSearchInputObj.valid) {
                this.resetResultList();
                this.setErrorMessage(1);
                return;
            }
            const searchData = this.setDataForRequest();
            const data = Object.fromEntries(Object.entries(searchData));
            const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: this.getDirectSearchSuggestDataFromResult.bind(this),
                payload: data
            });
        }, 500);
    }
    setDataForRequest() {
        const retVal = {
            type: 'directsearchsuggest',
            inputValue: encodeURIComponent(this.directSearchInputObj.value),
            filterAttribute: this.directSearchFilterElement?.dataset.tkSearchFilterAttribute,
            filterValue: this.directSearchFilterElement?.value
        };
        if (!this.directSearchFilterElement) {
            delete retVal.filterAttribute;
            delete retVal.filterValue;
        }
        return retVal;
    }
    getDirectSearchSuggestDataFromResult(response) {
        if (!this.directSearchResult) return;
        this.classList.add(this.activeResultClassName);
        this.directSearchResult.innerHTML = response.dataAsJson.html;
    }
    modifyDOM() {
        const classListObj = $011e7dbf949e9361$export$2e2bcd8739ae039.clearClassListObj();
        classListObj.push({
            element: this,
            className: this.activeClassName
        }, {
            element: this,
            className: this.activeResultClassName
        });
        if (this.directSearchInputObj.valid) $011e7dbf949e9361$export$2e2bcd8739ae039.addClassList(classListObj);
        else this.resetResultList();
    }
    static clearClassListObj() {
        const classListObj = [];
        return classListObj;
    }
    static addClassList(items) {
        items.forEach((item)=>{
            item.element?.classList.add(item.className);
        });
    }
    static removeClassList(items) {
        items.forEach((item)=>{
            item.element?.classList.remove(item.className);
        });
    }
    resetResultList() {
        this.directSearchResult?.replaceChildren();
    }
    navigateBack() {
        const classListObj = $011e7dbf949e9361$export$2e2bcd8739ae039.clearClassListObj();
        classListObj.push({
            element: this,
            className: this.activeClassName
        });
        $011e7dbf949e9361$export$2e2bcd8739ae039.removeClassList(classListObj);
    }
    resetSearch() {
        const classListObj = $011e7dbf949e9361$export$2e2bcd8739ae039.clearClassListObj();
        classListObj.push({
            element: this,
            className: this.activeClassName
        }, {
            element: this,
            className: this.activeResultClassName
        });
        this.resetResultList();
        $011e7dbf949e9361$export$2e2bcd8739ae039.removeClassList(classListObj);
        this.directSearchForm?.reset();
    }
    static replaceToActionUrl() {
        const actionUrl = localStorage.getItem('searchActionUrl') ? new URL(localStorage.getItem('searchActionUrl')) : undefined;
        if (actionUrl && actionUrl.pathname === window.location.pathname) window.history.replaceState(null, 'searchActionUrl', actionUrl);
        if (actionUrl) localStorage.removeItem('searchActionUrl');
    }
    validateSearchInput() {
        const value = this.directSearchInputElement?.value.trim() || '';
        const minLength = Number(this.getAttribute('data-tk-search-min-input-length') || 3);
        const hasDangerousString = value?.includes('<');
        const hasDisallowedChars = this.hasDisallowedCharacters(value);
        return {
            minimum: minLength,
            value: value,
            valid: value.length >= minLength && !hasDangerousString && !hasDisallowedChars,
            hasDangerousString: hasDangerousString,
            hasDisallowedChars: hasDisallowedChars
        };
    }
    hasDisallowedCharacters(value) {
        if (!value) {
            this.disallowedCharacters = '';
            return false;
        }
        const character = value.match(this.allowedCharactersRegex)?.at(0) ?? '';
        this.disallowedCharacters = character;
        return Boolean(character);
    }
}




var $1943502441640b9f$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType[MessageType["tooShort"] = 1] = "tooShort";
    MessageType[MessageType["dangerousString"] = 2] = "dangerousString";
    MessageType[MessageType["disallowedCharacters"] = 3] = "disallowedCharacters";
    return MessageType;
}({});
class $1943502441640b9f$export$2e2bcd8739ae039 extends (0, $011e7dbf949e9361$export$2e2bcd8739ae039) {
    static{
        this.MessageType = $1943502441640b9f$export$80edbf15fa61a4db;
    }
    constructor(){
        super();
        this.defaultSearchUrl = this.getAttribute('data-tk-default-search-url') || '';
        this.mobileBtn = document.querySelector('[data-tk-search-mobile-btn]');
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.mobileBtn) this.registerMobileListener();
    }
    getSuggest() {
        if (!this.defaultSearchUrl) throw new Error('Missing default search url');
        if (!this.directSearchResult) return;
        this.directSearchInputObj = this.validateSearchInput();
        this.modifyDOM();
        if (!this.directSearchInputObj.valid) {
            this.classList.add(this.activeResultClassName);
            if (this.directSearchInputObj.hasDangerousString) this.setErrorMessage(2);
            else if (this.directSearchInputObj.hasDisallowedChars) this.setErrorMessage(3);
            else this.setErrorMessage(1);
            return;
        }
        this.resetResultList();
        this.timerID && clearTimeout(this.timerID);
        this.timerID = window.setTimeout(()=>{
            // append Progress-Bar
            this.setProgressBar();
            const searchData = this.setDataForRequest();
            const data = Object.fromEntries(Object.entries(searchData));
            let searchTerm = data?.inputValue;
            const minLen = Number(this.attributeSearchMinLength) || 3;
            searchTerm = (searchTerm ?? '').split('%20').filter((part)=>part.length >= minLen).join('%20');
            const url = `${this.defaultSearchUrl}?query=${searchTerm}`;
            const getSuggestAction = this.onDirectSearchSuggest.bind(this);
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: getSuggestAction,
                payload: data
            });
        }, 500);
    }
    onDirectSearchSuggest(response) {
        if (!this.directSearchResult) return;
        this.classList.add(this.activeResultClassName);
        this.directSearchResult.innerHTML = response.dataAsHtml;
    }
    registerMobileListener() {
        const searchInput = this.directSearchForm?.querySelector('input');
        if (!searchInput) return;
        const action = ()=>{
            searchInput.focus();
            this.setActiveClass();
        };
        this.pushListener({
            event: 'click',
            element: this.mobileBtn,
            action: action
        });
    }
    focusOut(event) {
        if (event.pointerId === -1) return;
        const fieldElement = this.directSearchInputElement;
        const resultElement = this.directSearchResult;
        if (!fieldElement || !resultElement) return;
        const fieldElementRect = fieldElement.getBoundingClientRect();
        const resultRect = resultElement.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: fieldElementRect
            },
            {
                rectangle: resultRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles) && event.target != this.mobileBtn) {
            this.classList.remove(this.activeClassName);
            this.resetSearch();
        }
    }
}



/**
 * Swiper 12.1.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2026 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: February 18, 2026
 */ /**
 * SSR Window 5.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: June 27, 2025
 */ /* eslint-disable no-param-reassign */ function $6b317c2177284918$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $6b317c2177284918$var$extend(target = {}, src = {}) {
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($6b317c2177284918$var$isObject(src[key]) && $6b317c2177284918$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $6b317c2177284918$var$extend(target[key], src[key]);
    });
}
const $6b317c2177284918$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $6b317c2177284918$export$39b482c5e57630a8() {
    const doc = typeof document !== 'undefined' ? document : {};
    $6b317c2177284918$var$extend(doc, $6b317c2177284918$var$ssrDocument);
    return doc;
}
const $6b317c2177284918$var$ssrWindow = {
    document: $6b317c2177284918$var$ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $6b317c2177284918$export$407448d2b89b1813() {
    const win = typeof window !== 'undefined' ? window : {};
    $6b317c2177284918$var$extend(win, $6b317c2177284918$var$ssrWindow);
    return win;
}



function $36f917fbf2efdd6b$export$342063e11d6c3cad(classes = '') {
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $36f917fbf2efdd6b$export$4a5767248b18ef41(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $36f917fbf2efdd6b$export$dda1d9f60106f0e9() {
    return Date.now();
}
function $36f917fbf2efdd6b$var$getComputedStyle(el) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $36f917fbf2efdd6b$export$882b5998b3b9117c(el, axis = 'x') {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $36f917fbf2efdd6b$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $36f917fbf2efdd6b$export$ffb5f4729a158638(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $36f917fbf2efdd6b$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $36f917fbf2efdd6b$export$d141bba7fdc215a3(...args) {
    const to = Object(args[0]);
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$36f917fbf2efdd6b$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>key !== '__proto__' && key !== 'constructor' && key !== 'prototype');
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($36f917fbf2efdd6b$export$ffb5f4729a158638(to[nextKey]) && $36f917fbf2efdd6b$export$ffb5f4729a158638(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $36f917fbf2efdd6b$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else if (!$36f917fbf2efdd6b$export$ffb5f4729a158638(to[nextKey]) && $36f917fbf2efdd6b$export$ffb5f4729a158638(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $36f917fbf2efdd6b$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $36f917fbf2efdd6b$export$8b22cf2602fb60ce(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $36f917fbf2efdd6b$export$3b14a55fb2447963({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $36f917fbf2efdd6b$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function $36f917fbf2efdd6b$export$f1e1789686576879(element, selector = '') {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $36f917fbf2efdd6b$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $36f917fbf2efdd6b$export$efccba1c4a2ef57b(el, parent) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $36f917fbf2efdd6b$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $36f917fbf2efdd6b$export$90a7f3efeed30595(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $36f917fbf2efdd6b$export$db3b6bfb95261072(tag, classes = []) {
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $36f917fbf2efdd6b$export$342063e11d6c3cad(classes));
    return el;
}
function $36f917fbf2efdd6b$export$2d1720544b23b823(el) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $36f917fbf2efdd6b$export$625550452a3fa3ec(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $36f917fbf2efdd6b$export$43caf9889c228507(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $36f917fbf2efdd6b$export$9e5f44173e64f162(el, prop) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $36f917fbf2efdd6b$export$35e795649ee09318(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $36f917fbf2efdd6b$export$4368d992c4eafac0(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $36f917fbf2efdd6b$export$ae1af26003f05816(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function $36f917fbf2efdd6b$export$23f2a1d2818174ef(el, size, includeMargins) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function $36f917fbf2efdd6b$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $36f917fbf2efdd6b$export$407448d2b89b1813(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $36f917fbf2efdd6b$export$2408f22a0fab9ae5(el, html = '') {
    if (typeof trustedTypes !== 'undefined') el.innerHTML = trustedTypes.createPolicy('html', {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}


let $029bc59d811a92d7$var$support;
function $029bc59d811a92d7$var$calcSupport() {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $029bc59d811a92d7$var$getSupport() {
    if (!$029bc59d811a92d7$var$support) $029bc59d811a92d7$var$support = $029bc59d811a92d7$var$calcSupport();
    return $029bc59d811a92d7$var$support;
}
let $029bc59d811a92d7$var$deviceCached;
function $029bc59d811a92d7$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = $029bc59d811a92d7$var$getSupport();
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel';
    // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function $029bc59d811a92d7$var$getDevice(overrides = {}) {
    if (!$029bc59d811a92d7$var$deviceCached) $029bc59d811a92d7$var$deviceCached = $029bc59d811a92d7$var$calcDevice(overrides);
    return $029bc59d811a92d7$var$deviceCached;
}
let $029bc59d811a92d7$var$browser;
function $029bc59d811a92d7$var$calcBrowser() {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const device = $029bc59d811a92d7$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $029bc59d811a92d7$var$getBrowser() {
    if (!$029bc59d811a92d7$var$browser) $029bc59d811a92d7$var$browser = $029bc59d811a92d7$var$calcBrowser();
    return $029bc59d811a92d7$var$browser;
}
function $029bc59d811a92d7$var$Resize({ swiper: swiper, on: on, emit: emit }) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function $029bc59d811a92d7$var$Observer({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var $029bc59d811a92d7$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $029bc59d811a92d7$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'padding-left') || 0, 10) - parseInt((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'padding-top') || 0, 10) - parseInt((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $029bc59d811a92d7$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    const swiperSize = swiper.size - offsetBefore - offsetAfter;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    // set cssMode offsets
    if (params.cssMode) {
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-slides-offset-before', `${offsetBefore}px`);
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-slides-offset-after', `${offsetAfter}px`);
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides[i];
        if (slide) {
            if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
            if ((0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(slide, 'display') === 'none') continue; // eslint-disable-line
        }
        if (isVirtual && params.slidesPerView === 'auto') {
            if (params.virtual.slidesPerViewAutoSlideSize) slideSize = params.virtual.slidesPerViewAutoSlideSize;
            if (slideSize && slide) {
                if (params.roundLengths) slideSize = Math.floor(slideSize);
                slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
            }
        } else if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slide.style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $36f917fbf2efdd6b$export$23f2a1d2818174ef)(slide, 'width', true) : (0, $36f917fbf2efdd6b$export$23f2a1d2818174ef)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slide) slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slide) slide.swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        // Check if snapToSlideEdge should be applied
        const isFractionalSlidesPerView = params.slidesPerView !== 'auto' && params.slidesPerView % 1 !== 0;
        const shouldSnapToSlideEdge = params.snapToSlideEdge && !params.loop && (params.slidesPerView === 'auto' || isFractionalSlidesPerView);
        // Calculate the last allowed snap index when snapToSlideEdge is enabled
        // This ensures minimum slides are visible at the end
        let lastAllowedSnapIndex = snapGrid.length;
        if (shouldSnapToSlideEdge) {
            let minVisibleSlides;
            if (params.slidesPerView === 'auto') {
                // For 'auto' mode, calculate how many slides fit based on actual sizes
                minVisibleSlides = 1;
                let accumulatedSize = 0;
                for(let i = slidesSizesGrid.length - 1; i >= 0; i -= 1){
                    accumulatedSize += slidesSizesGrid[i] + (i < slidesSizesGrid.length - 1 ? spaceBetween : 0);
                    if (accumulatedSize <= swiperSize) minVisibleSlides = slidesSizesGrid.length - i;
                    else break;
                }
            } else minVisibleSlides = Math.floor(params.slidesPerView);
            lastAllowedSnapIndex = Math.max(slidesLength - minVisibleSlides, 0);
        }
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (shouldSnapToSlideEdge) // When snapToSlideEdge is enabled, only keep snaps up to lastAllowedSnapIndex
            {
                if (i <= lastAllowedSnapIndex) newSlidesGrid.push(slidesGridItem);
            } else if (snapGrid[i] <= swiper.virtualSize - swiperSize) // When snapToSlideEdge is disabled, keep snaps that fit within scrollable area
            newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) // Only add edge-aligned snap if snapToSlideEdge is not enabled
        {
            if (!shouldSnapToSlideEdge) snapGrid.push(swiper.virtualSize - swiperSize);
        }
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $029bc59d811a92d7$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $029bc59d811a92d7$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $029bc59d811a92d7$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $029bc59d811a92d7$var$updateSlidesProgress(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $029bc59d811a92d7$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $029bc59d811a92d7$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $029bc59d811a92d7$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
const $029bc59d811a92d7$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $029bc59d811a92d7$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $36f917fbf2efdd6b$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $36f917fbf2efdd6b$export$625550452a3fa3ec)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $029bc59d811a92d7$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $029bc59d811a92d7$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $029bc59d811a92d7$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $029bc59d811a92d7$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
                }
            });
        }
        // Skip removal if managed by React/Vue component
        if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
    }
};
const $029bc59d811a92d7$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $029bc59d811a92d7$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $029bc59d811a92d7$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $029bc59d811a92d7$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $029bc59d811a92d7$var$unlazy(swiper, i);
    }
};
function $029bc59d811a92d7$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $029bc59d811a92d7$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $029bc59d811a92d7$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled) {
        if (params.loop) realIndex = getVirtualRealIndex(activeIndex);
        else realIndex = activeIndex;
    } else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $029bc59d811a92d7$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $029bc59d811a92d7$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $029bc59d811a92d7$var$update = {
    updateSize: $029bc59d811a92d7$var$updateSize,
    updateSlides: $029bc59d811a92d7$var$updateSlides,
    updateAutoHeight: $029bc59d811a92d7$var$updateAutoHeight,
    updateSlidesOffset: $029bc59d811a92d7$var$updateSlidesOffset,
    updateSlidesProgress: $029bc59d811a92d7$var$updateSlidesProgress,
    updateProgress: $029bc59d811a92d7$var$updateProgress,
    updateSlidesClasses: $029bc59d811a92d7$var$updateSlidesClasses,
    updateActiveIndex: $029bc59d811a92d7$var$updateActiveIndex,
    updateClickedSlide: $029bc59d811a92d7$var$updateClickedSlide
};
function $029bc59d811a92d7$var$getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $029bc59d811a92d7$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $029bc59d811a92d7$var$minTranslate() {
    return -this.snapGrid[0];
}
function $029bc59d811a92d7$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $029bc59d811a92d7$var$translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $029bc59d811a92d7$var$translate = {
    getTranslate: $029bc59d811a92d7$var$getSwiperTranslate,
    setTranslate: $029bc59d811a92d7$var$setTranslate,
    minTranslate: $029bc59d811a92d7$var$minTranslate,
    maxTranslate: $029bc59d811a92d7$var$maxTranslate,
    translateTo: $029bc59d811a92d7$var$translateTo
};
function $029bc59d811a92d7$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $029bc59d811a92d7$var$transitionEmit({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $029bc59d811a92d7$var$transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $029bc59d811a92d7$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function $029bc59d811a92d7$var$transitionEnd(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $029bc59d811a92d7$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var $029bc59d811a92d7$var$transition = {
    setTransition: $029bc59d811a92d7$var$setTransition,
    transitionStart: $029bc59d811a92d7$var$transitionStart,
    transitionEnd: $029bc59d811a92d7$var$transitionEnd
};
function $029bc59d811a92d7$var$slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $36f917fbf2efdd6b$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    const browser = $029bc59d811a92d7$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $029bc59d811a92d7$var$slideToLoop(index = 0, speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter } = swiper.params;
            const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (bothDirections) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideNext(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slidePrev(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideReset(speed, runCallbacks = true, internal) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $029bc59d811a92d7$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) swiper.slideToLoop(realIndex);
        else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $029bc59d811a92d7$var$slide = {
    slideTo: $029bc59d811a92d7$var$slideTo,
    slideToLoop: $029bc59d811a92d7$var$slideToLoop,
    slideNext: $029bc59d811a92d7$var$slideNext,
    slidePrev: $029bc59d811a92d7$var$slidePrev,
    slideReset: $029bc59d811a92d7$var$slideReset,
    slideToClosest: $029bc59d811a92d7$var$slideToClosest,
    slideToClickedSlide: $029bc59d811a92d7$var$slideToClickedSlide
};
function $029bc59d811a92d7$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    const clearBlankSlides = ()=>{
        const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach((el)=>{
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) clearBlankSlides();
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: bothDirections ? undefined : 'next',
        initial: initial
    });
}
function $029bc59d811a92d7$var$loopFix({ slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = {}) {
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter, initialSlide: initialSlide } = params;
    const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!bothDirections && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (bothDirections && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $36f917fbf2efdd6b$export$90a7f3efeed30595)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit('loopFix');
}
function $029bc59d811a92d7$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $029bc59d811a92d7$var$loop = {
    loopCreate: $029bc59d811a92d7$var$loopCreate,
    loopFix: $029bc59d811a92d7$var$loopFix,
    loopDestroy: $029bc59d811a92d7$var$loopDestroy
};
function $029bc59d811a92d7$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $029bc59d811a92d7$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $029bc59d811a92d7$var$grabCursor = {
    setGrabCursor: $029bc59d811a92d7$var$setGrabCursor,
    unsetGrabCursor: $029bc59d811a92d7$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $029bc59d811a92d7$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $6b317c2177284918$export$39b482c5e57630a8)() || el === (0, $6b317c2177284918$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $029bc59d811a92d7$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $029bc59d811a92d7$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $029bc59d811a92d7$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $36f917fbf2efdd6b$export$efccba1c4a2ef57b)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $029bc59d811a92d7$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$029bc59d811a92d7$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function $029bc59d811a92d7$var$onTouchMove(event) {
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $029bc59d811a92d7$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
    (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $029bc59d811a92d7$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $029bc59d811a92d7$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $029bc59d811a92d7$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $029bc59d811a92d7$var$onLoad(e) {
    const swiper = this;
    $029bc59d811a92d7$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $029bc59d811a92d7$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
const $029bc59d811a92d7$var$events = (swiper, method)=>{
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $029bc59d811a92d7$var$onResize, true);
    else swiper[swiperMethod]('observerUpdate', $029bc59d811a92d7$var$onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $029bc59d811a92d7$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $029bc59d811a92d7$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $029bc59d811a92d7$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $029bc59d811a92d7$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $029bc59d811a92d7$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $029bc59d811a92d7$var$onScroll.bind(swiper);
    swiper.onClick = $029bc59d811a92d7$var$onClick.bind(swiper);
    swiper.onLoad = $029bc59d811a92d7$var$onLoad.bind(swiper);
    $029bc59d811a92d7$var$events(swiper, 'on');
}
function $029bc59d811a92d7$var$detachEvents() {
    const swiper = this;
    $029bc59d811a92d7$var$events(swiper, 'off');
}
var $029bc59d811a92d7$var$events$1 = {
    attachEvents: $029bc59d811a92d7$var$attachEvents,
    detachEvents: $029bc59d811a92d7$var$detachEvents
};
const $029bc59d811a92d7$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $029bc59d811a92d7$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $029bc59d811a92d7$var$isGridEnabled(swiper, params);
    const isMultiRow = $029bc59d811a92d7$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === 'undefined') return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function $029bc59d811a92d7$var$getBreakpoint(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $6b317c2177284918$export$407448d2b89b1813)();
    const currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $029bc59d811a92d7$var$breakpoints = {
    setBreakpoint: $029bc59d811a92d7$var$setBreakpoint,
    getBreakpoint: $029bc59d811a92d7$var$getBreakpoint
};
function $029bc59d811a92d7$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $029bc59d811a92d7$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $029bc59d811a92d7$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $029bc59d811a92d7$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $029bc59d811a92d7$var$classes = {
    addClasses: $029bc59d811a92d7$var$addClasses,
    removeClasses: $029bc59d811a92d7$var$removeClasses
};
function $029bc59d811a92d7$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $029bc59d811a92d7$var$checkOverflow$1 = {
    checkOverflow: $029bc59d811a92d7$var$checkOverflow
};
var $029bc59d811a92d7$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    snapToSlideEdge: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $029bc59d811a92d7$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $029bc59d811a92d7$var$prototypes = {
    eventsEmitter: $029bc59d811a92d7$var$eventsEmitter,
    update: $029bc59d811a92d7$var$update,
    translate: $029bc59d811a92d7$var$translate,
    transition: $029bc59d811a92d7$var$transition,
    slide: $029bc59d811a92d7$var$slide,
    loop: $029bc59d811a92d7$var$loop,
    grabCursor: $029bc59d811a92d7$var$grabCursor,
    events: $029bc59d811a92d7$var$events$1,
    breakpoints: $029bc59d811a92d7$var$breakpoints,
    checkOverflow: $029bc59d811a92d7$var$checkOverflow$1,
    classes: $029bc59d811a92d7$var$classes
};
const $029bc59d811a92d7$var$extendedDefaults = {};
class $029bc59d811a92d7$export$25ce5a424b770e84 {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, params, {
                    el: containerEl
                });
                swipers.push(new $029bc59d811a92d7$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $029bc59d811a92d7$var$getSupport();
        swiper.device = $029bc59d811a92d7$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $029bc59d811a92d7$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) params.modules.forEach((mod)=>{
            if (typeof mod === 'function' && swiper.modules.indexOf(mod) < 0) swiper.modules.push(mod);
        });
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $029bc59d811a92d7$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, $029bc59d811a92d7$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, swiperParams, $029bc59d811a92d7$var$extendedDefaults, params);
        swiper.originalParams = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, swiper.params);
        swiper.passedParams = (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $36f917fbf2efdd6b$export$35e795649ee09318)(slides[0]);
        return (0, $36f917fbf2efdd6b$export$35e795649ee09318)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
    }
    getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
            if (this.params.grid.fill === 'column') index = Math.floor(index / this.params.grid.rows);
            else if (this.params.grid.fill === 'row') index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
        return index;
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $029bc59d811a92d7$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === 'string') el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $36f917fbf2efdd6b$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $36f917fbf2efdd6b$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $36f917fbf2efdd6b$export$9e5f44173e64f162)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $029bc59d811a92d7$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $029bc59d811a92d7$var$processLazyPreloader(swiper, e.target);
            });
        });
        $029bc59d811a92d7$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $029bc59d811a92d7$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $36f917fbf2efdd6b$export$4a5767248b18ef41)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $36f917fbf2efdd6b$export$d141bba7fdc215a3)($029bc59d811a92d7$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $029bc59d811a92d7$var$extendedDefaults;
    }
    static get defaults() {
        return $029bc59d811a92d7$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__) $029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$029bc59d811a92d7$export$25ce5a424b770e84.installModule(m));
            return $029bc59d811a92d7$export$25ce5a424b770e84;
        }
        $029bc59d811a92d7$export$25ce5a424b770e84.installModule(module);
        return $029bc59d811a92d7$export$25ce5a424b770e84;
    }
}
Object.keys($029bc59d811a92d7$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($029bc59d811a92d7$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $029bc59d811a92d7$export$25ce5a424b770e84.prototype[protoMethod] = $029bc59d811a92d7$var$prototypes[prototypeGroup][protoMethod];
    });
});
$029bc59d811a92d7$export$25ce5a424b770e84.use([
    $029bc59d811a92d7$var$Resize,
    $029bc59d811a92d7$var$Observer
]);









function $33834d902fe381ab$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            slidesPerViewAutoSlideSize: 320,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement('div');
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === 'string') {
                (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, slideEl);
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('swiper-slide');
        else slideEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', index);
        if (!params.renderSlide) (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, slidesPerView: slidesPerView, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter, slidesPerViewAutoSlideSize: slidesPerViewAutoSlideSize } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesPerViewNumeric;
        if (slidesPerView === 'auto') {
            if (slidesPerViewAutoSlideSize) {
                let swiperSize = swiper.size;
                if (!swiperSize) swiperSize = swiper.isHorizontal() ? swiper.el.getBoundingClientRect().width : swiper.el.getBoundingClientRect().height;
                slidesPerViewNumeric = Math.max(1, Math.ceil(swiperSize / slidesPerViewAutoSlideSize));
            } else slidesPerViewNumeric = 1;
        } else slidesPerViewNumeric = slidesPerView;
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerViewNumeric + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerViewNumeric : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === 'undefined') {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $36f917fbf2efdd6b$export$8b22cf2602fb60ce)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $52e509fb8653e0d9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true,
            speed: undefined
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && (document.activeElement.isContentEditable || document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea'))) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $36f917fbf2efdd6b$export$2d1720544b23b823)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        const speed = swiper.params.keyboard.speed;
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext(speed);
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev(speed);
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext(speed);
            if (isPageUp || isArrowUp) swiper.slidePrev(speed);
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $05e7c97b57a34c96$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $756cc3b72a05f628$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



const $9dcb69c205fd1703$var$arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
function $9dcb69c205fd1703$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: true,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null,
        arrowSvg: $9dcb69c205fd1703$var$arrowSvg
    };
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $756cc3b72a05f628$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) {
                if (params.addIcons && el.matches('.swiper-button-next,.swiper-button-prev') && !el.querySelector('svg')) {
                    const tempEl = document.createElement('div');
                    (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempEl, $9dcb69c205fd1703$var$arrowSvg);
                    el.appendChild(tempEl.querySelector('svg'));
                    tempEl.remove();
                }
                el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            }
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEl.forEach((el)=>initButton(el, 'next'));
        prevEl.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
        };
        nextEl.forEach((el)=>destroyButton(el, 'next'));
        prevEl.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on('click', (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $781a64a6db1a7446$export$db3b6bfb95261072(classes = '') {
    // Escape all CSS selector special characters
    return `.${classes.trim().replace(/([\.:!+\/()[\]#>~*^$|=,'"@{}\\])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}




function $69d1e0b9767b27dd$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return;
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $36f917fbf2efdd6b$export$35e795649ee09318)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $36f917fbf2efdd6b$export$23f2a1d2818174ef)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        '',
                        '-next',
                        '-next-next',
                        '-prev',
                        '-prev-prev',
                        '-main'
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $36f917fbf2efdd6b$export$35e795649ee09318)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== 'custom') (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(subEl, paginationHTML || '');
            if (params.type === 'bullets') swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $781a64a6db1a7446$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== 'custom') emit('paginationRender', el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $756cc3b72a05f628$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find((subEl)=>{
                if ((0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(subEl, '.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $c7252c6c2cf4bba7$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $36f917fbf2efdd6b$export$2d1720544b23b823)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style['scroll-snap-type'] = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style['scroll-snap-type'] = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        target[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $756cc3b72a05f628$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $36f917fbf2efdd6b$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $c36b71b742710ea0$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $401de11e8a126d45$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $36f917fbf2efdd6b$export$882b5998b3b9117c)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $36f917fbf2efdd6b$export$2d1720544b23b823)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $36f917fbf2efdd6b$export$2d1720544b23b823)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $36f917fbf2efdd6b$export$4368d992c4eafac0)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $411c83a941bc1076$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        if (typeof window !== 'undefined' && // eslint-disable-line
        (typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === 'string' ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $9649bf9a787c3914$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true,
            wrapperLiveRegion: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(notification, message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-controls', controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', true);
        });
    }
    function enableEl(el) {
        el = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $36f917fbf2efdd6b$export$35e795649ee09318)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $781a64a6db1a7446$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const isActive = (isVirtual ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : swiper.slides.indexOf(slideEl)) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'))), 0);
            else if (isVirtual) swiper.slideTo(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10)), 0);
            else swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        addElId(wrapperEl, wrapperId);
        if (params.wrapperLiveRegion) {
            const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
            addElLive(wrapperEl, live);
        }
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $36f917fbf2efdd6b$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('span', swiper.params.a11y.notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $38bb61499ef50fab$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ''}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history'));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $87b0baa371d09db8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
    const window = (0, $6b317c2177284918$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $36f917fbf2efdd6b$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $c1783ac9556c9fef$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params }) {
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
    };
    const getTotalDelay = ()=>{
        let totalDelay = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0) totalDelay = currentSlideDelay;
        return totalDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = delayForce;
        if (typeof delay === 'undefined') {
            delay = getTotalDelay();
            autoplayDelayTotal = delay;
            autoplayDelayCurrent = delay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) {
            autoplayTimeLeft = getTotalDelay();
            autoplayDelayTotal = getTotalDelay();
        }
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $21e2f533778c20f0$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function isVirtualEnabled() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return false;
        return thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled;
    }
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $36f917fbf2efdd6b$export$ffb5f4729a158638)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        if (isVirtualEnabled()) swiper.thumbs.swiper.on('virtualUpdate', ()=>{
            update(false, {
                autoScroll: false
            });
        });
        return true;
    }
    function update(initial, p) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || isVirtualEnabled()) for(let i = 0; i < thumbsToActivate; i += 1)(0, $36f917fbf2efdd6b$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        if (p?.autoScroll ?? true) autoScroll(initial ? 0 : undefined);
    }
    function autoScroll(slideSpeed) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, slideSpeed);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $6b317c2177284918$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $49f3fa363ac09256$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $36f917fbf2efdd6b$export$dda1d9f60106f0e9)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $3e2c28ea1ae0e231$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style[swiper.getDirectionLabel('margin-top')] = '';
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && `${spaceBetween}px` : '';
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}



function $eb2d45639f1e8538$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.append(tempDOM.children[0]);
            (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $eb2d45639f1e8538$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.prepend(tempDOM.children[0]);
            (0, $36f917fbf2efdd6b$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $eb2d45639f1e8538$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: $eb2d45639f1e8538$var$appendSlide.bind(swiper),
        prependSlide: $eb2d45639f1e8538$var$prependSlide.bind(swiper),
        addSlide: $eb2d45639f1e8538$var$addSlide.bind(swiper),
        removeSlide: $eb2d45639f1e8538$var$removeSlide.bind(swiper),
        removeAllSlides: $eb2d45639f1e8538$var$removeAllSlides.bind(swiper)
    });
}


function $6be88bfc4d238db6$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $b32fc4882a084e0d$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}



function $8cd9c8d5770c3e4b$export$f1e1789686576879({ swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides }) {
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $36f917fbf2efdd6b$export$ae1af26003f05816)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $5d17e4afe2f572c9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $7a34974922f14d54$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $fab3d8cd791e5fc7$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
    if (!shadowEl) {
        shadowEl = (0, $36f917fbf2efdd6b$export$db3b6bfb95261072)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $68ca3c9f22027c47$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $983c76c349961a02$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $ed2173e49aa32019$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $36f917fbf2efdd6b$export$407448d2b89b1813)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $e7abdc2d61949d3e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${(params.rotate || swiper.isHorizontal() ? -25 : 0) * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $fab3d8cd791e5fc7$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $b32fc4882a084e0d$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $36f917fbf2efdd6b$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $8cd9c8d5770c3e4b$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $6be88bfc4d238db6$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




const $123791bf45f73bdd$var$isObject = (item)=>{
    return item !== null && typeof item === 'object';
};
/**
 * Merges two objects deeply, combining their properties recursively.
 * If a property in the source object is an object and not an array,
 * it will be merged with the corresponding property in the target object.
 * Otherwise, the property from the source object will overwrite the one in the target object.
 *
 * @template T - The type of the target object.
 * @template U - The type of the source object.
 * @param {T} target - The target object to merge into.
 * @param {U} source - The source object to merge from.
 * @returns {T & U} A new object that is the result of deeply merging the target and source objects.
 */ const $123791bf45f73bdd$var$deepMerge = (target, source)=>{
    const output = {
        ...target
    };
    for(const key in source)if (Object.prototype.hasOwnProperty.call(source, key) && $123791bf45f73bdd$var$isObject(source[key]) && !Array.isArray(source[key])) output[key] = $123791bf45f73bdd$var$deepMerge(target[key] ?? {}, source[key]);
    else output[key] = source[key];
    return output;
};
var $123791bf45f73bdd$export$2e2bcd8739ae039 = $123791bf45f73bdd$var$deepMerge;


class $1e52ca8fdbe257bc$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.customOptions = {};
        this.options = this.getAttribute('data-tk-carousel-options') || undefined;
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-carousel--loaded';
        if (this.options) this.customOptions = JSON.parse(this.options);
    }
    connectedCallback() {
        this.mountCarousel();
    }
    mountCarousel() {
        const root = this.querySelector('[data-tk-carousel-root]');
        const prevButton = this.querySelector('[data-tk-carousel-prev]');
        const nextButton = this.querySelector('[data-tk-carousel-next]');
        const pagination = this.querySelector('[data-tk-carousel-pagination]');
        if (!root || !prevButton || !nextButton || !pagination) {
            console.error('TKCarousel: Required elements are missing in the DOM.');
            return;
        }
        const defaultOptions = {
            modules: [
                (0, $9dcb69c205fd1703$export$2e2bcd8739ae039),
                (0, $69d1e0b9767b27dd$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 24,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
                disabledClass: 'tk-carousel__arrow--disabled',
                enabled: false
            },
            pagination: {
                el: pagination,
                bulletClass: 'tk-carousel__pagination-page',
                bulletActiveClass: 'tk-carousel__pagination-page--active',
                clickable: true,
                enabled: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1200: {
                    slidesPerView: 3,
                    navigation: {
                        enabled: true
                    },
                    pagination: {
                        enabled: true
                    }
                }
            },
            on: {
                init: this.onCarouselReady.bind(this)
            }
        };
        const config = (0, $123791bf45f73bdd$export$2e2bcd8739ae039)(defaultOptions, this.customOptions);
        this.slider = new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(root, config);
    }
    onCarouselReady() {
        this.classList.add(this.loadedClassName);
    }
}





class $b0d382fe358ed836$export$2e2bcd8739ae039 extends (0, $1e52ca8fdbe257bc$export$2e2bcd8739ae039) {
    mountCarousel() {
        const root = this.querySelector('[data-tk-carousel-root]');
        const prevButton = this.querySelector('[data-tk-carousel-prev]');
        const nextButton = this.querySelector('[data-tk-carousel-next]');
        const pagination = this.querySelector('[data-tk-carousel-pagination]');
        if (!root || !prevButton || !nextButton || !pagination) {
            console.error('DIWCarousel: Required elements are missing in the DOM.');
            return;
        }
        const defaultOptions = {
            modules: [
                (0, $9dcb69c205fd1703$export$2e2bcd8739ae039),
                (0, $69d1e0b9767b27dd$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 8,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
                disabledClass: 'tk-carousel__arrow--disabled',
                enabled: false
            },
            pagination: {
                el: pagination,
                bulletClass: 'tk-carousel__pagination-page',
                bulletActiveClass: 'tk-carousel__pagination-page--active',
                clickable: true,
                enabled: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 8
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 8,
                    navigation: {
                        enabled: true
                    },
                    pagination: {
                        enabled: true
                    }
                }
            },
            on: {
                init: this.onCarouselReady.bind(this)
            }
        };
        const config = (0, $123791bf45f73bdd$export$2e2bcd8739ae039)(defaultOptions, this.customOptions);
        this.slider = new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(root, config);
    }
}




class $d9484b764f1a944d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.buttons = this.querySelectorAll('[data-tk-context-button]');
        this.items = this.querySelector('[data-tk-context-items]') || undefined;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'tk-context-menu--open';
        this.responsiveClassName = this.getAttribute('data-tk-responsive-class-name') || 'tk-context-menu--responsive';
        this.dropDownClassName = this.getAttribute('data-tk-dropdown-class-name') || 'tk-context-menu__dropdown';
        this.showAlways = this.hasAttribute('data-tk-show-always');
        this.disableScrolldownBreakpoint = this.getAttribute('data-tk-disable-scrolldown-breakpoint') || 's';
        this.minWidthBreakpoint = window.viewport.breakpoints.get(this.disableScrolldownBreakpoint) || 0;
        this.offset = Number(this.getAttribute('data-tk-context-offset')) || 4;
        this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
        this.eventListeners = new Map();
    }
    subscribe(eventName, callback) {
        if (!this.eventListeners.has(eventName)) this.eventListeners.set(eventName, []);
        this.eventListeners.get(eventName).push(callback);
    }
    unsubscribe(eventName, callback) {
        const listeners = this.eventListeners.get(eventName);
        if (!listeners) return;
        this.eventListeners.set(eventName, listeners.filter((listener)=>listener !== callback));
    }
    emit(eventName, data) {
        const listeners = this.eventListeners.get(eventName);
        if (!listeners) return;
        listeners.forEach((callback)=>callback(data));
    }
    connectedCallback() {
        if (this.buttons.length === 0 || !this.items) throw new Error('Context Menu: Elements are missing!');
        this.registerViewportListener();
        (window.viewport.clientWidth < this.minWidthBreakpoint || this.showAlways) && this.switchToMobile();
        this.registerClickListener();
        this.emit('READY');
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.resizeObserver.unobserve(this);
        this.emit('ENDED');
    }
    registerClickListener() {
        const onClick = this.open.bind(this);
        this.buttons.forEach((button)=>{
            this.pushListener({
                event: 'click',
                element: button,
                action: onClick
            });
        });
    }
    registerCloseListener() {
        const handleClose = this.handleClose.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: handleClose
        });
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleResize(entries) {
        entries.forEach(()=>{
            if (!this.copiedItems) return;
            this.setPosition(this.copiedItems);
            const width = this.copiedItems.offsetWidth;
            const height = this.copiedItems.offsetHeight;
            this.emit('RESIZED', {
                width: width,
                height: height
            });
        });
    }
    handleViewportResize(event) {
        event.detail.width < this.minWidthBreakpoint || this.showAlways ? this.switchToMobile() : this.switchToDesktop();
    }
    getVisibleButton(visibility) {
        const buttonList = Array.from(this.buttons);
        return buttonList.find((button)=>visibility === button.checkVisibility());
    }
    switchToDesktop() {
        const button = this.getVisibleButton(true);
        if (!button) return;
        button.hidden = true;
        this.classList.remove(this.responsiveClassName);
    }
    switchToMobile() {
        const button = this.getVisibleButton(false);
        if (!button) return;
        button.hidden = false;
        this.classList.add(this.responsiveClassName);
    }
    copyItemsIfNotExists() {
        const copiedItems = this.items.cloneNode(true);
        copiedItems.classList.add(this.dropDownClassName);
        this.copiedItems = copiedItems;
        document.body.insertAdjacentElement('beforeend', copiedItems);
        this.emit('COPIED');
    }
    open() {
        !this.copiedItems && this.copyItemsIfNotExists();
        if (!this.copiedItems) return;
        this.setPosition(this.copiedItems);
        this.resizeObserver.observe(document.body);
        setTimeout(()=>{
            this.registerCloseListener();
        }, 0);
        this.emit('OPENED', {
            target: this.copiedItems
        });
    }
    setPosition(element) {
        const button = this.getVisibleButton(true);
        if (!button) return;
        element.classList.add(this.openClassName);
        const { top: top, height: height, left: left, right: right } = button.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        const rightPosition = right + window.scrollX;
        element.style.top = `${top + height + window.scrollY + this.offset}px`;
        if (window.innerWidth <= element.clientWidth + leftPosition) element.style.left = `${rightPosition - element.clientWidth}px`;
        else element.style.left = `${leftPosition}px`;
    }
    handleClose(event) {
        const button = this.getVisibleButton(true);
        if (!this.copiedItems || !button) return;
        const buttonRect = button.getBoundingClientRect();
        const dropdownRect = this.copiedItems.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: buttonRect
            },
            {
                rectangle: dropdownRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) this.close();
    }
    close() {
        if (!this.copiedItems) return;
        this.copiedItems.classList.remove(this.openClassName);
        this.removeListener(window);
        this.resizeObserver.unobserve(document.body);
        this.emit('CLOSED');
    }
}



class $0d07f57cc5d15afe$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorFlagItem = '[data-tk-flag-item]', this.selectorFlagIcon = '[data-tk-flag-icon]', this.selectorFlagLabel = '[data-tk-flag-label]', this.flagItems = [], this.removedFlagElements = [];
    }
    connectedCallback() {
        this.getAllFlags();
        if (this.flagItems.length < 1) return;
        this.appendSummarizedFlag();
    }
    getAllFlags() {
        const allFlagElements = this.querySelectorAll(this.selectorFlagItem) || undefined;
        // convert NodeList to Array
        const allFlags = Array.from(allFlagElements);
        // remove last Element (not needed for Tooltip-Flag)
        allFlags.pop();
        if (allFlags.length < 1) return;
        allFlags.forEach((item)=>{
            const iconElem = item.querySelector(this.selectorFlagIcon);
            const labelElem = item.querySelector(this.selectorFlagLabel);
            const singleFlagItem = {
                icon: iconElem?.outerHTML,
                label: labelElem?.getAttribute(this.selectorFlagLabel.slice(1, -1)) === 'true' ? labelElem.innerHTML : '',
                showIcon: iconElem?.getAttribute(this.selectorFlagIcon.slice(1, -1)) === 'true',
                showLabel: labelElem?.getAttribute(this.selectorFlagLabel.slice(1, -1)) === 'true'
            };
            this.flagItems.push(singleFlagItem);
            this.removedFlagElements.push(item);
            item.remove();
        });
    }
    getFlagDetails() {
        const returnVal = [];
        this.flagItems.forEach((elem)=>{
            let tooltipString;
            if (elem.showLabel) tooltipString = elem.showIcon ? `${elem.icon} ${elem.label}` : `${elem.label}`;
            else {
                const removedElement = this.removedFlagElements.shift();
                const removedElementLabel = removedElement?.querySelector('[data-tk-flag-label]')?.innerHTML;
                const tmpTooltipString = removedElementLabel || '';
                tooltipString = elem.showIcon ? `${elem.icon}` : tmpTooltipString;
            }
            returnVal.push(tooltipString);
        });
        return returnVal.join(', ').trim();
    }
    appendSummarizedFlag() {
        const tooltipTemplate = this.querySelector('[data-tk-flag-merged]');
        if (!tooltipTemplate) return;
        const clone = tooltipTemplate.content.cloneNode(true);
        const tooltipElement = clone.querySelector('[data-tk-tooltip-content]');
        if (!tooltipElement) return;
        tooltipElement.innerHTML = `+${this.flagItems.length}`;
        tooltipElement.setAttribute('data-tk-tooltip-content', this.getFlagDetails());
        this.prepend(clone);
    }
}




class $21ae20c5af7baedb$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.productVariants = this.querySelector('[data-tk-product-variants]') || undefined;
    }
    connectedCallback() {
        if (!this.url) throw new Error('Product-Tile: No URL defined!');
        this.registerListener();
    }
    registerListener() {
        if (!this.productVariants) return;
        const switchProductVariantHandler = this.changeVariant.bind(this);
        this.pushListener({
            event: 'change',
            element: this.productVariants,
            action: switchProductVariantHandler
        });
    }
    changeVariant() {
        this.getProductVariant(this.productVariants.value);
    }
    getProductVariant(id) {
        const data = {
            article: id
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.url,
            resolveHandler: this.switchProductVariant.bind(this),
            payload: data
        });
    }
    switchProductVariant(response) {
        if (!response || !response.success) return;
        this.insertAdjacentHTML('afterend', response.dataAsHtml);
        this.remove();
    }
}




class $21611c672b0d32ce$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorProductVariant = '[data-tk-product-variant]', this.selectorproductVariantFilters = '[data-tk-product-variant-filter]', this.selectorProductVariantList = '[data-tk-product-variant-list]', this.selectorProductVariantAttribute = '[data-tk-product-variant-attribute]', this.selectorProductVariantValue = '[data-tk-product-variant-value]', this.filteredOptions = [], this.selectionHistory = [];
        this.productVariantList = this.querySelector(this.selectorProductVariantList) || undefined;
        this.productVariantFilters = this.querySelectorAll(this.selectorproductVariantFilters) || undefined;
        this.productVariantsCollection = [];
        this.filteredCollection = [];
        this.noVariantFound = this.getAttribute('data-tk-product-variant-none') || 'NONE';
        this.disableSelectingFirst = this.hasAttribute('data-tk-disable-selecting-first');
        this.resetButton = this.querySelector('[data-tk-product-variants-reset]') || undefined;
        this.enableFilterInURL = this.hasAttribute('data-tk-enable-filter-in-url');
    }
    connectedCallback() {
        this.collectProductVariants();
        this.prepareVariantFilters();
        !this.disableSelectingFirst && this.selectFirstVariantInCollection(this.productVariantsCollection);
        this.registerListener();
    }
    registerListener() {
        if (this.productVariantFilters) this.productVariantFilters.forEach((filter)=>{
            const filterListEventHandler = this.filterList.bind(this);
            this.pushListener({
                event: 'change',
                element: filter,
                action: filterListEventHandler
            });
        });
        if (this.productVariantsCollection.length > 0) this.productVariantsCollection.forEach((variant)=>{
            const getSelectedVariantValueHandler = this.getSelectedVariantValue.bind(this, variant.element);
            this.pushListener({
                event: 'change',
                element: variant.element,
                action: getSelectedVariantValueHandler
            });
        });
        const handleReset = this.handleReset.bind(this);
        this.resetButton && this.pushListener({
            event: 'click',
            element: this.resetButton,
            action: handleReset
        });
    }
    getSelectedVariantValue(variant) {
        this.setSelectedVariant(variant.getAttribute('data-tk-product-variant') || '');
    }
    filterList(event) {
        const selectedValues = this.getSelectedFilterValues();
        this.filteredCollection = this.productVariantsCollection.filter((element)=>{
            return Object.keys(selectedValues).every((key)=>{
                return selectedValues[key] === element.spec[key];
            });
        }) || [];
        this.updateProductVariantList();
        this.enableFilterInURL && this.setFilterInURL();
        event && this.filterOptions(event.currentTarget);
    }
    setFilterInURL() {
        const url = new URL(window.location.href);
        const selectedValues = this.getSelectedFilterValues();
        Object.keys(selectedValues).forEach((key)=>{
            url.searchParams.set(key, selectedValues[key]);
        });
        window.history.pushState(null, '', url.href);
    }
    handleReset() {
        this.productVariantsCollection.filter((item)=>item.id !== 'NONE').forEach((item)=>{
            item.element.hidden = false;
        });
        this.filteredOptions.forEach((item)=>{
            const { element: element } = item;
            if (!element) return;
            const optionList = Array.from(element.options);
            optionList.forEach((option)=>{
                option.hidden = false;
                option.selected = false;
            });
            element.disabled = item.options.size < 2;
            const firstOption = element.options.item(0);
            if (!firstOption) return;
            firstOption.selected = true;
        });
        if (!this.enableFilterInURL) return;
        const url = new URL(window.location.href);
        const { searchParams: searchParams } = url;
        this.filteredOptions.forEach((option)=>{
            const { attr: attr } = option;
            searchParams.has(attr) && searchParams.delete(attr);
        });
        window.history.pushState(null, '', url.href);
    }
    filterOptions(target) {
        const filteredList = this.filteredOptions.filter((item)=>item.element !== target);
        const currentValues = filteredList.map((filterOption)=>{
            const values = new Set();
            this.filteredCollection.forEach((item)=>{
                values.add(item.spec[filterOption.attr]);
            });
            return {
                attr: filterOption.attr,
                values: values
            };
        });
        filteredList.forEach((filterOption)=>{
            if (!filterOption.element) return;
            const { options: options } = filterOption.element;
            const optionList = Array.from(options);
            const values = currentValues.find((item)=>item.attr === filterOption.attr)?.values;
            if (!values) return;
            optionList.forEach((option)=>{
                option.hidden = false;
            });
            optionList.filter((option)=>option.value !== '').forEach((option)=>{
                option.hidden = !values.has(option.value);
            });
            filterOption.element.disabled = optionList.filter((item)=>!item.hidden && item.value !== '').length < 2;
        });
        const selectedOption = target.options.item(target.selectedIndex);
        if (!selectedOption) return;
        if (selectedOption.value === '') {
            this.enableLastSelection(target);
            return;
        }
        if (this.selectionHistory.at(-1) !== target) this.selectionHistory.push(target);
    }
    enableLastSelection(target) {
        if (this.selectionHistory.length < 1) return;
        const lastSelection = this.selectionHistory.at(-2);
        if (lastSelection === target) return;
        const index = this.filteredOptions.findIndex((item)=>item.element === lastSelection);
        const lastItem = this.filteredOptions.at(index);
        const lastElement = lastItem?.element;
        if (!lastElement) return;
        Array.from(lastElement.options).forEach((option)=>{
            option.hidden = false;
        });
        lastElement.disabled = false;
        lastElement.dispatchEvent(new Event('change'));
    }
    updateProductVariantList() {
        this.productVariantsCollection.forEach((variant)=>{
            variant.element.hidden = true;
        });
        this.filteredCollection.forEach((variant)=>{
            variant.element.hidden = false;
            if (variant.id === this.noVariantFound) variant.element.hidden = true;
        });
        if (this.filteredCollection.length > 0) !this.disableSelectingFirst && this.selectFirstVariantInCollection(this.filteredCollection);
        else this.showNoVariantsFoundMessage();
    }
    selectFirstVariantInCollection(collection) {
        const hasSelectedElement = collection.some($21611c672b0d32ce$export$2e2bcd8739ae039.findFirstSelectedElement);
        if (hasSelectedElement) return;
        const input = collection.at(0)?.element.querySelector('input[type="radio"]');
        if (!input) return;
        input.checked = true;
        this.setSelectedVariant(input.value);
    }
    static findFirstSelectedElement(variant) {
        const input = variant.element.querySelector('input');
        if (!input) return false;
        return !input.hidden && input.checked;
    }
    setSelectedVariant(selectedValue) {
        this.selectedVariant = selectedValue;
    }
    showNoVariantsFoundMessage() {
        const noVariantFound = this.productVariantsCollection.filter((variant)=>variant.id === this.noVariantFound);
        if (noVariantFound) noVariantFound[0].element.hidden = false;
        this.setSelectedVariant('');
    }
    getSelectedFilterValues() {
        const selectedValues = {};
        this.productVariantFilters.forEach((filter)=>{
            if (filter.value !== '') {
                const selected = {
                    attr: filter.getAttribute('data-tk-product-variant-filter') || '',
                    value: filter.value
                };
                selectedValues[selected.attr] = selected.value;
            }
        });
        return selectedValues;
    }
    collectProductVariants() {
        const variants = this.productVariantList?.querySelectorAll(this.selectorProductVariant);
        variants?.forEach((element)=>{
            const variant = {
                id: element.getAttribute('data-tk-product-variant') || '',
                element: element,
                spec: this.getVariantSpecs(element)
            };
            this.productVariantsCollection.push(variant);
        });
    }
    prepareVariantFilters() {
        const filterAttribute = new Set();
        this.productVariantsCollection.forEach((variant)=>{
            Object.keys(variant.spec).forEach((key)=>filterAttribute.add(key));
        });
        filterAttribute.forEach((attr)=>{
            // filter undefined or null values
            const distinctOptions = new Set(this.productVariantsCollection.map((variant)=>variant.spec[attr]).filter(Boolean));
            const sortedOptions = new Set([
                ...distinctOptions
            ].sort());
            const selectElement = this.querySelector(`[data-tk-product-variant-filter="${attr}"]`) || undefined;
            this.filteredOptions.push({
                element: selectElement,
                attr: attr,
                options: sortedOptions
            });
        });
        this.filteredOptions.forEach((item)=>{
            if (!item.element) return;
            item.element.disabled = item.options.size < 2;
            const optionsHTML = [
                ...item.options
            ].map((option)=>{
                const urlParams = new URLSearchParams(window.location.search);
                const isSelected = urlParams.get(item.attr) === option;
                return `<option value="${option}" ${isSelected ? 'selected' : ''}>${option}</option>`;
            }).join('');
            let resultHTML = '';
            item.options.size > 1 ? resultHTML = `<option value="">${(0, $86b3c5b6d66bd808$export$1c7f7f3bbe522ebc).all.text}</option>${optionsHTML}` : resultHTML = optionsHTML;
            item.element.insertAdjacentHTML('beforeend', resultHTML);
        });
        this.enableFilterInURL && this.filterList();
    }
    getVariantSpecs(variant) {
        const specs = variant.querySelectorAll(this.selectorProductVariantAttribute);
        const specCollection = {};
        specs.forEach((elem)=>{
            const spec = {
                attr: elem.getAttribute('data-tk-product-variant-attribute') || '',
                value: elem.getAttribute('data-tk-product-variant-value') || ''
            };
            specCollection[spec.attr] = spec.value;
        });
        return specCollection;
    }
}


/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $13064aa41dd611dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $2835f189066da699$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $6be351e83d6bf643$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6be351e83d6bf643$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6be351e83d6bf643$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $2835f189066da699$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $312913fa2edc14b2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $312913fa2edc14b2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || !(0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $312913fa2edc14b2$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $312913fa2edc14b2$var$applyStyles,
    effect: $312913fa2edc14b2$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $8d1d6c453d67c9ab$export$8960430cfd85939f = Math.max;
var $8d1d6c453d67c9ab$export$96ec731ed4dcb222 = Math.min;
var $8d1d6c453d67c9ab$export$2077e0241d6afd3c = Math.round;



function $9641053f99441231$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $b49248e188a52b8b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
}


function $1b9ce20ada6267ed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? (0, $2835f189066da699$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $b49248e188a52b8b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $0acc17feb41c51bd$export$2e2bcd8739ae039(node) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $c829ab0279467772$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b71097fc0b0e5f5c$export$2e2bcd8739ae039(node) {
    if (node === (0, $2835f189066da699$export$2e2bcd8739ae039)(node) || !(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node)) return (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(node);
    else return (0, $c829ab0279467772$export$2e2bcd8739ae039)(node);
}






function $37f38c85c1edad4d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e951d80a0194865c$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)).left + (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $270edfbc2bfbd22f$export$2e2bcd8739ae039(element) {
    return (0, $2835f189066da699$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $9873d63ab8539814$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $b01cf64433a5b37b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $b01cf64433a5b37b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent) && $b01cf64433a5b37b$var$isElementScaled(offsetParent);
    var documentElement = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9873d63ab8539814$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b71097fc0b0e5f5c$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e951d80a0194865c$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $ad01075005a54bff$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $c16bae6800ecc025$export$2e2bcd8739ae039(element) {
    if ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $c48b941fd834c962$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(node) && (0, $9873d63ab8539814$export$2e2bcd8739ae039)(node)) return node;
    return $c48b941fd834c962$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(node));
}





function $295d0ca7e8ef250a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $c48b941fd834c962$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9873d63ab8539814$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($295d0ca7e8ef250a$export$2e2bcd8739ae039((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(target)));
}







function $27c48183f07ddbe8$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(element)) >= 0;
}




function $3df2d470c30a409e$var$getTrueOffsetParent(element) {
    if (!(0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3df2d470c30a409e$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $9641053f99441231$export$2e2bcd8739ae039)());
    if (isIE && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element);
    if ((0, $6be351e83d6bf643$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3df2d470c30a409e$export$2e2bcd8739ae039(element) {
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $27c48183f07ddbe8$export$2e2bcd8739ae039)(offsetParent) && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $3df2d470c30a409e$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $3df2d470c30a409e$var$getContainingBlock(element) || window;
}


var $935c50c8659545b7$export$1e95b668f3b82d = 'top';
var $935c50c8659545b7$export$40e543e69a8b3fbb = 'bottom';
var $935c50c8659545b7$export$79ffe56a765070d2 = 'right';
var $935c50c8659545b7$export$eabcd2c8791e7bf4 = 'left';
var $935c50c8659545b7$export$dfb5619354ba860 = 'auto';
var $935c50c8659545b7$export$aec2ce47c367b8c3 = [
    $935c50c8659545b7$export$1e95b668f3b82d,
    $935c50c8659545b7$export$40e543e69a8b3fbb,
    $935c50c8659545b7$export$79ffe56a765070d2,
    $935c50c8659545b7$export$eabcd2c8791e7bf4
];
var $935c50c8659545b7$export$b3571188c770cc5a = 'start';
var $935c50c8659545b7$export$bd5df0f255a350f8 = 'end';
var $935c50c8659545b7$export$390fd549c5303b4d = 'clippingParents';
var $935c50c8659545b7$export$d7b7311ec04a3e8f = 'viewport';
var $935c50c8659545b7$export$ae5ab1c730825774 = 'popper';
var $935c50c8659545b7$export$ca50aac9f3ba507f = 'reference';
var $935c50c8659545b7$export$368f9a87e87fa4e1 = /*#__PURE__*/ $935c50c8659545b7$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []);
var $935c50c8659545b7$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($935c50c8659545b7$export$aec2ce47c367b8c3, [
    $935c50c8659545b7$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $935c50c8659545b7$export$b3571188c770cc5a,
        placement + "-" + $935c50c8659545b7$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $935c50c8659545b7$export$421679a7c3d56e = 'beforeRead';
var $935c50c8659545b7$export$aafa59e2e03f2942 = 'read';
var $935c50c8659545b7$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $935c50c8659545b7$export$c65e99957a05207c = 'beforeMain';
var $935c50c8659545b7$export$f22da7240b7add18 = 'main';
var $935c50c8659545b7$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $935c50c8659545b7$export$8d4d2d70e7d46032 = 'beforeWrite';
var $935c50c8659545b7$export$68d8715fc104d294 = 'write';
var $935c50c8659545b7$export$70a6e5159acce2e6 = 'afterWrite';
var $935c50c8659545b7$export$d087d3878fdf71d5 = [
    $935c50c8659545b7$export$421679a7c3d56e,
    $935c50c8659545b7$export$aafa59e2e03f2942,
    $935c50c8659545b7$export$6964f6c886723980,
    $935c50c8659545b7$export$c65e99957a05207c,
    $935c50c8659545b7$export$f22da7240b7add18,
    $935c50c8659545b7$export$bab79516f2d662fe,
    $935c50c8659545b7$export$8d4d2d70e7d46032,
    $935c50c8659545b7$export$68d8715fc104d294,
    $935c50c8659545b7$export$70a6e5159acce2e6
];


function $455dca0e08f2a815$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $455dca0e08f2a815$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $455dca0e08f2a815$var$order(modifiers); // order based on phase
    return (0, $935c50c8659545b7$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $6d2b77c34ff005f5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $81912adbd60ec5c0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $1839837374f95732$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $1839837374f95732$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $1839837374f95732$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $1839837374f95732$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $1839837374f95732$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(reference) ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $455dca0e08f2a815$export$2e2bcd8739ae039)((0, $81912adbd60ec5c0$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$1839837374f95732$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $b01cf64433a5b37b$export$2e2bcd8739ae039)(reference, (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $ad01075005a54bff$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6d2b77c34ff005f5$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$1839837374f95732$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $1839837374f95732$export$8f7491d57c8f97a9 = /*#__PURE__*/ $1839837374f95732$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $fa02e10eb4995658$var$passive = {
    passive: true
};
function $fa02e10eb4995658$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2835f189066da699$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $fa02e10eb4995658$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $fa02e10eb4995658$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $fa02e10eb4995658$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $fa02e10eb4995658$var$effect,
    data: {}
};



function $6653967f933aaf29$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $66a6b9b7896d6ec4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $271a905a3adf884c$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $4f7414566eeea71a$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $935c50c8659545b7$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $935c50c8659545b7$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $935c50c8659545b7$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $935c50c8659545b7$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $935c50c8659545b7$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $935c50c8659545b7$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $ee48a1861d343976$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee48a1861d343976$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ee48a1861d343976$var$popperOffsets,
    data: {}
};










var $063d2297888fea12$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $063d2297888fea12$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $8d1d6c453d67c9ab$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $063d2297888fea12$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var sideY = (0, $935c50c8659545b7$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(popper);
            if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || placement === (0, $935c50c8659545b7$export$79ffe56a765070d2)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideY = (0, $935c50c8659545b7$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) || (placement === (0, $935c50c8659545b7$export$1e95b668f3b82d) || placement === (0, $935c50c8659545b7$export$40e543e69a8b3fbb)) && variation === (0, $935c50c8659545b7$export$bd5df0f255a350f8)) {
            sideX = (0, $935c50c8659545b7$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $063d2297888fea12$var$unsetSides);
    var _ref4 = roundOffsets === true ? $063d2297888fea12$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2835f189066da699$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $063d2297888fea12$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $063d2297888fea12$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $063d2297888fea12$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $063d2297888fea12$var$computeStyles,
    data: {}
};





function $8d644778f0e020f0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8d644778f0e020f0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $935c50c8659545b7$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $8d644778f0e020f0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8d644778f0e020f0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8d644778f0e020f0$var$offset
};


var $d79ddf39683d3f91$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $d79ddf39683d3f91$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $d79ddf39683d3f91$var$hash[matched];
    });
}



var $5887002dcefa0743$var$hash = {
    start: 'end',
    end: 'start'
};
function $5887002dcefa0743$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5887002dcefa0743$var$hash[matched];
    });
}







function $7da9d5689cacb0a6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2835f189066da699$export$2e2bcd8739ae039)(element);
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $b49248e188a52b8b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $ab4ea6dd03061fae$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $0acc17feb41c51bd$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e951d80a0194865c$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $122a9b90bb37fc73$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $6be351e83d6bf643$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $1cd357ee33805adc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $93ee5964b4e9d426$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) ? (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $7da9d5689cacb0a6$export$2e2bcd8739ae039)(element, strategy)) : (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) ? $93ee5964b4e9d426$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $1cd357ee33805adc$export$2e2bcd8739ae039)((0, $ab4ea6dd03061fae$export$2e2bcd8739ae039)((0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $93ee5964b4e9d426$var$getClippingParents(element) {
    var clippingParents = (0, $295d0ca7e8ef250a$export$2e2bcd8739ae039)((0, $c16bae6800ecc025$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $270edfbc2bfbd22f$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $6be351e83d6bf643$export$1b3bfaa9684536aa)(element) ? (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(clippingParent) && (0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $13064aa41dd611dc$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $93ee5964b4e9d426$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $93ee5964b4e9d426$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $93ee5964b4e9d426$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $93ee5964b4e9d426$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5dd4eac14cb3a9cb$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $0ad6ec2b432662d8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)(), paddingObject);
}


function $e3a5d8ce75f76756$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $70321b611e132ecc$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $935c50c8659545b7$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $935c50c8659545b7$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $935c50c8659545b7$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? (0, $935c50c8659545b7$export$ca50aac9f3ba507f) : (0, $935c50c8659545b7$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $93ee5964b4e9d426$export$2e2bcd8739ae039)((0, $6be351e83d6bf643$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $37f38c85c1edad4d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $1b9ce20ada6267ed$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $4f7414566eeea71a$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $1cd357ee33805adc$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $935c50c8659545b7$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $935c50c8659545b7$export$79ffe56a765070d2),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $935c50c8659545b7$export$1e95b668f3b82d),
                (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $bec6b628c79c2a3d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $935c50c8659545b7$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $935c50c8659545b7$export$368f9a87e87fa4e1) : (0, $935c50c8659545b7$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $935c50c8659545b7$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $dabd09962ff7b702$var$getExpandedFallbackPlacements(placement) {
    if ((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5887002dcefa0743$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $dabd09962ff7b702$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $dabd09962ff7b702$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$dfb5619354ba860) ? (0, $bec6b628c79c2a3d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(placement) === (0, $935c50c8659545b7$export$b3571188c770cc5a);
        var isVertical = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $935c50c8659545b7$export$79ffe56a765070d2) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $d79ddf39683d3f91$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $dabd09962ff7b702$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $dabd09962ff7b702$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $e82c9e5baaa8e9af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max) {
    return (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(min, (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(value, max));
}
function $4faf3481d1df2f95$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $4faf3481d1df2f95$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $4804c92787f86449$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $66a6b9b7896d6ec4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e82c9e5baaa8e9af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $935c50c8659545b7$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5dd4eac14cb3a9cb$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? (0, $8d1d6c453d67c9ab$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $8d1d6c453d67c9ab$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $935c50c8659545b7$export$1e95b668f3b82d),
            (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4faf3481d1df2f95$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4804c92787f86449$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $4804c92787f86449$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $20e743289f291887$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0ad6ec2b432662d8$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $e3a5d8ce75f76756$export$2e2bcd8739ae039)(padding, (0, $935c50c8659545b7$export$aec2ce47c367b8c3)));
};
function $20e743289f291887$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $6653967f933aaf29$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $271a905a3adf884c$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4),
        (0, $935c50c8659545b7$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $20e743289f291887$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $ad01075005a54bff$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $935c50c8659545b7$export$1e95b668f3b82d) : (0, $935c50c8659545b7$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $935c50c8659545b7$export$40e543e69a8b3fbb) : (0, $935c50c8659545b7$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $3df2d470c30a409e$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4faf3481d1df2f95$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $20e743289f291887$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $122a9b90bb37fc73$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $20e743289f291887$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $20e743289f291887$var$arrow,
    effect: $20e743289f291887$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $7d3d400f3b7c97f3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7d3d400f3b7c97f3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $935c50c8659545b7$export$1e95b668f3b82d),
        (0, $935c50c8659545b7$export$79ffe56a765070d2),
        (0, $935c50c8659545b7$export$40e543e69a8b3fbb),
        (0, $935c50c8659545b7$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7d3d400f3b7c97f3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $70321b611e132ecc$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7d3d400f3b7c97f3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7d3d400f3b7c97f3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7d3d400f3b7c97f3$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7d3d400f3b7c97f3$var$hide
};




var $98a9ef6d31ff03cd$export$d34966752335dd47 = [
    (0, $fa02e10eb4995658$export$2e2bcd8739ae039),
    (0, $ee48a1861d343976$export$2e2bcd8739ae039),
    (0, $063d2297888fea12$export$2e2bcd8739ae039),
    (0, $312913fa2edc14b2$export$2e2bcd8739ae039),
    (0, $8d644778f0e020f0$export$2e2bcd8739ae039),
    (0, $dabd09962ff7b702$export$2e2bcd8739ae039),
    (0, $4804c92787f86449$export$2e2bcd8739ae039),
    (0, $20e743289f291887$export$2e2bcd8739ae039),
    (0, $7d3d400f3b7c97f3$export$2e2bcd8739ae039)
];
var $98a9ef6d31ff03cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1839837374f95732$export$ed5e13716264f202)({
    defaultModifiers: $98a9ef6d31ff03cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $c55de979aca75bc6$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $c55de979aca75bc6$var$BOX_CLASS = "tippy-box";
var $c55de979aca75bc6$var$CONTENT_CLASS = "tippy-content";
var $c55de979aca75bc6$var$BACKDROP_CLASS = "tippy-backdrop";
var $c55de979aca75bc6$var$ARROW_CLASS = "tippy-arrow";
var $c55de979aca75bc6$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $c55de979aca75bc6$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $c55de979aca75bc6$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $c55de979aca75bc6$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $c55de979aca75bc6$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $c55de979aca75bc6$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $c55de979aca75bc6$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $c55de979aca75bc6$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $c55de979aca75bc6$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $c55de979aca75bc6$var$normalizeToArray(value) {
    return [].concat(value);
}
function $c55de979aca75bc6$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $c55de979aca75bc6$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $c55de979aca75bc6$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $c55de979aca75bc6$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $c55de979aca75bc6$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $c55de979aca75bc6$var$div() {
    return document.createElement('div');
}
function $c55de979aca75bc6$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $c55de979aca75bc6$var$isType(value, type);
    });
}
function $c55de979aca75bc6$var$isNodeList(value) {
    return $c55de979aca75bc6$var$isType(value, 'NodeList');
}
function $c55de979aca75bc6$var$isMouseEvent(value) {
    return $c55de979aca75bc6$var$isType(value, 'MouseEvent');
}
function $c55de979aca75bc6$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $c55de979aca75bc6$var$getArrayOfElements(value) {
    if ($c55de979aca75bc6$var$isElement(value)) return [
        value
    ];
    if ($c55de979aca75bc6$var$isNodeList(value)) return $c55de979aca75bc6$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $c55de979aca75bc6$var$arrayFrom(document.querySelectorAll(value));
}
function $c55de979aca75bc6$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $c55de979aca75bc6$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $c55de979aca75bc6$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $c55de979aca75bc6$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $c55de979aca75bc6$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $c55de979aca75bc6$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $c55de979aca75bc6$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $c55de979aca75bc6$var$currentInput = {
    isTouch: false
};
var $c55de979aca75bc6$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $c55de979aca75bc6$var$onDocumentTouchStart() {
    if ($c55de979aca75bc6$var$currentInput.isTouch) return;
    $c55de979aca75bc6$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $c55de979aca75bc6$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $c55de979aca75bc6$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $c55de979aca75bc6$var$lastMouseMoveTime < 20) {
        $c55de979aca75bc6$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $c55de979aca75bc6$var$onDocumentMouseMove);
    }
    $c55de979aca75bc6$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $c55de979aca75bc6$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($c55de979aca75bc6$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $c55de979aca75bc6$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $c55de979aca75bc6$var$onDocumentTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $c55de979aca75bc6$var$onWindowBlur);
}
var $c55de979aca75bc6$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $c55de979aca75bc6$var$isIE11 = $c55de979aca75bc6$var$isBrowser ? !!window.msCrypto : false;
function $c55de979aca75bc6$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $c55de979aca75bc6$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $c55de979aca75bc6$var$getDevMessage(message) {
    return $c55de979aca75bc6$var$clean("\n  %ctippy.js\n\n  %c" + $c55de979aca75bc6$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $c55de979aca75bc6$var$getFormattedMessage(message) {
    return [
        $c55de979aca75bc6$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $c55de979aca75bc6$var$visitedMessages;
function $c55de979aca75bc6$var$resetVisitedMessages() {
    $c55de979aca75bc6$var$visitedMessages = new Set();
}
function $c55de979aca75bc6$var$warnWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$errorWhen(condition, message) {
    if (condition && !$c55de979aca75bc6$var$visitedMessages.has(message)) {
        var _console2;
        $c55de979aca75bc6$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $c55de979aca75bc6$var$getFormattedMessage(message));
    }
}
function $c55de979aca75bc6$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $c55de979aca75bc6$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $c55de979aca75bc6$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $c55de979aca75bc6$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $c55de979aca75bc6$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $c55de979aca75bc6$var$defaultProps = Object.assign({
    appendTo: $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $c55de979aca75bc6$var$pluginProps, $c55de979aca75bc6$var$renderProps);
var $c55de979aca75bc6$var$defaultKeys = Object.keys($c55de979aca75bc6$var$defaultProps);
var $c55de979aca75bc6$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $c55de979aca75bc6$var$defaultProps[key] = partialProps[key];
    });
};
function $c55de979aca75bc6$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $c55de979aca75bc6$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $c55de979aca75bc6$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($c55de979aca75bc6$var$getExtendedPassedProps(Object.assign({}, $c55de979aca75bc6$var$defaultProps, {
        plugins: plugins
    }))) : $c55de979aca75bc6$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $c55de979aca75bc6$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $c55de979aca75bc6$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $c55de979aca75bc6$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $c55de979aca75bc6$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $c55de979aca75bc6$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $c55de979aca75bc6$var$removeProperties($c55de979aca75bc6$var$defaultProps, Object.keys($c55de979aca75bc6$var$pluginProps));
        var didPassUnknownProp = !$c55de979aca75bc6$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $c55de979aca75bc6$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $c55de979aca75bc6$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $c55de979aca75bc6$var$dangerouslySetInnerHTML(element, html) {
    element[$c55de979aca75bc6$var$innerHTML()] = html;
}
function $c55de979aca75bc6$var$createArrowElement(value) {
    var arrow = $c55de979aca75bc6$var$div();
    if (value === true) arrow.className = $c55de979aca75bc6$var$ARROW_CLASS;
    else {
        arrow.className = $c55de979aca75bc6$var$SVG_ARROW_CLASS;
        if ($c55de979aca75bc6$var$isElement(value)) arrow.appendChild(value);
        else $c55de979aca75bc6$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $c55de979aca75bc6$var$setContent(content, props) {
    if ($c55de979aca75bc6$var$isElement(props.content)) {
        $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $c55de979aca75bc6$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $c55de979aca75bc6$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $c55de979aca75bc6$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$ARROW_CLASS) || node.classList.contains($c55de979aca75bc6$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($c55de979aca75bc6$var$BACKDROP_CLASS);
        })
    };
}
function $c55de979aca75bc6$var$render(instance) {
    var popper = $c55de979aca75bc6$var$div();
    var box = $c55de979aca75bc6$var$div();
    box.className = $c55de979aca75bc6$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $c55de979aca75bc6$var$div();
    content.className = $c55de979aca75bc6$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $c55de979aca75bc6$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $c55de979aca75bc6$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $c55de979aca75bc6$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($c55de979aca75bc6$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$c55de979aca75bc6$var$render.$$tippy = true;
var $c55de979aca75bc6$var$idCounter = 1;
var $c55de979aca75bc6$var$mouseMoveListeners = []; // Used by `hideAll()`
var $c55de979aca75bc6$var$mountedInstances = [];
function $c55de979aca75bc6$var$createTippy(reference, passedProps) {
    var props = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, $c55de979aca75bc6$var$defaultProps, $c55de979aca75bc6$var$getExtendedPassedProps($c55de979aca75bc6$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $c55de979aca75bc6$var$idCounter++;
    var popperInstance = null;
    var plugins = $c55de979aca75bc6$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $c55de979aca75bc6$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $c55de979aca75bc6$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $c55de979aca75bc6$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $c55de979aca75bc6$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $c55de979aca75bc6$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $c55de979aca75bc6$var$mouseMoveListeners = $c55de979aca75bc6$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($c55de979aca75bc6$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $c55de979aca75bc6$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $c55de979aca75bc6$var$actualContains(el, actualTarget);
        })) {
            if ($c55de979aca75bc6$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $c55de979aca75bc6$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $c55de979aca75bc6$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $c55de979aca75bc6$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $c55de979aca75bc6$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $c55de979aca75bc6$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($c55de979aca75bc6$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $c55de979aca75bc6$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $c55de979aca75bc6$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($c55de979aca75bc6$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $c55de979aca75bc6$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $c55de979aca75bc6$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $98a9ef6d31ff03cd$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $c55de979aca75bc6$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $c55de979aca75bc6$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $c55de979aca75bc6$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($c55de979aca75bc6$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $c55de979aca75bc6$var$evaluateProps(reference, Object.assign({}, prevProps, $c55de979aca75bc6$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $c55de979aca75bc6$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $c55de979aca75bc6$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $c55de979aca75bc6$var$currentInput.isTouch && !instance.props.touch;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 0, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $c55de979aca75bc6$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $c55de979aca75bc6$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $c55de979aca75bc6$var$getValueAtIndexOrReturn(instance.props.duration, 1, $c55de979aca75bc6$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $c55de979aca75bc6$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $c55de979aca75bc6$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $c55de979aca75bc6$var$pushIfUnique($c55de979aca75bc6$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $c55de979aca75bc6$var$mountedInstances = $c55de979aca75bc6$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $c55de979aca75bc6$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $c55de979aca75bc6$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $c55de979aca75bc6$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $c55de979aca75bc6$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $c55de979aca75bc6$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $c55de979aca75bc6$var$isElement(targets) ? instances[0] : instances;
}
$c55de979aca75bc6$var$tippy.defaultProps = $c55de979aca75bc6$var$defaultProps;
$c55de979aca75bc6$var$tippy.setDefaultProps = $c55de979aca75bc6$var$setDefaultProps;
$c55de979aca75bc6$var$tippy.currentInput = $c55de979aca75bc6$var$currentInput;
var $c55de979aca75bc6$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $c55de979aca75bc6$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $c55de979aca75bc6$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $c55de979aca75bc6$var$applyStylesModifier = Object.assign({}, (0, $312913fa2edc14b2$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $c55de979aca75bc6$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $c55de979aca75bc6$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $c55de979aca75bc6$var$tippy($c55de979aca75bc6$var$div(), Object.assign({}, $c55de979aca75bc6$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $c55de979aca75bc6$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $c55de979aca75bc6$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $c55de979aca75bc6$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $c55de979aca75bc6$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $c55de979aca75bc6$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $c55de979aca75bc6$var$tippy(targets, parentProps);
    var normalizedReturnValue = $c55de979aca75bc6$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $c55de979aca75bc6$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($c55de979aca75bc6$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $c55de979aca75bc6$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $c55de979aca75bc6$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $c55de979aca75bc6$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $c55de979aca75bc6$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $c55de979aca75bc6$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $c55de979aca75bc6$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $c55de979aca75bc6$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $c55de979aca75bc6$var$createBackdropElement() {
    var backdrop = $c55de979aca75bc6$var$div();
    backdrop.className = $c55de979aca75bc6$var$BACKDROP_CLASS;
    $c55de979aca75bc6$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $c55de979aca75bc6$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $c55de979aca75bc6$var$activeInstances = [];
function $c55de979aca75bc6$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $c55de979aca75bc6$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $c55de979aca75bc6$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $c55de979aca75bc6$var$storeMouseCoords);
}
function $c55de979aca75bc6$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $c55de979aca75bc6$var$storeMouseCoords);
}
var $c55de979aca75bc6$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $c55de979aca75bc6$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $c55de979aca75bc6$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $c55de979aca75bc6$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $c55de979aca75bc6$var$activeInstances = $c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($c55de979aca75bc6$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $c55de979aca75bc6$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($c55de979aca75bc6$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) $c55de979aca75bc6$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $c55de979aca75bc6$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $c55de979aca75bc6$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $c55de979aca75bc6$var$getInlineBoundingClientRect($c55de979aca75bc6$var$getBasePlacement(placement), reference.getBoundingClientRect(), $c55de979aca75bc6$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($c55de979aca75bc6$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($c55de979aca75bc6$var$isMouseEvent(event)) {
                    var rects = $c55de979aca75bc6$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $c55de979aca75bc6$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $c55de979aca75bc6$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $c55de979aca75bc6$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $c55de979aca75bc6$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $c55de979aca75bc6$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$c55de979aca75bc6$var$tippy.setDefaultProps({
    render: $c55de979aca75bc6$var$render
});
var $c55de979aca75bc6$export$2e2bcd8739ae039 = $c55de979aca75bc6$var$tippy;



class $b4b8cee06c4cfcc8$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorTooltipContent = 'data-tk-tooltip-content', this.selectorTooltipOptions = 'data-tk-tooltip-options';
        this.tooltipContent = this.getAttribute(this.selectorTooltipContent) || undefined;
        this.customOptions = this.getAttribute(this.selectorTooltipOptions) || '{}';
        if (!this.tooltipContent) throw new Error('TK: Missing tooltip content');
    }
    connectedCallback() {
        this.initTooltip();
    }
    initTooltip() {
        this.customOptions = this.customOptions.replace(/'/g, '"');
        const tooltipOptions = {
            content: this.tooltipContent,
            ...this.defaultTooltipOptions(),
            ...JSON.parse(this.customOptions)
        };
        (0, $c55de979aca75bc6$export$2e2bcd8739ae039)(this, tooltipOptions);
    }
    defaultTooltipOptions() {
        return {
            arrow: false,
            theme: 'tk-tooltip',
            allowHTML: true,
            offset: [
                0,
                8
            ]
        };
    }
}





/**
 * data-tk-dialog-jump-forward
 * data-tk-dialog-jump-backward
 * data-tk-dialog-jump-to
 * data-tk-dialog-close
 * data-tk-dialog-close-and-reset
 * data-tk-close-on-backdrop-click
 */ var $2215c02a950e9fbf$var$DialogActions = /*#__PURE__*/ function(DialogActions) {
    DialogActions["JUMP_FORWARD"] = "jump_forward";
    DialogActions["JUMP_BACKWARD"] = "jump_backward";
    DialogActions["JUMP_TO"] = "jump_to";
    DialogActions["RESET_FORM"] = "reset_form";
    return DialogActions;
}($2215c02a950e9fbf$var$DialogActions || {});
class $2215c02a950e9fbf$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.dialogs = [], this.currentDialog = 0, this.shouldOpen = false, this.closeOnBackdropClick = true;
        this.tag = this.getAttribute('data-tk-tag') || 'dialog';
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.button = this.querySelector('button') || undefined;
        this.shouldOpen = this.hasAttribute('data-tk-open');
        this.closeOnBackdropClick = this.hasAttribute('data-tk-close-on-backdrop-click') ? JSON.parse(this.getAttribute('data-tk-close-on-backdrop-click')) : true;
        this.shouldMaxWidth = this.hasAttribute('data-tk-should-max-width');
        this.dialogClassName = this.getAttribute('data-tk-dialog-class-name') || 'tk-dialog';
        this.dialogInnerClassName = this.getAttribute('data-tk-dialog-inner-class-name') || 'tk-dialog__inner';
        this.dialogCloseClassName = this.getAttribute('data-tk-dialog-close-class-name') || 'tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close';
        this.maxWidthClassName = this.getAttribute('data-tk-max-width-class-name') || 'tk-dialog--max-width';
        this.formDataString = this.getAttribute('data-tk-form-data') || undefined;
        this.isPopup = this.hasAttribute('data-tk-is-popup');
        this.isConfirm = this.hasAttribute('data-tk-is-confirm');
        this.confirmTitle = this.getAttribute('data-tk-confirm-title') || undefined;
        this.confirmDescription = this.getAttribute('data-tk-confirm-description') || undefined;
        this.confirmCancelIcon = this.getAttribute('data-tk-confirm-cancel-icon') || 'cross';
        this.confirmCancelLabel = this.getAttribute('data-tk-confirm-cancel-label') || undefined;
        this.confirmSubmitIcon = this.getAttribute('data-tk-confirm-submit-icon') || 'check';
        this.confirmSubmitLabel = this.getAttribute('data-tk-confirm-submit-label') || undefined;
        this.forceReloadContent = this.hasAttribute('data-tk-force-reload-content');
    }
    connectedCallback() {
        if (!this.url) throw new Error('Dialog: URL is missing!');
        this.registerClickListener();
        this.checkAutoOpen();
    }
    registerClickListener() {
        if (!this.button) return;
        const onClick = this.openDialog.bind(this, this.url);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerFormListener(form) {
        const onSubmit = this.handleForm.bind(this, form);
        this.pushListener({
            event: 'submit',
            element: form,
            action: onSubmit
        });
    }
    registerCloseListener() {
        const onClick = this.closeDialog.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: onClick
        });
    }
    createDialog(url) {
        const dialog = $2215c02a950e9fbf$export$2e2bcd8739ae039.renderDialog({
            className: `${this.dialogClassName} ${this.shouldMaxWidth ? this.maxWidthClassName : ''}`,
            closeClassName: this.dialogCloseClassName,
            innerClassName: this.dialogInnerClassName,
            tag: this.tag,
            isConfirm: this.isConfirm,
            confirmURL: url,
            confirmTitle: this.confirmTitle,
            confirmDescription: this.confirmDescription,
            confirmCancelIcon: this.confirmCancelIcon,
            confirmCancelLabel: this.confirmCancelLabel,
            confirmSubmitIcon: this.confirmSubmitIcon,
            confirmSubmitLabel: this.confirmSubmitLabel
        });
        const onClosed = this.closedDialog.bind(this);
        this.pushListener({
            event: 'close',
            element: dialog,
            action: onClosed
        });
        this.currentDialog = this.forceReloadContent ? 0 : this.dialogs.push({
            url: url,
            dialog: dialog
        }) - 1;
        return dialog;
    }
    getContent(url) {
        if (this.isConfirm) {
            this.closeCurrentDialog();
            const dialog = this.createDialog(url);
            $2215c02a950e9fbf$export$2e2bcd8739ae039.open(dialog, this.isPopup);
            this.hookAfterShowModal(dialog);
        } else (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url)
        });
    }
    getContentWithData(url, payload) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: payload
        });
    }
    handleResponseSuccess(url, response) {
        if (!response || !response.success) return;
        this.closeCurrentDialog();
        const dialog = this.createDialog(url);
        const content = dialog.querySelector('[data-tk-dialog-content]');
        if (!content) return;
        content.innerHTML = response.dataAsHtml;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(dialog, this.isPopup);
        this.hookAfterShowModal(dialog);
        const form = content.querySelector('form');
        form && this.registerFormListener(form);
    }
    openDialog(url) {
        this.handleUrlAndDialogs(url);
        // This method would be used to execute code in a non-blocking way to prevent potential delays.
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    closeDialog(event) {
        const dialogItem = this.dialogs.at(this.currentDialog);
        // Used to check if the event isn't triggered by the enter key
        const isRealClickEvent = event.pointerId !== -1;
        if (!dialogItem || !isRealClickEvent) return;
        const { dialog: dialog } = dialogItem;
        if (this.closeOnBackdropClick) $2215c02a950e9fbf$export$2e2bcd8739ae039.closeDialogIfOutside(dialog, event, this.forceReloadContent);
    }
    hookAfterShowModal(dialog) {
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close]', ()=>$2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialog, this.forceReloadContent));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close-and-reset]', (button)=>this.handleActions("reset_form", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-forward]', (button)=>this.handleActions("jump_forward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-backward]', (button)=>this.handleActions("jump_backward", button));
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-jump-to]', (button)=>this.handleActions("jump_to", button));
    }
    static attachButtonClickHandler(dialog, selector, callback) {
        const buttons = dialog.querySelectorAll(selector);
        buttons.forEach((button)=>{
            button.addEventListener('click', ()=>callback(button));
        });
    }
    handleActions(action, button) {
        const handler = {
            jump_forward: ()=>this.forward(button),
            jump_backward: ()=>this.backward(),
            jump_to: ()=>this.jumpTo(button),
            reset_form: ()=>this.resetForm(button)
        };
        handler[action]();
    }
    closeCurrentDialog() {
        const dialogItem = this.dialogs.at(this.currentDialog);
        if (!dialogItem) return;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialogItem.dialog, this.forceReloadContent);
    }
    handleUrlAndDialogs(url) {
        const existsURL = this.dialogs.some((dialogItem)=>dialogItem.url === url);
        if (existsURL) {
            const nextDialog = this.getDialogByURL(url);
            if (!nextDialog) return;
            $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialog);
        } else try {
            const payload = JSON.parse(this.formDataString || '{}');
            Object.keys(payload).length > 0 ? this.getContentWithData(url, payload) : this.getContent(url);
        } catch (error) {
            throw new Error(`Dialog: ${error}`);
        }
    }
    forward(button) {
        // Check if already exists
        const url = button.getAttribute('data-tk-url');
        if (!url) throw new Error('Dialog: URL is missing!');
        this.closeCurrentDialog();
        this.handleUrlAndDialogs(url);
        this.currentDialog += 1;
    }
    backward() {
        const nextDialogItem = this.dialogs.at(this.currentDialog - 1);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialogItem.dialog);
        this.currentDialog -= 1;
    }
    jumpTo(button) {
        const index = Number(button.getAttribute('data-tk-dialog-jump-to'));
        const nextDialogItem = this.dialogs.at(index);
        if (!nextDialogItem) return;
        this.closeCurrentDialog();
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(nextDialogItem.dialog);
        this.currentDialog = index;
    }
    resetForm(button) {
        button.form?.reset();
        this.closeCurrentDialog();
    }
    handleForm(form, event) {
        const shouldSwitchToNext = form.hasAttribute('data-tk-switch-to-next');
        if (!shouldSwitchToNext) return;
        event.preventDefault();
        const formData = new FormData(form);
        const url = form.action;
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this, url),
            payload: formData
        });
    }
    getDialogByURL(url) {
        const dialogItem = this.dialogs.find((item)=>item.url === url);
        return dialogItem?.dialog;
    }
    closedDialog() {
        const allDialogClosed = this.dialogs.every((item)=>!item.dialog.open);
        if (!allDialogClosed) return;
        this.currentDialog = 0;
        this.removeListener(window);
    }
    static renderDialog(options) {
        const { tag: tag, className: className = 'tk-dialog', closeClassName: closeClassName = 'tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close', innerClassName: innerClassName = 'tk-dialog__inner', content: content, isConfirm: isConfirm = false, confirmURL: confirmURL, confirmTitle: confirmTitle, confirmDescription: confirmDescription, confirmCancelIcon: confirmCancelIcon, confirmCancelLabel: confirmCancelLabel, confirmSubmitIcon: confirmSubmitIcon, confirmSubmitLabel: confirmSubmitLabel, forceClosing: forceClosing } = options;
        const dialog = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
            ${isConfirm ? `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            <form action="${confirmURL}" method="post">
                                <h3>${confirmTitle}</h3>
                                <p>${confirmDescription}</p>
                                <div class="flex flex--gap-x-2 flex--justify-end spacer-mt-9">
                                    <button type="button" class="tk-button tk-button--secondary" data-tk-dialog-close>
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmCancelIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmCancelLabel}</span>
                                    </button>
                                    <button type="submit" class="tk-button tk-button--primary">
                                        <span class="tk-button__icon">
                                            <i class="tk-icon-${confirmSubmitIcon}"></i>
                                        </span>
                                        <span class="tk-button__label">${confirmSubmitLabel}</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </${tag}>
                ` : `
                    <${tag} class="${className}">
                        <button
                            type="button"
                            class="${closeClassName}"
                            data-tk-dialog-close
                        ></button>
                        <div class="${innerClassName}" data-tk-dialog-content>
                            ${content}
                        </div>
                    </${tag}>
                `}
        `);
        document.body.insertAdjacentElement('beforeend', dialog);
        $2215c02a950e9fbf$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close]', ()=>$2215c02a950e9fbf$export$2e2bcd8739ae039.close(dialog, forceClosing));
        return dialog;
    }
    static open(element, isPopup = false) {
        if (element instanceof HTMLDialogElement) isPopup ? element.show() : element.showModal();
        else element.classList.add('tk-dialog--open');
    }
    static close(element, forceClosing = false) {
        forceClosing && $2215c02a950e9fbf$export$2e2bcd8739ae039.destoryInstances(element);
        if (element instanceof HTMLDialogElement) element.close();
        else {
            element.classList.remove('tk-dialog--open');
            element.dispatchEvent(new Event('close'));
        }
        const contextMenus = element.querySelectorAll('[data-tk-context-menu]');
        contextMenus.forEach((menu)=>menu.close());
        forceClosing && element.remove();
    }
    static closeDialogIfOutside(element, event, forceClosing = false) {
        /**
         * Checking the coordinates of the client for the value 0 and the
         * HTMLSelectElement or HTMLOptionElement element ensures that the
         * dialogue does not close in Mozilla. This is a bug in Firefox
         * that has not yet been fixed.
         */ if (event.clientX === 0 && event.clientY === 0 && (event.target instanceof HTMLSelectElement || event.target instanceof HTMLOptionElement)) return;
        const dialogDimensions = element.getBoundingClientRect();
        if (event.clientX < dialogDimensions.left || event.clientX > dialogDimensions.right || event.clientY < dialogDimensions.top || event.clientY > dialogDimensions.bottom) $2215c02a950e9fbf$export$2e2bcd8739ae039.close(element, forceClosing);
    }
    checkAutoOpen() {
        if (!this.shouldOpen) return;
        this.openDialog(this.url);
    }
    renewDialogContent(dialog, url) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.getRenewDialogContent.bind(this, dialog)
        });
    }
    getRenewDialogContent(openDialog, response) {
        const dialogInner = openDialog.querySelector('[data-tk-dialog-content]');
        dialogInner.innerHTML = response.dataAsHtml;
        $2215c02a950e9fbf$export$2e2bcd8739ae039.open(openDialog);
        this.hookAfterShowModal(openDialog);
    }
    static destoryInstances(element) {
        const richtexts = element.querySelectorAll('[data-cms-richtext]');
        const datepickers = element.querySelectorAll('[data-tk-form-datepicker]');
        richtexts.forEach((richtext)=>{
            const item = richtext;
            item.editors?.forEach((editor)=>{
                editor.destroy();
            });
        });
        datepickers.forEach((datepicker)=>{
            datepicker.flatpickr?.destroy();
        });
    }
}


class $5a26c1218729bf34$export$2e2bcd8739ae039 extends (0, $2215c02a950e9fbf$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.dialogCloseClassName = this.getAttribute('data-tk-dialog-close-class-name') || 'tk-button tk-button--tertiary tk-button--size-l tk-button--only-icon tk-dialog__close';
    }
}





class $1ccb7c18f671f1de$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.hasStartedSync = false;
        this.isAsyncTile = Boolean(this.closest('[data-tk-product-tile][data-tk-url]'));
        this.articleList = this.closest('[data-tk-article-list]') || undefined;
        this.asyncURL = this.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.source = this.getAttribute('data-tk-source') || '';
        this.service = this.getAttribute('data-tk-service') || '';
        this.catItemId = this.getAttribute('data-tk-cat-item-id') || '';
        this.articleId = this.getAttribute('data-tk-article-id') || '';
        this.loadingType = this.getAttribute('data-tk-loading-type') || '';
        this.sort = this.getAttribute('data-tk-sort') || '';
        this.key = this.getAttribute('data-tk-key') || '';
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || '';
        this.isServiceClassName = this.getAttribute('data-tk-is-service-class-name') || 'tk-price--has-service';
        this.isPromotionClassName = this.getAttribute('data-tk-is-promotion-class-name') || 'tk-price--has-promotion';
    }
    connectedCallback() {
        this.item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: this
        };
        if (this.articleList && this.loadingType !== '2' && !this.isAsyncTile) this.sendDataToArticleList();
        else this.loadingType === '2' ? this.registerHoverListener() : this.handlePrice();
    }
    registerHoverListener() {
        const onHover = this.handlePrice.bind(this);
        this.pushListener({
            event: 'mouseover',
            element: this,
            action: onHover
        });
    }
    hover() {
        this.hasStartedSync = true;
        this.handlePrice();
    }
    sendDataToArticleList() {
        this.item && this.articleList.addPrice(this.item);
    }
    handlePrice() {
        if (!this.item) return;
        const items = this.asyncURL === (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true) ? $1ccb7c18f671f1de$export$2e2bcd8739ae039.getItemsAsJSONString([
            this.item
        ]) : $1ccb7c18f671f1de$export$2e2bcd8739ae039.getItemsAsEntrypoint([
            this.item
        ]);
        const data = {
            type: 'price',
            ...items
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            resolveHandler: this.handleResponse.bind(this),
            payload: data
        });
    }
    static getItemsAsEntrypoint(data) {
        const articles = [];
        data.forEach((item)=>{
            articles.push(item.articleId);
        });
        return {
            articles: articles.join(',')
        };
    }
    static getItemsAsJSONString(data) {
        const items = [];
        data.forEach((item)=>{
            items.push({
                source: item.source,
                service: item.service,
                catitemboid: item.catItemId,
                catitemartinternalno: item.articleId,
                loadingtype: item.loadingType,
                sort: item.sort,
                key: item.key,
                template: item.asyncTemplate
            });
        });
        return {
            catitems: JSON.stringify({
                items: items
            })
        };
    }
    handleResponse(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== 1) return;
        const list = response.dataAsJson.items;
        const responseItem = list[0];
        const item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: undefined
        };
        this.refreshPrice(item, responseItem);
    }
    handleError(error) {
        this.hasStartedSync = false;
        throw new Error(error);
    }
    refreshPrice(_item, responseItem) {
        const conditions = [
            {
                condition: responseItem.basispriceisset,
                selector: '[data-tk-price-basic]',
                className: undefined
            },
            {
                condition: responseItem.servicepriceisset,
                selector: '[data-tk-price-service]',
                className: this.isServiceClassName
            },
            {
                condition: responseItem.promopriceisset,
                selector: '[data-tk-price-promotion]',
                className: this.isPromotionClassName
            }
        ];
        const { selector: selector, className: className } = conditions.find(({ condition: condition })=>condition) || {};
        if (!selector) return;
        const element = this.querySelector(selector);
        const { html: html } = responseItem;
        if (!html) return;
        const htmlString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(html) ? (0, $fbcf93c2a0aa5bcb$export$c537b38001c583b7)(html) : html;
        if (element) element.innerHTML = htmlString;
        else this.innerHTML = htmlString;
        className && this.classList.add(className);
    }
}






class $edcef81612fbf4b7$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector('[data-tk-static-content-edit]') || undefined;
        this.target = this.getAttribute('data-tk-target') || '#tk-static-content-editor';
        this.boId = this.getAttribute('data-tk-bo-id') || undefined;
        this.boNumber = this.getAttribute('data-tk-bo-number') || undefined;
        this.artTextNumber = this.getAttribute('data-tk-art-text-number') || undefined;
        this.bo = this.getAttribute('data-tk-bo') || undefined;
        this.attr = this.getAttribute('data-tk-attr') || undefined;
        this.itemId = this.getAttribute('data-tk-id') || undefined;
        this.langNumber = this.getAttribute('data-tk-lang-number') || undefined;
        this.dataPer = this.getAttribute('data-tk-data-per') || undefined;
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || undefined;
        this.urlTemplate = [];
        this.templateContentPromiseArray = [];
        this.templatesLoaded = false;
        this.fileUploadIFrameURL = this.getAttribute('data-tk-file-upload-iframe-url') || '';
    }
    async connectedCallback() {
        if (!this.button || !this.boId || !this.dataPer || !this.asyncTemplate) return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        await (parcelRequire("cnCS2"));
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.sendAjaxRequest.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerModalListener(modal) {
        const saveButton = modal.querySelector('[data-tk-static-content-save]') || undefined;
        const onSave = this.save.bind(this, saveButton);
        saveButton && this.pushListener({
            event: 'click',
            element: saveButton,
            action: onSave
        });
        const cancelButton = modal.querySelector('[data-tk-static-content-cancel]');
        const onCancel = this.cancel.bind(this);
        cancelButton && this.pushListener({
            event: 'click',
            element: cancelButton,
            action: onCancel
        });
    }
    sendAjaxRequest() {
        this.requestData = {
            type: 'staticcontent',
            boid: this.boId,
            bonumber: this.boNumber,
            arttextno: this.artTextNumber,
            per: this.dataPer,
            template: this.asyncTemplate,
            modalid: this.target,
            bo: this.bo,
            id: this.itemId,
            attr: this.attr
        };
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.showContentInEditMode.bind(this),
            payload: this.requestData
        });
    }
    save(button) {
        if (!button) return;
        const htmlEncoded = $edcef81612fbf4b7$export$2e2bcd8739ae039.htmlEncode($edcef81612fbf4b7$export$2e2bcd8739ae039.getContentFromEditMode());
        this.requestData = {
            type: 'staticcontent',
            boid: this.boId,
            bonumber: this.boNumber,
            arttextno: this.artTextNumber,
            bo: this.bo,
            id: this.itemId,
            attr: this.attr,
            html: htmlEncoded
        };
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshContent.bind(this),
            payload: this.requestData
        });
        this.cancel();
    }
    cancel() {
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).close(this.dialog);
    }
    showContentInEditMode(response) {
        if (!response.success || !this.requestData) return;
        this.dialog = (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).renderDialog({
            content: response.dataAsHtml,
            className: 'tk-dialog tk-dialog--fullscreen',
            tag: 'div'
        });
        (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).open(this.dialog);
        this.pushListener({
            event: 'close',
            element: this.dialog,
            action: ()=>this.dialog?.remove()
        });
        this.initEditor();
        const modal = document.querySelector(this.target);
        if (!modal) return;
        this.registerModalListener(modal);
    }
    static getContentFromEditMode() {
        return window.tinymce.activeEditor?.getContent({
            format: 'raw'
        }) || '';
    }
    refreshContent(response) {
        if (!response.success || !this.requestData) return;
        let contentContainer = document.getElementById(`staticcontent-${this.requestData.boid}-${this.requestData.arttextno}`);
        if (!contentContainer) this.requestData.id !== undefined && (contentContainer = document.getElementById(this.requestData.id));
        else contentContainer.innerHTML = response.dataAsHtml;
    }
    initEditor() {
        if (!this.requestData) return;
        const selector = `${this.requestData.modalid} [data-tk-static-content-textarea]`;
        // Editor must be removed before initialisation
        window.tinymce.remove(selector);
        const options = {
            selector: selector,
            language: $edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage(),
            plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'pagebreak',
                'searchreplace',
                'wordcount',
                'visualblocks',
                'visualchars',
                'code',
                'fullscreen',
                'insertdatetime',
                'media',
                'nonbreaking',
                'save',
                'table',
                'directionality',
                'emoticons',
                'template',
                'quickbars'
            ],
            insertdatetime_formats: [
                '%d.%m.%Y',
                '%H:%M'
            ],
            contextmenu: 'link image table',
            tools: 'inserttable',
            toolbar: "undo redo | styles | bold italic | forecolor backcolor | alignleft aligncenteralignright alignjustify | bullist numlist outdent indent | image media link | preview print | filemanager",
            width: '100%',
            base_url: '/webportal/config/layout/themes/tk/vendor/tinymce/',
            language_url: `/webportal/config/layout/themes/tk/translations/tinymce/${$edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage()}.js`,
            promotion: false,
            content_css: [
                'default',
                `/webportal/config/layout/themes/project/generated/staticcontent.css?${new Date().getTime()}`
            ],
            templates: this.urlTemplate,
            extended_valid_elements: 'tk-tabs-accordion,tk-tabs-accordion[class],i[data-tk-accordion-icon]',
            custom_elements: 'tk-tabs-accordion,tk-tabs-accordion',
            setup: (editor)=>{
                editor.on('SaveContent', (event)=>{
                    event.content = $edcef81612fbf4b7$export$2e2bcd8739ae039.htmlEncode($edcef81612fbf4b7$export$2e2bcd8739ae039.htmlDecode(event.content));
                });
                const openmanager = ()=>{
                    editor.windowManager.openUrl({
                        title: 'File Manager',
                        url: $edcef81612fbf4b7$export$2e2bcd8739ae039.getFileManagerURL(editor),
                        width: 900,
                        height: 440
                    });
                };
                editor.ui.registry.addButton('filemanager', {
                    icon: 'browse',
                    tooltip: 'Insert file',
                    onAction: openmanager
                });
                editor.ui.registry.addMenuItem('filemanager', {
                    icon: 'browse',
                    text: 'Insert file',
                    onAction: openmanager
                });
                const templateURLElement = document.querySelector('[data-tk-staticcontent-templates-url]');
                const templateURL = templateURLElement && templateURLElement.getAttribute('data-op-url');
                if (templateURL) this.getTemplates(templateURL);
            }
        };
        if (this.fileUploadIFrameURL) options.file_picker_callback = this.handleFilePicker.bind(this);
        window.tinymce.init(options);
    }
    handleFilePicker(callback) {
        window.tinymce.activeEditor?.windowManager.openUrl({
            title: 'Fileupload Area',
            url: this.fileUploadIFrameURL,
            width: 800,
            height: 600
        });
        window.addEventListener('message', (event)=>{
            const { data: data } = event;
            if (window.location.origin !== event.origin) return;
            callback(data.content);
        });
    }
    static getFileManagerURL(editor) {
        return `/webportal/filemanager.aspx?editor=${editor.id}&lang=${$edcef81612fbf4b7$export$2e2bcd8739ae039.getLanguage()}`;
    }
    static htmlEncode(content) {
        return content.toString().replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    static htmlDecode(content) {
        return content.toString().replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&quot;/g, '"').replace(/&amp;/g, '&');
    }
    static getLanguage() {
        if (window.location.href.indexOf('/en/') !== -1) return 'en_GB';
        if (window.location.href.indexOf('/fr/') !== -1) return 'fr_FR';
        if (window.location.href.indexOf('/it/') !== -1) return 'it';
        return 'de';
    }
    async getTemplates(templateURL) {
        if (this.templatesLoaded) return;
        // get url content
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: templateURL,
                resolveHandler: (response)=>{
                    this.getTemplateContent(response, resolve);
                }
            });
        });
    }
    getTemplateContent(response, resolveFunction) {
        response.dataAsJson.forEach((element)=>{
            this.templateContentPromiseArray = [];
            this.templateContentPromiseArray.push(new Promise((resolve)=>{
                (0, $1653b55d89a7adce$export$24835cb787452b46)({
                    requestURL: element.url,
                    resolveHandler: (response)=>{
                        this.saveTemplateContent(response, element, resolveFunction, resolve);
                    }
                });
            }));
        });
    }
    saveTemplateContent(response, element, resolvedAllFunction, resolveArrayElementFunction) {
        const templateContent = response.dataAsHtml;
        const newTemplateEntry = {
            title: element.title,
            description: element.description,
            content: templateContent
        };
        this.urlTemplate.push(newTemplateEntry);
        resolveArrayElementFunction();
        Promise.allSettled(this.templateContentPromiseArray).then(()=>{
            resolvedAllFunction();
            this.templatesLoaded = true;
        });
    }
}



class $237e800aa488702c$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selectorTabsHead = '[data-tk-tab-head]', this.selectorTabsBody = '[data-tk-tab-body]';
        const tabHead = this.querySelector(this.selectorTabsHead);
        const tabBody = this.querySelector(this.selectorTabsBody);
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-tabs-tab--active';
        this.initialTabIndex = Number(this.getAttribute('data-tk-initial-tab')) || 1;
        this.enableLinks = this.hasAttribute('data-tk-enable-links');
        if (!tabHead) throw new Error('TK: Missing Tab-Header');
        if (!tabBody) throw new Error('TK: Missing Tab-Body');
        this.tabList = tabHead.childElementCount > 0 ? tabHead.children : undefined;
        this.tabContentList = tabBody.childElementCount > 0 ? tabBody.children : undefined;
        if (!this.tabList) throw new Error('TK: Empty Tab-Header');
        if (!this.tabContentList) throw new Error('TK: Empty Tab-Content');
        if (this.tabList.length !== this.tabContentList.length && !this.enableLinks) throw new Error('TK: Tab-Header Elements and Tab-Content Elements must be equal');
    }
    connectedCallback() {
        this.registerListener();
        if (this.tabList && +this.initialTabIndex > 0) {
            const button = this.tabList.item(this.initialTabIndex - 1);
            this.setTabActive(button, this.initialTabIndex - 1);
        }
    }
    registerListener() {
        if (this.tabList) [
            ...this.tabList
        ].forEach((element, index)=>{
            const button = element;
            const eventHandler = this.setTabActive.bind(this, button, index);
            this.pushListener({
                event: 'click',
                element: button,
                action: eventHandler
            });
        });
    }
    setTabActive(button, index) {
        const input = button.querySelector('input');
        if (input && input.disabled || button.disabled) return;
        const item = this.tabContentList?.item(index);
        if (!item) {
            const url = button.getAttribute('data-tk-url');
            const target = button.getAttribute('target') || undefined;
            if (!url) return;
            window.open(url, target);
        } else {
            this.setTabInactive();
            button.classList.add(this.activeClassName);
            item.classList.add(this.activeClassName);
        }
        this.toggleRequiredAttribute(index);
    }
    setTabInactive() {
        if (!this.tabContentList) return;
        [
            ...this.tabContentList
        ].forEach((element, index)=>{
            const button = element;
            button.classList.remove(this.activeClassName);
            const item = this.tabList?.item(index);
            if (!item) return;
            item.classList.remove(this.activeClassName);
        });
    }
    toggleRequiredAttribute(index) {
        if (!this.tabContentList) return;
        const currentElement = this.tabContentList.item(index);
        const contentList = Array.from(this.tabContentList);
        const filteredList = contentList.filter((element)=>element !== currentElement);
        filteredList.forEach((element)=>{
            const fieldElements = element.querySelectorAll('input[required]');
            fieldElements.forEach((fieldElement)=>{
                fieldElement.required = false;
                fieldElement.setAttribute('data-tk-is-required', '');
            });
        });
        const fieldElements = currentElement?.querySelectorAll('input[data-tk-is-required]');
        fieldElements?.forEach((fieldElement)=>{
            fieldElement.required = true;
            fieldElement.removeAttribute('data-tk-is-required');
        });
    }
}








class $ad2181492f474118$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.isAsyncTile = Boolean(this.closest('[data-tk-product-tile][data-tk-url]'));
        this.articleList = this.closest('[data-tk-article-list]') || undefined;
        this.asyncURL = this.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.source = this.getAttribute('data-tk-source') || '';
        this.catItemId = this.getAttribute('data-tk-cat-item-id') || '';
        this.articleId = this.getAttribute('data-tk-article-id') || '';
        this.stockType = this.getAttribute('data-tk-stock-type') || '';
        this.stockLocation = this.getAttribute('data-tk-stock-location') || '';
        this.dispo = this.getAttribute('data-tk-dispo') || '';
        this.dispoDate = this.getAttribute('data-tk-dispo-date') || '';
        this.loadingType = this.getAttribute('data-tk-loading-type') || '';
        this.asyncTemplate = this.getAttribute('data-tk-async-template') || '';
        this.stockPeriodType = this.getAttribute('data-tk-stock-period-type') || '1';
        this.artUnitType = this.getAttribute('data-tk-art-unit-type') || '3';
    }
    connectedCallback() {
        const item = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            stockPeriodType: this.stockPeriodType,
            artUnitType: this.artUnitType,
            element: this
        };
        if (this.articleList && !this.isAsyncTile) this.sendDataToArticleList(item);
        else this.handleStock(item);
    }
    sendDataToArticleList(item) {
        this.articleList.addStock(item);
    }
    handleStock(item) {
        const items = this.asyncURL === (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true) ? $ad2181492f474118$export$2e2bcd8739ae039.getItemsAsJSONString([
            item
        ]) : $ad2181492f474118$export$2e2bcd8739ae039.getItemsAsEntrypoint([
            item
        ]);
        const data = {
            type: 'stock',
            ...items
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            payload: data,
            resolveHandler: this.handleResponse.bind(this)
        });
    }
    static getItemsAsEntrypoint(data) {
        const items = [];
        const articles = [];
        data.forEach((item)=>{
            items.push([
                item.articleId,
                item.stockType,
                item.stockLocation,
                item.stockPeriodType,
                item.dispoDate,
                item.artUnitType
            ].join(','));
            articles.push(item.articleId);
        });
        return {
            items: items.join(','),
            articles: articles.join(',')
        };
    }
    static getItemsAsJSONString(data) {
        const items = [];
        data.forEach((item)=>{
            items.push({
                source: item.source,
                catitemboid: item.catItemId,
                catitemartinternalno: item.articleId,
                stocktype: item.stockType,
                stockloc: item.stockLocation,
                dispo: item.dispo,
                dispodate: item.dispoDate,
                loadingtype: item.loadingType,
                template: item.asyncTemplate
            });
        });
        return {
            catitems: JSON.stringify({
                items: items
            })
        };
    }
    handleResponse(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== 1) return;
        const list = response.dataAsJson.items;
        const responseItem = list[0];
        const item = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            element: undefined
        };
        this.refreshStock(item, responseItem);
    }
    refreshStock(_item, responseItem) {
        const { html: html } = responseItem;
        if (!html) return;
        const htmlString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(html) ? (0, $fbcf93c2a0aa5bcb$export$c537b38001c583b7)(html) : html;
        const tooltip = this.querySelector('tk-tooltip');
        tooltip && tooltip.remove();
        this.insertAdjacentHTML('beforeend', htmlString);
    }
}


var $6406837936bc2cfc$var$ArticleDataType = /*#__PURE__*/ function(ArticleDataType) {
    ArticleDataType["PRICE"] = "price";
    ArticleDataType["STOCK"] = "stock";
    return ArticleDataType;
}($6406837936bc2cfc$var$ArticleDataType || {});
class $6406837936bc2cfc$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.prices = [], this.stocks = [], this.isCustomPriceURL = false, this.isCustomStockURL = false;
    }
    addPrice(item) {
        this.prices.push(item);
        this.handlePrice();
    }
    addStock(item) {
        this.stocks.push(item);
        this.handleStock();
    }
    handlePrice() {
        const elements = this.querySelectorAll('[data-tk-price-wrapper]');
        const filteredList = Array.from(elements).filter((element)=>!element.closest('[data-tk-product-tile][data-tk-url]'));
        if (filteredList.length !== this.prices.length) return;
        const url = filteredList.at(0)?.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.isCustomPriceURL = url !== (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshPriceData.bind(this),
            payload: this.getPreparedData("price")
        });
    }
    handleStock() {
        const elements = this.querySelectorAll('[data-tk-stock-wrapper]');
        const filteredList = Array.from(elements).filter((element)=>!element.closest('[data-tk-product-tile][data-tk-url]'));
        if (filteredList.length !== this.stocks.length) return;
        const url = filteredList.at(0)?.getAttribute('data-tk-async-url') || (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        this.isCustomStockURL = url !== (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshStockData.bind(this),
            payload: this.getPreparedData("stock")
        });
    }
    getPreparedData(type) {
        return {
            type: type,
            ...this.getListByType(type)
        };
    }
    getListByType(type) {
        const handler = {
            price: ()=>this.getPriceData(),
            stock: ()=>this.getStockData()
        };
        return handler[type]();
    }
    getPriceData() {
        const items = this.isCustomPriceURL ? (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039).getItemsAsEntrypoint(this.prices) : (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039).getItemsAsJSONString(this.prices);
        return items;
    }
    getStockData() {
        const items = this.isCustomStockURL ? (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsEntrypoint(this.stocks) : (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsJSONString(this.stocks);
        return items;
    }
    refreshPriceData(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== this.prices.length) return;
        const list = response.dataAsJson.items;
        this.prices.forEach((item, index)=>{
            const responseItem = list[index];
            const { element: element } = item;
            element && element.refreshPrice(item, responseItem);
        });
    }
    refreshStockData(response) {
        if (!response || !response.success) return;
        if (response.dataAsJson.items?.length !== this.stocks.length) return;
        const list = response.dataAsJson.items;
        this.stocks.forEach((item, index)=>{
            const responseItem = list[index];
            const { element: element } = item;
            element && element.refreshStock(item, responseItem);
        });
    }
}







var $2c226fea39ede692$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["ADD"] = "add";
    Actions["ADDED"] = "added";
    Actions["DELETED"] = "deleted";
    Actions["MOVED"] = "moved";
    Actions["MOVE"] = "move";
    return Actions;
}({});
class $2c226fea39ede692$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector('button') || undefined;
        this.artBoId = this.getAttribute('data-tk-art-bo-id') || '';
        this.type = this.getAttribute('data-tk-type') || '';
        this.artNumber = this.getAttribute('data-tk-art-number') || '';
        this.asyncCountId = this.getAttribute('data-tk-async-count-id') || '';
        this.multiFavoritesAction = this.getAttribute('data-tk-multi-favorites-action') || '';
        this.onList = this.getAttribute('data-tk-on-list') || '';
        this.saldocBoIdTarget = this.getAttribute('data-tk-saldoc-bo-id-target') || '';
        this.saldocBoIdSource = this.getAttribute('data-tk-saldoc-bo-id-source') || '';
        this.maxList = Number(this.getAttribute('data-tk-max-list'));
        this.maxPosition = Number(this.getAttribute('data-tk-max-position'));
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-button--selected';
        this.listName = this.getAttribute('data-tk-list-name') || '';
        this.selectedOption = Number(this.getAttribute('data-tk-selected-option')) || 1;
        this.isGuestUser = this.hasAttribute('data-tk-guest-user');
    }
    connectedCallback() {
        if (!this.button) throw new Error('Favorite: Button is missing!');
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.send.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    async send(event) {
        const formValidator = this.closest('[data-tk-form-validator]');
        const formElement = formValidator?.form;
        if (formElement) {
            const formData = new FormData(formElement);
            const optionElements = formElement.querySelectorAll('input[name="favorite-option"]');
            const optionElementList = Array.from(optionElements);
            const selectedOptionIndex = optionElementList.findIndex((element)=>element.checked);
            // if the selected option is `existing`, then take the `saldocBoIdTarget`
            if (selectedOptionIndex === this.selectedOption) {
                const selectElement = formElement.querySelector('select');
                const selectedOption = selectElement?.selectedOptions.item(0);
                this.saldocBoIdTarget = selectedOption?.getAttribute('data-tk-saldoc-bo-id-target') || '';
            }
            if (this.listName === '') {
                const { length: length } = formData.getAll('field-name');
                this.listName = length > 1 ? formData.getAll('field-name')?.at(selectedOptionIndex)?.toString() || '' : formData.get('field-name')?.toString() || '';
            } else this.listName = formData.get('field-name')?.toString() || '';
            if (this.multiFavoritesAction === "added" || this.multiFavoritesAction === "moved") this.checkMaximum(formElement, selectedOptionIndex);
            await this.saveListToSessionVar(this.listName);
        }
        const isFormValid = await formValidator?.isFormValid();
        if (formValidator && !isFormValid) return;
        const data = {
            Type: 'favorite',
            ArtFavorite_ArtNo: this.artNumber,
            ArtFavorite_ArtBoId: this.artBoId,
            ArtFavorite_ListName: this.listName,
            ArtFavorite_MultiAction: this.multiFavoritesAction,
            ArtFavorite_OnList: this.onList,
            ArtFavorite_SalDocBoIdSource: this.saldocBoIdSource,
            ArtFavorite_SalDocBoIdTarget: this.saldocBoIdTarget,
            maxLists: String(this.maxList),
            maxPositions: String(this.maxPosition)
        };
        Object.keys(this.dataset).filter((key)=>key.startsWith('opSaldocitem.')).forEach((key)=>{
            data[key.substring(2).toLowerCase()] = this.dataset[key];
        });
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)();
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshContent.bind(this, event),
            payload: data,
            showMessages: false
        });
    }
    refreshContent(event, response) {
        if (!response) return;
        if (response.success && response.messages?.length === 0 && (response.dataAsJson.action === "add" || response.dataAsJson.action === "move")) {
            if (this.isGuestUser && this.listName !== '') {
                const html = document.createElement('div');
                html.innerHTML = response.dataAsJson.message;
                const favoriteButton = html.querySelector('[data-tk-saldoc-bo-id-target]');
                const saldocBoIdTarget = favoriteButton?.getAttribute('data-tk-saldoc-bo-id-target');
                const saldocBoId = favoriteButton?.getAttribute('data-tk-saldoc-bo-id');
                saldocBoIdTarget && (this.saldocBoIdTarget = saldocBoIdTarget);
                this.multiFavoritesAction = "added";
                this.setAttribute('data-tk-on-list', `#${saldocBoId}#`);
                this.setAttribute('data-tk-saldoc-bo-id-target', this.saldocBoIdTarget);
                this.send(event);
            } else {
                const { message: message } = response.dataAsJson;
                const dialog = (0, $2215c02a950e9fbf$export$2e2bcd8739ae039).renderDialog({
                    content: message,
                    className: 'tk-dialog tk-dialog--max-width',
                    tag: 'dialog'
                });
                const favoriteButton = dialog.querySelector('tk-favorite-button');
                if (favoriteButton) favoriteButton.addButton = this;
                dialog.showModal();
                this.pushListener({
                    event: 'close',
                    element: dialog,
                    action: ()=>dialog.remove()
                });
            }
        } else {
            const dialog = this.closest('dialog');
            const { action: action, artBoId: artBoId, favoriteCount: favoriteCount } = response.dataAsJson;
            action !== "added" && dialog?.close();
            const actionHandler = {
                added: ()=>this.addedItem(response),
                deleted: ()=>this.deleteArticle(artBoId, response),
                moved: ()=>this.deleteArticle(artBoId, response),
                ["add"] () {
                    throw new Error('Function not implemented.');
                },
                ["move"] () {
                    throw new Error('Function not implemented.');
                }
            };
            actionHandler[action]();
            if (this.isGuestUser) return;
            $2c226fea39ede692$export$2e2bcd8739ae039.syncInfo(favoriteCount);
        }
    }
    addedItem(response) {
        const { messages: messages } = response;
        const dialog = this.closest('dialog');
        // check for empty value
        if (!response.dataAsJson.salDocName) return;
        dialog?.close();
        messages?.forEach((message)=>{
            (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(message);
        });
        if (this.addButton) {
            this.addButton.setAttribute('data-tk-on-list', response.dataAsJson.onList);
            this.addButton.button.classList.add(this.activeClassName);
            this.addButton.onList = response.dataAsJson.onList;
        }
        this.button.setAttribute('data-tk-on-list', response.dataAsJson.onList);
        this.button.classList.add(this.activeClassName);
        this.onList = response.dataAsJson.onList;
        this.saldocBoIdTarget = response.dataAsJson.salDocBoIdTarget;
        this.setAttribute('data-tk-multi-favorites-action', 'added');
        $2c226fea39ede692$export$2e2bcd8739ae039.updateItemsCount(this.multiFavoritesAction);
        if (this.isGuestUser) {
            console.log('set multiFavoritesAction to deleted');
            this.setAttribute('data-tk-multi-favorites-action', 'deleted');
            this.multiFavoritesAction = "deleted";
        }
        this.pushTrackItem(response.dataAsJson);
    }
    deleteArticle(id, response) {
        const article = document.querySelector(`[data-tk-article-id="${id}"]`);
        if (!article) return;
        if (article.getAttribute('data-tk-item-number')) {
            article.remove();
            const contextMenu = this.closest('[data-tk-context-items]');
            if (!contextMenu) return;
            contextMenu.remove();
            $2c226fea39ede692$export$2e2bcd8739ae039.syncCounter();
        }
        $2c226fea39ede692$export$2e2bcd8739ae039.updateItemsCount(this.multiFavoritesAction);
        this.button?.removeAttribute('data-tk-on-list');
        this.button?.classList.remove(this.activeClassName);
        this.removeAttribute('data-tk-on-list');
        this.setAttribute('data-tk-multi-favorites-action', 'add');
        this.multiFavoritesAction = "add";
        this.saldocBoIdTarget = '';
        const { messages: messages } = response;
        messages?.forEach((message)=>{
            (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(message);
        });
    }
    checkMaximum(formElement, selectedOptionIndex) {
        // if the selected option is `existing`, check positions
        const selectElement = formElement.querySelector('select');
        const selectedOption = selectElement?.selectedOptions.item(0);
        const countPositions = Number(selectedOption?.getAttribute('data-tk-saldoc-count-positions'));
        if (selectedOptionIndex === 0 && countPositions > this.maxPosition) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, 'Maximum erreicht an Positionen.');
            throw new Error('Rechead maximum of positions in this list');
        }
    }
    pushTrackItem(data) {
        const { action: action, artNo: artNo } = data;
        const trackerElement = document.querySelector('[data-tk-tracker-wrapper]');
        trackerElement?.dispatchEvent(new CustomEvent('tk-tracking-push', {
            detail: {
                type: (0, $588d148f2c9ac202$export$4120f82005ec4b2d).FAVORITE_UPDATE,
                item: {
                    action: action,
                    location: window.location.href,
                    category: 'Wishlist',
                    name: artNo,
                    value: '1'
                }
            }
        }));
    }
    /**
     * Save last used favorite list in session variable
     * to preselect it when adding another article to favorites
     */ async saveListToSessionVar(listName) {
        const url = this.getAttribute('data-tk-sessionvar-url');
        if (!url) return;
        const data = {
            listName: listName
        };
        await (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: ()=>null,
            payload: data,
            showMessages: false
        });
    }
    static syncCounter() {
        const counterElement = document.querySelector('[data-tk-favorite-counter]');
        const listElement = document.querySelector('[data-tk-article-list-grid]');
        if (!counterElement || !listElement) return;
        counterElement.textContent = String(listElement.childElementCount);
    }
    static syncInfo(quantity) {
        const infoElement = document.querySelector('[data-tk-favorite-info]');
        if (!infoElement) return;
        infoElement.setAttribute('data-tk-quantity', String(quantity));
    }
    static updateItemsCount(action) {
        // TODO: After the next WAS update, the item count should be included in the response when not logged in. Until then workaround with + 1
        const favoriteInfoElement = document.querySelector('[data-tk-favorite-info]');
        if (!favoriteInfoElement) return;
        const previousItemscount = favoriteInfoElement.getAttribute('data-tk-quantity') ? parseInt(favoriteInfoElement.getAttribute('data-tk-quantity'), 10) : 0;
        favoriteInfoElement.setAttribute('data-tk-quantity', (action === "deleted" ? previousItemscount - 1 : previousItemscount + 1).toString());
    }
}



class $38c77688df6cd108$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static{
        this.observedAttributes = [
            'data-tk-quantity'
        ];
    }
    constructor(){
        super();
        this.anchor = this.querySelector('a') || undefined;
        this.counter = this.anchor?.querySelector('[data-tk-counter-info') || undefined;
        this.quantity = Number(this.getAttribute('data-tk-quantity'));
        this.isMulti = this.hasAttribute('data-tk-is-multi');
        this.href = this.getAttribute('data-tk-href') || '';
        this.emptyClassName = this.getAttribute('data-tk-empty-class-name') || 'tk-button__counter--empty';
    }
    attributeChangedCallback(name, _oldValue, newValue) {
        if (name === 'data-tk-quantity' && this.counter) {
            if (!this.anchor) return;
            this.anchor.setAttribute('data-count', newValue);
            if (Number(newValue) === 0) this.counter?.classList.add(this.emptyClassName);
            else {
                this.counter?.classList.remove(this.emptyClassName);
                this.counter.textContent = newValue;
            }
        }
    }
}



var $9a3403e3213d867d$var$HoverState = /*#__PURE__*/ function(HoverState) {
    HoverState["ACTIVE"] = "active";
    HoverState["INACTIVE"] = "inactive";
    return HoverState;
}($9a3403e3213d867d$var$HoverState || {});
class $9a3403e3213d867d$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.fieldElement = this.querySelector('input, select, textarea');
        this.labelElement = this.querySelector('label') || undefined;
        this.isMaterial = this.hasAttribute('data-tk-is-material');
        this.materialClass = this.getAttribute('data-tk-material-class') || 'tk-form-material';
        this.materialNumberInputClass = this.getAttribute('data-tk-material-number-input-class') || 'tk-form-material--number';
        this.materialLabelInsideClass = this.getAttribute('data-tk-material-label-inside-class') || 'tk-form-material--label-inside';
        this.materialSelectFocussedClass = this.getAttribute('data-tk-material-select-focussed-class') || 'tk-form-select--focussed';
        this.materialLoadedClass = this.getAttribute('data-tk-material-loaded-class') || 'tk-form-material--loaded';
        this.isPasswordInput = this.hasAttribute('data-tk-toggle-password');
        this.disableOnAddonClick = this.hasAttribute('data-tk-disable-on-addon-click');
        this.addonElement = this.querySelector('[data-tk-addon]') || undefined;
        this.waitForSurroundingContent = this.closest('[data-wait-for-surrounding-content]') || undefined;
        this.addonSuffixDistance = 0;
        this.addonPrefixDistance = 0;
        this.addonDefaultPadding = parseInt(this.getAttribute('data-tk-addon-default-padding') || '0', 10) || 4;
        this.onTransitionEnd = ()=>{};
        this.isBoolean = this.hasAttribute('data-tk-boolean');
        this.checkboxElement = this.querySelector('input[type="checkbox"]') || undefined;
        this.hiddenElement = this.querySelector('input[type="hidden"]') || undefined;
        this.defaultValue = this.hiddenElement?.value || '0';
        this.mask = this.getAttribute('data-tk-mask') || undefined;
        this.hintMaxLength = Number(this.getAttribute('data-tk-hint-max-length')) || undefined;
        this.hintWarningClassName = this.getAttribute('data-tk-hint-warning-class-name') || 'text--warning';
        this.hintCriticalClassName = this.getAttribute('data-tk-hint-critical-class-nameh') || 'text--error';
    }
    connectedCallback() {
        if (this.isNumberInput() || this.waitForSurroundingContent) {
            this.onDomContentLoaded();
            return;
        }
        this.checkRequiredAttribute();
        this.registerAddonClickedListener();
        this.registerAddonHoverListener();
        this.registerShowPasswordClickedListener();
        this.initMaterialInput();
        this.observeDisabledAttribute();
        this.registerMaskListener();
        this.registerHintMaxLengthListener();
        if (!this.isBoolean) return;
        this.registerBooleanListener();
        this.checkboxElement && this.toggleBoolean(this.checkboxElement);
    }
    /**
     * For the Material Number Input or forms inside of tables, it is necessary that all surrounding elements have been
     * fullyloaded before the Material Number Element itself is displayed.
     * This is because the position of the label in the collapsed state
     * needs to be calculated for the Material Number Input. This calculation depends on the surrounding elements
     */ onDomContentLoaded() {
        document.addEventListener('DOMContentLoaded', ()=>{
            this.checkRequiredAttribute();
            this.registerAddonClickedListener();
            this.registerAddonHoverListener();
            this.registerShowPasswordClickedListener();
            this.initMaterialInput();
            this.observeDisabledAttribute();
        });
    }
    // #region Required
    checkRequiredAttribute() {
        if (!this.labelElement || !this.fieldElement || !this.fieldElement.hasAttribute('required')) return;
        this.labelElement.textContent = `${this.labelElement.textContent} *`;
    }
    // #endregion
    // #region disabled
    observeDisabledAttribute() {
        if (!this.fieldElement || !this.labelElement) return;
        // inital check
        this.checkDisabledAttribute();
        const observerConfig = {
            attributes: true,
            attributeFilter: [
                'disabled'
            ]
        };
        const onCheckDiabledAttribute = this.checkDisabledAttribute.bind(this);
        const observer = new MutationObserver(onCheckDiabledAttribute);
        observer.observe(this.fieldElement, observerConfig);
    }
    checkDisabledAttribute() {
        const addDisabledClass = this.fieldElement.hasAttribute('disabled');
        this.classList.toggle('tk-form-input--disabled', addDisabledClass);
    }
    // #endregion
    // #region Addon
    registerAddonClickedListener() {
        if (!this.addonElement || this.disableOnAddonClick) return;
        const addonClickHandler = this.onAddonClicked.bind(this);
        this.pushListener({
            event: 'click',
            element: this.addonElement,
            action: addonClickHandler
        });
    }
    registerAddonHoverListener() {
        if (!this.addonElement) return;
        const onHoverStartHandler = this.onAddonHover.bind(this, "active");
        this.pushListener({
            event: 'mouseenter',
            element: this.addonElement,
            action: onHoverStartHandler
        });
        const onHoverEndHandler = this.onAddonHover.bind(this, "inactive");
        this.pushListener({
            event: 'mouseleave',
            element: this.addonElement,
            action: onHoverEndHandler
        });
    }
    registerBooleanListener() {
        if (!this.checkboxElement || !this.hiddenElement) return;
        const onInput = this.handleBoolean.bind(this);
        this.pushListener({
            event: 'input',
            element: this.checkboxElement,
            action: onInput
        });
    }
    registerHintMaxLengthListener() {
        if (!this.fieldElement || !this.hintMaxLength) return;
        const action = this.handleHintMaxLength.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: action
        });
    }
    handleBoolean(event) {
        const target = event.target;
        this.toggleBoolean(target);
    }
    toggleBoolean(element) {
        if (element.checked) this.hiddenElement.value = element.value;
        else this.hiddenElement.value = this.defaultValue;
    }
    onAddonHover(hoverState) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error('No Input element found');
        this.classList.toggle('tk-form--addon-hover', hoverState === "active" && !this.fieldElement.disabled);
    }
    onAddonClicked() {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement) && !(this.fieldElement instanceof HTMLTextAreaElement)) throw new Error('No Input element found');
        if (this.isPasswordInput) return;
        this.fieldElement.focus();
        const lastCharPosition = this.fieldElement.value.length;
        const isNumberInput = this.fieldElement.type === 'number';
        if (isNumberInput) this.fieldElement.setAttribute('type', 'text');
        this.fieldElement.setSelectionRange(lastCharPosition, lastCharPosition);
        if (isNumberInput) this.fieldElement.setAttribute('type', 'number');
    }
    registerShowPasswordClickedListener() {
        if (!this.isPasswordInput || !this.addonElement) return;
        const passwordShowClickHandler = this.onPasswordShowClicked.bind(this);
        this.pushListener({
            event: 'mousedown',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'mouseup',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'touchstart',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
        this.pushListener({
            event: 'touchend',
            element: this.addonElement,
            action: passwordShowClickHandler
        });
    }
    onPasswordShowClicked(event) {
        if (!this.fieldElement || !(this.fieldElement instanceof HTMLInputElement)) throw new Error('Missing input element');
        if (event.type === 'mousedown' || event.type === 'touchstart') this.fieldElement.type = 'text';
        else this.fieldElement.type = 'password';
    }
    // #endregion
    // #region Material
    initMaterialInput() {
        if (!this.isMaterial) return;
        if (!this.fieldElement) throw new Error('No element found');
        this.classList.add(this.materialClass);
        if (this.isNumberInput()) this.classList.add(this.materialNumberInputClass);
        this.registerLabelTransitionEndListener();
        this.calculateAddonWidth();
        this.setMaterialLabelState();
        this.registerMaterialValueChangeListener();
        this.registerMaterialSelectFocusChangeListener();
    }
    /**
     * This function is mainly used to check whether a valid value has been
     * set for the data-tk-addon attribute
     * @returns addonType: string representing the addon type
     */ getAddonType() {
        if (!this.addonElement) throw new Error('Missing addon');
        const addonType = this.addonElement.getAttribute('data-tk-addon');
        if (addonType !== 'prefix' && addonType !== 'suffix') throw new Error('Wrong addon type');
        return addonType;
    }
    /**
     * Checks whether the element contains a value or not. This information is required
     * to determine whether the label should be displayed inside or outside the element.
     * @returns isEmptyElement: boolean
     */ checkForValue() {
        let isEmptyElement;
        if (this.fieldElement instanceof HTMLSelectElement) {
            const selectedOption = this.querySelector('option:checked');
            const isPlaceholderOption = selectedOption?.hasAttribute('data-tk-empty-option');
            isEmptyElement = isPlaceholderOption;
        } else isEmptyElement = this.fieldElement?.value === '';
        return isEmptyElement;
    }
    /**
     * This function implements the material functionality by displaying the label either
     * inside or outside the control, depending on the content
     */ setMaterialLabelState() {
        // check input value
        const isEmptyMaterialInput = this.checkForValue();
        if (isEmptyMaterialInput) {
            this.classList.add(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error('Missing label element');
            if (this.isNumberInput()) this.setupMaterialNumberLabelStyle();
            if (!this.isNumberInput()) this.setupMaterialDefaultLabelStyle();
        } else {
            this.classList.remove(this.materialLabelInsideClass);
            if (!this.labelElement) throw new Error('Missing label element');
            this.labelElement.removeAttribute('style');
        }
    }
    /**
     * This function calculates the label position for a material input that is not of type
     * number and where the label is located within the input
     */ setupMaterialDefaultLabelStyle() {
        if (this.addonPrefixDistance === 0 && this.addonSuffixDistance === 0) return;
        this.labelElement.style.marginLeft = this.addonPrefixDistance > 0 ? `${this.addonPrefixDistance + this.addonDefaultPadding}px` : '0px';
        this.labelElement.style.marginRight = this.addonSuffixDistance > 0 ? `${this.addonSuffixDistance + this.addonDefaultPadding}px` : '0px';
        this.labelElement.style.paddingInline = '0';
    }
    /**
     * This function calculates the label position for a material input of type Number where
     *  the label is located within the input
     */ setupMaterialNumberLabelStyle() {
        this.labelElement.style.paddingInline = '0';
        const labelWidthWithPadding = this.labelElement.getBoundingClientRect().width;
        const computedLabelStyle = window.getComputedStyle(this.labelElement);
        const labelPaddingLeft = parseFloat(computedLabelStyle.paddingLeft);
        const labelPaddingRight = parseFloat(computedLabelStyle.paddingRight);
        const labelWidth = labelWidthWithPadding - labelPaddingLeft - labelPaddingRight;
        const formControlWidth = this.getBoundingClientRect().width;
        const computetInputStyle = window.getComputedStyle(this.fieldElement);
        const inputPaddingRight = parseFloat(computetInputStyle.paddingRight);
        const addonWidth = this.addonElement && this.getAddonType() === 'suffix' ? this.addonElement.getBoundingClientRect().width : 0;
        const xOffset = Math.round(formControlWidth - labelWidth - addonWidth - inputPaddingRight);
        this.labelElement.style.paddingLeft = `${xOffset}px`;
    }
    /**
     * This function checks whether the current control has an addon. If so, depending
     * on the type of control, it checks whether the material label requires additional
     * spacing in the folded state
     */ calculateAddonWidth() {
        if (!this.addonElement) return;
        if (this.fieldElement instanceof HTMLSelectElement) return;
        /* The text is displayed right-aligned for the number inputs.
        They must therefore be treated separately */ const isNumberInput = this.isNumberInput();
        const addonType = this.getAddonType();
        if (!isNumberInput && addonType === 'prefix') this.addonPrefixDistance = this.addonElement.offsetWidth;
        else if (isNumberInput && addonType === 'suffix') this.addonSuffixDistance = this.addonElement.offsetWidth;
    }
    /**
     * Checks whether the input is of type Number. This information is required because
     * the text does not start on the left when the number input is collapsed
     * @returns boolean: representing is input of type number
     */ isNumberInput() {
        if (!(this.fieldElement instanceof HTMLInputElement)) return false;
        return this.fieldElement && this.fieldElement.type === 'number';
    }
    /**
     * Listener for material control value changes
     */ registerMaterialValueChangeListener() {
        const onValueChanged = this.setMaterialLabelState.bind(this);
        this.pushListener({
            event: 'input',
            element: this.fieldElement,
            action: onValueChanged
        });
    }
    /**
     * Is required so that a class can be added to the focused material select
     * element that colors the text of the select white
     */ registerMaterialSelectFocusChangeListener() {
        if (!(this.fieldElement instanceof HTMLSelectElement)) return;
        const onFocusChanged = this.onMaterialSelectFocusChanged.bind(this);
        this.pushListener({
            event: 'focusin',
            element: this.fieldElement,
            action: onFocusChanged
        });
        this.pushListener({
            event: 'focusout',
            element: this.fieldElement,
            action: onFocusChanged
        });
    }
    /**
     * This function is used to add a class to the focused material select, which sets
     * the font to white if no option has been selected
     * @param event: Used to determin if focus has been set or removed
     */ onMaterialSelectFocusChanged(event) {
        const { type: type } = event;
        if (type === 'focusin') this.classList.add(this.materialSelectFocussedClass);
        else this.classList.remove(this.materialSelectFocussedClass);
    }
    /**
     * This function fades in the material element as soon as the label is in
     * the correct position
     */ registerLabelTransitionEndListener() {
        if (!this.labelElement) throw new Error('Missing label element');
        this.onTransitionEnd = this.addMaterialLoadedModifier.bind(this);
        this.pushListener({
            event: 'transitionend',
            element: this.labelElement,
            action: this.onTransitionEnd
        });
    }
    addMaterialLoadedModifier() {
        this.classList.add(this.materialLoadedClass);
        this.labelElement.removeEventListener('transitionend', this.onTransitionEnd);
    }
    // #endregion
    registerMaskListener() {
        if (!this.mask || !(this.fieldElement instanceof HTMLInputElement)) return;
        const options = JSON.parse(this.mask);
        const onMaskInput = this.onMaskInput.bind(this, options);
        try {
            this.pushListener({
                event: 'input',
                element: this.fieldElement,
                action: onMaskInput
            });
            this.pushListener({
                event: 'paste',
                element: this.fieldElement,
                action: onMaskInput
            });
        } catch (error) {
            console.warn('Invalid mask config:', this.mask, error);
        }
    }
    onMaskInput(options, event) {
        const target = event.currentTarget;
        if (options.type === 'slug') {
            const normalizeCharMap = {
                "\xe9": 'e',
                "\xe8": 'e',
                "\xf6": 'oe',
                "\xe4": 'ae',
                "\xfc": 'ue',
                "\xe0": 'a',
                "\xee": 'i'
            };
            const normalized = target.value.split('').map((char)=>normalizeCharMap[char] ?? char).join('');
            const value = normalized.toLowerCase().replace(/[^a-z0-9\s_-]/g, '') // only lower case letters, numbers, spaces, -, _
            .replace(/[\s_]+/g, '-') // Spaces or underscores → hyphen
            .replace(/-+/g, '-') // Avoid double hyphens
            .replace(/^-+|-+$/g, ''); // no hyphens at the beginning or end
            target.value = value;
            return;
        }
        let value = target.value.replace(/[^a-zA-Z0-9]/g, '');
        if (options.uppercase) value = value.toUpperCase();
        const result = [];
        let idx = 0;
        for(let i = 0; i < options.blocks.length; i++){
            const blockLen = options.blocks[i];
            const part = value.substring(idx, idx + blockLen);
            if (!part) break;
            result.push(part);
            idx += blockLen;
        }
        const withDelimiters = result.map((part, i)=>{
            if (i < options.delimiters.length) return part + options.delimiters[i];
            return part;
        });
        target.value = withDelimiters.join('').substring(0, target.maxLength || 100);
    }
    handleHintMaxLength(event) {
        if (!this.hintMaxLength) return;
        const target = event.currentTarget;
        const length = target.value.length;
        const wrapperElement = this.querySelector('[data-tk-hint-max-length-wrapper]');
        const counterElement = this.querySelector('[data-tk-hint-max-length-counter]');
        if (!wrapperElement || !counterElement) return;
        counterElement.textContent = String(length);
        wrapperElement.classList.toggle(this.hintWarningClassName, length >= this.hintMaxLength * 0.9);
        wrapperElement.classList.toggle(this.hintCriticalClassName, length >= this.hintMaxLength);
    }
}








class $cb17fd7e698c018c$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.listWrapperClassName = this.getAttribute('data-tk-zip-list-class') || 'tk-form-zipcity__list';
        this.fieldCountry = this.querySelector('[data-tk-zip-country]') || undefined;
        this.fieldZip = this.querySelector('[data-tk-zip-zip]') || undefined;
        this.fieldCity = this.querySelector('[data-tk-zip-city]') || undefined;
        this.lastSearchTerm = '';
        this.selectedField = undefined;
        this.listWrapper = document.createElement('div');
        this.listWrapper.classList.add(this.listWrapperClassName);
        this.listWrapper.hidden = true;
        this.loadingSpinnerTimeout = null;
        this.clearDataTimeout = null;
        this.inputObject = {
            inputField: undefined,
            dropdown: this.listWrapper,
            listItemSelected: undefined,
            data: []
        };
    }
    connectedCallback() {
        this.registerListener();
    }
    registerListener() {
        if (!this.fieldZip && !this.fieldCity) return;
        const onInputHandler = this.searchZipCity.bind(this);
        const onClickHandler = this.toggleDropdown.bind(this);
        const onSelectHandler = this.selectItem.bind(this);
        const onChangeHandler = this.clearFormFields.bind(this);
        const onInputKeyNavigationHandler = this.inputKeyNavigation.bind(this);
        const onDropdownKeyNavigationHandler = this.dropdownKeyNavigation.bind(this);
        this.pushListener({
            event: 'click',
            element: this.fieldZip,
            action: onClickHandler
        });
        this.pushListener({
            event: 'click',
            element: this.fieldCity,
            action: onClickHandler
        });
        this.pushListener({
            event: 'click',
            element: this.inputObject.dropdown,
            action: onSelectHandler
        });
        this.pushListener({
            event: 'input',
            element: this.fieldZip,
            action: onInputHandler
        });
        this.pushListener({
            event: 'input',
            element: this.fieldCity,
            action: onInputHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.fieldZip,
            action: onInputKeyNavigationHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.fieldCity,
            action: onInputKeyNavigationHandler
        });
        this.pushListener({
            event: 'keydown',
            element: this.inputObject.dropdown,
            action: onDropdownKeyNavigationHandler
        });
        if (this.fieldCountry) this.pushListener({
            event: 'change',
            element: this.fieldCountry,
            action: onChangeHandler
        });
    }
    inputKeyNavigation(event) {
        if (!(event.code === 'Tab' || event.code === 'Enter' || event.code === 'ArrowDown')) return;
        this.inputObject.listItemSelected = this.inputObject.dropdown?.firstElementChild;
        if (!this.inputObject.listItemSelected) return;
        this.inputObject.dropdown?.classList.remove('hide');
        this.inputObject.listItemSelected.focus();
        event.preventDefault();
    }
    dropdownKeyNavigation(event) {
        const keyActions = {
            ArrowDown: ()=>this.handleArrowKey(true),
            ArrowUp: ()=>this.handleArrowKey(false),
            Enter: ()=>this.selectItem(event),
            Space: ()=>this.selectItem(event),
            Tab: ()=>this.hideDropdown(true),
            Escape: ()=>this.hideDropdown(true)
        };
        const action = keyActions[event.code];
        if (!action) return;
        action();
        event.preventDefault();
    }
    handleArrowKey(isDown) {
        if (this.inputObject.listItemSelected) {
            const nextElement = isDown ? this.inputObject.listItemSelected.nextElementSibling : this.inputObject.listItemSelected.previousElementSibling;
            if (nextElement instanceof HTMLElement) this.inputObject.listItemSelected = nextElement;
        } else this.inputObject.listItemSelected = this.inputObject.dropdown?.firstElementChild;
        if (!this.inputObject.listItemSelected) return;
        this.inputObject.listItemSelected.focus();
        this.setScroller();
    }
    hideDropdown(isHidden = false) {
        if (this.inputObject.dropdown) {
            if (!isHidden) {
                this.showLoadingAnimation();
                this.listWrapper.style.border = 'unset';
            }
            this.inputObject.dropdown.hidden = isHidden;
        }
    }
    toggleDropdown() {
        if (this.inputObject.dropdown && this.inputObject.dropdown.hasChildNodes()) this.inputObject.dropdown.hidden = !this.inputObject.dropdown.hidden;
    }
    setScroller() {
        const { dropdown: dropdown, listItemSelected: listItemSelected } = this.inputObject;
        if (!dropdown || !listItemSelected) return;
        const index = Array.from(dropdown.children).indexOf(listItemSelected);
        const elHeight = listItemSelected.offsetHeight;
        const { scrollTop: scrollTop } = dropdown;
        const viewport = scrollTop + dropdown.offsetHeight;
        const elOffset = elHeight * index;
        if (elOffset >= scrollTop && elOffset + elHeight <= viewport) return;
        dropdown.scrollTop = elOffset;
    }
    setInputObject() {
        if (!this.selectedField?.parentElement?.querySelector(`.${this.listWrapperClassName}`)) this.selectedField?.insertAdjacentElement('afterend', this.listWrapper);
        this.inputObject.inputField = this.selectedField;
    }
    searchZipCity(event) {
        this.selectedField = event.target;
        const value = this.selectedField.value.trim();
        if (value.length < 2) {
            this.clearDataTimeout && clearTimeout(this.clearDataTimeout);
            this.clearDataTimeout = setTimeout(()=>{
                this.clearData();
            }, 300);
            return;
        }
        this.lastSearchTerm = value;
        this.setInputObject();
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.callApi(value);
        }, 300);
    }
    callApi(value) {
        if (!this.inputObject.dropdown) return;
        this.hideDropdown(false);
        if (this.lastSearchTerm !== value) return;
        const zipCity = this.parseZipCity(value);
        const apiUrl = `${window.location.origin}/api/portal/v1/zipsearch`;
        const urlObject = new URL(apiUrl);
        const { searchParams: searchParams } = urlObject;
        Object.entries(zipCity).forEach(([key, value])=>{
            searchParams.set(key, value);
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: urlObject.toString(),
            resolveHandler: this.refreshResultList.bind(this),
            decodeJSONResponse: false
        });
    }
    parseZipCity(value) {
        let zip;
        let city;
        const country = this.fieldCountry?.value?.toLowerCase() || 'ch';
        const arr = value.split(' ');
        const numberRegex = /^[0-9]+$/;
        const regexTest = arr.find((elem)=>numberRegex.test(elem));
        if (regexTest === undefined) zip = '';
        else zip = regexTest;
        if (!zip) {
            if (arr.length > 1) zip = +arr[1] || '';
        }
        zip = zip.toString();
        city = value.replace(zip, '').trim();
        if (city === 'undefined') city = '';
        return {
            zip: zip,
            city: city,
            country: country
        };
    }
    refreshResultList(response) {
        if (!response) return;
        this.clearData();
        if (Array.isArray(response)) response.forEach((element)=>{
            const listItemTpl = `
                <button type="button" class="tk-form-list-item"
                    data-tk-country="${element.country}"
                    data-tk-zip="${element.zip}"
                    data-tk-city="${element.city}"
                    tabindex="-1"
                >
                    <span class="tk-form__label">
                        ${element.zip} ${element.city}
                    </span>
                </button>`;
            this.inputObject.dropdown.insertAdjacentHTML('beforeend', listItemTpl);
            this.inputObject.data?.push({
                zip: element.zip,
                city: element.city,
                country: element.country
            });
        });
        if (this.inputObject.data.length === 0) {
            const listItemTpl = `
                <div class="spacer-p-2">
                    <div class="tk-message tk-message--info tk-message--fullwidth">
                        <span class="tk-message__icon">
                            <i class="tk-icon-warning"></i>
                        </span>
                        <span class="tk-message__label">${(0, $86b3c5b6d66bd808$export$97a703132b664051).noMatchFound}</span>
                    </div>
                </div>`;
            this.inputObject.dropdown.insertAdjacentHTML('beforeend', listItemTpl);
        }
        this.listWrapper.style.border = '';
        this.loadingSpinnerTimeout && clearTimeout(this.loadingSpinnerTimeout);
        this.inputObject.dropdown.hidden = false;
    }
    selectItem(event) {
        let selectedItem = event.target;
        selectedItem = selectedItem.closest('[data-tk-zip]');
        if (!selectedItem) return;
        const zip = selectedItem.getAttribute('data-tk-zip');
        const city = selectedItem.getAttribute('data-tk-city');
        const country = selectedItem.getAttribute('data-tk-country');
        if (this.fieldZip) this.fieldZip.value = zip;
        if (this.fieldCity) this.fieldCity.value = city;
        if (this.fieldCountry) this.fieldCountry.value = country;
        this.inputObject.inputField.focus();
        this.clearData();
    }
    clearFormFields() {
        this.clearData();
        this.fieldCity.value = '';
        this.fieldZip.value = '';
    }
    clearData() {
        if (this.inputObject.dropdown) {
            this.hideDropdown(true);
            this.inputObject.dropdown.replaceChildren();
        }
        this.inputObject.data = [];
    }
    showLoadingAnimation() {
        this.loadingSpinnerTimeout && clearTimeout(this.loadingSpinnerTimeout);
        this.loadingSpinnerTimeout = setTimeout(()=>{
            this.listWrapper.innerHTML = `
                <div class="tk-progress tk-progress--infinite tk-progress--breakout">
                    <div class="tk-progress__bar"></div>
                </div>`;
        }, 300);
    }
    static async isValidZipCity(form) {
        const apiUrl = `${window.location.origin}/api/portal/v1/zipsearch`;
        const zipCityElem = {
            country: form.querySelector('[data-tk-zip-country]') || '',
            zip: form.querySelector('[data-tk-zip-zip]') || '',
            city: form.querySelector('[data-tk-zip-city]') || ''
        };
        const zipCityValue = {
            country: zipCityElem.country.value,
            zip: zipCityElem.zip.value,
            city: zipCityElem.city.value
        };
        const urlObject = new URL(apiUrl);
        const { searchParams: searchParams } = urlObject;
        Object.entries(zipCityValue).forEach(([key, value])=>{
            searchParams.set(key, value);
        });
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: urlObject.toString(),
                decodeJSONResponse: false,
                resolveHandler: (response)=>{
                    let isValid = false;
                    if (Array.isArray(response)) response.some((item)=>{
                        isValid = $cb17fd7e698c018c$export$2e2bcd8739ae039.shallowObjectEquality(zipCityValue, item);
                        return isValid;
                    });
                    resolve(isValid);
                }
            });
        });
    }
    static shallowObjectEquality(object1, object2) {
        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);
        let isEqual = true;
        if (keys1.length !== keys2.length) {
            isEqual = false;
            return isEqual;
        }
        keys1.forEach((key)=>{
            if (object1[key] !== object2[key]) {
                isEqual = false;
                return isEqual;
            }
        });
        return isEqual;
    }
}


var $21a7ddce6a8de4e2$var$matchType = /*#__PURE__*/ function(matchType) {
    matchType["Some"] = "SOME";
    matchType["Full"] = "FULLMATCH";
    return matchType;
}($21a7ddce6a8de4e2$var$matchType || {});
class $21a7ddce6a8de4e2$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.validationList = [];
        this.form = this.querySelector('form') || undefined;
        this.fieldWrapperSelector = this.getAttribute('data-tk-field-wrapper-selector') || '[data-tk-field-wrapper]';
        this.formErrorClassName = this.getAttribute('data-tk-form-error-class-name') || 'tk-form--error';
        this.fieldHintClassName = this.getAttribute('data-tk-field-hint-class-name') || 'tk-form__hint';
        this.shouldValidateInline = this.hasAttribute('data-tk-should-validate-inline');
        this.passwordStrengthMeter = this.querySelector('[data-tk-password-strength-meter]') || undefined;
        this.passwordNewElement = this.querySelector('[data-tk-password-new]') || undefined;
        this.passwordRepeatElement = this.querySelector('[data-tk-password-repeat]') || undefined;
        this.passwordValidClassName = this.getAttribute('data-tk-password-valid-class-name') || 'tk-form--valid';
        this.passwordInvalidClassName = this.getAttribute('data-tk-password-valid-class-name') || 'tk-form--invalid';
        this.googleRecaptcha = this.querySelector('[data-tk-google-recaptcha]') || undefined;
        // Selects an element that is clicked when the enter key is pressed
        this.preventEnterDefaultAction = this.getAttribute('data-tk-enter-data-attribute-selector') || undefined;
    }
    connectedCallback() {
        if (!this.form) return;
        this.validationList = [];
        this.setNoValidateForm();
        this.searchFieldElements();
        this.registerSubmitListener();
        this.registerPasswordListener();
        this.shouldValidateInline && this.registerFieldValidationListener();
    }
    setNoValidateForm() {
        if (!this.form) return;
        this.form.noValidate = true;
    }
    searchFieldElements() {
        const formElements = this.querySelectorAll('input, select, textarea');
        const formElementList = Array.from(formElements);
        const filteredFormElements = formElementList.filter((element)=>!element.disabled);
        filteredFormElements.forEach((element)=>{
            const wrapper = element.closest(this.fieldWrapperSelector);
            wrapper && this.validationList.push({
                element: element,
                wrapper: wrapper,
                messages: $21a7ddce6a8de4e2$export$2e2bcd8739ae039.generateValidityMessages(element)
            });
        });
    }
    registerSubmitListener() {
        if (!this.form) return;
        const onSubmitHandler = this.validateForm.bind(this);
        this.pushListener({
            event: 'submit',
            element: this.form,
            action: onSubmitHandler
        });
    }
    registerPasswordListener() {
        if (!(this.passwordStrengthMeter && this.passwordNewElement && this.passwordRepeatElement)) return;
        const onValidatePassword = this.validatePassword.bind(this);
        this.pushListener({
            event: 'input',
            element: this.passwordNewElement,
            action: onValidatePassword
        });
        this.pushListener({
            event: 'input',
            element: this.passwordRepeatElement,
            action: onValidatePassword
        });
    }
    registerFieldValidationListener() {
        this.validationList.forEach((item)=>{
            const onValidation = this.validateField.bind(this, item);
            this.pushListener({
                event: 'blur',
                element: item.element,
                action: onValidation
            });
            this.pushListener({
                event: 'input',
                element: item.element,
                action: onValidation
            });
        });
    }
    async validateRecaptcha() {
        if (!this.googleRecaptcha) return true;
        return new Promise((resolve)=>{
            window.grecaptcha.ready(async ()=>{
                const siteKey = this.googleRecaptcha.getAttribute('data-tk-site-key');
                if (!siteKey) return resolve(false);
                const token = await window.grecaptcha.execute(siteKey, {
                    action: 'submit'
                });
                if (!token) return resolve(false);
                this.googleRecaptcha.value = token;
                resolve(true);
            });
        });
    }
    async validateZipCity() {
        const validationList = [];
        const fieldElements = this.querySelectorAll('[data-tk-field-check-zip-city]');
        if (fieldElements.length === 0) return true;
        const apiPromises = Array.from(fieldElements).map(async (element)=>{
            const input = element.querySelector('input');
            if (!input) return true;
            const isValid = await (0, $cb17fd7e698c018c$export$2e2bcd8739ae039).isValidZipCity(this.form);
            const validationItem = this.validationList.find((item)=>item.wrapper === element);
            if (!isValid && validationItem) {
                this.removeMessage(validationItem);
                this.createElementMessage(validationItem, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).typeMismatch);
            }
            return isValid;
        });
        const results = await Promise.all(apiPromises);
        validationList.push(...results);
        return validationList.every((item)=>item);
    }
    async validateByAPI() {
        const validationList = [];
        const fieldElements = this.querySelectorAll('[data-tk-field-check-api]');
        if (fieldElements.length === 0) return true;
        const apiPromises = Array.from(fieldElements).map(async (element)=>{
            const apiURL = element.getAttribute('data-tk-field-check-api');
            const input = element.querySelector('input');
            if (!input || !apiURL || input.value === '') return true;
            const response = await $21a7ddce6a8de4e2$export$2e2bcd8739ae039.fetchExistAPI(apiURL, input.value);
            const { isValid: isValid } = response.dataAsJson;
            const validationItem = this.validationList.find((item)=>item.wrapper === element);
            if (!isValid && validationItem) {
                this.removeMessage(validationItem);
                this.createElementMessage(validationItem, (0, $86b3c5b6d66bd808$export$35e6ad2b040b8403).existigName);
            }
            return isValid;
        });
        const results = await Promise.all(apiPromises);
        validationList.push(...results);
        return validationList.every((item)=>item);
    }
    static async fetchExistAPI(url, value) {
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                payload: {
                    value: value
                },
                resolveHandler: (response)=>{
                    resolve(response);
                }
            });
        });
    }
    async validateForm(event) {
        event.preventDefault();
        const isFormValid = await this.isFormValid();
        if (!isFormValid) return;
        if (this.preventEnterDefaultAction) {
            const elemntToClick = document.querySelector(`[${this.preventEnterDefaultAction}]`);
            elemntToClick?.querySelector('button')?.click();
            return;
        }
        this.form?.submit();
    }
    async isFormValid() {
        await this.validateFields();
        const areFieldsValid = this.validationList.every((item)=>item.element.validity.valid);
        if (!areFieldsValid) return false;
        const isValid = await this.validateByAPI() && await this.validateZipCity();
        const isRecaptchaValid = await this.validateRecaptcha();
        return (!this.passwordStrengthMeter || this.checkPasswordStengthMeter()) && this.checkPasswordMatching() && isValid && isRecaptchaValid;
    }
    async validateFields() {
        this.validationList.forEach((item)=>{
            this.validateField(item);
        });
        this.firstElementToScrollTo = undefined;
    }
    validateField(item) {
        this.removeMessage(item);
        if (!item.element.validity.valid) this.showMessage(item);
    }
    showMessage(item) {
        const validityList = $21a7ddce6a8de4e2$export$2e2bcd8739ae039.createValidityDictionary(item.element);
        const invalidMessage = validityList.find((validity)=>validity.value);
        const message = invalidMessage ? item.messages.find((message)=>message.key === invalidMessage.key)?.value || '' : item.element.validationMessage;
        this.createElementMessage(item, message);
    }
    createElementMessage(item, message) {
        const spanElement = document.createElement('span');
        spanElement.classList.add(this.fieldHintClassName);
        spanElement.textContent = $21a7ddce6a8de4e2$export$2e2bcd8739ae039.replacePlaceholders(message, item.element);
        item.messageElement = spanElement;
        item.wrapper.classList.add(this.formErrorClassName);
        item.wrapper.insertAdjacentElement('beforeend', spanElement);
        if (this.firstElementToScrollTo) return;
        this.firstElementToScrollTo = item.messageElement;
        this.firstElementToScrollTo.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }
    removeMessage(item) {
        const spanElement = item.messageElement;
        if (!spanElement) return;
        spanElement.remove();
        item.wrapper.classList.remove(this.formErrorClassName);
    }
    static createValidityDictionary(element) {
        const { validity: validity } = element;
        const validityList = [];
        for(const key in validity){
            const validityItem = {
                key: key,
                value: Boolean(validity[key])
            };
            validityList.push(validityItem);
        }
        return validityList;
    }
    static generateValidityMessages(element) {
        const list = [];
        const customErrorPrefix = 'data-tk-error-msg-';
        const attributeList = element.getAttributeNames().filter((name)=>name.startsWith(customErrorPrefix));
        attributeList.forEach((key)=>{
            const keyFormatted = key.replace(customErrorPrefix, '').replace(/-./g, (x)=>x[1].toUpperCase());
            const value = element.getAttribute(key);
            value && list.push({
                key: keyFormatted,
                value: value
            });
        });
        if (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91) {
            const messages = (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91);
            Object.entries(messages).forEach((entry)=>{
                const [key, value] = entry;
                const foundMessage = list.filter((item)=>item.key === key);
                !foundMessage.length && list.push({
                    key: key,
                    value: value
                });
            });
        }
        return list;
    }
    static replacePlaceholders(value, element) {
        const dictionary = {
            '{minLength}': element.getAttribute('minlength') || '',
            '{maxLength}': element.getAttribute('maxlength') || '',
            '{length}': element.value.length.toString() || '',
            '{step}': element.getAttribute('step') || '',
            '{min}': element.getAttribute('min') || '',
            '{max}': element.getAttribute('max') || '',
            '{currentValue}': element.value
        };
        const re = new RegExp(Object.keys(dictionary).join('|'), 'gi');
        return value.replace(re, (matched)=>dictionary[matched]);
    }
    checkPasswordStengthMeter() {
        const patterns = this.getPasswordPatterns();
        return patterns.every((item)=>item.element?.classList.contains(this.passwordValidClassName));
    }
    checkPasswordMatching() {
        let isValid;
        const newPasswordItem = this.validationList.find((item)=>item.element === this.passwordNewElement);
        const repeatPasswordItem = this.validationList.find((item)=>item.element === this.passwordRepeatElement);
        if (!newPasswordItem || !repeatPasswordItem) return true;
        if (newPasswordItem.element.value !== repeatPasswordItem.element.value) {
            this.removeMessage(repeatPasswordItem);
            this.createElementMessage(repeatPasswordItem, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).passwordNotMatching);
            isValid = false;
        } else isValid = true;
        return isValid;
    }
    validatePassword(event) {
        const target = event.currentTarget;
        const patterns = this.getPasswordPatterns();
        patterns.forEach((item)=>{
            const regex = new RegExp(item.pattern || '', item.matchtype === "FULLMATCH" ? 'g' : '');
            const regexpMatch = target.value.match(regex);
            if (item.matchtype === "SOME") {
                if (regexpMatch) {
                    item.element?.classList.remove(this.passwordInvalidClassName);
                    item.element?.classList.add(this.passwordValidClassName);
                } else {
                    item.element?.classList.remove(this.passwordValidClassName);
                    item.element?.classList.add(this.passwordInvalidClassName);
                }
            }
            if (item.matchtype === "FULLMATCH") {
                if (regexpMatch?.length === target.value.length) {
                    item.element?.classList.remove(this.passwordInvalidClassName);
                    item.element?.classList.add(this.passwordValidClassName);
                } else {
                    item.element?.classList.remove(this.passwordValidClassName);
                    item.element?.classList.add(this.passwordInvalidClassName);
                }
            }
        });
    }
    getPasswordPatterns() {
        const characterPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-character-pattern]');
        const upperPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-upper-pattern]');
        const numberPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-number-pattern]');
        const allowedSymbolPatternElement = this.passwordStrengthMeter?.querySelector('[data-tk-pwd-allowed-symbols-pattern]');
        const characterPattern = characterPatternElement?.getAttribute('data-tk-pwd-character-pattern');
        const upperPattern = upperPatternElement?.getAttribute('data-tk-pwd-upper-pattern');
        const numberPattern = numberPatternElement?.getAttribute('data-tk-pwd-number-pattern');
        const allowedSymbolPattern = allowedSymbolPatternElement?.getAttribute('data-tk-pwd-allowed-symbols-pattern');
        return [
            {
                pattern: characterPattern,
                element: characterPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: upperPattern,
                element: upperPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: numberPattern,
                element: numberPatternElement,
                matchtype: "SOME"
            },
            {
                pattern: allowedSymbolPattern,
                element: allowedSymbolPatternElement,
                matchtype: "FULLMATCH"
            }
        ];
    }
}



class $7217ff2f9b2d295c$export$2e2bcd8739ae039 extends (0, $21a7ddce6a8de4e2$export$2e2bcd8739ae039) {
    validateField(item) {
        this.removeMessage(item);
        // Always check email fields first to properly clear/set custom validity
        if (item.element instanceof HTMLInputElement && item.element.type.toLowerCase() === 'email') {
            this.validateEmailField(item);
            return;
        }
        if (!item.element.validity.valid) this.showMessage(item);
    }
    validateEmailField(item) {
        const element = item.element;
        if (!(element instanceof HTMLInputElement) || element.type.toLowerCase() !== 'email') return;
        const value = element.value.trim();
        if (value === '') {
            element.setCustomValidity('');
            return;
        }
        const atIndex = value.indexOf('@');
        const dotIndex = value.lastIndexOf('.');
        const hasValidFormat = atIndex > 0 && dotIndex > atIndex + 1 && dotIndex < value.length - 1;
        if (hasValidFormat) {
            element.setCustomValidity('');
            return;
        }
        const customTypeMismatchMessage = element.getAttribute('data-tk-error-msg-type-mismatch') || '';
        const fallbackMessage = (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).typeMismatch || element.validationMessage;
        const message = customTypeMismatchMessage || fallbackMessage;
        element.setCustomValidity(message);
        this.createElementMessage(item, message);
    }
}







const $8a0ac73f21029ce5$var$FULLSCREEN_EVENT_NAME = 'tk-asset-gallery-fullscreen-update';
class $8a0ac73f21029ce5$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.isOpen = false, this.maxThumbnails = 'auto';
        this.initializeElements();
    }
    connectedCallback() {
        this.validateRequiredElements();
        this.initSwipers();
        this.setupLightbox();
        this.handleVideoSlides();
    }
    initializeElements() {
        this.previewElement = this.querySelector('[data-tk-asset-preview]') || undefined;
        this.thumbnailsElement = this.querySelector('[data-tk-asset-thumbnails]') || undefined;
        this.iframeTemplate = this.querySelector('[data-tk-iframe-template]') || undefined;
        this.fullscreenCloseButton = this.querySelector('[data-tk-close-fullscreen]') || undefined;
    }
    validateRequiredElements() {
        if (!this.previewElement || !this.thumbnailsElement) throw new Error('Asset Gallery: Missing required elements for preview or thumbnails!');
    }
    initSwipers() {
        if (!this.previewElement || !this.thumbnailsElement) return;
        this.initThumbnailsSwiper();
        this.initPreviewSwiper();
        this.setupFullscreenEventListener();
    }
    initThumbnailsSwiper() {
        if (!this.thumbnailsElement) return;
        this.thumbnailsSwiper = new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(this.thumbnailsElement, {
            modules: [
                (0, $21e2f533778c20f0$export$2e2bcd8739ae039)
            ],
            spaceBetween: 16,
            slidesPerView: 'auto',
            freeMode: true,
            watchSlidesProgress: true
        });
    }
    initPreviewSwiper() {
        if (!this.previewElement) return;
        this.previewSwiper = new (0, $029bc59d811a92d7$export$25ce5a424b770e84)(this.previewElement, {
            init: false,
            modules: [
                (0, $21e2f533778c20f0$export$2e2bcd8739ae039)
            ],
            spaceBetween: 16,
            thumbs: {
                swiper: this.thumbnailsSwiper,
                slideThumbActiveClass: 'tk-asset-gallery-item--selected'
            }
        });
        this.previewSwiper.on('afterInit', this.setupThumbnailOverflow.bind(this));
        this.previewSwiper.on('slideChange', this.stopAllClips.bind(this));
        this.previewSwiper.init();
    }
    setupFullscreenEventListener() {
        this.pushListener({
            event: $8a0ac73f21029ce5$var$FULLSCREEN_EVENT_NAME,
            element: this,
            action: (event)=>{
                this.toggleThumbnailAlignment(event.detail.isOpen);
            }
        });
    }
    toggleThumbnailAlignment(isOpen) {
        if (!this.thumbnailsSwiper) return;
        this.thumbnailsSwiper.wrapperEl.classList.toggle('flex--justify-center', isOpen);
    }
    setupLightbox() {
        if (!this.previewElement) return;
        this.pushListener({
            event: 'click',
            element: this.previewElement,
            action: this.openLightbox.bind(this)
        });
    }
    openLightbox() {
        if (this.isOpen || !this.fullscreenCloseButton) return;
        this.toggleFullscreen(true);
        this.setupCloseButtonListener();
        this.dispatchFullscreenEvent(true);
    }
    closeLightbox() {
        this.toggleFullscreen(false);
        this.dispatchFullscreenEvent(false);
    }
    toggleFullscreen(isOpen) {
        document.body.style.overflow = isOpen ? 'hidden' : '';
        this.classList.toggle('tk-asset-gallery--fullscreen', isOpen);
        if (this.fullscreenCloseButton) this.fullscreenCloseButton.hidden = !isOpen;
        this.isOpen = isOpen;
    }
    setupCloseButtonListener() {
        this.pushListener({
            event: 'click',
            element: this.fullscreenCloseButton,
            action: this.closeLightbox.bind(this)
        });
    }
    dispatchFullscreenEvent(isOpen) {
        this.dispatchEvent(new CustomEvent($8a0ac73f21029ce5$var$FULLSCREEN_EVENT_NAME, {
            detail: {
                isOpen: isOpen
            }
        }));
    }
    setupThumbnailOverflow() {
        if (!this.previewSwiper) return;
        const thumbnails = this.previewSwiper.thumbs.swiper.slides;
        if (this.maxThumbnails === 'auto') this.setupAutoThumbnailOverflow(thumbnails);
        else if (typeof this.maxThumbnails === 'number') this.setupFixedThumbnailOverflow(thumbnails);
    }
    setupAutoThumbnailOverflow(thumbnails) {
        const container = this.thumbnailsElement;
        if (!container) return;
        const resizeObserver = new ResizeObserver(()=>{
            this.handleAutoThumbnailResize(container, thumbnails);
        });
        resizeObserver.observe(container);
    }
    handleAutoThumbnailResize(container, thumbnails) {
        const availableWidth = container.clientWidth;
        let usedWidth = 0;
        let visibleCount = 0;
        const gap = Number(this.thumbnailsSwiper?.originalParams.spaceBetween);
        this.resetThumbnailVisibility(thumbnails);
        thumbnails.forEach((element)=>{
            const itemWidth = element.offsetWidth;
            const tileWithGap = itemWidth + gap;
            if (usedWidth + (tileWithGap * 2 - gap) <= availableWidth) {
                usedWidth += tileWithGap;
                element.hidden = false;
                visibleCount++;
            } else element.hidden = true;
        });
        const hiddenCount = thumbnails.length - visibleCount;
        this.renderMoreCounter(hiddenCount);
    }
    resetThumbnailVisibility(thumbnails) {
        const existingCounter = this.thumbnailsElement?.querySelector('.tk-asset-gallery-item--more');
        if (existingCounter) existingCounter.remove();
        thumbnails.forEach((element)=>element.hidden = false);
    }
    setupFixedThumbnailOverflow(thumbnails) {
        if (typeof this.maxThumbnails !== 'number') return;
        const maxThumbnails = this.maxThumbnails;
        thumbnails.forEach((element, index)=>{
            element.hidden = index >= maxThumbnails;
        });
        const hiddenCount = thumbnails.length - this.maxThumbnails;
        this.renderMoreCounter(hiddenCount);
    }
    renderMoreCounter(hiddenCount) {
        if (hiddenCount <= 1) return;
        const counter = document.createElement('div');
        counter.classList.add('tk-asset-gallery-item', 'tk-asset-gallery-item--more');
        counter.setAttribute('data-count', `+${hiddenCount}`);
        this.thumbnailsSwiper?.wrapperEl.appendChild(counter);
        this.pushListener({
            event: 'click',
            element: counter,
            action: this.openLightbox.bind(this)
        });
        this.thumbnailsSwiper?.update();
    }
    handleVideoSlides() {
        this.previewElement?.querySelectorAll('[data-tk-video-url]').forEach((slide)=>{
            slide.addEventListener('click', ()=>this.setupVideoSlide(slide));
        });
    }
    setupVideoSlide(slide) {
        const url = new URL(slide.dataset.tkVideoUrl || '');
        url.searchParams.set('enablejsapi', '1');
        if (!this.iframeTemplate) return;
        const iframe = this.iframeTemplate.content.firstElementChild?.cloneNode(true);
        iframe.src = url.href;
        slide.innerHTML = '';
        slide.appendChild(iframe);
    }
    stopAllClips() {
        const iframes = this.querySelectorAll('iframe');
        iframes.forEach((iframe)=>{
            iframe.contentWindow?.postMessage(JSON.stringify({
                event: 'command',
                func: 'pauseVideo',
                args: ''
            }), '*');
        });
    }
}



class $59575c6d2ba9e740$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.accordionHead = this.querySelector('[data-tk-accordion-head]') || undefined;
        this.accordionBody = this.querySelector('[data-tk-accordion-body]') || undefined;
        this.accordionIcon = this.querySelector('[data-tk-accordion-icon]') || undefined;
        this.accordionIcons = {
            iconAdd: this.getAttribute('data-tk-icon-open') || 'tk-icon-add',
            iconRemove: this.getAttribute('data-tk-icon-collapse') || 'tk-icon-remove'
        };
        this.isActive = this.hasAttribute('data-tk-accordion-is-active');
        this.isHeaderLink = this.accordionHead && this.accordionHead.hasAttribute('data-tk-accordion-link');
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-tabs-accordion--active';
    }
    connectedCallback() {
        if ((!this.accordionHead || !this.accordionBody || !this.accordionIcon) && !this.isHeaderLink) throw new Error('Accordion: Elements are missing!');
        this.setAccordionState(this.isActive);
        this.registerListener();
    }
    registerListener() {
        const eventHandler = this.toggleEvent.bind(this);
        this.pushListener({
            event: 'click',
            element: this.accordionHead,
            action: eventHandler
        });
    }
    toggleEvent() {
        this.toggleMarkupElements();
    }
    toggleMarkupElements() {
        this.classList.toggle(this.activeClassName);
        this.accordionIcon?.classList.toggle(this.accordionIcons.iconAdd);
        this.accordionIcon?.classList.toggle(this.accordionIcons.iconRemove);
    }
    setAccordionState(isActive) {
        if (isActive) {
            this.classList.toggle(this.activeClassName);
            this.accordionIcon?.classList.add(this.accordionIcons.iconRemove);
        } else this.accordionIcon?.classList.add(this.accordionIcons.iconAdd);
    }
}



class $407d2fd9d876caa3$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.targetElement = this.querySelector('input[type="hidden"]') || undefined;
        this.toggleWrapper = this.querySelector('[data-tk-selection-toggles]') || undefined;
        this.selectWrapper = this.querySelector('[data-tk-selection-select]') || undefined;
        this.maxVisible = Number(this.getAttribute('data-tk-max-visible')) || 3;
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-selection--loaded';
    }
    connectedCallback() {
        if (!this.targetElement || !this.toggleWrapper || !this.selectWrapper) throw new Error('Selection: Elements are missing!');
        this.registerInputListener();
        this.switchView();
        this.classList.add(this.loadedClassName);
    }
    registerInputListener() {
        const fieldElements = this.toggleWrapper.querySelectorAll('input');
        const selectElement = this.selectWrapper.querySelector('select');
        const onInput = this.syncTargetElement.bind(this);
        fieldElements.forEach((fieldElement)=>{
            this.pushListener({
                event: 'input',
                element: fieldElement,
                action: onInput
            });
        });
        selectElement && this.pushListener({
            event: 'input',
            element: selectElement,
            action: onInput
        });
    }
    syncTargetElement(event) {
        const target = event.target;
        const selectedTarget = target instanceof HTMLInputElement ? target : target.options[target.selectedIndex];
        const { dataset: dataset } = selectedTarget;
        this.targetElement.value = selectedTarget.value;
        Object.keys(this.targetElement.dataset).forEach((key)=>{
            delete this.targetElement.dataset[key];
        });
        Object.keys(dataset).forEach((key)=>{
            this.targetElement.dataset[key] = dataset[key];
        });
        this.targetElement?.dispatchEvent(new Event('change'));
    }
    switchView() {
        if (this.toggleWrapper.childElementCount > this.maxVisible) {
            this.toggleWrapper.hidden = true;
            this.selectWrapper.hidden = false;
        } else {
            this.toggleWrapper.hidden = false;
            this.selectWrapper.hidden = true;
        }
    }
}


const $f1a4dbe7c35f0ef9$var$group = (array, property)=>array.reduce((result, object)=>{
        const key = object[property];
        if (!result[key]) result[key] = [];
        result[key].push(object);
        return result;
    }, {});
var $f1a4dbe7c35f0ef9$export$2e2bcd8739ae039 = $f1a4dbe7c35f0ef9$var$group;




class $6d076883806887db$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.groupTemplateElement = this.querySelector('[data-tk-template-list-group]') || undefined;
        this.rowTemplateElement = this.querySelector('[data-tk-template-list-row]') || undefined;
        this.listWrapper = this.querySelector('[data-tk-list-wrapper]') || undefined;
        this.loadedClassName = this.getAttribute('[data-tk-loaded-class-name]') || 'tk-list-description--loaded';
        this.colorClassName = this.getAttribute('[data-tk-color-class-name]') || 'tk-list-description__color';
        this.colorHexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    }
    connectedCallback() {
        if (!this.url || !this.groupTemplateElement || !this.rowTemplateElement || !this.listWrapper) throw new Error('ArtSpecTable: Elements or URL are missing!');
        this.fetch();
    }
    fetch() {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.url,
            resolveHandler: this.refreshContent.bind(this)
        });
    }
    refreshContent(response) {
        if (!response || !response.success) return;
        const { data: data } = response.dataAsJson;
        const groupedList = Object.values((0, $f1a4dbe7c35f0ef9$export$2e2bcd8739ae039)(data, 'groupId'));
        const groups = groupedList.map((rows)=>({
                groupName: rows.at(0)?.groupName,
                rows: rows.filter((row)=>row.value !== '').map((row)=>({
                        label: row.label,
                        value: row.value
                    }))
            }));
        groups.forEach((group)=>{
            if (group.rows.length === 0) return;
            const groupElement = this.groupTemplateElement.content.cloneNode(true).children[0];
            const groupTitleElement = groupElement.querySelector('[data-tk-title]');
            if (!groupTitleElement) return;
            groupTitleElement.textContent = group.groupName || '';
            group.rows.forEach((row)=>{
                const rowElement = this.rowTemplateElement.content.cloneNode(true).children[0];
                const labelElement = rowElement.querySelector('[data-tk-label]');
                if (!labelElement) return;
                const valueElement = rowElement.querySelector('[data-tk-value]');
                if (!valueElement) return;
                labelElement.textContent = row.label;
                if (row.value.match(this.colorHexRegex)) valueElement.insertAdjacentElement('beforeend', this.createColorElement(row.value));
                else valueElement.textContent = row.value;
                groupElement.insertAdjacentElement('beforeend', rowElement);
            });
            this.listWrapper?.insertAdjacentElement('beforeend', groupElement);
        });
        this.classList.add(this.loadedClassName);
        const showMoreComponent = this.closest('[data-tk-show-more-wrapper]');
        showMoreComponent && showMoreComponent.dispatchEvent(new Event('tk-show-more-recalc'));
    }
    createColorElement(colorHexString) {
        const colorElement = document.createElement('div');
        colorElement.classList.add(this.colorClassName);
        colorElement.style.backgroundColor = colorHexString;
        colorElement.title = colorHexString;
        return colorElement;
    }
}



class $ebcc63c186c91a77$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.content = this.querySelector('[data-tk-content]') || undefined;
        this.showingElements = Number(this.getAttribute('data-tk-showing-elements')) || 1;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'tk-show-more--open';
        this.disableClassName = this.getAttribute('data-tk-disable-class-name') || 'tk-show-more--disable';
        this.expandButton = this.querySelector('[data-tk-expand-button]') || undefined;
        this.foldButton = this.querySelector('[data-tk-fold-button]') || undefined;
        this.minHeight = this.getMinHeight();
    }
    connectedCallback() {
        if (!this.content || !this.expandButton || !this.foldButton) throw new Error('Show more: Button is missing!');
        if (this.content.scrollHeight === this.minHeight) this.classList.add(this.disableClassName);
        else {
            this.fold();
            this.registerClickListener();
        }
    }
    registerClickListener() {
        const onExpand = this.expand.bind(this);
        this.pushListener({
            event: 'click',
            element: this.expandButton,
            action: onExpand
        });
        const onFold = this.fold.bind(this);
        this.pushListener({
            event: 'click',
            element: this.foldButton,
            action: onFold
        });
        const onRecalc = this.recalc.bind(this);
        this.pushListener({
            event: 'tk-show-more-recalc',
            element: this,
            action: onRecalc
        });
    }
    getMinHeight() {
        if (!this.content || this.content.childElementCount === 0) return 0;
        const rectContent = this.content.getBoundingClientRect();
        const childElement = this.content.children.item(this.showingElements - 1);
        if (!childElement) return 0;
        const childRect = childElement.getBoundingClientRect();
        const { marginBottom: marginBottom } = window.getComputedStyle(childElement);
        const { top: top } = rectContent;
        const { bottom: bottom } = childRect;
        return bottom - top + (parseInt(marginBottom, 10) || 0);
    }
    expand() {
        this.content.style.maxHeight = '100%';
        this.classList.add(this.openClassName);
        this.removeListener(this.content);
    }
    fold() {
        this.content.style.maxHeight = `${this.minHeight}px`;
        this.classList.remove(this.openClassName);
        const onTransitionEnd = this.scrollToExpandButton.bind(this);
        this.pushListener({
            event: 'transitionend',
            element: this.content,
            action: onTransitionEnd
        });
    }
    scrollToExpandButton() {
        if (!this.expandButton) return;
        this.expandButton.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }
    recalc() {
        this.minHeight = this.getMinHeight();
        this.fold();
    }
}


/**
 * Compares two arrays of objects based on certain properties.
 * @param array1 - The first array of objects.
 * @param array2 - The second array of objects.
 * @param properties - The properties to be used for comparison.
 * @returns A boolean value indicating whether both arrays have at least one object that matches based on the specified properties.
 */ const $515c9c8ed6f3c231$var$compareArrays = (array1, array2, properties)=>array1.some((item1)=>array2.some((item2)=>properties.every((property)=>item1[property] === item2[property])));
var $515c9c8ed6f3c231$export$2e2bcd8739ae039 = $515c9c8ed6f3c231$var$compareArrays;





const $bacbdefa17cfec0c$var$ASYNC_CONTENT_RELOAD_URL_ATTR = 'data-tk-selection-reload-url';
class $bacbdefa17cfec0c$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.selections = [], this.variants = [];
        this.selectElement = this.querySelector('select') || undefined;
        this.queryName = this.getAttribute('data-tk-query-name') || 'query';
        this.form = this.querySelector('form') || undefined;
        this.asyncURL = this.getAttribute('data-tk-async-url') || undefined;
        this.currentId = this.getAttribute('data-tk-current-id') || undefined;
    }
    connectedCallback() {
        if (this.asyncURL) this.getData();
        else if (this.form) this.registerInputListener();
        else {
            if (!this.selectElement) throw new Error('TKSelectRedirect: Select element is missing!');
            this.registerSelectListener();
        }
    }
    registerInputListener() {
        const fieldElements = this.form.querySelectorAll('input');
        const onInputByField = this.handleInput.bind(this);
        fieldElements.forEach((fieldElements)=>{
            this.pushListener({
                event: 'input',
                element: fieldElements,
                action: onInputByField
            });
        });
    }
    registerSelectListener() {
        const onInputBySelect = this.handleSelect.bind(this);
        this.pushListener({
            event: 'input',
            element: this.selectElement,
            action: onInputBySelect
        });
    }
    handleSelect() {
        const selectedOption = this.selectElement?.options.item(this.selectElement.selectedIndex);
        if (!selectedOption) return;
        this.redirectByValue(selectedOption.value);
    }
    handleInput(event) {
        const { value: value } = event.target;
        this.redirectByValue(value);
    }
    redirectByValue(value) {
        const url = new URL(window.location.href);
        url.searchParams.set(this.queryName, value);
        window.location.href = url.href;
    }
    getData() {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            resolveHandler: this.handleVariantsResponse.bind(this)
        });
    }
    handleVariantsResponse(response) {
        if (!response || !response.success) return;
        const { variants: variants, attributes: attributes } = response.dataAsJson;
        this.variants = variants;
        const variantDictionary = this.currentId ? this.getAllVariantsById(this.currentId) : undefined;
        const selectedAttributes = this.currentId ? this.getAttributesById(this.currentId) : undefined;
        if (!variantDictionary) return;
        attributes.forEach((item)=>{
            const values = new Set();
            variantDictionary[item.attr].forEach((value)=>{
                values.add(value);
            });
            const selectedValue = selectedAttributes?.find((selectedItem)=>selectedItem.attr === item.attr)?.value;
            const elements = this.createSelectbox({
                id: item.attr,
                label: item.label,
                values: Array.from(values),
                selectedValue: selectedValue
            });
            if (!elements) return;
            this.selections.push({
                fieldElement: elements.fieldElement,
                wrapper: elements.wrapper,
                attribute: item.attr,
                label: item.label,
                values: values
            });
        });
        this.innerHTML = '';
        this.selections.forEach((item)=>{
            this.insertAdjacentElement('beforeend', item.wrapper);
        });
    }
    /**
     * Retrieves all unique values of attributes related to a given attribute and value pair.
     *
     * @param {string} attribute - The attribute to match.
     * @param {string} value - The value of the attribute to match.
     * @returns {Record<string, Set<string>>}
     * An object where keys are attribute names and values are Sets of unique values associated with those attributes.
     */ getValuesBySelection(attribute, value) {
        return this.variants.filter((variant)=>variant.attributes.some((attr)=>attr.attr === attribute && attr.value === value)).flatMap((variant)=>variant.attributes).filter((attr)=>attr.attr !== attribute && attr.value !== undefined).reduce((result, attr)=>{
            if (!result[attr.attr]) result[attr.attr] = new Set();
            if (!result[attr.attr].has(attr.value)) result[attr.attr].add(attr.value);
            return result;
        }, {});
    }
    /**
     * Creates a select box with the given configuration and attaches change event listener.
     *
     * @param {Object} params - The parameters for creating the select box.
     * @param {string} params.id - The ID for the select box element.
     * @param {string} params.label - The label for the select box element.
     * @param {string[]} params.values - The values to populate the select box options.
     * @param {string} [params.selectedValue] - The value to be selected by default, if any.
     * @returns {{ wrapper: HTMLElement, fieldElement: HTMLSelectElement } | undefined}
     * An object containing the wrapper and field element, or undefined if the field element is not found.
     */ createSelectbox({ id: id, label: label, values: values, selectedValue: selectedValue }) {
        const wrapper = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
            <div class="tk-form-select">
                <label for="form-variants-${id}">${label}</label>
                <div class="tk-form__wrapper">
                    <select
                        id="form-variants-${id}"
                        name="form-variants-${id}"
                        data-tk-product-variants
                    >
                        ${values.map((value)=>`
                            <option value="${value}" ${selectedValue === value && 'selected'}>${value}</option>
                        `).join('\n')}
                    </select>
                </div>
            </div>
        `);
        const fieldElement = wrapper.querySelector('select');
        if (!fieldElement) return;
        const onChange = this.handleChangeSelection.bind(this);
        this.pushListener({
            event: 'input',
            element: fieldElement,
            action: onChange
        });
        return {
            wrapper: wrapper,
            fieldElement: fieldElement
        };
    }
    async handleChangeSelection(event) {
        const target = event.target;
        const selectedOption = target.selectedOptions.item(0);
        const currentSelection = this.selections.find((item)=>item.fieldElement === target);
        if (!currentSelection) return;
        const { attribute: attribute } = currentSelection;
        if (!selectedOption) return;
        const { value: value } = selectedOption;
        const id = this.getIdBySelection(attribute, value);
        if (!id) return;
        await this.getAsyncContentById(id);
    }
    /**
     * Retrieves the ID of the current variant based on the selected attributes.
     *
     * @returns {string | undefined} The ID of the matched variant, or undefined if no match is found.
     */ getIdBySelection(attribute, value) {
        const currentAttribute = {
            attr: attribute,
            value: value
        };
        const attributes = [
            currentAttribute
        ];
        const currentVariant = this.variants.find((variant)=>(0, $515c9c8ed6f3c231$export$2e2bcd8739ae039)(variant.attributes, attributes, [
                'attr',
                'value'
            ]));
        return currentVariant?.id;
    }
    /**
     * Retrieves all variants by the given ID, mapping the first attribute and its value to other related values.
     *
     * @param {string} id - The ID of the variant to retrieve related values for.
     * @returns {Record<string, Set<string>> | undefined} A record of attribute keys and their corresponding values, or undefined if no match is found.
     */ getAllVariantsById(id) {
        const variant = this.variants.find((variant)=>variant.id === id);
        const firstAttribute = variant?.attributes.at(0);
        if (!firstAttribute) return;
        const { attr: attr, value: value } = firstAttribute;
        if (!value) return;
        return {
            ...this.getValuesByAttribute(attr),
            ...this.getValuesBySelection(attr, value)
        };
    }
    /**
     * Retrieves all unique values associated with a specific attribute across all variants.
     *
     * @param {string} attribute - The attribute to retrieve values for.
     * @returns {Record<string, Set<string>>}
     * An object with the attribute as the key and a Set of its unique values, or undefined if no values are found.
     */ getValuesByAttribute(attribute) {
        const values = this.variants.flatMap((item)=>item.attributes).filter((item)=>item.attr === attribute).map((item)=>item.value);
        return {
            [attribute]: new Set(values)
        };
    }
    /**
     * Retrieves the attributes of a variant based on the given ID.
     *
     * @param {string} id - The ID of the variant to retrieve attributes for.
     * @returns {Attribute[] | undefined}
     * An array of attributes for the variant with the specified ID, or undefined if no variant is found.
     */ getAttributesById(id) {
        return this.variants.find((item)=>item.id === id)?.attributes;
    }
    async getAsyncContentById(id) {
        const asyncElements = document.querySelectorAll(`[${$bacbdefa17cfec0c$var$ASYNC_CONTENT_RELOAD_URL_ATTR}]`);
        const payload = {
            articleId: id
        };
        const executer = [];
        asyncElements.forEach((element)=>{
            const url = element.getAttribute($bacbdefa17cfec0c$var$ASYNC_CONTENT_RELOAD_URL_ATTR);
            if (!url) return;
            executer.push((0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: this.refreshContent.bind(this, element, id),
                payload: payload
            }));
        });
        await Promise.all(executer);
    }
    refreshContent(element, id, response) {
        if (!response || !response.success) return;
        element.innerHTML = response.dataAsHtml;
        const url = new URL(window.location.href);
        url.searchParams.set(this.queryName, id);
        window.history.pushState(null, '', url.href);
    }
}





class $c380876ef7ad99ae$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.url = this.getAttribute('data-tk-url') || undefined;
        this.button = this.querySelector('button') || undefined;
        this.offset = Number(this.getAttribute('data-tk-offset')) || 4;
    }
    connectedCallback() {
        if (!this.url) throw new Error('Dialog: URL is missing!');
        this.registerClickListener();
    }
    registerClickListener() {
        if (!this.button) return;
        const onClick = this.openDialog.bind(this, this.url);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerCloseListener() {
        const onClick = this.closeDialogIfOutside.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: onClick
        });
    }
    createDialog() {
        this.popup = this.render();
        const onClosed = this.closedDialog.bind(this);
        this.pushListener({
            event: 'close',
            element: this.popup,
            action: onClosed
        });
    }
    openDialog(url) {
        this.getContent(url);
        // This method would be used to execute code in a non-blocking way to prevent potential delays.
        setTimeout(()=>{
            this.registerCloseListener();
        });
    }
    getContent(url) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this)
        });
    }
    getContentWithData(url, payload) {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleResponseSuccess.bind(this),
            payload: payload
        });
    }
    handleResponseSuccess(response) {
        if (response && response.success) {
            this.createDialog();
            const content = this.popup?.querySelector('[data-tk-dialog-content]');
            if (!content) return;
            content.innerHTML = response.dataAsHtml;
            this.open();
        }
    }
    open() {
        if (!this.popup) return;
        this.setPosition(this.popup);
        this.popup.show();
    }
    static attachButtonClickHandler(dialog, selector, callback) {
        const buttons = dialog.querySelectorAll(selector);
        buttons.forEach((button)=>{
            button.addEventListener('click', ()=>callback(button));
        });
    }
    closedDialog() {
        this.removeListener(window);
        this.popup?.remove();
    }
    render() {
        const dialog = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`
            <dialog class="tk-dialog tk-dialog--popup">
                <button
                    type="button"
                    class="tk-button tk-button--tertiary tk-button--only-icon tk-dialog__close"
                    data-tk-dialog-close
                ></button>
                <div class="tk-dialog__inner" data-tk-dialog-content></div>
            </dialog>
        `);
        document.body.insertAdjacentElement('beforeend', dialog);
        $c380876ef7ad99ae$export$2e2bcd8739ae039.attachButtonClickHandler(dialog, '[data-tk-dialog-close]', ()=>dialog.close());
        return dialog;
    }
    setPosition(element) {
        const { top: top, height: height, left: left, right: right } = this.button.getBoundingClientRect();
        const leftPosition = left + window.scrollX;
        const rightPosition = right + window.scrollX;
        element.style.top = `${top + height + window.scrollY + this.offset}px`;
        if (window.innerWidth <= element.clientWidth + leftPosition) element.style.left = `${rightPosition - element.clientWidth}px`;
        else element.style.left = `${leftPosition}px`;
    }
    closeDialogIfOutside(event) {
        /**
         * Checking the coordinates of the client for the value 0 and the
         * HTMLSelectElement or HTMLOptionElement element ensures that the
         * dialogue does not close in Mozilla. This is a bug in Firefox
         * that has not yet been fixed.
         */ if (!this.popup) return;
        if (event.clientX === 0 && event.clientY === 0 && (event.target instanceof HTMLSelectElement || event.target instanceof HTMLOptionElement)) return;
        const dialogDimensions = this.popup.getBoundingClientRect();
        if (event.clientX < dialogDimensions.left || event.clientX > dialogDimensions.right || event.clientY < dialogDimensions.top || event.clientY > dialogDimensions.bottom) this.popup.close();
    }
}





const $4cfe9ec7fa1b3e1e$var$showDimmer = (elementToAttach, style)=>{
    if (elementToAttach) {
        const dimmer = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="tk-dimmer tk-dimmer--attached"></div>');
        style && Object.keys(style).forEach((key)=>{
            dimmer.style.setProperty(key, style[key]);
        });
        elementToAttach.insertAdjacentElement('beforeend', dimmer);
        return dimmer;
    } else {
        const dimmer = (0, $2d540709c75492d4$export$2e2bcd8739ae039)('<div class="tk-dimmer"></div>');
        const dialog = Array.from(document.querySelectorAll('dialog[open]'));
        dialog.length > 0 ? dialog.at(-1)?.insertAdjacentElement('beforeend', dimmer) : document.body.insertAdjacentElement('beforeend', dimmer);
        return dimmer;
    }
};
var $4cfe9ec7fa1b3e1e$export$2e2bcd8739ae039 = $4cfe9ec7fa1b3e1e$var$showDimmer;



var $a891510b26e6e0ec$exports = {};
/*! @license DOMPurify 3.4.13 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.13/LICENSE */ (function(global, factory) {
    $a891510b26e6e0ec$exports = factory();
})($a891510b26e6e0ec$exports, function() {
    'use strict';
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = true, o = false;
            try {
                if (i = (t = t.call(r)).next, 0 === l) ;
                else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = true, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    const entries = Object.entries, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    let freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    let _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const arrayIsArray = Array.isArray;
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const numberToString = unapply(Number.prototype.toString);
    const booleanToString = unapply(Boolean.prototype.toString);
    const bigintToString = typeof BigInt === 'undefined' ? null : unapply(BigInt.prototype.toString);
    const symbolToString = typeof Symbol === 'undefined' ? null : unapply(Symbol.prototype.toString);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const objectToString = unapply(Object.prototype.toString);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        if (!arrayIsArray(array)) return set;
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const _ref2 of entries(object)){
            var _ref3 = _slicedToArray(_ref2, 2);
            const property = _ref3[0];
            const value = _ref3[1];
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (arrayIsArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * Convert non-node values into strings without depending on direct property access.
   *
   * @param value - The value to stringify.
   * @returns A string representation of the provided value.
   */ function stringifyValue(value) {
        switch(typeof value){
            case 'string':
                return value;
            case 'number':
                return numberToString(value);
            case 'boolean':
                return booleanToString(value);
            case 'bigint':
                return bigintToString ? bigintToString(value) : '0';
            case 'symbol':
                return symbolToString ? symbolToString(value) : 'Symbol()';
            case 'undefined':
                return objectToString(value);
            case 'function':
            case 'object':
                {
                    if (value === null) return objectToString(value);
                    const valueAsRecord = value;
                    const valueToString = lookupGetter(valueAsRecord, 'toString');
                    if (typeof valueToString === 'function') {
                        const stringified = valueToString(valueAsRecord);
                        return typeof stringified === 'string' ? stringified : objectToString(stringified);
                    }
                    return objectToString(value);
                }
            default:
                return objectToString(value);
        }
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    function isRegex(value) {
        try {
            regExpTest(value, '');
            return true;
        } catch (_unused) {
            return false;
        }
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'search',
        'section',
        'select',
        'shadow',
        'slot',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'enterkeyhint',
        'exportparts',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'inputmode',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'part',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'command',
        'commandfor',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'exportparts',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inert',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'part',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dominant-baseline',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'mask-type',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-orientation',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnalign',
        'columnlines',
        'columnspacing',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lquote',
        'lspace',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    const MUSTACHE_EXPR = seal(/{{[\w\W]*|^[\w\W]*}}/g);
    const ERB_EXPR = seal(/<%[\w\W]*|^[\w\W]*%>/g);
    const TMPLIT_EXPR = seal(/\${[\w\W]*/g);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    // Markup-significant character probes used by _sanitizeElements.
    // Shared module-level instances are safe despite the sticky /g flags:
    // unapply() resets lastIndex for RegExp receivers before every call.
    const ELEMENT_MARKUP_PROBE = seal(/<[/\w!]/g);
    const COMMENT_MARKUP_PROBE = seal(/<[/\w]/g);
    const FALLBACK_TAG_CLOSE = seal(/<\/no(script|embed|frames)/i);
    const SELF_CLOSING_TAG = seal(/\/>/i);
    // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        processingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    /**
   * Resolve a set-valued configuration option: a fresh set built from
   * cfg[key] when it is an own array property (seeded with a clone of
   * options.base when given, case-normalized via options.transform),
   * the fallback set otherwise.
   *
   * @param cfg the cloned, prototype-free configuration object
   * @param key the configuration property to read
   * @param fallback the set to use when the option is absent or not an array
   * @param options transform and optional base set to merge into
   * @returns the resolved set
   */ const _resolveSetOption = function _resolveSetOption(cfg, key, fallback, options) {
        return objectHasOwnProperty(cfg, key) && arrayIsArray(cfg[key]) ? addToSet(options.base ? clone(options.base) : {}, cfg[key], options.transform) : fallback;
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.4.13';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let document = window1.document;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        window1.DocumentFragment;
        const HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap;
        _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap;
        window1.HTMLFormElement;
        const DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        const getShadowRoot = lookupGetter(ElementPrototype, 'shadowRoot');
        const getAttributes = lookupGetter(ElementPrototype, 'attributes');
        const getNodeType = Node && Node.prototype ? lookupGetter(Node.prototype, 'nodeType') : null;
        const getNodeName = Node && Node.prototype ? lookupGetter(Node.prototype, 'nodeName') : null;
        const getOwnerDocument = Node && Node.prototype ? lookupGetter(Node.prototype, 'ownerDocument') : null;
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        // The instance's own internal Trusted Types policy. Unlike a caller-supplied
        // `TRUSTED_TYPES_POLICY`, this is created at most once — Trusted Types throws
        // on duplicate policy names — and is the only policy allowed to persist
        // across configurations and survive `clearConfig()`.
        let defaultTrustedTypesPolicy;
        let defaultTrustedTypesPolicyResolved = false;
        // Tracks whether we are already inside a call to the configured Trusted Types
        // policy (`createHTML` or `createScriptURL`). If a supplied policy callback
        // itself calls `DOMPurify.sanitize` (the cause of #1422), `sanitize` would
        // re-enter the policy and recurse until the stack overflows. We detect that
        // re-entry and throw a clear, actionable error instead. The guard is shared
        // across both callbacks, because either one re-entering `sanitize` triggers
        // the same unbounded recursion.
        let IN_TRUSTED_TYPES_POLICY = 0;
        const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy() {
            if (IN_TRUSTED_TYPES_POLICY > 0) throw typeErrorCreate('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
        };
        const _createTrustedHTML = function _createTrustedHTML(html) {
            _assertNotInTrustedTypesPolicy();
            IN_TRUSTED_TYPES_POLICY++;
            try {
                return trustedTypesPolicy.createHTML(html);
            } finally{
                IN_TRUSTED_TYPES_POLICY--;
            }
        };
        const _createTrustedScriptURL = function _createTrustedScriptURL(scriptUrl) {
            _assertNotInTrustedTypesPolicy();
            IN_TRUSTED_TYPES_POLICY++;
            try {
                return trustedTypesPolicy.createScriptURL(scriptUrl);
            } finally{
                IN_TRUSTED_TYPES_POLICY--;
            }
        };
        // Lazily resolve (and cache) the instance's internal default policy.
        // Resolution is attempted at most once: a successful `createPolicy` cannot be
        // repeated (Trusted Types throws on duplicate names), and a failed or
        // unsupported attempt must not be retried on every parse.
        const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy() {
            if (!defaultTrustedTypesPolicyResolved) {
                defaultTrustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                defaultTrustedTypesPolicyResolved = true;
            }
            return defaultTrustedTypesPolicy;
        };
        const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        const importNode = originalDocument.importNode;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        let IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Pristine allowlist bindings captured at setConfig() time. On the
     * persistent-config path sanitize() restores the sets from these before
     * the per-walk hook clone-guard, so a hook's in-call widening cannot
     * carry across calls. Null until setConfig() is called; reset by
     * clearConfig(). */ let SET_CONFIG_ALLOWED_TAGS = null;
        let SET_CONFIG_ALLOWED_ATTR = null;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
            // the UA (customizable <select>) — including any on* handlers — and the
            // engine re-mirrors synchronously whenever a removal changes which
            // option/selectedcontent is current, even inside DOMPurify's inert
            // DOMParser document. Hoisting its children on removal re-inserts a fresh
            // mirror target ahead of the walk, which the engine refills, looping
            // forever (DoS) and amplifying output. Dropping its content on removal
            // (rather than hoisting) breaks that cascade; the content is a duplicate
            // of the option, which is sanitized on its own. See campaign-3 F1/F6.
            'selectedcontent',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = freeze([
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
        const DEFAULT_HTML_INTEGRATION_POINTS = freeze([
            'annotation-xml'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = _resolveSetOption(cfg, 'ALLOWED_TAGS', DEFAULT_ALLOWED_TAGS, {
                transform: transformCaseFunc
            });
            ALLOWED_ATTR = _resolveSetOption(cfg, 'ALLOWED_ATTR', DEFAULT_ALLOWED_ATTR, {
                transform: transformCaseFunc
            });
            ALLOWED_NAMESPACES = _resolveSetOption(cfg, 'ALLOWED_NAMESPACES', DEFAULT_ALLOWED_NAMESPACES, {
                transform: stringToString
            });
            URI_SAFE_ATTRIBUTES = _resolveSetOption(cfg, 'ADD_URI_SAFE_ATTR', DEFAULT_URI_SAFE_ATTRIBUTES, {
                transform: transformCaseFunc,
                base: DEFAULT_URI_SAFE_ATTRIBUTES
            });
            DATA_URI_TAGS = _resolveSetOption(cfg, 'ADD_DATA_URI_TAGS', DEFAULT_DATA_URI_TAGS, {
                transform: transformCaseFunc,
                base: DEFAULT_DATA_URI_TAGS
            });
            FORBID_CONTENTS = _resolveSetOption(cfg, 'FORBID_CONTENTS', DEFAULT_FORBID_CONTENTS, {
                transform: transformCaseFunc
            });
            FORBID_TAGS = _resolveSetOption(cfg, 'FORBID_TAGS', clone({}), {
                transform: transformCaseFunc
            });
            FORBID_ATTR = _resolveSetOption(cfg, 'FORBID_ATTR', clone({}), {
                transform: transformCaseFunc
            });
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === 'object' ? clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI; // Default regexp
            NAMESPACE = typeof cfg.NAMESPACE === 'string' ? cfg.NAMESPACE : HTML_NAMESPACE; // Default HTML namespace
            MATHML_TEXT_INTEGRATION_POINTS = objectHasOwnProperty(cfg, 'MATHML_TEXT_INTEGRATION_POINTS') && cfg.MATHML_TEXT_INTEGRATION_POINTS && typeof cfg.MATHML_TEXT_INTEGRATION_POINTS === 'object' ? clone(cfg.MATHML_TEXT_INTEGRATION_POINTS) : addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS); // Default built-in map
            HTML_INTEGRATION_POINTS = objectHasOwnProperty(cfg, 'HTML_INTEGRATION_POINTS') && cfg.HTML_INTEGRATION_POINTS && typeof cfg.HTML_INTEGRATION_POINTS === 'object' ? clone(cfg.HTML_INTEGRATION_POINTS) : addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS); // Default built-in map
            const customElementHandling = objectHasOwnProperty(cfg, 'CUSTOM_ELEMENT_HANDLING') && cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING === 'object' ? clone(cfg.CUSTOM_ELEMENT_HANDLING) : create(null);
            CUSTOM_ELEMENT_HANDLING = create(null);
            if (objectHasOwnProperty(customElementHandling, 'tagNameCheck') && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck; // Default undefined
            if (objectHasOwnProperty(customElementHandling, 'attributeNameCheck') && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck; // Default undefined
            if (objectHasOwnProperty(customElementHandling, 'allowCustomizedBuiltInElements') && typeof customElementHandling.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements; // Default undefined
            seal(CUSTOM_ELEMENT_HANDLING);
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = create(null);
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
       * leaking across calls when switching from function to array config */ EXTRA_ELEMENT_HANDLING.tagCheck = null;
            EXTRA_ELEMENT_HANDLING.attributeCheck = null;
            /* Merge configuration parameters */ if (objectHasOwnProperty(cfg, 'ADD_TAGS')) {
                if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else if (arrayIsArray(cfg.ADD_TAGS)) {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, 'ADD_ATTR')) {
                if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else if (arrayIsArray(cfg.ADD_ATTR)) {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && arrayIsArray(cfg.ADD_URI_SAFE_ATTR)) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && arrayIsArray(cfg.FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            if (objectHasOwnProperty(cfg, 'ADD_FORBID_CONTENTS') && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Re-derive the active Trusted Types policy from this configuration on
            // every parse. The active policy must never be sticky closure state that
            // outlives the config that set it: a caller-supplied policy left in place
            // after `clearConfig()` — or after a later call that supplied none, or
            // `TRUSTED_TYPES_POLICY: null` — could sign a subsequent "default"
            // `RETURN_TRUSTED_TYPE` result with a foreign, possibly unsafe policy.
            // See GHSA-vxr8-fq34-vvx9.
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // A caller-supplied policy applies to this configuration only.
                const previousTrustedTypesPolicy = trustedTypesPolicy;
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`. If the supplied policy's
                // `createHTML` is circular (i.e. it calls `DOMPurify.sanitize`), this
                // throws via the re-entrancy guard. Restore the previous policy first so
                // the instance is not left in a poisoned state. See #1422.
                try {
                    emptyHTML = _createTrustedHTML('');
                } catch (error) {
                    trustedTypesPolicy = previousTrustedTypesPolicy;
                    throw error;
                }
            } else if (cfg.TRUSTED_TYPES_POLICY === null) {
                // Explicit opt-out for this call: perform no Trusted Types signing and
                // create nothing (so a strict `trusted-types` CSP that disallows a
                // `dompurify` policy can still call `sanitize` from inside its own
                // policy — see #1422). Resetting to `undefined` rather than a sticky
                // `null` also drops any previously retained caller policy, so it cannot
                // resurface on a later call, while still allowing the next config-less
                // call to restore the internal default policy. See GHSA-vxr8-fq34-vvx9.
                trustedTypesPolicy = undefined;
                emptyHTML = '';
            } else {
                // No policy supplied: keep the currently active policy if one is set — a
                // previously supplied policy is intentionally sticky across config-less
                // calls — otherwise fall back to the instance's own internal policy,
                // created at most once. (A policy supplied for a *single* call still
                // lingers by design; what must not linger is a policy whose configuration
                // has been torn down via `clearConfig()`, which restores the default.)
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
                // Sign internal variables only when a policy is active. A falsy policy
                // (Trusted Types unsupported, creation failed, or an explicit opt-out)
                // leaves `emptyHTML` as a plain string, so we never call `.createHTML` on
                // a non-policy and throw. See #1422.
                if (trustedTypesPolicy && typeof emptyHTML === 'string') emptyHTML = _createTrustedHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * Namespace rules for an element in the SVG namespace.
     *
     * @param tagName the element's lowercase tag name
     * @param parent the (possibly simulated) parent node
     * @param parentTagName the parent's lowercase tag name
     * @returns true if a spec-compliant parser could produce this element
     */ const _checkSvgNamespace = function _checkSvgNamespace(tagName, parent, parentTagName) {
            // The only way to switch from HTML namespace to SVG
            // is via <svg>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
            // The only way to switch from MathML to SVG is via <svg>
            // if the parent is either <annotation-xml> or a MathML
            // text integration point.
            if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
            // We only allow elements that are defined in SVG
            // spec. All others are disallowed in SVG namespace.
            return Boolean(ALL_SVG_TAGS[tagName]);
        };
        /**
     * Namespace rules for an element in the MathML namespace.
     *
     * @param tagName the element's lowercase tag name
     * @param parent the (possibly simulated) parent node
     * @param parentTagName the parent's lowercase tag name
     * @returns true if a spec-compliant parser could produce this element
     */ const _checkMathMlNamespace = function _checkMathMlNamespace(tagName, parent, parentTagName) {
            // The only way to switch from HTML namespace to MathML
            // is via <math>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
            // The only way to switch from SVG to MathML is via
            // <math> and HTML integration points
            if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
            // We only allow elements that are defined in MathML
            // spec. All others are disallowed in MathML namespace.
            return Boolean(ALL_MATHML_TAGS[tagName]);
        };
        /**
     * Namespace rules for an element in the HTML namespace.
     *
     * @param tagName the element's lowercase tag name
     * @param parent the (possibly simulated) parent node
     * @param parentTagName the parent's lowercase tag name
     * @returns true if a spec-compliant parser could produce this element
     */ const _checkHtmlNamespace = function _checkHtmlNamespace(tagName, parent, parentTagName) {
            // The only way to switch from SVG to HTML is via
            // HTML integration points, and from MathML to HTML
            // is via MathML text integration points
            if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
            if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
            // We disallow tags that are specific for MathML
            // or SVG and should never appear in HTML namespace
            return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        };
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) return _checkSvgNamespace(tagName, parent, parentTagName);
            if (element.namespaceURI === MATHML_NAMESPACE) return _checkMathMlNamespace(tagName, parent, parentTagName);
            if (element.namespaceURI === HTML_NAMESPACE) return _checkHtmlNamespace(tagName, parent, parentTagName);
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                /* The normal detach failed — this is reached for a parentless node
           (getParentNode() is null, so .removeChild throws). Element.prototype
           .remove() is itself a spec no-op on a parentless node, so a recorded
           "removal" would otherwise hand the caller back an intact,
           payload-bearing node (e.g. a detached IN_PLACE root the mXSS canary or
           the style-with-element-child rule decided to kill). Fail closed by
           throwing — exactly as a clobbered root does at the IN_PLACE entry —
           rather than trying to "neutralize" the node via its own methods.
           Neutralizing would mean calling getAttributeNames()/removeAttribute()
           on the node, both of which a <form> root can clobber via a named child
           (and _isClobbered does not even probe getAttributeNames), so the
           neutralize step could itself be silently defeated, leaving the payload
           intact. A throw touches only the cached, clobber-safe remove() and
           getParentNode(). Generalizes GHSA-r47g-fvhr-h676 (clobbered-form root)
           to every root-kill reason. REPORT-3.
                  This lives inside the catch, so it never fires for a normally-removed
           in-tree node: those have a parent, removeChild() succeeds, and the
           catch is not entered. Only a kept (parentless) root reaches here. */ remove(node);
                if (!getParentNode(node)) throw typeErrorCreate("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
            }
        };
        /**
     * _neutralizeRoot
     *
     * Fail-closed teardown of an in-place root after the sanitize walk aborts
     * (campaign-3 F2). An internal throw mid-walk — e.g. a page-registered
     * custom element's reaction detaches a node so `_forceRemove`'s deliberate
     * parentless guard throws, or any other re-entrant engine mutation — would
     * otherwise leave the caller's *live* tree half-sanitized, with everything
     * after the abort point still carrying its handlers. There is no safe way
     * to resume the walk (the tree mutated under us), so we strip the root bare:
     * remove every child and every attribute, then let the caller's catch see
     * the original error. Clobber-safe (cached `remove`/`childNodes`/`attributes`
     * getters; the root was already clobber-pre-flighted at the IN_PLACE entry).
     *
     * @param root the in-place root to empty
     */ const _neutralizeRoot = function _neutralizeRoot(root) {
            /* Strip every disallowed attribute (on* handlers included) off the whole
         subtree BEFORE detaching anything. Detaching first would hand back
         handler-bearing originals (e.g. an already-loading `<img onerror>`)
         whose queued resource event still fires in page scope after we throw.
         Clobber-safe reads; a doomed clobbered node's own attributes are
         irrelevant while its non-clobbered descendants are reached and scrubbed. */ _neutralizeSubtree(root);
            const childNodes = getChildNodes(root);
            if (childNodes) {
                const snapshot = [];
                arrayForEach(childNodes, (child)=>{
                    arrayPush(snapshot, child);
                });
                arrayForEach(snapshot, (child)=>{
                    try {
                        remove(child);
                    } catch (_) {
                    /* Best-effort teardown; a still-attached child is handled below */ }
                });
            }
            const attributes = getAttributes(root);
            if (attributes) for(let i = attributes.length - 1; i >= 0; --i){
                const attribute = attributes[i];
                const name = attribute && attribute.name;
                if (typeof name === 'string') try {
                    root.removeAttribute(name);
                } catch (_) {
                /* Clobbered removeAttribute — ignore (fail-closed best effort) */ }
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _stripDisallowedAttributes
     *
     * Removes every attribute the active configuration does not allow from a
     * single element, using the same allowlist as the main attribute pass (so
     * `on*` handlers go, but no `/^on/` blocklist is introduced). Used only to
     * neutralise nodes that are being discarded from an in-place tree.
     *
     * @param element the element to strip
     */ const _stripDisallowedAttributes = function _stripDisallowedAttributes(element) {
            const attributes = getAttributes(element);
            if (!attributes) return;
            for(let i = attributes.length - 1; i >= 0; --i){
                const attribute = attributes[i];
                const name = attribute && attribute.name;
                if (typeof name !== 'string' || ALLOWED_ATTR[transformCaseFunc(name)]) continue;
                try {
                    element.removeAttribute(name);
                } catch (_) {
                /* Clobbered removeAttribute on a doomed node — ignore */ }
            }
        };
        /**
     * _neutralizeSubtree
     *
     * Completes the audit-5 F1 fix across every removal path. The KEEP_CONTENT
     * move-hoist neutralises only disallowed-tag removals; clobber, mXSS-canary,
     * namespace, comment, processing-instruction and KEEP_CONTENT:false removals
     * all drop their subtree wholesale via `_forceRemove`. On the IN_PLACE path
     * those dropped nodes are detached from the caller's LIVE tree but a
     * handler-bearing original among them (an `<img onerror>`/`<video>` that was
     * loading) keeps its queued resource event, which fires in page scope after
     * sanitize returns. This walks a removed subtree and strips every attribute
     * the active configuration does not allow — so `on*` handlers are cancelled
     * through the SAME allowlist that governs kept nodes, not a separate `/^on/`
     * blocklist. Run synchronously before sanitize returns, i.e. before any
     * queued event can fire. Hook-free by design: these nodes leave the output,
     * so firing attribute hooks for them would be surprising. Clobber-safe reads;
     * a doomed clobbered node may shadow `removeAttribute` (its own attributes are
     * irrelevant — it is discarded — while its non-clobbered descendants, e.g.
     * the `<img>`, are reached and scrubbed).
     *
     * @param root the root of a removed subtree to neutralise
     */ const _neutralizeSubtree = function _neutralizeSubtree(root) {
            const stack = [
                root
            ];
            while(stack.length > 0){
                const node = stack.pop();
                const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
                if (nodeType === NODE_TYPE.element) _stripDisallowedAttributes(node);
                const childNodes = getChildNodes(node);
                if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
            }
        };
        /**
     * _neutralizePatchLinkage
     *
     * IN_PLACE entry pre-pass (declarative-partial-updates / streaming
     * hardening, https://github.com/WICG/declarative-partial-updates).
     *
     * The main walk strips patch linkage (`for`/`patchsrc`) and removes range
     * markers (PIs / markup comments) node-by-node, in document order, AS it
     * reaches each node. On a live in-place root that leaves a window: from the
     * moment the root is connected until the walk arrives at a given node, that
     * node's linkage is live. A patch applied on connection/stream can fire as
     * a microtask during the walk and inject or teleport an unsanitized DOM
     * range into a region the iterator has already passed and will not revisit,
     * so the post-return "tree is sanitized" contract is violated. Sweep the
     * whole tree once up front and sever every linkage before the walk begins,
     * closing that window.
     *
     * This CANNOT undo a patch that already fired before sanitize ran — that is
     * the irreducible "do not IN_PLACE a live-connected attacker tree" caveat —
     * but it closes everything from sanitize-start onward. Gated on SAFE_FOR_XML
     * to group with the rest of the declarative-partial-updates handling and
     * stay overridable, consistent with the codebase.
     *
     * Clobber-safe traversal (cached childNodes getter); per-node try/catch so a
     * clobbered root cannot defeat the sweep of its non-clobbered descendants.
     *
     * NOTE (pending real-Chrome confirmation, see test/declarative-patch-probe
     * .html Q1): this mirrors the existing policy of keeping `for` on
     * <label>/<output>. If the shipping feature can drive a patch through a
     * surviving `for`-on-label/output + `id` pair, this pre-pass and the
     * attribute check at _isBasicCustomElement's caller must additionally drop
     * that pair on the IN_PLACE path. Left as-is until the taxonomy is verified.
     *
     * @param root the in-place root to sweep
     */ const _neutralizePatchLinkage = function _neutralizePatchLinkage(root) {
            if (!SAFE_FOR_XML) return;
            const stack = [
                root
            ];
            while(stack.length > 0){
                const node = stack.pop();
                const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
                /* Remove range markers (the target side of a patch linkage): every
           processing instruction, and any markup-bearing comment. */ if (nodeType === NODE_TYPE.processingInstruction || nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, node.data)) {
                    try {
                        remove(node);
                    } catch (_) {
                    /* Best-effort */ }
                    continue;
                }
                /* Strip patch-source attributes (the source side) off elements. */ if (nodeType === NODE_TYPE.element) {
                    const element = node;
                    const lcTag = transformCaseFunc(getNodeName ? getNodeName(node) : node.nodeName);
                    try {
                        if (element.hasAttribute && element.hasAttribute('patchsrc')) element.removeAttribute('patchsrc');
                        if (element.hasAttribute && element.hasAttribute('for') && lcTag !== 'label' && lcTag !== 'output') element.removeAttribute('for');
                    } catch (_) {
                    /* Clobbered removeAttribute/hasAttribute on a doomed node — ignore */ }
                }
                const childNodes = getChildNodes(node);
                if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            /* Read ownerDocument through the cached Node.prototype getter, never the
         direct property. HTMLFormElement has [LegacyOverrideBuiltIns], so a
         clobbering child (<input name="ownerDocument"> or a form-associated
         external input) shadows the prototype getter and makes a direct read
         return that <input>. createNodeIterator.call(<input>, ...) then throws
         "Illegal invocation", and on the IN_PLACE path that throw lands before
         the walk's fail-closed barrier - leaving the caller's live tree, with
         any already-armed handler in it, un-neutralized. The cached getter
         returns the real Document regardless of the clobber. */ const doc = getOwnerDocument ? getOwnerDocument(root) : root.ownerDocument;
            return createNodeIterator.call(doc || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * Replace template expression syntax (mustache, ERB, template
     * literal) with a space; shared by all SAFE_FOR_TEMPLATES scrub
     * sites. Order matters: mustache, then ERB, then template literal.
     *
     * @param value the string to scrub
     * @returns the scrubbed string
     */ const _stripTemplateExpressions = function _stripTemplateExpressions(value) {
            value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
            value = stringReplace(value, ERB_EXPR$1, ' ');
            value = stringReplace(value, TMPLIT_EXPR$1, ' ');
            return value;
        };
        /**
     * Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
     * character data of an element subtree. Used as the final safety net for
     * SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
     * which only form after text-node normalization (e.g. fragments split across
     * stripped elements) cannot survive into a template-evaluating framework.
     *
     * Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
     * in place rather than round-tripping through innerHTML. This preserves
     * descendant node references (important for IN_PLACE callers), avoids a
     * serialize/reparse cycle, and reads literal character data — which means
     * `<%...%>` in text content matches the ERB regex against its real bytes
     * instead of the HTML-entity-escaped form innerHTML would produce.
     *
     * Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
     * attributes is performed during the per-node `_sanitizeAttributes` pass.
     *
     * @param node The root element whose character data should be scrubbed.
     */ const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
            var _node$querySelectorAl;
            node.normalize();
            /* Clobber-safe ownerDocument read, same reasoning as _createNodeIterator:
         under SAFE_FOR_TEMPLATES this runs on the live IN_PLACE root, which may
         carry a form-named-getter override of ownerDocument. */ const doc = getOwnerDocument ? getOwnerDocument(node) : node.ownerDocument;
            const walker = createNodeIterator.call(doc || node, node, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
            let currentNode = walker.nextNode();
            while(currentNode){
                currentNode.data = _stripTemplateExpressions(currentNode.data);
                currentNode = walker.nextNode();
            }
            // NodeIterator does not descend into <template>.content per the DOM spec,
            // so we must explicitly recurse into each template's content fragment,
            // mirroring the approach used by _sanitizeShadowDOM.
            const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, 'template');
            if (templates) arrayForEach(templates, (tmpl)=>{
                if (_isDocumentFragment(tmpl.content)) _scrubTemplateExpressions2(tmpl.content);
            });
        };
        /**
     * _isClobbered
     *
     * Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
     * interface with [LegacyOverrideBuiltIns]; a descendant element with a
     * `name` attribute matching a prototype property shadows that property
     * on direct reads. We use this check at the IN_PLACE entry-point and
     * during attribute sanitization to refuse clobbered forms.
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            // Realm-independent tag-name probe. If we can't determine the tag
            // name at all, we can't reason about clobbering — return false
            // (the caller's other defences still apply).
            const realTagName = getNodeName ? getNodeName(element) : null;
            if (typeof realTagName !== 'string') return false;
            if (transformCaseFunc(realTagName) !== 'form') return false;
            return typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || // Realm-safe NamedNodeMap detection: equality against the cached
            // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
            // makes the direct read diverge from the cached read; a clean form
            // (same-realm OR foreign-realm) has both reads pointing at the same
            // canonical NamedNodeMap.
            element.attributes !== getAttributes(element) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function' || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
            // returns the integer 1 for any Element regardless of realm; direct
            // read on a clobbered form (e.g. <input name="nodeType">) returns
            // the named child element. Cheap addition — nodeType is read from
            // an internal slot, no serialization cost — and removes a residual
            // clobbering surface used by several mXSS / PI / comment branches
            // in _sanitizeElements that compare currentNode.nodeType directly.
            element.nodeType !== getNodeType(element) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
            // "childNodes" shadows the prototype getter. Direct reads of
            // form.childNodes from a clobbered form return the named child
            // instead of the real NodeList, so any walk that reads it directly
            // skips the form's real children. Compare the direct read to the
            // cached Node.prototype getter — when the form's named-property
            // getter intercepts the read, the two values differ and we flag
            // the form. This catches every clobbering child type (input,
            // select, etc.) regardless of whether the named child happens to
            // carry a numeric .length, which a typeof-based probe would miss
            // (e.g. HTMLSelectElement.length is a defined unsigned-long).
            element.childNodes !== getChildNodes(element);
        };
        /**
     * Checks whether the given value is a DocumentFragment from any realm.
     *
     * The realm-independent replacement reads `nodeType` through the cached
     * Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
     * constant (11). nodeType is a numeric value resolved from the node's
     * internal slot, identical across realms for the same kind of node.
     *
     * @param value object to check
     * @return true if value is a DocumentFragment-shaped node from any realm
     */ const _isDocumentFragment = function _isDocumentFragment(value) {
            if (!getNodeType || typeof value !== 'object' || value === null) return false;
            try {
                return getNodeType(value) === NODE_TYPE.documentFragment;
            } catch (_) {
                return false;
            }
        };
        /**
     * Checks whether the given object is a DOM node, including nodes that
     * originate from a different window/realm (e.g. an iframe's
     * contentDocument). The previous `value instanceof Node` check was
     * realm-bound: nodes from a different window failed it, causing
     * sanitize() to silently stringify them and reset IN_PLACE to false,
     * returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
     *
     * @param value object to check whether it's a DOM node
     * @return true if value is a DOM node from any realm
     */ const _isNode = function _isNode(value) {
            if (!getNodeType || typeof value !== 'object' || value === null) return false;
            try {
                return typeof getNodeType(value) === 'number';
            } catch (_) {
                return false;
            }
        };
        function _executeHooks(hooks, currentNode, data) {
            if (hooks.length === 0) return;
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * Structural-threat checks that condemn a node regardless of the
     * allowlists: mXSS via namespace confusion, risky CSS construction,
     * processing instructions, markup-bearing comments. Pure predicate;
     * the caller removes. Check order is load-bearing.
     *
     * @param currentNode the node to inspect
     * @param tagName the node's transformCaseFunc'd tag name
     * @return true if the node must be removed
     */ const _isUnsafeNode = function _isUnsafeNode(currentNode, tagName) {
            /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.textContent) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) return true;
            /* Remove risky CSS construction leading to mXSS */ if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && tagName === 'style' && _isNode(currentNode.firstElementChild)) return true;
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.processingInstruction) return true;
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, currentNode.data)) return true;
            return false;
        };
        /**
     * Handle a node whose tag is forbidden or not allowlisted: keep
     * allowed custom elements (false return exits _sanitizeElements
     * early - the namespace and fallback-tag removal checks are
     * intentionally skipped for kept custom elements), else hoist
     * content per KEEP_CONTENT and remove.
     *
     * A kept custom element is the ONLY case in which this function
     * returns false, so the caller uses that return value to run the
     * afterSanitizeElements hook on the kept element and keep the
     * element-hook lifecycle consistent with normal allowlisted
     * elements (GHSA-c2j3-45gr-mqc4).
     *
     * @param currentNode the disallowed node
     * @param tagName the node's transformCaseFunc'd tag name
     * @return true if the node was removed, false if kept
     */ const _sanitizeDisallowedNode = function _sanitizeDisallowedNode(currentNode, tagName, root) {
            /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
            }
            /* Keep content except for bad-listed elements.
           Use the cached prototype getters exclusively — the previous code
           had `|| currentNode.parentNode` / `|| currentNode.childNodes`
           fallbacks, but the cached getters always return the canonical
           value (or null for a real parent-less node), so the fallback
           path was dead in safe cases and a clobbering surface in unsafe
           ones. Falsy cached results stay falsy; the `if (childNodes &&
           parentNode)` check already gates correctly. */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                const parentNode = getParentNode(currentNode);
                const childNodes = getChildNodes(currentNode);
                if (childNodes && parentNode) {
                    const childCount = childNodes.length;
                    /* Hoist by moving each child up one level rather than deep-cloning
               it. Moving transfers every descendant exactly once, so a chain of
               nested disallowed elements costs O(n) instead of the O(n^2) that
               re-cloning the shrinking subtree at each level produced; it also
               empties the removed original, so `DOMPurify.removed` no longer
               pins whole subtrees. Moving preserves the in-place guarantee too:
               an original carrying already-queued resource events (`<img
               onerror>`, `<video>`/`<audio>` error, lazy/`onload`, …) is
               relocated and sanitised rather than left detached but still armed.
                        The sole case that must clone is removing the walk root itself.
               The result is serialised from the root's subtree, so a restrictive
               ALLOWED_TAGS that strips the root (`body` on the string path) must
               leave the content inside it, which only cloning does. In IN_PLACE
               the root is pre-validated as an allowed tag and so is never removed
               here, so that path always takes the move branch.
                        `childNodes` is live; a tail-to-head walk keeps `childNodes[i]`
               valid whether we move (drops the trailing entry) or clone (leaves
               the list intact). */ for(let i = childCount - 1; i >= 0; --i){
                        const hoisted = currentNode === root ? cloneNode(childNodes[i], true) : childNodes[i];
                        parentNode.insertBefore(hoisted, getNextSibling(currentNode));
                    }
                }
            }
            _forceRemove(currentNode);
            return true;
        };
        /**
     * Fork a hook-mutable allowlist off its shared binding the first time a
     * (possibly lazily-installed) uponSanitize* hook is about to see it, so the
     * hook cannot widen the per-instance default or the setConfig binding by
     * reference and leak past the call. Returns the set unchanged once it is
     * already call-local, so repeated calls across elements are idempotent.
     *
     * @param hookList the uponSanitize* hook array for this event
     * @param set the current ALLOWED_TAGS / ALLOWED_ATTR binding
     * @param defaultSet the per-instance DEFAULT_ALLOWED_* constant
     * @param setConfigSet the captured setConfig() binding, or null
     * @return a call-local clone if a hook is present and set is still shared,
     *   else set unchanged
     */ const _forkSharedAllowlist = function _forkSharedAllowlist(hookList, set, defaultSet, setConfigSet) {
            if (hookList.length === 0) return set;
            return set === defaultSet || set === setConfigSet ? clone(set) : set;
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ // eslint-disable-next-line complexity
        const _sanitizeElements = function _sanitizeElements(currentNode, root) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* A hook may have detached the node - treat it as removed (see the
         detached-node comment after the uponSanitizeElement hook below). On
         the IN_PLACE path, neutralize the detached subtree first so a queued
         resource handler on it cannot fire in page scope after we return. */ if (currentNode !== root && getParentNode(currentNode) === null) {
                if (IN_PLACE) _neutralizeSubtree(currentNode);
                return true;
            }
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(getNodeName ? getNodeName(currentNode) : currentNode.nodeName);
            /* Close the pre-walk clone-guard's timing gap: an uponSanitizeElement
         hook may have been installed after that guard sampled the hook arrays
         (e.g. lazily from beforeSanitizeElements), leaving ALLOWED_TAGS still
         aliasing a shared binding that a widening hook would mutate by
         reference. Fork it before exposing it to the hook. */ ALLOWED_TAGS = _forkSharedAllowlist(hooks.uponSanitizeElement, ALLOWED_TAGS, DEFAULT_ALLOWED_TAGS, SET_CONFIG_ALLOWED_TAGS);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* A hook may have detached the node from the tree — a long-standing
         user pattern (issue #469; draw.io-style foreignObject filtering).
         Per the cached, unclobberable parentNode getter the node is
         genuinely out of the tree, so it can reach neither the serialized
         output nor an IN_PLACE live tree; treat it as removed and stop
         processing it. Without this guard, the unsafe-node / namespace
         checks below would call _forceRemove on a parentless node and hit
         the REPORT-3 fail-closed throw — which exists for nodes DOMPurify
         wants gone but *cannot* detach (clobbered / parentless roots), the
         opposite of a node that is already safely gone. The walk root is
         exempt: a detached IN_PLACE root is legitimate input and must still
         be fully sanitized, and a kill-decision on it must keep hitting the
         REPORT-3 throw. Nodes detached by hooks stay the hook's
         responsibility for placement: they are not recorded in
         DOMPurify.removed, so the post-walk IN_PLACE pass (which iterates
         DOMPurify.removed) does not reach them. But a hook-detached subtree
         can still hold a queued resource-event handler - e.g. an <img onload>
         that began loading when the caller built the live tree - which fires
         in page scope after sanitize returns even though the handler never
         reached the returned tree. That is the audit-5 F1 hazard, and the
         documented node.remove() hook pattern walks straight into it. So on
         the IN_PLACE path we neutralize the detached subtree inline here,
         stripping its non-allow-listed attributes before returning, exactly
         as the post-walk pass does for _forceRemove'd subtrees. */ if (currentNode !== root && getParentNode(currentNode) === null) {
                if (IN_PLACE) _neutralizeSubtree(currentNode);
                return true;
            }
            /* Remove mXSS vectors, processing instructions and risky comments */ if (_isUnsafeNode(currentNode, tagName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
                const removed = _sanitizeDisallowedNode(currentNode, tagName, root);
                /* A false return means the node is a custom element kept via
           CUSTOM_ELEMENT_HANDLING - the only keep path through
           _sanitizeDisallowedNode. Run afterSanitizeElements on it so the
           element-hook lifecycle matches normal allowlisted elements: a
           security policy applied in this hook (e.g. stripping an attribute
           from every surviving element) must not silently skip kept custom
           elements (GHSA-c2j3-45gr-mqc4). This mirrors the normal-element
           tail below - the hook runs, then the walker's subsequent
           _sanitizeAttributes pass sanitizes the element's attributes. The
           deliberately skipped namespace and fallback-tag removal checks stay
           skipped; they are removal decisions, not the hook contract. */ if (removed === false) _executeHooks(hooks.afterSanitizeElements, currentNode, null);
                return removed;
            }
            /* Check whether element has a valid namespace.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): use the cached Node.prototype
         nodeType getter rather than `instanceof Element`, which is realm-
         bound and short-circuits to false for any node minted in a different
         realm — letting a foreign-realm element with a forbidden namespace
         slip past the namespace check entirely. */ const nt = getNodeType ? getNodeType(currentNode) : currentNode.nodeType;
            if (nt === NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ const content = _stripTemplateExpressions(currentNode.textContent);
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
            /* Reject declarative-partial-updates patch-linkage attributes
         (https://github.com/WICG/declarative-partial-updates).
              Empirical note (Chrome 150, verified — see
         test/declarative-patch-probe-v3.html): expansion is NOT applied after
         sanitization. For the string path it fires during sanitize()'s own
         parse, so the walk sees and sanitizes the fully materialized expanded
         tree — teleports into MathML/SVG integration points included; a
         weaponized `<template for>`->`<img onerror>` comes back with the handler
         stripped. For the IN_PLACE path it fires on connection, before the walk.
         Either way DOMPurify is NOT blind to the patch.
              This removal is therefore defense-in-depth rather than the sole barrier:
         it prevents live linkage from surviving into the OUTPUT and re-expanding
         in the caller's context, and keeps behaviour deterministic if a future
         engine defers expansion. `for` is legitimate only on <label>/<output>;
         anywhere else (notably <template for>) it links the element to a patch
         target and teleports or removes an arbitrary DOM range by id/marker name.
         `patchsrc` fetches remote markup and is treated as a script-loading
         mechanism (CSP). Gated on SAFE_FOR_XML so the removal groups with the
         other structural-threat checks and stays overridable, consistent with
         the rest of the codebase. PI range markers are already removed by
         _isUnsafeNode. */ if (SAFE_FOR_XML && lcName === 'patchsrc') return false;
            if (SAFE_FOR_XML && lcName === 'for' && lcTag !== 'label' && lcTag !== 'output') return false;
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!nameIsPermitted) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /* Names the HTML spec reserves from valid-custom-element-name; these must
     * never be treated as basic custom elements even when a permissive
     * CUSTOM_ELEMENT_HANDLING.tagNameCheck is configured. */ const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, [
            'annotation-xml',
            'color-profile',
            'font-face',
            'font-face-format',
            'font-face-name',
            'font-face-src',
            'font-face-uri',
            'missing-glyph'
        ]);
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT$1, tagName);
        };
        /**
     * Wrap an attribute value in the matching Trusted Types object when
     * the active policy requires it. Namespaced attributes pass through
     * unchanged (no TT support yet, see
     * https://bugs.chromium.org/p/chromium/issues/detail?id=1305293).
     *
     * @param lcTag lowercase tag name of the containing element
     * @param lcName lowercase attribute name
     * @param namespaceURI the attribute's namespace, if any
     * @param value the attribute value to wrap
     * @return the value, wrapped when Trusted Types demand it
     */ const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value) {
            if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function' && !namespaceURI) switch(trustedTypes.getAttributeType(lcTag, lcName)){
                case 'TrustedHTML':
                    return _createTrustedHTML(value);
                case 'TrustedScriptURL':
                    return _createTrustedScriptURL(value);
            }
            return value;
        };
        /**
     * Write a modified attribute value back onto the element. On
     * success, re-probe for clobbering introduced by the new value and
     * remove the element when found; otherwise pop the removal entry
     * recorded by the earlier _removeAttribute (long-standing pairing
     * with the SANITIZE_NAMED_PROPS path - do not "fix" casually). On
     * failure, remove the attribute instead.
     *
     * @param currentNode the element carrying the attribute
     * @param name the attribute name as present on the element
     * @param namespaceURI the attribute's namespace, if any
     * @param value the new attribute value
     */ const _setAttributeValue = function _setAttributeValue(currentNode, name, namespaceURI, value) {
            try {
                if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                if (_isClobbered(currentNode)) _forceRemove(currentNode);
                else arrayPop(DOMPurify.removed);
            } catch (_) {
                _removeAttribute(name, currentNode);
            }
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            /* Same lazy-install guard as uponSanitizeElement (see there): fork the
         attribute allowlist off its shared binding before a hook can see it. */ ALLOWED_ATTR = _forkSharedAllowlist(hooks.uponSanitizeAttribute, ALLOWED_ATTR, DEFAULT_ALLOWED_ATTR, SET_CONFIG_ALLOWED_ATTR);
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            const lcTag = transformCaseFunc(currentNode.nodeName);
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === 'value' ? initValue : stringTrim(initValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name') && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                // Else: already prefixed, leave the attribute alone — the prefix is
                // itself the clobbering protection, and re-applying it is incorrect.
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && stringMatch(value, 'href')) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks force-keep the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(SELF_CLOSING_TAG, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) value = _stripTemplateExpressions(value);
                /* Is `value` valid for this attribute? */ if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
                /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) _setAttributeValue(currentNode, name, namespaceURI, value);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode, fragment);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected.
           Realm-safe check (GHSA-hpcv-96wg-7vj8): use nodeType against the
           DOCUMENT_FRAGMENT_NODE constant rather than instanceof, so we
           recurse into <template>.content from foreign realms too. */ if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
                /* An element iterated here may itself host an attached
           shadow root. The default NodeIterator does not enter shadow
           trees, so a shadow root nested inside template.content was
           previously reached by no walk at all (the pre-pass at
           _sanitizeAttachedShadowRoots descends via childNodes, which
           doesn't enter template.content; the template-content recursion
           above iterates the content but never inspected shadowRoot).
           Walk it explicitly. The nodeType guard avoids reading
           shadowRoot off text / comment / CDATA / PI nodes that the
           iterator also surfaces. */ const shadowNodeType = getNodeType ? getNodeType(shadowNode) : shadowNode.nodeType;
                if (shadowNodeType === NODE_TYPE.element) {
                    const innerSr = getShadowRoot(shadowNode);
                    if (_isDocumentFragment(innerSr)) {
                        _sanitizeAttachedShadowRoots(innerSr);
                        _sanitizeShadowDOM2(innerSr);
                    }
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        /**
     * _sanitizeAttachedShadowRoots
     *
     * Walks `root` and feeds every attached shadow root we encounter into
     * the existing _sanitizeShadowDOM pipeline. The default node iterator
     * does not descend into shadow trees, so nodes inside an attached
     * shadow root would otherwise be skipped entirely.
     *
     * Two real input paths put attached shadow roots in front of us:
     *   1. IN_PLACE on a DOM node that already has shadow roots attached.
     *   2. DOM-node input where importNode(dirty, true) deep-clones the
     *      shadow root because it was created with `clonable: true`.
     *
     * This pass runs once, up front, so the main iteration loop (and the
     * existing _sanitizeShadowDOM template-content recursion) stay
     * untouched — string-input paths are not affected.
     *
     * @param root the subtree root to walk for attached shadow roots
     */ const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots(root) {
            /* Iterative (explicit stack) rather than per-child recursion. DOM APIs
         impose no depth cap, so an attacker-shaped tree (JSON/CRDT/editor data
         built straight into the DOM — the IN_PLACE surface) deeper than the JS
         call-stack budget would otherwise overflow native recursion here and
         throw at the IN_PLACE entry pre-pass, before a single node is
         sanitized, leaving the caller's live tree untouched (fail-open). See
         campaign-3 F4. A heap stack keeps depth off the call stack.
              Each work item is either a node to descend into, or a deferred
         `_sanitizeShadowDOM` for an already-walked shadow root. The deferred
         form preserves the original post-order discipline: a shadow root's
         nested shadow roots are discovered before the outer shadow is
         sanitized (which may remove hosts). Pushes are in reverse of the
         desired processing order (LIFO): template content, then children, then
         the shadow-sanitize, then the shadow walk — so the order matches the
         previous recursion exactly. */ const stack = [
                {
                    node: root,
                    shadow: null
                }
            ];
            while(stack.length > 0){
                const item = stack.pop();
                /* Deferred shadow-DOM sanitisation: runs after its subtree was walked. */ if (item.shadow) {
                    _sanitizeShadowDOM2(item.shadow);
                    continue;
                }
                const node = item.node;
                const nodeType = getNodeType ? getNodeType(node) : node.nodeType;
                const isElement = nodeType === NODE_TYPE.element;
                /* (pushed last → processed first) Children, snapshotted in reverse so
           the first child is processed first. Snapshotting matters because a
           hook may detach siblings mid-walk. */ const childNodes = getChildNodes(node);
                if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push({
                    node: childNodes[i],
                    shadow: null
                });
                /* (pushed before children → processed after them, matching the old
           "template content last" order) When the node is a <template>,
           descend into its content. */ if (isElement) {
                    const rootName = getNodeName ? getNodeName(node) : null;
                    if (typeof rootName === 'string' && transformCaseFunc(rootName) === 'template') {
                        const content = node.content;
                        if (_isDocumentFragment(content)) stack.push({
                            node: content,
                            shadow: null
                        });
                    }
                }
                /* Shadow root (processed first): walk its subtree, then sanitise it.
           Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
           rather than `instanceof DocumentFragment`, which is realm-bound and
           silently skipped foreign-realm shadow roots (e.g.
           iframe.contentDocument attachShadow). */ if (isElement) {
                    const sr = getShadowRoot(node);
                    if (_isDocumentFragment(sr)) /* Push the deferred sanitise first so it pops after the shadow
               walk we push next, i.e. nested shadow roots are discovered
               before this one is sanitised. */ stack.push({
                        node: null,
                        shadow: sr
                    }, {
                        node: sr,
                        shadow: null
                    });
                }
            }
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                dirty = stringifyValue(dirty);
                if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (SET_CONFIG) {
                /* Persistent setConfig() path: _parseConfig is skipped, so the sets are
         * not re-derived per call. Restore them from the pristine bindings
         * captured at setConfig() time so a previous call's hook clone (mutated
         * below) does not carry over. */ ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
                ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
            } else _parseConfig(cfg);
            /* Clone the hook-mutable allowlists before the walk whenever an
       * uponSanitize* hook is registered. The hook event exposes ALLOWED_TAGS
       * and ALLOWED_ATTR by reference (as allowedTags / allowedAttributes), so
       * a hook that widens them would otherwise mutate the shared set
       * permanently: across later calls and across every element. Cloning per
       * walk keeps documented in-call widening working while scoping it to the
       * call. A single guard for both config paths - the per-call path rebinds
       * the sets in _parseConfig each call, the persistent path restores them
       * from the captured bindings just above - so the two cannot diverge. */ if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) ALLOWED_TAGS = clone(ALLOWED_TAGS);
            if (hooks.uponSanitizeAttribute.length > 0) ALLOWED_ATTR = clone(ALLOWED_ATTR);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Resolve IN_PLACE for this call without mutating persistent config.
         Writing the IN_PLACE closure variable here leaks under setConfig(),
         where _parseConfig is skipped on later calls: a single string call would
         disable in-place mode for every subsequent node call, returning a
         sanitized copy while leaving the caller's node — which in-place callers
         keep using and whose return value they ignore — unsanitized. REPORT-2. */ const inPlace = IN_PLACE && typeof dirty !== 'string' && _isNode(dirty);
            if (inPlace) {
                /* Declarative-partial-updates / streaming pre-pass: sever every patch
           linkage across the live tree BEFORE the walk, so no patch can fire
           mid-walk and inject into an already-processed region. Runs first, so
           it also covers the forbidden/clobbered roots that throw below. */ _neutralizePatchLinkage(dirty);
                /* Do some early pre-sanitization to avoid unsafe root nodes.
           Read nodeName through the cached prototype getter — a clobbering
           child named "nodeName" on the form root would otherwise shadow
           the property and let this check skip the root-allowlist
           validation entirely. */ const nn = getNodeName ? getNodeName(dirty) : dirty.nodeName;
                if (typeof nn === 'string') {
                    const tagName = transformCaseFunc(nn);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                        /* Fail closed on a live root: neutralize handlers/children before
               throwing, exactly as the mid-walk abort path does. */ _neutralizeRoot(dirty);
                        throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                    }
                }
                /* Pre-flight the root through _isClobbered. The iterator-driven
           removal path can not detach a parent-less root: _forceRemove
           falls through to Element.prototype.remove(), which per spec
           is a no-op on a node with no parent. A clobbered root would
           then survive the main loop with its attributes uninspected,
           because _sanitizeAttributes early-returns on _isClobbered. The
           result would be an attacker-controlled form, complete with any
           event-handler attributes the caller passed in, handed back to
           the application unsanitized. Refuse to sanitize such a root
           the same way we refuse a forbidden tag. GHSA-r47g-fvhr-h676. */ if (_isClobbered(dirty)) {
                    /* Fail closed on a live clobbered root before throwing.
             _neutralizeRoot's reads are clobber-safe (cached getters); the
             form's non-clobbered descendants, e.g. an armed <img>, are scrubbed. */ _neutralizeRoot(dirty);
                    throw typeErrorCreate('root node is clobbered and cannot be sanitized in-place');
                }
                /* Sanitize attached shadow roots before the main iterator runs.
           The iterator does not descend into shadow trees. Same fail-closed
           barrier as the main walk (campaign-3 F2): a custom-element reaction
           inside a shadow root could abort this pre-pass before the walk runs,
           which would otherwise leave the entire live tree unsanitized. */ try {
                    _sanitizeAttachedShadowRoots(dirty);
                } catch (error) {
                    _neutralizeRoot(dirty);
                    throw error;
                }
            } else if (_isNode(dirty)) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
                /* Clonable shadow roots are deep-cloned by importNode(); sanitize
           them before the main iterator runs, since the iterator does not
           descend into shadow trees. The walk routes every read through a
           cached prototype getter so clobbering descendants on a form root
           cannot hide a shadow host from this pass. */ _sanitizeAttachedShadowRoots(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const walkRoot = inPlace ? dirty : body;
            /* Now start iterating over the created document.
         The walk runs inside an exception barrier (campaign-3 F2): a re-entrant
         engine/custom-element mutation can detach a node mid-walk so
         `_forceRemove`'s parentless guard throws, aborting the loop. Without the
         barrier the caller's in-place tree would be left half-sanitized with the
         unvisited tail still armed. _createNodeIterator itself is inside the
         barrier too: constructing the iterator dereferences the root's document,
         and any failure there (e.g. an exotic/clobbered root) must still fail
         closed rather than skip the neutralize. On any throw we fail closed -
         strip the in-place root bare - then rethrow so the existing throw
         contract is preserved. (String/DOM-copy paths never return the partial
         body, so the propagating throw is already fail-closed there.) */ try {
                const nodeIterator = _createNodeIterator(walkRoot);
                while(currentNode = nodeIterator.nextNode()){
                    /* Sanitize tags and elements */ _sanitizeElements(currentNode, walkRoot);
                    /* Check attributes next */ _sanitizeAttributes(currentNode);
                    /* Shadow DOM detected, sanitize it.
             Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
             instead of instanceof, so foreign-realm <template>.content is
             walked correctly. */ if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
                }
            } catch (error) {
                if (inPlace) {
                    _neutralizeRoot(dirty);
                    /* Nodes _forceRemove'd earlier in the aborted walk are already
             detached from the root, so _neutralizeRoot's subtree pass does not
             reach them. Defuse them too, mirroring the success-path loop below. */ arrayForEach(DOMPurify.removed, (entry)=>{
                        if (entry.element) _neutralizeSubtree(entry.element);
                    });
                }
                throw error;
            }
            /* If we sanitized `dirty` in-place, return it. */ if (inPlace) {
                /* Fail-closed completion of the audit-5 F1 fix: every node removed from
           the caller's live tree is detached but may still hold a queued
           resource-event handler that fires in page scope after we return. The
           move-hoist covers only disallowed-tag KEEP_CONTENT removals; strip the
           non-allow-listed attributes off every other removed subtree (clobber,
           mXSS, namespace, comments, KEEP_CONTENT:false, …) so those handlers are
           cancelled before any event can fire. Runs synchronously, pre-return. */ arrayForEach(DOMPurify.removed, (entry)=>{
                    if (entry.element) _neutralizeSubtree(entry.element);
                });
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(dirty);
                return dirty;
            }
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(body);
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) serializedHTML = _stripTemplateExpressions(serializedHTML);
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
            SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
            SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
            SET_CONFIG_ALLOWED_TAGS = null;
            SET_CONFIG_ALLOWED_ATTR = null;
            // Drop any caller-supplied Trusted Types policy so it cannot poison later
            // `RETURN_TRUSTED_TYPE` output. The internal default policy (cached, and
            // never recreated — Trusted Types throws on duplicate names) is restored by
            // the next `_parseConfig`. See GHSA-vxr8-fq34-vvx9.
            trustedTypesPolicy = defaultTrustedTypesPolicy;
            emptyHTML = '';
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            /* Reject unknown entry points. Without this, a non-hook key (e.g.
       * '__proto__') indexes off the prototype chain rather than a real
       * hook array, and arrayPush then writes to Object.prototype. Guard
       * with an own-property check against the known hook names. */ if (!objectHasOwnProperty(hooks, entryPoint)) return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (!objectHasOwnProperty(hooks, entryPoint)) return undefined;
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            if (!objectHasOwnProperty(hooks, entryPoint)) return;
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


const $cf4d99a15e7ffead$var$sanitize = (content)=>(0, (/*@__PURE__*/$parcel$interopDefault($a891510b26e6e0ec$exports))).sanitize(content, {
        RETURN_DOM_FRAGMENT: false,
        RETURN_DOM: false,
        USE_PROFILES: {
            html: true,
            svg: true,
            svgFilters: true
        },
        ADD_TAGS: [
            'use'
        ]
    });
var $cf4d99a15e7ffead$export$2e2bcd8739ae039 = $cf4d99a15e7ffead$var$sanitize;


const $084901060266a3ff$export$7892ac5e21f7f65f = ()=>`${window.location.pathname}${window.location.search}`;
const $084901060266a3ff$export$b133e49578bc0022 = (key)=>{
    window.sessionStorage.removeItem(key);
    return true;
};
const $084901060266a3ff$export$90cc9345251baa19 = (url)=>$084901060266a3ff$export$b133e49578bc0022(url);
const $084901060266a3ff$export$5f485f7748acb272 = (key, value)=>{
    window.sessionStorage.setItem(key, value);
    return true;
};
const $084901060266a3ff$export$9e136a631bf74376 = (key)=>window.sessionStorage.getItem(key);
const $084901060266a3ff$export$ea606431d2f3c045 = (url, replaceSelectors = true)=>{
    const data = JSON.parse($084901060266a3ff$export$9e136a631bf74376(url) || '[]');
    if (!replaceSelectors) return data;
    data.forEach((item)=>{
        const wrapper = document.querySelector(item.selector);
        if (!wrapper) return;
        wrapper.outerHTML = (0, $cf4d99a15e7ffead$export$2e2bcd8739ae039)(item.element);
    });
};
const $084901060266a3ff$export$47393a4c08668ccd = (url, ...selectors)=>{
    const data = [];
    selectors.forEach((selector)=>{
        data.push({
            selector: selector,
            element: document.querySelector(selector)?.outerHTML || ''
        });
    });
    return $084901060266a3ff$export$5f485f7748acb272(url, JSON.stringify(data));
};
const $084901060266a3ff$export$421eaf623316c864 = (url)=>{
    Object.keys(window.sessionStorage).forEach((item)=>{
        if (!(item === url || item.includes('take=async'))) return;
        $084901060266a3ff$export$b133e49578bc0022(item);
    });
};


class $d587f703cacf0ca0$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.buttons = this.querySelectorAll('button');
        this.action = this.getAttribute('data-tk-action') || window.location.href;
        this.sortFieldName = this.getAttribute('data-tk-article-list-sort-name') || 'field-sort';
        this.articleList = document.querySelector('[data-tk-article-list-to-sort]') || undefined;
        this.headerElement = this.articleList?.querySelector('[data-tk-article-list-header]') || undefined;
        this.gridElement = this.articleList?.querySelector('[data-tk-article-list-grid]') || undefined;
        this.pagingElement = this.articleList?.querySelector('[data-tk-article-list-paging]') || undefined;
    }
    connectedCallback() {
        if (!this.articleList) throw new Error('TKArticleListSort: Article list is missing!');
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.sortList.bind(this);
        this.buttons.forEach((button)=>{
            this.pushListener({
                event: 'click',
                element: button,
                action: onClick
            });
        });
    }
    sortList(event) {
        if (!event.target) return;
        const { value: value } = event.currentTarget;
        const data = {
            [this.sortFieldName]: value,
            originalUrl: window.location.href
        };
        const dimmer = (0, $4cfe9ec7fa1b3e1e$export$2e2bcd8739ae039)();
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.action,
            resolveHandler: this.refreshResultList.bind(this),
            payload: data
        }).finally(()=>{
            this.remove();
            dimmer.remove();
        });
    }
    refreshResultList(response) {
        if (!response || !response.success) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        const headerElement = html.querySelector('[data-tk-article-list-header]');
        const gridElement = html.querySelector('[data-tk-article-list-grid]');
        const pagingElement = html.querySelector('[data-tk-article-list-paging]');
        if (headerElement) this.headerElement.innerHTML = headerElement.innerHTML;
        if (gridElement) this.gridElement.innerHTML = gridElement.innerHTML;
        if (this.pagingElement && pagingElement) this.pagingElement.innerHTML = pagingElement.innerHTML;
        (0, $084901060266a3ff$export$90cc9345251baa19)((0, $084901060266a3ff$export$7892ac5e21f7f65f)());
    }
}





class $aae44772e434b2fe$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.layouts = [];
        this.articleList = document.querySelector('[data-tk-article-list-to-switch-layout]') || undefined;
        this.url = this.getAttribute('data-tk-url') || undefined;
    }
    connectedCallback() {
        if (!this.articleList || !this.url) throw new Error('TKArticleListLayoutSwitch: Elements are missing!');
        this.initLayouts();
        this.registerLayoutListener();
    }
    initLayouts() {
        const fieldElements = this.querySelectorAll('input');
        fieldElements.forEach((element)=>{
            this.layouts.push({
                id: element.value,
                className: element.getAttribute('data-tk-layout-class-name') || undefined
            });
        });
    }
    registerLayoutListener() {
        const radioElements = this.querySelectorAll('input');
        const onInput = this.handleInput.bind(this);
        radioElements.forEach((element)=>{
            this.pushListener({
                event: 'input',
                element: element,
                action: onInput
            });
        });
    }
    handleInput(event) {
        if (!event.target) return;
        const { value: value } = event.target;
        this.switchLayout(value);
        this.saveSelectedLayout(value);
        (0, $084901060266a3ff$export$47393a4c08668ccd)((0, $084901060266a3ff$export$7892ac5e21f7f65f)(), '[data-tk-article-list]');
    }
    switchLayout(id) {
        this.layouts.forEach((item)=>{
            const className = item.className || '';
            this.articleList.classList.contains(className) && this.articleList.classList.remove(className);
        });
        const layoutItem = this.layouts.find((item)=>item.id === id);
        layoutItem?.className && this.articleList.classList.add(layoutItem.className);
    }
    saveSelectedLayout(value) {
        const data = {
            value: value
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.url,
            resolveHandler: ()=>{},
            payload: data
        });
    }
}



class $4c4645f38df6caf9$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.scrollingWrapper = this.querySelector('[data-tk-scrolling-wrapper]') || undefined;
    }
    connectedCallback() {
        if (!this.scrollingWrapper) return;
        this.scrollEnd();
    }
    scrollEnd() {
        const { scrollWidth: scrollWidth } = this.scrollingWrapper;
        const { width: width } = this.scrollingWrapper.getBoundingClientRect();
        this.scrollingWrapper?.scrollTo({
            behavior: 'smooth',
            left: scrollWidth - width
        });
    }
}





const $f8125d35cd9a4f7a$var$storeRegistry = {};
async function $f8125d35cd9a4f7a$export$7d8a5b498da695ac(stores) {
    Object.keys(stores).forEach((key)=>{
        $f8125d35cd9a4f7a$var$storeRegistry[key] = stores[key];
    });
    await Promise.all(Object.values(stores).map((store)=>store.startInitialization()));
}
function $f8125d35cd9a4f7a$export$6ccbb43953eebf8(storeName) {
    const store = $f8125d35cd9a4f7a$var$storeRegistry[storeName];
    if (!store) throw new Error(`Store not found: ${storeName}`);
    return store;
}
async function $f8125d35cd9a4f7a$export$be9343d232c38cbb(key) {
    const store = $f8125d35cd9a4f7a$var$storeRegistry[key];
    if (store) return store.isInitialized;
    return Promise.reject(`Store ${key} not found`);
}


var $cc14b9b65c9c652e$export$7df56cf357be2b81 = /*#__PURE__*/ function(CompareButtonType) {
    CompareButtonType["ADD"] = "add";
    CompareButtonType["REMOVE"] = "remove";
    CompareButtonType["REMOVE_ALL"] = "removeAll";
    return CompareButtonType;
}({});
class $cc14b9b65c9c652e$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.button = this.querySelector('button') || undefined;
        this.counter = this.button?.querySelector('[data-tk-counter-info') || undefined;
        this.activeClass = this.getAttribute('data-tk-compare-active-class') || 'tk-compare-button--active';
        this.articleId = Number(this.getAttribute('data-tk-article-id') || 0);
        this.categoryId = Number(this.getAttribute('data-tk-category-id') || 0);
        this.categoryName = this.getAttribute('data-tk-category-name') || undefined;
        this.type = this.getAttribute('data-tk-type') || "add";
    }
    async connectedCallback() {
        if (!this.button) throw new Error('Compare: Button is missing!');
        await (0, $f8125d35cd9a4f7a$export$be9343d232c38cbb)('compareStore');
        this.store = (0, $f8125d35cd9a4f7a$export$6ccbb43953eebf8)('compareStore');
        this.initializeDatabase();
        this.registerClickListener();
    }
    disconnectedCallback() {
        this.unsubscribe && this.unsubscribe();
    }
    registerClickListener() {
        this.pushListener({
            event: 'click',
            element: this,
            action: this.runActionByType.bind(this)
        });
    }
    async runActionByType() {
        if (!this.store) return;
        const handler = {
            add: this.toggle.bind(this),
            remove: this.remove.bind(this),
            removeAll: this.clearAll.bind(this)
        };
        handler[this.type]();
    }
    initializeDatabase() {
        if (!this.store) return;
        this.unsubscribe = this.store.subscribe(()=>this.render());
        this.render();
    }
    clearAll() {
        if (!this.store) return;
        this.button.disabled = true;
        this.store.clearAll().then(()=>{
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).allRemoved.text);
            this.button.disabled = false;
        });
    }
    async remove() {
        if (!this.categoryId || !this.articleId || !this.store) throw new Error('Category or article id is missing!');
        const category = this.store.getCategoryById(this.categoryId);
        if (!category) return;
        const filteredArticles = category.articleIds.filter((id)=>id !== this.articleId);
        if (filteredArticles.length === 0) {
            await this.store.removeCategoryById(this.categoryId);
            const categories = this.store?.getState().categories;
            this.store?.switchCategory(categories?.at(0)?.id || 0);
        } else {
            category.articleIds = filteredArticles;
            await this.store.patchCategoryById(this.categoryId, category);
        }
    }
    async toggle() {
        if (!this.categoryId || !this.articleId || !this.store) throw new Error('Category or article id is missing!');
        const category = this.store.getCategoryById(this.categoryId);
        if (category) await this.updateExistingCategory(category);
        else await this.createNewCategory();
    }
    async updateExistingCategory(category) {
        const articleExists = category.articleIds.includes(this.articleId);
        if (articleExists) {
            category.articleIds = category.articleIds.filter((id)=>id !== this.articleId);
            const articleCount = this.store?.getArticleCountByCategoryId(category.id);
            if (articleCount === 0) await this.store?.removeCategoryById(this.categoryId);
            else await this.store?.patchCategoryById(this.categoryId, category);
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).removed.text);
        } else {
            category.articleIds.push(this.articleId);
            await this.store?.patchCategoryById(this.categoryId, category);
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).added.text);
        }
    }
    async createNewCategory() {
        const newCategory = {
            id: this.categoryId,
            name: this.categoryName || '',
            articleIds: [
                this.articleId
            ]
        };
        await this.store?.patchCategoryById(this.categoryId, newCategory);
        (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$ad480231e1cfb49).added.text);
    }
    checkAvailability() {
        if (!this.store) return;
        const { currentCategoryId: currentCategoryId } = this.store.getState();
        const currentCategory = this.store.getCategoryById(currentCategoryId);
        this.button.hidden = !currentCategory;
    }
    render() {
        if (this.type === "add") {
            const category = this.store?.getCategoryById(this.categoryId);
            if (!category) {
                this.classList.remove(this.activeClass);
                return;
            }
            this.classList.toggle(this.activeClass, category.articleIds.includes(this.articleId));
        } else if (this.type === "removeAll") this.checkAvailability();
    }
}


class $562c28a8df1194c9$export$60b03b353ad03260 {
    constructor(initialState){
        this.listeners = [];
        this.state = initialState;
        this.isInitialized = new Promise((resolve)=>{
            this.resolveInitialize = resolve;
        });
    }
    async startInitialization() {
        await this.initialize();
        this.resolveInitialize();
    }
    subscribe(callback) {
        this.listeners.push(callback);
        return ()=>{
            this.listeners = this.listeners.filter((listener)=>listener !== callback);
        };
    }
    notifyListeners(action) {
        this.listeners.forEach((listener)=>listener({
                state: this.state,
                action: action
            }));
    }
    notify(action, state) {
        this.state = {
            ...this.state,
            ...state
        };
        console.log(`Action: ${action}`, state);
        this.notifyListeners(action);
    }
}


const $7818c326be87ea84$var$instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $7818c326be87ea84$var$idbProxyableTypes;
let $7818c326be87ea84$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $7818c326be87ea84$var$getIdbProxyableTypes() {
    return $7818c326be87ea84$var$idbProxyableTypes || ($7818c326be87ea84$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $7818c326be87ea84$var$getCursorAdvanceMethods() {
    return $7818c326be87ea84$var$cursorAdvanceMethods || ($7818c326be87ea84$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $7818c326be87ea84$var$transactionDoneMap = new WeakMap();
const $7818c326be87ea84$var$transformCache = new WeakMap();
const $7818c326be87ea84$var$reverseTransformCache = new WeakMap();
function $7818c326be87ea84$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($7818c326be87ea84$export$4997ffc0176396a6(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    // This mapping exists in reverseTransformCache but doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $7818c326be87ea84$var$reverseTransformCache.set(promise, request);
    return promise;
}
function $7818c326be87ea84$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($7818c326be87ea84$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $7818c326be87ea84$var$transactionDoneMap.set(tx, done);
}
let $7818c326be87ea84$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $7818c326be87ea84$var$transactionDoneMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $7818c326be87ea84$export$4997ffc0176396a6(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $7818c326be87ea84$var$replaceTraps(callback) {
    $7818c326be87ea84$var$idbProxyTraps = callback($7818c326be87ea84$var$idbProxyTraps);
}
function $7818c326be87ea84$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($7818c326be87ea84$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($7818c326be87ea84$export$debb760848ca95a(this), args);
        return $7818c326be87ea84$export$4997ffc0176396a6(this.request);
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $7818c326be87ea84$export$4997ffc0176396a6(func.apply($7818c326be87ea84$export$debb760848ca95a(this), args));
    };
}
function $7818c326be87ea84$var$transformCachableValue(value) {
    if (typeof value === 'function') return $7818c326be87ea84$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $7818c326be87ea84$var$cacheDonePromiseForTransaction(value);
    if ($7818c326be87ea84$var$instanceOfAny(value, $7818c326be87ea84$var$getIdbProxyableTypes())) return new Proxy(value, $7818c326be87ea84$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $7818c326be87ea84$export$4997ffc0176396a6(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $7818c326be87ea84$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($7818c326be87ea84$var$transformCache.has(value)) return $7818c326be87ea84$var$transformCache.get(value);
    const newValue = $7818c326be87ea84$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $7818c326be87ea84$var$transformCache.set(value, newValue);
        $7818c326be87ea84$var$reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const $7818c326be87ea84$export$debb760848ca95a = (value)=>$7818c326be87ea84$var$reverseTransformCache.get(value);
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $7818c326be87ea84$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = $7818c326be87ea84$export$4997ffc0176396a6(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade($7818c326be87ea84$export$4997ffc0176396a6(request.result), event.oldVersion, event.newVersion, $7818c326be87ea84$export$4997ffc0176396a6(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $7818c326be87ea84$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return $7818c326be87ea84$export$4997ffc0176396a6(request).then(()=>undefined);
}
const $7818c326be87ea84$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $7818c326be87ea84$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $7818c326be87ea84$var$cachedMethods = new Map();
function $7818c326be87ea84$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($7818c326be87ea84$var$cachedMethods.get(prop)) return $7818c326be87ea84$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $7818c326be87ea84$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $7818c326be87ea84$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $7818c326be87ea84$var$cachedMethods.set(prop, method);
    return method;
}
$7818c326be87ea84$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$7818c326be87ea84$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$7818c326be87ea84$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));
const $7818c326be87ea84$var$advanceMethodProps = [
    'continue',
    'continuePrimaryKey',
    'advance'
];
const $7818c326be87ea84$var$methodMap = {};
const $7818c326be87ea84$var$advanceResults = new WeakMap();
const $7818c326be87ea84$var$ittrProxiedCursorToOriginalProxy = new WeakMap();
const $7818c326be87ea84$var$cursorIteratorTraps = {
    get (target, prop) {
        if (!$7818c326be87ea84$var$advanceMethodProps.includes(prop)) return target[prop];
        let cachedFunc = $7818c326be87ea84$var$methodMap[prop];
        if (!cachedFunc) cachedFunc = $7818c326be87ea84$var$methodMap[prop] = function(...args) {
            $7818c326be87ea84$var$advanceResults.set(this, $7818c326be87ea84$var$ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
        };
        return cachedFunc;
    }
};
async function* $7818c326be87ea84$var$iterate(...args) {
    // tslint:disable-next-line:no-this-assignment
    let cursor = this;
    if (!(cursor instanceof IDBCursor)) cursor = await cursor.openCursor(...args);
    if (!cursor) return;
    cursor;
    const proxiedCursor = new Proxy(cursor, $7818c326be87ea84$var$cursorIteratorTraps);
    $7818c326be87ea84$var$ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
    // Map this double-proxy back to the original, so other cursor methods work.
    $7818c326be87ea84$var$reverseTransformCache.set(proxiedCursor, $7818c326be87ea84$export$debb760848ca95a(cursor));
    while(cursor){
        yield proxiedCursor;
        // If one of the advancing methods was not called, call continue().
        cursor = await ($7818c326be87ea84$var$advanceResults.get(proxiedCursor) || cursor.continue());
        $7818c326be87ea84$var$advanceResults.delete(proxiedCursor);
    }
}
function $7818c326be87ea84$var$isIteratorProp(target, prop) {
    return prop === Symbol.asyncIterator && $7818c326be87ea84$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore,
        IDBCursor
    ]) || prop === 'iterate' && $7818c326be87ea84$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore
    ]);
}
$7818c326be87ea84$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get (target, prop, receiver) {
            if ($7818c326be87ea84$var$isIteratorProp(target, prop)) return $7818c326be87ea84$var$iterate;
            return oldTraps.get(target, prop, receiver);
        },
        has (target, prop) {
            return $7818c326be87ea84$var$isIteratorProp(target, prop) || oldTraps.has(target, prop);
        }
    }));


var $9f71fef3739216f1$export$61e2e3c065b02bd0 = /*#__PURE__*/ function(CompareActions) {
    CompareActions["SWITCH_CATEGORY"] = "switchCategory";
    CompareActions["REMOVE_CATEGORY"] = "removeCategory";
    CompareActions["ADD_MULTIPLE_ITEMS"] = "addMultipleItems";
    CompareActions["PATCH_ITEM"] = "patchItem";
    CompareActions["CLEAR_TABLE"] = "clearTable";
    CompareActions["CLEAR_ALL_TABLE"] = "clearAllTable";
    return CompareActions;
}({});
class $9f71fef3739216f1$export$2e2bcd8739ae039 extends (0, $562c28a8df1194c9$export$60b03b353ad03260) {
    constructor(){
        super({
            categories: [],
            articles: [],
            attributeList: [],
            currentCategoryId: 0
        });
    }
    async initialize() {
        this.database = await (0, $7818c326be87ea84$export$ca0ed41b1a2af7e)('CompareStore', 1, {
            upgrade (db) {
                db.createObjectStore('categories');
                db.createObjectStore('articles');
                db.createObjectStore('attributeList').createIndex('categoryId', 'categoryId', {
                    unique: false
                });
            }
        });
        const firstCategory = (await this.database.getAll('categories')).at(0);
        if (firstCategory) this.state.currentCategoryId = firstCategory.id;
        await this.saveAllStores();
    }
    getState() {
        return this.state;
    }
    async clearAll() {
        await this.database?.clear('categories');
        await this.database?.clear('articles');
        await this.database?.clear('attributeList');
        await this.syncState();
        this.notify("clearAllTable", this.state);
    }
    async clear(storeName) {
        await this.database?.clear(storeName);
        await this.syncState();
        this.notify("clearTable", this.state);
    }
    getCategoryById(categoryId) {
        const { categories: categories } = this.state;
        return categories.find((item)=>item.id === categoryId);
    }
    getArticleCountByCategoryId(categoryId) {
        const { categories: categories, articles: articles } = this.state;
        const category = categories.find((item)=>item.id === categoryId);
        const length = articles.filter((article)=>category?.articleIds.includes(article.id)).length;
        if (length === 0) return category?.articleIds.length;
        else return length;
    }
    async patchCategoryById(categoryId, category) {
        await this.database?.put('categories', category, categoryId);
        await this.syncState();
        this.notify("patchItem", this.state);
    }
    async removeCategoryById(categoryId) {
        await this.database?.delete('categories', categoryId);
        await this.syncState();
        this.notify("removeCategory", this.state);
    }
    async getEntriesByCategoryId(categoryId) {
        if (!this.database) return;
        const tx = this.database.transaction('attributeList', 'readonly');
        const index = tx.store.index('categoryId');
        const keyRange = IDBKeyRange.only(categoryId);
        const results = await index.getAll(keyRange);
        await tx.done;
        return results;
    }
    async addMultipleItems(storeName, items) {
        const transaction = this.database?.transaction(storeName, 'readwrite');
        const store = transaction?.objectStore(storeName);
        if (!this.hasAllItemsAnId(items)) return;
        await Promise.all([
            items.map(async (item)=>{
                await store?.put(item, item.id);
            })
        ]);
        await transaction?.done;
        await this.syncState();
        this.notify("addMultipleItems", this.state);
    }
    async modifyItem(storeName, id, modifiedState) {
        const item = await this.database?.get(storeName, id);
        const newItem = {
            ...item,
            ...modifiedState
        };
        await this.database?.put(storeName, newItem, id);
        await this.syncState();
        this.notify("patchItem", this.state);
    }
    switchCategory(categoryId) {
        this.state.currentCategoryId = categoryId;
        this.notify("switchCategory", this.state);
    }
    async syncState() {
        await this.saveAllStores();
    }
    async saveAllStores() {
        this.state = {
            categories: await this.database?.getAll('categories'),
            articles: await this.database?.getAll('articles'),
            attributeList: await this.database?.getAll('attributeList'),
            currentCategoryId: this.state.currentCategoryId
        };
    }
    hasAllItemsAnId(items) {
        const invalidItems = items.filter((item)=>!('id' in item) || item.id === undefined);
        return invalidItems.length === 0;
    }
}




class $7cfc9025399237fb$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.anchor = this.querySelector('a') || undefined;
        this.counter = this.anchor?.querySelector('[data-tk-counter-info') || undefined;
        this.emptyClassName = this.getDataAttribute('empty-class-name', 'tk-button__counter--empty');
    }
    async connectedCallback() {
        if (!this.anchor) throw new Error('Compare Info: Element is missing!');
        await (0, $f8125d35cd9a4f7a$export$be9343d232c38cbb)('compareStore');
        this.store = (0, $f8125d35cd9a4f7a$export$6ccbb43953eebf8)('compareStore');
        this.unsubscribe = this.store.subscribe(()=>this.render());
        this.render();
    }
    disconnectedCallback() {
        this.unsubscribe && this.unsubscribe();
    }
    render() {
        if (this.store && this.counter) {
            const { categories: categories } = this.store.getState();
            this.anchor?.setAttribute('data-count', String(categories.length));
            if (categories.length === 0 && this.counter) this.counter?.classList.add(this.emptyClassName);
            else {
                this.counter?.classList.remove(this.emptyClassName);
                this.counter.textContent = String(categories.length);
            }
        }
    }
}



class $9cc5e30d1bc8a0e8$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.viewportElement = this.closest('[data-tk-viewport]') || undefined;
    }
    connectedCallback() {
        if (!this.viewportElement) throw new Error('Status Console: Missing Viewport Element!');
        this.resize();
        this.registerViewportListener();
    }
    registerViewportListener() {
        const onResize = this.resize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: this.viewportElement,
            action: onResize
        });
    }
    resize() {
        document.documentElement.style.setProperty('--offset-top', `${this.clientHeight}px`);
    }
}





class $68fa613ad09d90db$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.cursor = this.getAttribute('data-tk-cursor') || 'pointer';
    }
    connectedCallback() {
        this.style.cursor = this.cursor;
        this.registerClickListener();
    }
    registerClickListener() {
        const onClick = this.copy.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: onClick
        });
    }
    async copy() {
        try {
            await navigator.clipboard.writeText(this.textContent || '');
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$39227038979f1988).messageClipboard.text);
        } catch (error) {
            console.error('Error when copying to the clipboard:', error);
        }
    }
}




class $d3f5c18545e5cabd$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.queue = [], this.activeRequests = 0;
        this.maxConcurrentRequests = Number(this.getAttribute('data-tk-max-concurrent') || 3);
    }
    async addRequest(params) {
        return new Promise((resolve, reject)=>{
            const requestItem = {
                ...params,
                resolveHandler: (data)=>{
                    params.resolveHandler(data);
                    resolve();
                },
                rejectHandler: (error)=>{
                    params.rejectHandler?.(error);
                    reject(error);
                }
            };
            this.queue.push(requestItem);
            this.processQueue();
        });
    }
    async processQueue() {
        if (this.activeRequests >= this.maxConcurrentRequests || this.queue.length === 0) return;
        const request = this.queue.shift();
        this.activeRequests += 1;
        try {
            await (0, $1653b55d89a7adce$export$d5a8517da06db2d)(request);
        } finally{
            this.activeRequests -= 1;
            this.processQueue();
        }
    }
}





const $b314948e6a7c6950$var$isValidJSON = (value)=>{
    try {
        const json = JSON.parse(value);
        return {
            isValid: true,
            json: json
        };
    } catch  {
        return {
            isValid: false
        };
    }
};
var $b314948e6a7c6950$export$2e2bcd8739ae039 = $b314948e6a7c6950$var$isValidJSON;


const $3507ba4caf4aa34e$var$parseBooleanOrString = (value)=>{
    if (value === 'true') return true;
    if (value === 'false') return false;
    return value;
};
var $3507ba4caf4aa34e$export$2e2bcd8739ae039 = $3507ba4caf4aa34e$var$parseBooleanOrString;


const $bf3fdf42d85858f4$var$toSnakeCase = (input)=>input.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
var $bf3fdf42d85858f4$export$2e2bcd8739ae039 = $bf3fdf42d85858f4$var$toSnakeCase;


class $0efda1b115753384$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.hasItems = false, this.attributeList = [];
        this.trackerElement = this.closest('[data-tk-tracker-wrapper]') || undefined;
        this.event = this.getAttribute('data-tk-event') || undefined;
        this.isAsync = this.hasAttribute('data-tk-is-async');
        this.asyncAttributesURL = this.getAttribute('data-tk-async-attributes-url') || undefined;
        this.trackerType = this.getAttribute('data-tk-tracker-type') || undefined;
        this.hasItems = this.hasAttribute('data-tk-has-items');
        this.itemsKey = this.getDataAttribute('has-items', 'items');
        this.location = window.location.href;
    }
    async connectedCallback() {
        if (!this.trackerElement) throw new Error('Tracker Element is missing!');
        if (!this.event) throw new Error('Event is not defined');
        if (this.isAsync) this.init();
        else this.pushListener({
            event: 'tk-tracker-ready',
            element: this.trackerElement,
            action: this.init.bind(this)
        });
    }
    async init() {
        this.attributeList = this.extractAttributesFrom(this);
        if (this.hasItems) this.collectItemAttributes();
        await this.getAsyncAttributes();
        this.pushTracker();
    }
    extractAttributesFrom(element) {
        return Object.keys(element.dataset).filter((key)=>!key.startsWith('tk')).map((key)=>this.createAttribute(key, element.dataset[key])).filter(Boolean);
    }
    createAttribute(key, value) {
        const result = (0, $b314948e6a7c6950$export$2e2bcd8739ae039)(value);
        return {
            key: key,
            value: result.isValid ? result.json : (0, $3507ba4caf4aa34e$export$2e2bcd8739ae039)(value)
        };
    }
    collectItemAttributes() {
        const items = Array.from(this.querySelectorAll('[data-tk-item]'));
        const itemAttributes = items.map((item)=>this.extractAttributesFrom(item)).map(this.mapToSnakeCase);
        this.attributeList.push({
            key: this.itemsKey,
            value: itemAttributes
        });
    }
    mapToSnakeCase(attributes) {
        return attributes.reduce((acc, attr)=>{
            const key = (0, $bf3fdf42d85858f4$export$2e2bcd8739ae039)(attr.key);
            // Wenn der Wert ein Array ist, konvertiere ihn in einen String (z.B. JSON.stringify)
            if (Array.isArray(attr.value)) acc[key] = JSON.stringify(attr.value);
            else acc[key] = attr.value;
            return acc;
        }, {});
    }
    async getAsyncAttributes() {
        if (!this.asyncAttributesURL) return;
        await (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncAttributesURL,
            resolveHandler: this.handleAsyncAttributes.bind(this)
        });
    }
    handleAsyncAttributes(response) {
        Object.entries(response.dataAsJson.attributes).forEach(([key, value])=>{
            this.attributeList.push({
                key: value,
                value: response.dataAsJson[key]
            });
        });
    }
    pushTracker() {
        const item = {
            event: this.event,
            location: this.location,
            ...this.attributeList.reduce((acc, attr)=>{
                const key = (0, $bf3fdf42d85858f4$export$2e2bcd8739ae039)(attr.key);
                acc[key] = attr.value;
                return acc;
            }, {})
        };
        this.trackerElement?.dispatchEvent(new CustomEvent('tk-tracking-push', {
            detail: {
                trackerType: this.trackerType,
                item: item
            }
        }));
    }
}




var $fe64c06a372e274b$export$bcd15065bd7fecf6 = /*#__PURE__*/ function(SortDirectionEnum) {
    SortDirectionEnum["ASC"] = "ASC";
    SortDirectionEnum["DESC"] = "DESC";
    return SortDirectionEnum;
}({});
const $fe64c06a372e274b$export$633da1651c3bd3f9 = (a, b, direction)=>direction.toUpperCase() === "DESC" ? b.localeCompare(a) : a.localeCompare(b);
const $fe64c06a372e274b$export$dcb32d3e7e407924 = (a, b, direction)=>{
    const numberA = Number(a);
    const numberB = Number(b);
    return direction.toUpperCase() === "DESC" ? numberB - numberA : numberA - numberB;
};
const $fe64c06a372e274b$export$c4c806e061935577 = (a, b, direction)=>{
    const dateFormattedA = a.split('.').reverse().join('-');
    const dateFormattedB = b.split('.').reverse().join('-');
    const dateA = Date.parse(dateFormattedA);
    const dateB = Date.parse(dateFormattedB);
    return direction.toUpperCase() === "DESC" ? dateB - dateA : dateA - dateB;
};
const $fe64c06a372e274b$export$15d252ed5f5f8636 = (a, b, direction)=>{
    const dateA = new Date();
    const dateB = new Date();
    const splittedA = a.split(':').map((item)=>Number(item));
    const splittedB = b.split(':').map((item)=>Number(item));
    dateA.setHours(splittedA.at(0) || 0, splittedA.at(1), splittedA.at(2));
    dateB.setHours(splittedB.at(0) || 0, splittedB.at(1), splittedB.at(2));
    const timeA = dateA.getTime();
    const timeB = dateB.getTime();
    return direction.toUpperCase() === "DESC" ? timeB - timeA : timeA - timeB;
};
const $fe64c06a372e274b$export$ed1371d464d87bcf = (a, b, direction)=>{
    const timeStampListA = a.split(' ');
    const timeStampListB = b.split(' ');
    const dateA = timeStampListA.at(0)?.split('.').reverse().join('-');
    const dateB = timeStampListB.at(0)?.split('.').reverse().join('-');
    const timeA = timeStampListA.at(1);
    const timeB = timeStampListB.at(1);
    const timestampA = Date.parse(`${dateA}T${timeA}`);
    const timestampB = Date.parse(`${dateB}T${timeB}`);
    return direction.toUpperCase() === "DESC" ? timestampB - timestampA : timestampA - timestampB;
};
const $fe64c06a372e274b$export$92f3520fe1ac7383 = (a, b, direction)=>{
    const booleanA = Boolean(a);
    const booleanB = Boolean(b);
    const numberA = Number(booleanA);
    const numberB = Number(booleanB);
    return direction === "DESC" ? numberB - numberA : numberA - numberB;
};



var $2595e2ca594d6789$var$DataMaster = /*#__PURE__*/ function(DataMaster) {
    DataMaster["CLIENT"] = "client";
    return DataMaster;
}($2595e2ca594d6789$var$DataMaster || {});
class $2595e2ca594d6789$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.gridTemplateColList = [], this.hasAccordionRows = false, this.isHorizontalScrollable = false;
        this.headElement = this.querySelector('[data-tk-table-head]') || undefined;
        if (!this.headElement) throw new Error('Table: Head is missing!');
        this.rowHeadElement = this.headElement.querySelector('[data-tk-table-row]') || undefined;
        this.headShadowClassName = this.getAttribute('data-tk-head-shadow-class-name') || 'tk-table__head-shadow';
        this.isStickyLeft = this.hasAttribute('data-tk-is-sticky-left');
        this.isStickyHead = this.hasAttribute('data-tk-is-sticky-head');
        this.gridTemplateMobile = this.getAttribute('data-tk-grid-template-mobile') || '1fr';
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-table--loaded';
        this.stickyLeftClassname = this.getAttribute('data-tk-sticky-left-class-name') || 'tk-table--sticky-left';
        this.rightShadowClassName = this.getAttribute('data-tk-right-shadow-class-name') || 'tk-table__right-shadow';
        this.stickyHeadClassName = this.getAttribute('data-tk-sticky-head-class-name') || 'tk-table--sticky-head';
        this.customCols = this.getAttribute('data-tk-col-width') || 'auto';
        this.observer = new ResizeObserver(this.handleResize.bind(this));
        this.desktopMinWidth = Number(this.getAttribute('data-tk-desktop-min-width')) || 992;
        this.rowLinkSelector = 'data-tk-table-row-link';
        this.table = this.querySelector('table') || undefined;
        this.ascSortClassName = this.getAttribute('data-tk-asc-sort-class-name') || 'tk-table--sort-asc';
        this.descSortClassName = this.getAttribute('data-tk-desc-sort-class-name') || 'tk-table--sort-desc';
        this.isSortTable = Boolean(this.table?.hasAttribute('data-tk-table-sort'));
        this.colAlignStart = this.hasAttribute('data-tk-col-align-start');
        this.colAlignStartClassName = this.getAttribute('data-tk-col-align-start-class-name') || 'tk-table__col--align-left';
        this.colItemAlignCenter = this.hasAttribute('data-tk-col-item-align-center');
        this.colItemAlignCenterClassName = this.getAttribute('data-tk-col-item-align-center-class-name') || 'tk-table__col--item-align-center';
        this.colItemAlignStart = this.hasAttribute('data-tk-col-item-align-start');
        this.colItemAlignStartClassName = this.getAttribute('data-tk-col-item-align-start-class-name') || 'tk-table__col--item-align-start';
        this.colItemAlignEnd = this.hasAttribute('data-tk-col-item-align-end');
        this.colItemAlignEndClassName = this.getAttribute('data-tk-col-item-align-end-class-name') || 'tk-table__col--item-align-end';
        this.tableSelector = '[data-tk-table-sort]';
        this.sortDirectionSelector = '[data-tk-sort-direction]';
        this.tkSortDirectionSelector = 'tkSortDirection';
        this.tkSortAttrSelector = 'tkSortAttr';
        this.tkSortDatatypeSelector = 'tkSortDatatype';
        this.dataMasterSelector = 'data-tk-datamaster';
        this.dataSortAttrSelector = 'data-tk-sort-attr';
        this.hasAccordionRows = this.hasAttribute('data-tk-accordion-rows');
        this.accordionRowHeadActiveClassName = this.getDataAttribute('accordion-row-head-active-class-name', 'tk-table__row--head-accordion-active');
        this.accordionRowBodyActiveClassName = this.getDataAttribute('accordion-row-body-active-class-name', 'tk-table__row--body-accordion-active');
        this.accordionLastElementClassName = this.getDataAttribute('accordion-last-element-class-name', 'tk-table--accordion-last-row');
    }
    connectedCallback() {
        this.classList.add(this.loadedClassName);
        window.viewport.clientWidth < this.desktopMinWidth ? this.setGridMobile() : this.setGrid();
        this.registerViewportListener();
        this.registerScrollListener();
        this.registerRowLinkListener();
        this.observer.observe(this);
        this.isStickyHead && this.setStickyHead();
        this.isSortTable && this.registerTableHeadListener();
        this.colAlignStart && this.setColAlignStart();
        this.colItemAlignCenter && this.setColItemAlign(this.colItemAlignCenterClassName);
        this.colItemAlignStart && this.setColItemAlign(this.colItemAlignStartClassName);
        this.colItemAlignEnd && this.setColItemAlign(this.colItemAlignEndClassName);
        this.hasAccordionRows && this.registerAccordionListener();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.observer.unobserve(this);
    }
    registerViewportListener() {
        const onViewportResize = this.handleViewportResize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: window.viewport,
            action: onViewportResize
        });
    }
    handleViewportResize(event) {
        const customEvent = event;
        if (customEvent.detail.width < this.desktopMinWidth) this.setGridMobile();
        else this.setGrid();
    }
    registerScrollListener() {
        const action = this.handleScrollBehavior.bind(this);
        this.pushListener({
            event: 'scroll',
            element: this,
            action: action
        });
    }
    registerTableHeadListener() {
        const handleSortTable = this.handleSortTable.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleSortTable
        });
    }
    registerRowLinkListener() {
        const handleRowLink = this.handleRowLink.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: handleRowLink
        });
    }
    registerAccordionListener() {
        const onClick = this.handleAccordion.bind(this);
        const rows = this.querySelectorAll('[data-tk-table-row-id]');
        rows.forEach((row)=>{
            this.pushListener({
                event: 'click',
                element: row,
                action: onClick
            });
        });
    }
    handleScrollBehavior(event) {
        this.toggleScrollHorizontalBehavior(event);
        if (this.isStickyLeft) this.toggleScrollLeftBehavior(event);
        if (this.isStickyHead) this.toggleScrollTopBehavior(event);
    }
    handleRowLink(event) {
        const target = event.target;
        if (target.closest('a')) return;
        if (target.closest('button')) return;
        const row = target.closest(`[${this.rowLinkSelector}]`);
        if (!row) return;
        const link = row.getAttribute(this.rowLinkSelector);
        if (!link) return;
        window.location.href = link;
    }
    handleSortTable(event) {
        if (!event) return;
        const target = event.target;
        const column = target.closest('th');
        column && column.hasAttribute('data-tk-sort-direction') && this.sortTable(column);
    }
    handleResize(entries) {
        entries.forEach(()=>{
            this.isHorizontalScrollable = this.scrollWidth > this.clientWidth;
            if (this.isHorizontalScrollable && !this.horizontalScrollShadowElement) this.setHorizontalScrollShadow();
            if (!this.horizontalScrollShadowElement) return;
            this.horizontalScrollShadowElement.hidden = !this.isHorizontalScrollable;
            this.boxShadowElement && (this.boxShadowElement.style.width = `${this.scrollWidth}px`);
        });
    }
    setGrid() {
        if (!this.rowHeadElement) return;
        const cols = this.rowHeadElement.childElementCount;
        this.gridTemplateColList = this.customCols?.split(/(?!, ),/g);
        this.style.gridTemplateColumns = this.customCols?.includes(',') ? this.gridTemplateColList?.join(' ') : `repeat(${cols}, ${this.customCols})`;
        if (this.headElement) this.headElement.classList.remove('tk-table__head--force-mobile');
        const titleElements = this.table?.querySelectorAll('[data-tk-table-body] .tk-table__title');
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.remove('tk-table__title--force-mobile');
        });
    }
    setGridMobile() {
        this.style.gridTemplateColumns = this.gridTemplateMobile;
        if (this.headElement) this.headElement.classList.add('tk-table__head--force-mobile');
        const titleElements = this.table?.querySelectorAll('[data-tk-table-body] .tk-table__title');
        if (!titleElements) return;
        titleElements.forEach((titleElement)=>{
            titleElement.classList.add('tk-table__title--force-mobile');
        });
    }
    toggleScrollLeftBehavior(event) {
        const element = event.target;
        this.classList.toggle(this.stickyLeftClassname, element.scrollLeft > 0);
    }
    toggleScrollHorizontalBehavior(event) {
        if (!this.horizontalScrollShadowElement) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = event.target;
        this.horizontalScrollShadowElement.hidden = scrollLeft >= scrollWidth - clientWidth;
        this.horizontalScrollShadowElement.style.right = `-${scrollLeft}px`;
    }
    toggleScrollTopBehavior(event) {
        if (!this.boxShadowElement) return;
        const element = event.target;
        this.boxShadowElement.hidden = element.scrollTop === 0;
        this.classList.toggle(this.stickyHeadClassName, element.scrollTop > 0);
        this.boxShadowElement.style.top = `${element.scrollTop}px`;
    }
    setStickyHead() {
        if (!this.headElement) return;
        this.boxShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.headShadowClassName}' hidden></div>`);
        if (!this.boxShadowElement) return;
        const column = this.rowHeadElement?.firstElementChild;
        const height = column?.getBoundingClientRect().height || 0;
        this.boxShadowElement.style.width = `${this.scrollWidth}px`;
        this.boxShadowElement.style.height = `${height}px`;
        this.headElement.insertAdjacentElement('afterbegin', this.boxShadowElement);
    }
    setHorizontalScrollShadow() {
        this.horizontalScrollShadowElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(`<div class='${this.rightShadowClassName}'></div>`);
        if (!this.horizontalScrollShadowElement) return;
        this.insertAdjacentElement('beforeend', this.horizontalScrollShadowElement);
    }
    sortTable(column) {
        const dataMaster = this.table?.getAttribute(this.dataMasterSelector);
        if (dataMaster === "client") {
            this.setOrToggleSortDirection(column);
            this.clearHeadElementClassList(column);
            this.clientSortTable({
                element: column,
                type: column.dataset[this.tkSortDatatypeSelector],
                sortDirection: column.dataset[this.tkSortDirectionSelector],
                column: column.cellIndex
            });
            this.postAsynClientSortState(column);
        } else this.serverAsynTableSortRequest(column);
    }
    clientSortTable(headItem) {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const rows = tableBody.querySelectorAll('[data-tk-table-row]');
        if (!rows) return;
        const rowList = Array.from(rows).map((element)=>{
            const value = Array.from(element.querySelectorAll('[data-tk-table-value]')).at(headItem.column)?.textContent || '';
            return {
                element: element,
                value: value
            };
        });
        const sortTypes = {
            A: (a, b)=>(0, $fe64c06a372e274b$export$633da1651c3bd3f9)(a, b, headItem.sortDirection),
            N: (a, b)=>(0, $fe64c06a372e274b$export$dcb32d3e7e407924)(a, b, headItem.sortDirection),
            D: (a, b)=>(0, $fe64c06a372e274b$export$c4c806e061935577)(a, b, headItem.sortDirection),
            H: (a, b)=>(0, $fe64c06a372e274b$export$15d252ed5f5f8636)(a, b, headItem.sortDirection),
            S: (a, b)=>(0, $fe64c06a372e274b$export$ed1371d464d87bcf)(a, b, headItem.sortDirection),
            B: (a, b)=>(0, $fe64c06a372e274b$export$92f3520fe1ac7383)(a, b, headItem.sortDirection)
        };
        const sortedList = rowList.sort((a, b)=>sortTypes[headItem.type](a.value, b.value));
        tableBody.innerHTML = '';
        sortedList.forEach((item)=>{
            tableBody.appendChild(item.element);
        });
        if (headItem.element.classList.contains(this.ascSortClassName) || headItem.element.classList.contains(this.descSortClassName)) headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.replace(this.ascSortClassName, this.descSortClassName) : headItem.element.classList.replace(this.descSortClassName, this.ascSortClassName);
        else headItem.sortDirection.toUpperCase() === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC ? headItem.element.classList.add(this.descSortClassName) : headItem.element.classList.add(this.ascSortClassName);
    }
    clearHeadElementClassList(column) {
        if (!this.rowHeadElement) return;
        const head = Array.from(this.rowHeadElement.children);
        const filteredHead = head.filter((item)=>item !== column);
        filteredHead.forEach((child)=>{
            const element = child;
            element.classList.remove(this.ascSortClassName);
            element.classList.remove(this.descSortClassName);
        });
    }
    setOrToggleSortDirection(thElement) {
        this.removeUnseletectedSortDir(thElement);
        // toggelt direction auf geklickten header spalte
        thElement.dataset[this.tkSortDirectionSelector] = thElement.dataset[this.tkSortDirectionSelector] === (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC ? (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).DESC : (0, $fe64c06a372e274b$export$bcd15065bd7fecf6).ASC;
    }
    serverAsynTableSortRequest(thElement) {
        this.setOrToggleSortDirection(thElement);
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.asyncTableSortHandler.bind(this),
            payload: options
        });
    }
    postAsynClientSortState(thElement) {
        const url = window.location.href;
        const options = this.getAsynPostOptions(thElement);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: ()=>{},
            payload: options
        });
    }
    asyncTableSortHandler(response) {
        if (!response.success || !response.dataAsHtml) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.replaceAllResponseTable(html);
    }
    replaceAllResponseTable(element) {
        const oldTables = document.querySelectorAll(this.tableSelector);
        const newTables = element.querySelectorAll(this.tableSelector);
        oldTables.forEach((oldTable)=>{
            const correspondingNewTable = Array.from(newTables).find((newTable)=>oldTable.id === newTable.id);
            if (correspondingNewTable) oldTable?.parentNode?.replaceChild(correspondingNewTable, oldTable);
        });
    }
    getAsynPostOptions(thElement) {
        const table = thElement.closest(this.tableSelector);
        if (!table) return {};
        const client = table.getAttribute(this.dataMasterSelector);
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const sortDirection = thElement.dataset[this.tkSortDirectionSelector];
        const options = {
            type: 'tablesort',
            clientSort: String(!!client),
            tableid: table.id,
            sorting: `{"${sortAttribut}":"${sortDirection}"}`
        };
        return options;
    }
    removeUnseletectedSortDir(thElement) {
        const sortAttribut = thElement.dataset[this.tkSortAttrSelector];
        const table = thElement.closest(this.tableSelector);
        if (!table) return;
        const headers = table.querySelectorAll(this.sortDirectionSelector);
        headers.forEach((header)=>{
            const headerSortAttr = header.dataset[this.tkSortAttrSelector];
            if (headerSortAttr === sortAttribut) return;
            header.dataset[this.tkSortDirectionSelector] = '';
        });
    }
    setColAlignStart() {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll('[data-tk-table-row] td');
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(this.colAlignStartClassName);
        });
    }
    setColItemAlign(className) {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        if (!tableBody) return;
        const cols = tableBody.querySelectorAll('[data-tk-table-row] td');
        if (!cols) return;
        cols.forEach((col)=>{
            col.classList.add(className);
        });
    }
    handleAccordion(event) {
        const headElement = event.currentTarget;
        const id = headElement.getAttribute('data-tk-table-row-id');
        if (!id) return;
        const bodyElements = this.querySelectorAll(`[data-tk-table-accordion="${id}"]`);
        const isActive = headElement.classList.toggle(this.accordionRowHeadActiveClassName);
        bodyElements.forEach((element, index)=>{
            element.hidden = !isActive;
            element.classList.toggle(this.accordionRowBodyActiveClassName, isActive);
            if (index === bodyElements.length - 1) element.classList.add(this.accordionLastElementClassName);
        });
    }
}








class $8b05e2474621c644$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    static{
        this.observedAttributes = [
            'data-count'
        ];
    }
    constructor(){
        super(), this.isDataFetched = false;
        this.headerButton = this.querySelector('[data-tk-header-button]') || undefined;
        this.counter = this.headerButton?.querySelector('[data-tk-counter-info') || undefined;
        this.overlay = this.querySelector('[data-tk-minibasket-overlay]') || undefined;
        this.contentWrapper = this.querySelector('[data-tk-minibasket-content]') || undefined;
        this.countItemsRequestURL = this.getAttribute('data-tk-count-items-request-url') || undefined;
        this.getContentRequestURL = this.getAttribute('data-tk-get-content-request-url') || undefined;
        this.counterEmptyClassName = this.getAttribute('data-tk-counter-empty-class-name') || 'tk-button__counter--empty';
        this.offset = Number(this.getAttribute('data-tk-minibasket-offset')) || 4;
        this.openClassName = this.getAttribute('data-tk-open-class-name') || 'tk-minibasket--open';
        this.minDistanceToBorder = Number(this.getAttribute('data-tk-min-distance-to-border')) || 5;
        // Custom Events
        this.openedEventName = this.getAttribute('data-tk-event-opened-name') || 'tk-minibasket-opened';
        this.openedEvent = new CustomEvent(this.openedEventName);
        this.closedEventName = this.getAttribute('data-tk-event-closed-name') || 'tk-minibasket-closed';
        this.closedEvent = new CustomEvent(this.closedEventName);
        this.updateEventName = this.getAttribute('data-tk-event-update-name') || 'tk-minibasket-update';
        this.updateEvent = new CustomEvent(this.updateEventName);
    }
    connectedCallback() {
        if (!this.headerButton) throw new Error('Minibasket: Header Button is missing!');
        if (!this.countItemsRequestURL || !this.getContentRequestURL) throw new Error('Minibasket: Request URLs are missing!');
        this.registerInitializeListener();
        this.fetchQuantity();
    }
    attributeChangedCallback(name, _oldValue, newValue) {
        if (name === 'data-count') this.setCounter(Number(newValue));
    }
    registerInitializeListener() {
        const handleOpen = this.open.bind(this);
        this.pushListener({
            event: 'click',
            element: this.headerButton,
            action: handleOpen
        });
        const handleOpened = this.opened.bind(this);
        this.pushListener({
            event: this.openedEventName,
            element: this,
            action: handleOpened
        });
        const handleUpdate = this.update.bind(this);
        this.pushListener({
            event: this.updateEventName,
            element: this,
            action: handleUpdate
        });
    }
    registerCloseListener() {
        const handleClose = this.close.bind(this);
        this.pushListener({
            event: 'click',
            element: window,
            action: handleClose
        });
    }
    registerScrollListener() {
        const handleScroll = this.alignOverlayToButton.bind(this);
        this.pushListener({
            event: 'scroll',
            element: window,
            action: handleScroll
        });
    }
    open() {
        document.body.insertAdjacentElement('beforeend', this.overlay);
        this.overlay.classList.add(this.openClassName);
        this.alignOverlayToButton();
        !this.isDataFetched && this.fetchAll();
        this.dispatchEvent(this.openedEvent);
    }
    opened() {
        // This method would be used to execute code in a non-blocking way to prevent potential delays.
        setTimeout(()=>{
            this.registerCloseListener();
            this.registerScrollListener();
        }, 0);
    }
    update() {
        this.fetchQuantity();
        this.fetchAll();
    }
    close(event) {
        if (!this.overlay) return;
        const headerButtonRect = this.headerButton.getBoundingClientRect();
        const overlayRect = this.overlay.getBoundingClientRect();
        const rectangles = [
            {
                rectangle: headerButtonRect
            },
            {
                rectangle: overlayRect
            }
        ];
        if ((0, $7e8cc8975b3fe464$export$dcbd32acb1a13bc6)(event, rectangles)) {
            this.overlay.classList.remove(this.openClassName);
            this.dispatchEvent(this.closedEvent);
            this.removeListener(window);
        }
    }
    fetchAll() {
        Promise.all([
            $8b05e2474621c644$export$2e2bcd8739ae039.fetchData(this.getContentRequestURL)
        ]).then((responses)=>{
            this.isDataFetched = true;
            this.placeContent(responses[0]);
        }).catch(()=>{
            this.isDataFetched = false;
        });
    }
    fetchQuantity() {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.countItemsRequestURL,
            resolveHandler: this.getQuantity.bind(this)
        });
    }
    static fetchData(url) {
        return new Promise((resolve)=>{
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: (response)=>{
                    resolve(response);
                }
            });
        });
    }
    getQuantity(response) {
        if (!response || !response.success) return;
        const { quantity: quantity } = response.dataAsJson;
        this.setCounter(quantity);
    }
    setCounter(quantity) {
        if (quantity === 0) this.counter?.classList.add(this.counterEmptyClassName);
        else {
            this.headerButton?.setAttribute('data-count', `${quantity || 0}`);
            this.counter?.classList.remove(this.counterEmptyClassName);
            if (this.counter) this.counter.textContent = `${quantity}`;
        }
    }
    placeContent(response) {
        if (!response || !response.success) return;
        if (!this.contentWrapper) return;
        const items = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        this.contentWrapper.innerHTML = '';
        this.contentWrapper.insertAdjacentHTML('beforeend', items.innerHTML);
    }
    alignOverlayToButton() {
        const { bottom: bottom, right: right } = this.headerButton.getBoundingClientRect();
        const { width: width } = this.overlay.getBoundingClientRect();
        const distanceToBorder = right - width;
        this.overlay.style.top = `${bottom + this.offset}px`;
        if (distanceToBorder >= this.minDistanceToBorder) this.overlay.style.left = `${right - width}px`;
        else {
            this.overlay.style.left = '50%';
            this.overlay.style.transform = 'translateX(-50%)';
        }
    }
}


class $ba0287e7c80bda20$export$2e2bcd8739ae039 extends (0, $8b05e2474621c644$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.amountRequestURL = this.getAttribute('data-tk-amount-request-url') || undefined;
        this.amountDisplay = this.querySelector('[data-tk-amount-info]') || undefined;
        this.amountEmptyClass = this.getAttribute('data-tk-amount-empty-class-name') || 'tk-button__amount--empty';
        this.priceVisible = this.getAttribute('data-tk-price-visible') !== '0';
    }
    connectedCallback() {
        super.connectedCallback();
        this.fetchAmount();
    }
    fetchAmount() {
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.amountRequestURL,
            resolveHandler: this.setAmount.bind(this)
        });
    }
    setAmount(response) {
        if (!response || !response.success) return;
        const { amount: amount, currency: currency } = response.dataAsJson;
        if (parseInt(amount) === 0 || !this.priceVisible) this.amountDisplay?.classList.add(this.amountEmptyClass);
        else {
            this.headerButton?.setAttribute('data-amount', `${currency} ${amount || 0}`);
            this.amountDisplay?.classList.remove(this.amountEmptyClass);
            if (this.amountDisplay) this.amountDisplay.textContent = `${currency} ${amount}`;
        }
    }
    update() {
        this.fetchAmount();
        this.fetchQuantity();
        this.fetchAll();
    }
}



class $853de7f3d0ffebbd$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.radios = this.querySelectorAll('input[type="radio"]');
    }
    connectedCallback() {
        // Add event listeners to all radio buttons
        this.radios.forEach((radio)=>{
            radio.addEventListener('change', (event)=>this.handleChange(event));
        });
    }
    /**
     * Returns the value of the selected radio button
     */ get value() {
        const checkedRadio = Array.from(this.radios).find((radio)=>radio.checked);
        return checkedRadio ? checkedRadio.value : '';
    }
    /**
     * Sets a radio button as selected based on the provided value
     */ set value(val) {
        this.radios.forEach((radio)=>{
            radio.checked = radio.value === val;
        });
    }
    /**
     * Returns the name of the radio button group
     */ get name() {
        return this.radios.length > 0 ? this.radios[0].name : '';
    }
    /**
     * Checks if any radio button is selected
     */ get checked() {
        return Array.from(this.radios).some((radio)=>radio.checked);
    }
    /**
     * Returns the selected radio button element
     */ get selectedRadio() {
        return Array.from(this.radios).find((radio)=>radio.checked) || null;
    }
    /**
     * Handler for radio button changes
     * Only dispatches event when a radio button becomes checked (not unchecked)
     */ handleChange(event) {
        const target = event.target;
        // Only dispatch event when radio button is checked (selected), not when unchecked
        if (!target.checked) return;
        // Dispatch custom event so external components can react to changes
        this.dispatchEvent(new CustomEvent('change', {
            detail: {
                value: this.value,
                name: this.name,
                selectedRadio: this.selectedRadio
            },
            bubbles: true,
            composed: true
        }));
    }
    /**
     * Resets all radio buttons
     */ reset() {
        this.radios.forEach((radio)=>{
            radio.checked = false;
        });
    }
}



class $e7cb1307fe869e14$export$2e2bcd8739ae039 extends (0, $bacbdefa17cfec0c$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.radio = this.querySelector('[data-tk-product-variants]') || undefined;
    }
    connectedCallback() {
        if (this.asyncURL) this.getData();
        else if (this.form) this.registerInputListener();
        else {
            if (!this.radio) throw new Error('TKSelectRedirect: Radio element is missing!');
            this.registerRadioListener();
        }
    }
    registerRadioListener() {
        const action = this.handleRadio.bind(this);
        this.pushListener({
            event: 'change',
            element: this.radio,
            action: action
        });
    }
    handleRadio() {
        const selectedValue = this.radio.value;
        if (!selectedValue) return;
        this.redirectByValue(selectedValue);
    }
}





class $c7b0de4494db348b$export$2e2bcd8739ae039 extends (0, $ad2181492f474118$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    connectedCallback() {
        const item = {
            source: this.source,
            catItemId: this.catItemId,
            articleId: this.articleId,
            stockType: this.stockType,
            stockLocation: this.stockLocation,
            dispo: this.dispo,
            dispoDate: this.dispoDate,
            loadingType: this.loadingType,
            asyncTemplate: this.asyncTemplate,
            stockPeriodType: this.stockPeriodType,
            artUnitType: this.artUnitType,
            element: this
        };
        if (this.articleList && (!this.isAsyncTile || this.loadingType === '2')) this.sendDataToArticleList(item);
        else this.handleStock(item);
    }
    handleStock(item) {
        const items = this.asyncURL === (0, $1653b55d89a7adce$export$a4101276b4831ec4)(true) ? (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsJSONString([
            item
        ]) : (0, $ad2181492f474118$export$2e2bcd8739ae039).getItemsAsEntrypoint([
            item
        ]);
        const data = {
            type: 'stock',
            arttype: 'single',
            ...items
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.asyncURL,
            payload: data,
            resolveHandler: this.handleResponse.bind(this)
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    refreshStock(item, responseItem) {
        const { html: html, nextReceipt: nextReceipt } = responseItem;
        if (!html) return;
        const htmlString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(html) ? atob(html) : html;
        const tooltip = this.querySelector('tk-tooltip');
        tooltip && tooltip.remove();
        this.insertAdjacentHTML('beforeend', htmlString);
        if (nextReceipt) {
            const nextReceiptString = (0, $fbcf93c2a0aa5bcb$export$2e2bcd8739ae039)(nextReceipt) ? atob(nextReceipt) : nextReceipt;
            this.insertAdjacentHTML('afterend', nextReceiptString);
        }
    }
}





const $7cf802f14f3a63bb$var$QUANTITY_ATTR = 'data-quantity';
class $7cf802f14f3a63bb$export$2e2bcd8739ae039 extends (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039) {
    static{
        this.observedAttributes = [
            $7cf802f14f3a63bb$var$QUANTITY_ATTR
        ];
    }
    constructor(){
        super();
        this.quantity = Number(this.getAttribute($7cf802f14f3a63bb$var$QUANTITY_ATTR)) || undefined;
        this.requestURL = this.getAttribute('data-tk-request-url') || undefined;
    }
    connectedCallback() {
        if (!this.requestURL) return;
        this.item = {
            source: this.source,
            service: this.service,
            catItemId: this.catItemId,
            articleId: this.articleId,
            loadingType: this.loadingType,
            sort: this.sort,
            key: this.key,
            asyncTemplate: this.asyncTemplate,
            element: this
        };
        this.loadingType === '2' ? this.registerHoverListener() : this.handlePrice();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === $7cf802f14f3a63bb$var$QUANTITY_ATTR) {
            const quantity = Number(newValue);
            this.quantity = quantity;
            this.handlePrice();
        }
    }
    handlePrice() {
        const data = {
            quantity: String(this.quantity || 1)
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.requestURL,
            resolveHandler: this.updatePrice.bind(this),
            payload: data
        });
    }
    updatePrice(response) {
        const priceElement = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        if (priceElement.querySelector('[data-tk-price-promotion]')) this.classList.add(this.isPromotionClassName);
        this.innerHTML = priceElement.innerHTML;
    }
}







var $fd4fdaa8be3050bd$export$eb1b84084436143e = /*#__PURE__*/ function(BasketAction) {
    BasketAction["FETCHING"] = "fetching";
    BasketAction["REFRESHED_LIST"] = "refreshed-list";
    BasketAction["REFRESHED_BASKET"] = "refreshed-basket";
    return BasketAction;
}({});
class $fd4fdaa8be3050bd$export$2e2bcd8739ae039 {
    constructor(component){
        this.listeners = [];
        this.component = component;
        this.componentSelector = `.${this.component.classList.value}`;
        this.basketList = document.querySelector('[data-tk-basket-list]') || undefined;
        this.totalAmount = document.querySelector('[data-tk-basket-total-amount]') || undefined;
        this.miniBasket = document.querySelector('[data-tk-minibasket]') || undefined;
        this.emptyClassName = this.basketList?.getAttribute('data-tk-basket-empty-class-name') || 'module-basket--empty';
    }
    subscribe(listener) {
        this.listeners.push(listener);
    }
    emit(data) {
        this.listeners.forEach((listener)=>{
            listener(data);
        });
    }
    fetch(checkForReadonlyContext = false) {
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)(checkForReadonlyContext);
        this.emit({
            action: "fetching"
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshResultList.bind(this),
            payload: this.prepareDataSubmission()
        });
    }
    prepareDataSubmission() {
        const { tkAction: tkAction, tkModule: tkModule, tkArtInternalno: tkArtInternalno, tkSalDocItemBoId: tkSalDocItemBoId, tkSalDocBoId: tkSalDocBoId, tkAddAllOptions: tkAddAllOptions, tkVariant: tkVariant, tkQuantityId1: tkQuantityId1, tkQuantityId2: tkQuantityId2, tkQuantityId3: tkQuantityId3, tkAsyncTemplate: tkAsyncTemplate, tkRequest: tkRequest, tkEncrypted: tkEncrypted } = this.component.dataset;
        const data = {
            type: 'basket',
            action: tkAction,
            module: tkModule,
            originalUrl: window.location.href
        };
        tkArtInternalno && (data.artInternalNo = tkArtInternalno);
        tkSalDocItemBoId && (data.salDocItemBoId = tkSalDocItemBoId);
        tkSalDocBoId && (data.salDocBoId = tkSalDocBoId);
        tkAddAllOptions && (data.addalloptions = tkAddAllOptions);
        tkVariant && (data.artDimVariantNo = tkVariant);
        tkQuantityId1 && (data.catItemQuantityDim1 = this.getButtonDimValue(tkQuantityId1));
        tkQuantityId2 && (data.catItemQuantityDim2 = this.getButtonDimValue(tkQuantityId2));
        tkQuantityId3 && (data.catItemQuantityDim3 = this.getButtonDimValue(tkQuantityId3));
        tkAsyncTemplate && (data.template = tkAsyncTemplate);
        tkRequest && (data.request = tkRequest);
        tkEncrypted && (data.encrypted = tkEncrypted);
        Object.keys(this.component.dataset).filter((key)=>key.startsWith('tkSaldocitem.')).forEach((key)=>{
            data[key.substring(2).toLowerCase()] = this.component.dataset[key];
        });
        if (tkAction === 'addall') {
            const quantities = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.getQuantitiesFromPositions();
            quantities !== '{}' && (data.addall = quantities);
        }
        return data;
    }
    static getQuantitiesFromPositions() {
        const quantities = {};
        const articleList = document.querySelector('[data-tk-basket-add-all-wrapper]');
        const articles = articleList?.querySelectorAll('article');
        articles?.forEach((article)=>{
            const id = article.getAttribute('data-tk-item-number');
            if (!id) return;
            const basketButton = article.querySelector('[data-tk-basket-button]');
            if (!basketButton) return;
            const dimensions = basketButton.querySelectorAll('[data-tk-dimension]:not([hidden])');
            dimensions.forEach((dimension)=>{
                const dimensionNumber = dimension.getAttribute('data-tk-dimension') || '';
                const fieldElement = dimension.querySelector('[data-tk-input-quantity]');
                quantities[`position${id}${dimensionNumber}`] = fieldElement?.value || '0';
            });
        });
        return JSON.stringify(quantities);
    }
    getButtonDimValue(dimNumIdVal) {
        let retVal = '';
        const dim = this.component.querySelector(`[data-tk-dim-id="${dimNumIdVal}"]`);
        if (!dim) return retVal;
        const input = dim.querySelector('[data-tk-input-quantity]');
        if (!input) return retVal;
        let value = Number(input.value);
        const defaultValue = Number(input.min) || 1;
        if (dim.hidden) return retVal;
        if (Number.isNaN(value) || value <= 0) {
            value = defaultValue;
            retVal = String(defaultValue);
        } else retVal = String(value);
        return retVal;
    }
    getButtonDimUnit(dimNumIdVal) {
        let unit = '';
        const dim = this.component.querySelector(`[data-tk-dim-id="${dimNumIdVal}"]`);
        if (!dim) return unit;
        if (dim.hidden) return unit;
        const unitElement = dim.querySelector('[data-tk-basket-dim-unit]');
        if (!unitElement) return unit;
        unit = unitElement.innerText;
        return unit;
    }
    refreshResultList(response) {
        this.emit({
            action: "refreshed-list",
            data: response.dataAsJson
        });
        if (!response.success) return;
        this.updateMiniBasket(response.dataAsJson);
        this.updateBasket(response.dataAsJson);
        if (response.dataAsJson.action === 'added') (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(this.getQuantityMessage());
        const { action: action } = response.dataAsJson;
        this.updateCartTracker(action);
    }
    updateMiniBasket(data) {
        this.miniBasket?.dispatchEvent(this.miniBasket.updateEvent);
        this.miniBasket?.setAttribute('data-count', `${data.quantity}`);
    }
    updateBasket(data) {
        if (!this.basketList) return;
        const { tkAction: tkAction } = this.component.dataset;
        if (tkAction === 'delete' || tkAction === 'deleteall') {
            if (data.quantity === 0) window.location.reload();
            else {
                const basketPos = this.basketList.querySelector(`[data-tk-internalno="${this.component.dataset.tkInternalno}"]`) || this.component.closest('[data-tk-basket-item]');
                if (basketPos) basketPos.remove();
            }
        } else if (tkAction === 'change') {
            // update item price and amount
            const price = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-price]');
            if (price) price.innerHTML = `${data.currency} ${data.itemPrice}`;
            const amount = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-amount]');
            if (!amount) return;
            amount.innerHTML = `${data.currency} ${data.itemAmount}`;
        } else if (this.component.closest('tk-quick-order')) {
            // update after quickorder
            const quickorder = this.component.closest('tk-quick-order');
            if (!quickorder) return;
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: quickorder.dataset.tkUrlRefresh || window.location.href,
                resolveHandler: this.refreshBasketList.bind(this)
            });
        }
        // update total amount and VAT
        if (this.totalAmount) this.totalAmount.innerHTML = `${data.currency} ${data.totalAmount}`;
        const totalVat = this.basketList.querySelector('[data-tk-basket-total-vat]');
        if (totalVat) totalVat.innerHTML = `${data.currency} ${data.totalVat}`;
        this.emit({
            action: "refreshed-basket"
        });
    }
    refreshBasketList(response) {
        if (!response || !response.success || !this.basketList) return;
        const html = (0, $2d540709c75492d4$export$2e2bcd8739ae039)(response.dataAsHtml);
        const basketListWrapper = html.querySelector('[data-tk-basket-list]');
        basketListWrapper && (this.basketList.innerHTML = basketListWrapper.innerHTML);
        this.basketList.classList.remove(this.emptyClassName);
        const existDeleteAllButton = document.querySelector('[data-tk-basket-list-actions] > tk-basket-button');
        if (!existDeleteAllButton) {
            const basketHeaderActionWrapper = document.querySelector('[data-tk-basket-list-actions]');
            const deleteAllButton = html.querySelector('[data-tk-basket-list-actions] > tk-basket-button');
            deleteAllButton && basketHeaderActionWrapper?.insertAdjacentElement('beforeend', deleteAllButton);
        }
        const footer = document.querySelector('[data-tk-basket-list-footer]');
        if (!footer) {
            const footerWrapper = html.querySelector('[data-tk-basket-list-footer]');
            footerWrapper && this.basketList.insertAdjacentElement('afterend', footerWrapper);
        }
    }
    static quantityChanger(event) {
        const target = event.target;
        const currentTarget = event.currentTarget;
        if (!target || !target.parentElement) return;
        let wrapper = null;
        wrapper = target.closest('[data-tk-counter]');
        if (!wrapper) wrapper = target.closest('[data-tk-dimension]');
        if (!wrapper) return;
        const decrementButton = wrapper.querySelector('[data-tk-counter-decreaser]');
        const incrementButton = wrapper.querySelector('[data-tk-counter-increaser]');
        const inputField = wrapper.querySelector('[data-tk-input-quantity]');
        if (!inputField) return;
        const step = Number(inputField.getAttribute('step') || 1);
        const min = Number(inputField.getAttribute('min') || step);
        const max = Number(inputField.getAttribute('max') || 0);
        const isMaxSet = max > 0;
        const { tkArtDimCheckCd: tkArtDimCheckCd } = inputField.dataset;
        const artDimCheck = tkArtDimCheckCd ? Number(tkArtDimCheckCd) : 0;
        const oldValue = Number(inputField.value || 0);
        let hasChanged = false;
        let operator = '+';
        if (incrementButton && target === incrementButton) {
            operator = '+';
            if (oldValue < min) operator = '-';
        } else if (decrementButton && target === decrementButton) {
            operator = '-';
            if (oldValue > max && isMaxSet) operator = '+';
        }
        if (event.key === 'ENTER') {
            if (oldValue > max) operator = '+';
            else if (oldValue < min) operator = '-';
        }
        if (artDimCheck > 0) {
            const multiplikator = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.countDecimals(step);
            const currentValPow = oldValue * 10 ** multiplikator;
            const stepPow = step * 10 ** multiplikator;
            if ((currentValPow === 0 || currentValPow % stepPow !== 0) && oldValue >= min) {
                const result = (currentValPow + stepPow - currentValPow % stepPow) / 10 ** multiplikator;
                (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepMismatch.replace('{currentValue}', String(oldValue)).replace('{newValue}', String(result)).replace('{step}', String(step)));
                operator = '+';
            }
        }
        if (currentTarget === decrementButton || currentTarget === incrementButton) hasChanged = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.setCalculatedQuantityField(oldValue, inputField, step, min, max, operator);
        return hasChanged;
    }
    getQuantityMessage() {
        const message = {
            ...(0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedToBasket
        };
        const { tkQuantityId1: tkQuantityId1, tkQuantityId2: tkQuantityId2, tkQuantityId3: tkQuantityId3 } = this.component.dataset;
        const dim1Value = this.getButtonDimValue(tkQuantityId1 || '');
        const dim1Unit = this.getButtonDimUnit(tkQuantityId1 || '');
        const dim2Value = this.getButtonDimValue(tkQuantityId2 || '');
        const dim2Unit = this.getButtonDimUnit(tkQuantityId2 || '');
        const dim3Value = this.getButtonDimValue(tkQuantityId3 || '');
        const dim3Unit = this.getButtonDimUnit(tkQuantityId3 || '');
        let quantity = `${dim1Value} ${dim1Unit} `;
        if (dim2Value) quantity = `${quantity}x ${dim2Value} ${dim2Unit} `;
        if (dim3Value) quantity = `${quantity}x ${dim3Value} ${dim3Unit} `;
        message.text = quantity + (0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedToBasket.text;
        return message;
    }
    updateCartTracker(action) {
        const urlElement = document.querySelector('[data-tk-basket-tracker]');
        const url = urlElement?.getAttribute('data-tk-url');
        if (!url) return;
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.handleCartTracker.bind(this, action)
        });
    }
    handleCartTracker(action, response) {
        if (!response || !response.dataAsJson) return;
        const { items: items, data: data } = response.dataAsJson;
        const trackerElement = document.querySelector('[data-tk-tracker-wrapper]');
        trackerElement?.dispatchEvent(new CustomEvent('tk-tracking-push', {
            detail: {
                type: (0, $588d148f2c9ac202$export$4120f82005ec4b2d).BASKET_UPDATE,
                item: {
                    event: action,
                    location: window.location.href,
                    currency: data.currency,
                    value: data.totalAmount,
                    items: items
                }
            }
        }));
    }
    static setCalculatedQuantityField(currentVal, fieldElement, step, min, max = 0, operator = '+') {
        const multiplikator = $fd4fdaa8be3050bd$export$2e2bcd8739ae039.countDecimals(step);
        const currentValPow = Math.round(currentVal * 10 ** multiplikator);
        const stepPow = Math.round(step * 10 ** multiplikator);
        const minPow = Math.round(min * 10 ** multiplikator);
        const maxPow = Math.round(max * 10 ** multiplikator);
        let newValuePow = currentValPow;
        const { tkArtDimCheckCd: tkArtDimCheckCd } = fieldElement.dataset;
        const artDimCheck = Number(tkArtDimCheckCd);
        const operatorHandler = {
            '-': ()=>$fd4fdaa8be3050bd$export$2e2bcd8739ae039.calcMinus(currentValPow, newValuePow, stepPow, minPow, min, Number(artDimCheck)),
            '+': ()=>$fd4fdaa8be3050bd$export$2e2bcd8739ae039.calcPlus(currentValPow, newValuePow, stepPow, maxPow, max, Number(artDimCheck))
        };
        newValuePow = operatorHandler[operator]();
        // Wert veraendert und Step beruecksichtigt?
        if (newValuePow !== currentValPow) {
            if (newValuePow % stepPow === 0 || artDimCheck === 0) {
                fieldElement.value = String(newValuePow / 10 ** multiplikator);
                return true;
            }
            newValuePow = currentValPow;
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepMismatch.replace('{step}', String(step)));
        }
        return false;
    }
    static calcPlus(currentValPow, newValuePow, stepPow, maxPow, max, artDimCheck) {
        if (maxPow > 0 && newValuePow > maxPow) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).rangeOverflow.replace('{max}', String(max)));
            return maxPow;
        }
        return currentValPow + stepPow - (artDimCheck > 0 ? currentValPow % stepPow : 0);
    }
    static calcMinus(currentValPow, newValuePow, stepPow, minPow, min, artDimCheck) {
        if (newValuePow <= minPow) {
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).ERROR, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).rangeUnderflow.replace('{min}', String(min)));
            return minPow;
        }
        const adjustment = artDimCheck === 0 || currentValPow % stepPow === 0 ? stepPow : currentValPow % stepPow;
        return currentValPow - adjustment;
    }
    static countDecimals(value) {
        if (Math.floor(value) === value) return 0;
        return value.toString().split('.')[1].length || 0;
    }
}





class $d69b369e50d21df9$export$2e2bcd8739ae039 extends (0, $fd4fdaa8be3050bd$export$2e2bcd8739ae039) {
    constructor(component){
        super(component);
    }
    async fetch(checkForReadonlyContext = false) {
        const payload = this.prepareDataSubmission();
        const favorite2basket = this.component.closest('diw-favorite-to-basket');
        const giftCardSelect = document.querySelector('#giftcard-value');
        if (giftCardSelect) {
            payload['saldocitem.netsp'] = giftCardSelect.value;
            payload['saldocitem.grosssp'] = giftCardSelect.value;
            payload['saldocitem.free7'] = giftCardSelect.value;
        }
        if (payload.action === 'addall' && favorite2basket.isActive) {
            await favorite2basket.fetch();
            const basketButton = this.component.button;
            basketButton && (basketButton.disabled = false);
            (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).SUCCESS, (0, $86b3c5b6d66bd808$export$287bafa924522a4d).messageAddedAllToBasket.text);
            return;
        }
        const url = (0, $1653b55d89a7adce$export$a4101276b4831ec4)(checkForReadonlyContext);
        this.emit({
            action: (0, $fd4fdaa8be3050bd$export$eb1b84084436143e).FETCHING
        });
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: url,
            resolveHandler: this.refreshResultList.bind(this),
            payload: payload
        });
    }
    refreshResultList(response) {
        this.emit({
            action: (0, $fd4fdaa8be3050bd$export$eb1b84084436143e).REFRESHED_LIST,
            data: response.dataAsJson
        });
        if (!response.success) return;
        this.updateMiniBasket(response.dataAsJson);
        this.updateBasket(response.dataAsJson);
        if (response.dataAsJson.action === 'added') (0, $1221feb2184dfefe$export$146c7c7e50ed1bd2)(this.getQuantityMessage());
        if (response.dataAsJson.action === 'addedAll') {
            const favorite2basket = this.component.closest('diw-favorite-to-basket');
            favorite2basket && favorite2basket.fetch();
        }
        const { action: action } = response.dataAsJson;
        this.updateCartTracker(action);
    }
    updateBasket(data) {
        if (!this.basketList) return;
        const { tkAction: tkAction } = this.component.dataset;
        if (tkAction === 'delete' || tkAction === 'deleteall') {
            if (data.quantity === 0) window.location.reload();
            else {
                const basketPos = this.basketList.querySelector(`[data-tk-internalno="${this.component.dataset.tkInternalno}"]`) || this.component.closest('[data-tk-basket-item]');
                if (basketPos) basketPos.remove();
            }
        } else if (tkAction === 'change') {
            // update item price and amount
            const price = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-price]');
            if (price) price.innerHTML = `${data.currency} ${data.itemPrice}`;
            const amount = this.component.closest('[data-tk-basket-item]')?.querySelector('[data-tk-basket-item-amount]');
            if (!amount) return;
            amount.innerHTML = `${data.currency} ${data.itemAmount}`;
        } else if (this.component.closest('tk-quick-order')) {
            // update after quickorder
            const quickorder = this.component.closest('tk-quick-order');
            if (!quickorder) return;
            (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: quickorder.dataset.tkUrlRefresh || window.location.href,
                resolveHandler: this.refreshBasketList.bind(this)
            });
        }
        // update total amount and VAT
        if (this.totalAmount) {
            const url = this.totalAmount.getAttribute('data-tk-basket-amount-url');
            if (url) (0, $1653b55d89a7adce$export$24835cb787452b46)({
                requestURL: url,
                resolveHandler: this.refreshBasketTotal.bind(this)
            });
            else this.totalAmount.innerHTML = `${data.currency} ${data.totalAmount}`;
        }
        const totalVat = this.basketList.querySelector('[data-tk-basket-total-vat]');
        if (totalVat) totalVat.innerHTML = `${data.currency} ${data.totalVat}`;
        this.emit({
            action: (0, $fd4fdaa8be3050bd$export$eb1b84084436143e).REFRESHED_BASKET
        });
    }
    refreshBasketTotal(response) {
        if (!response || !response.dataAsJson) return;
        const data = response.dataAsJson;
        this.totalAmount.innerHTML = `${data.currency} ${data.amount}`;
        // update shipping fee
        const shipping = document.querySelector('[data-tk-shipping-fee]');
        if (shipping) shipping.innerHTML = data.shipping;
        // update article count
        const itemCount = document.querySelector('[data-tk-basket-icon-count]');
        if (itemCount) itemCount.innerHTML = data.itemCount;
    }
}






var $127c03b03da38c7a$export$416096e8140b15df = /*#__PURE__*/ function(BasketActionTypes) {
    BasketActionTypes["ADD"] = "add";
    BasketActionTypes["CHANGE"] = "change";
    BasketActionTypes["DELETE"] = "delete";
    BasketActionTypes["ADD_ALL"] = "addall";
    BasketActionTypes["DELETE_ALL"] = "deleteall";
    return BasketActionTypes;
}({});
class $127c03b03da38c7a$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.basketAction = new (0, $fd4fdaa8be3050bd$export$2e2bcd8739ae039)(this);
        this.action = this.getAttribute('data-tk-action') || "add";
        this.button = this.querySelector('[data-tk-basket-button]') || undefined;
        this.counterWrapper = this.querySelector('[data-tk-counter]') || undefined;
        this.variantWrapper = this.querySelector('[data-tk-basket-variants]') || undefined;
        if (this.counterWrapper) {
            this.decreaser = this.querySelector('[data-tk-counter-decreaser]') || undefined;
            this.increaser = this.querySelector('[data-tk-counter-increaser]') || undefined;
            this.counter = this.querySelector('[data-tk-input-quantity]') || undefined;
            this.counters = this.querySelectorAll('[data-tk-input-quantity]');
        }
    }
    connectedCallback() {
        if (!this.button) throw new Error('Basket: Button is missing!');
        this.registerClickListener();
        this.counterWrapper && this.registerCounter();
        this.registerBasketListener();
        this.variantWrapper && this.registerVariantListener();
    }
    registerClickListener() {
        const onClick = this.handleBasketClick.bind(this);
        this.pushListener({
            event: 'click',
            element: this.button,
            action: onClick
        });
    }
    registerVariantListener() {
        const onInput = this.updateDimensions.bind(this);
        const fieldElement = this.variantWrapper?.querySelector('input[type="hidden"]');
        fieldElement && this.pushListener({
            event: 'change',
            element: fieldElement,
            action: onInput
        });
    }
    registerCounter() {
        if (!this.decreaser || !this.increaser) return;
        if (this.action === "change") {
            const onChange = this.change.bind(this);
            this.pushListener({
                event: 'click',
                element: this.decreaser,
                action: onChange
            });
            this.pushListener({
                event: 'click',
                element: this.increaser,
                action: onChange
            });
            this.counters?.forEach((counter)=>{
                this.pushListener({
                    event: 'change',
                    element: counter,
                    action: onChange
                });
            });
        } else {
            const onDecrease = this.decrease.bind(this);
            this.pushListener({
                event: 'click',
                element: this.decreaser,
                action: onDecrease
            });
            const onIncrease = this.increase.bind(this);
            this.pushListener({
                event: 'click',
                element: this.increaser,
                action: onIncrease
            });
        }
    }
    registerBasketListener() {
        this.basketAction.subscribe((event)=>{
            const basketActionHandler = {
                fetching: ()=>{},
                'refreshed-list': ()=>event.data && this.closeDialog(event.data),
                'refreshed-basket': ()=>{}
            };
            basketActionHandler[event.action]();
        });
    }
    closeDialog(data) {
        this.button.disabled = false;
        if (!data.success) return;
        const dialog = this.closest('dialog');
        if (!dialog) return;
        dialog.close();
    }
    handleBasketClick() {
        this.button.disabled = true;
        this.validateQuantity();
        this.basketAction.fetch(false);
    }
    increase() {
        if (!this.counter || !this.increaser) return;
        const { step: step, max: max, value: value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) return;
        this.counter.value = String(valueNumber + (Number(step) || 1));
    }
    decrease() {
        if (!this.counter || !this.decreaser) return;
        const { step: step, min: min, value: value } = this.counter;
        const valueNumber = Number(value);
        if (valueNumber <= (Number(min) || 1)) return;
        this.counter.value = String(valueNumber - (Number(step) || 1));
    }
    change(event) {
        (0, $fd4fdaa8be3050bd$export$2e2bcd8739ae039).quantityChanger(event);
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.button?.click();
        }, 500);
    }
    validateQuantity() {
        const shouldCheckDimension = this.counter?.getAttribute('data-tk-art-dim-check-cd') === '1';
        if (!shouldCheckDimension || !this.counter) return;
        const step = Number(this.counter.step) || 1;
        const currentValue = Number(this.counter.value) || 1;
        const max = Number(this.counter.max);
        const min = Number(this.counter.min);
        if (currentValue % step === 0) return;
        let result = Math.ceil(currentValue / step) * step;
        if (min > 0 && result < min) result += step;
        if (max > 0 && result > max) result -= step;
        this.counter.value = String(result);
        (0, $1221feb2184dfefe$export$3a57e165650c636f)((0, $1221feb2184dfefe$export$9130146a86a85749).WARNING, (0, $86b3c5b6d66bd808$export$7ea287b8bcd34b91).stepAdjust.replace('{currentValue}', String(currentValue)).replace('{newValue}', String(result)).replace('{step}', String(step)));
    }
    updateDimensions(event) {
        const selectedVariant = event.target;
        const getDimensionValue = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-value`) || '0';
        const getDimensionName = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-name`) || '';
        const getDimensionUnit = (dimension)=>selectedVariant.getAttribute(`data-tk-${dimension}-unit`) || '';
        const getDimensionMin = ()=>Number(selectedVariant.getAttribute('data-tk-min'));
        const getDimensionMax = ()=>Number(selectedVariant.getAttribute('data-tk-max'));
        const getDimensionStep = ()=>Number(selectedVariant.getAttribute('data-tk-step'));
        const getDimensionCheckCd = ()=>selectedVariant.getAttribute('data-tk-art-dim-check-cd') || '';
        const setDimension = (wrapper, dimension)=>{
            const value = getDimensionValue(dimension);
            const fieldElement = wrapper.querySelector('[data-tk-input-quantity]');
            const nameElement = wrapper.querySelector('[data-tk-basket-dim-unit-name]');
            const unitElements = wrapper.querySelectorAll('[data-tk-basket-dim-unit]');
            if (!fieldElement) return;
            fieldElement.value = value !== '0' ? value : '';
            fieldElement.setAttribute('data-tk-art-dim-check-cd', getDimensionCheckCd());
            if (getDimensionMin() > 0) fieldElement.setAttribute('min', String(getDimensionMin()));
            else fieldElement.removeAttribute('min');
            if (getDimensionMax() > 0) fieldElement.setAttribute('max', String(getDimensionMax()));
            else fieldElement.removeAttribute('max');
            if (getDimensionStep() > 0) fieldElement.setAttribute('step', String(getDimensionStep()));
            else fieldElement.removeAttribute('step');
            nameElement && (nameElement.textContent = getDimensionName(dimension));
            unitElements.forEach((element)=>{
                element.textContent = getDimensionUnit(dimension);
            });
        };
        const dimensionWrappers = this.querySelectorAll('[data-tk-dimension]:not([hidden])');
        dimensionWrappers.forEach((wrapper)=>{
            const dimension = wrapper.getAttribute('data-tk-dimension');
            dimension && setDimension(wrapper, dimension);
        });
        this.setAttribute('data-tk-variant', selectedVariant.value);
    }
}


class $676bf9a0b3e6a9fd$export$2e2bcd8739ae039 extends (0, $127c03b03da38c7a$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.basketAction = new (0, $d69b369e50d21df9$export$2e2bcd8739ae039)(this);
        this.articleWrapper = this.closest('[data-article-wrapper]') || undefined;
    }
    increase() {
        if (!this.counter || !this.increaser) return;
        const { step: step, max: max, value: value } = this.counter;
        const valueNumber = Number(value);
        if (Number(max) !== 0 && valueNumber >= Number(max)) return;
        this.counter.value = String(valueNumber + (Number(step) || 1));
        this.syncPriceQuantity();
    }
    decrease() {
        if (!this.counter || !this.decreaser) return;
        const { step: step, min: min, value: value } = this.counter;
        const valueNumber = Number(value);
        if (valueNumber <= (Number(min) || 1)) return;
        this.counter.value = String(valueNumber - (Number(step) || 1));
        this.syncPriceQuantity();
    }
    change(event) {
        (0, $d69b369e50d21df9$export$2e2bcd8739ae039).quantityChanger(event);
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.button?.click();
            this.syncPriceQuantity();
        }, 500);
    }
    syncPriceQuantity() {
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            if (!this.counter) return;
            const priceElement = this.articleWrapper?.querySelector('[data-tk-dynamic-price]');
            priceElement?.setAttribute('data-quantity', this.counter.value);
        }, 500);
    }
}



class $0f7748d6531267ea$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.select = this.querySelector('#giftcard-value') || undefined;
        this.priceContainer = document.querySelector('[data-tk-price-container]') || undefined;
    }
    connectedCallback() {
        if (!this.select) throw new Error('DIWGiftcard: no select');
        const action = this.updatePrice.bind(this);
        this.pushListener({
            event: 'change',
            element: this.select,
            action: action
        });
        this.updatePrice();
    }
    updatePrice() {
        if (!this.priceContainer) return;
        const value = this.select?.selectedOptions[0]?.textContent || undefined;
        this.priceContainer.innerHTML = value;
    }
}




class $1de4bc533e624441$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.requestURL = this.getAttribute('data-tk-url') || undefined;
        this.checkbox = this.querySelector('#price-control') || undefined;
    }
    connectedCallback() {
        if (!this.requestURL) throw new Error('DIWPriceControl: Missung URL');
        if (!this.checkbox) throw new Error('DIWPriceControl: Missung Switch');
        const action = this.togglePriceVisibility.bind(this);
        this.pushListener({
            event: 'change',
            element: this.checkbox,
            action: action
        });
    }
    togglePriceVisibility() {
        const payload = {
            'price-control': `${Number(this.checkbox.checked)}`
        };
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.requestURL,
            resolveHandler: this.handlePriceChange.bind(this),
            payload: payload
        });
    }
    handlePriceChange(response) {
        const success = response.dataAsJson.success;
        if (!success) throw new Error('DIWPriceControl: Sessionvar could not be set');
        window.location.reload();
    }
}




class $6d1c1bebccef2c7f$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.form = this.querySelector('form') || undefined;
        this.fieldsContainer = this.querySelector('[data-tk-fields-container]') || undefined;
        this.fieldCount = this.fieldsContainer?.childElementCount || 1;
        this.addFieldButton = this.form?.querySelector('[data-tk-add-field]') || undefined;
        this.deleteFieldButtons = Array.from(this.querySelectorAll('[data-tk-delete]')) || undefined;
        this.template = this.querySelector('[data-tk-field-template]') || undefined;
        this.type = this.getAttribute('data-tk-type') || 'editlinks';
        this.existingData = this.getAttribute('data-tk-existing-data') || undefined;
    }
    connectedCallback() {
        if (!this.form || this.type == 'editlinks' && !this.fieldsContainer) throw new Error('DIWLinks: form or fields container not found');
        this.pushListener({
            event: 'submit',
            element: this.form,
            action: this.handleSubmit.bind(this)
        });
        if (this.addFieldButton && this.template) this.pushListener({
            event: 'click',
            element: this.addFieldButton,
            action: this.addField.bind(this)
        });
        this.registerDeleteButtons(this.deleteFieldButtons);
    }
    registerDeleteButtons(btns) {
        btns.forEach((btn)=>{
            this.pushListener({
                event: 'click',
                element: btn,
                action: this.deleteField.bind(this)
            });
        });
    }
    addField(e) {
        e.preventDefault();
        this.fieldCount++;
        if (!this.template) throw new Error('DIWLinks: template not found');
        const clone = this.template.content.cloneNode(true);
        // Replace {{ID}} placeholders in all attributes
        Array.from(clone.querySelectorAll('*')).forEach((element)=>{
            Array.from(element.attributes).forEach((attr)=>{
                attr.value = attr.value.replace(/\{\{ID\}\}/g, String(this.fieldCount));
            });
        });
        this.fieldsContainer.appendChild(clone);
        this.registerDeleteButtons(Array.from(this.fieldsContainer.lastElementChild.querySelectorAll('[data-tk-delete]')));
    }
    deleteField(e) {
        const target = e.target;
        const fieldset = target.closest('[data-tk-fieldset]');
        fieldset && fieldset.remove();
    }
    handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(this.form);
        let items = [];
        // Group entries by field number to pair name with link
        const fieldMap = new Map();
        formData.forEach((value, key)=>{
            const [fieldType, fieldNum] = key.split('-').slice(-2);
            if (!fieldMap.has(fieldNum)) fieldMap.set(fieldNum, {});
            if (fieldType == 'link') value = value.toString().split(window.location.host)[1] || value;
            fieldMap.get(fieldNum)[fieldType] = String(value);
        });
        fieldMap.forEach((field)=>{
            if (field.name && field.link) items.push(field);
        });
        console.log(items);
        if (this.type === 'addpage' && this.existingData) {
            const existingJson = JSON.parse(this.existingData).items;
            items = existingJson.concat(items);
        }
        const payload = {
            data: JSON.stringify({
                items: items
            })
        };
        console.log(payload);
        (0, $1653b55d89a7adce$export$24835cb787452b46)({
            requestURL: this.form.action,
            resolveHandler: this.updateLinks.bind(this),
            payload: payload
        });
    }
    updateLinks() {
        window.location.reload();
    }
}



class $b30bafcd895311f5$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.textarea = this.querySelector('[data-tk-textarea]') || undefined;
        this.resetBtn = this.querySelector('[data-tk-reset]') || undefined;
        this.salDocAttr = this.getAttribute('data-tk-saldoc-attr') || undefined;
        this.isRequired = this.hasAttribute('data-tk-required');
        this.container = this.closest('[data-tk-personalise-container]') || undefined;
    }
    connectedCallback() {
        if (!this.container) throw new Error('DIWPersonalisationElement: Missing Container');
        if (!this.textarea) return;
        this.registerListener();
    }
    registerListener() {
        const updateBasketButton = this.updateBasketButton.bind(this);
        const resetInput = this.resetInput.bind(this);
        this.pushListener({
            event: 'input',
            element: this.textarea,
            action: updateBasketButton
        });
        this.resetBtn && this.pushListener({
            event: 'click',
            element: this.resetBtn,
            action: resetInput
        });
    }
    resetInput() {
        this.textarea.value = '';
        this.updateBasketButton();
    }
    updateBasketButton() {
        this.container.updateBasketButton(this, this.textarea.value);
    }
}



class $01fe9ec417721a32$export$2e2bcd8739ae039 extends (0, $8f658dda969a7982$export$2e2bcd8739ae039) {
    constructor(){
        super(), this.text = [
            '',
            '',
            ''
        ];
        this.basketButton = this.querySelector('[data-tk-basket-button]') || undefined;
        this.personaliseElements = this.querySelectorAll('[data-tk-personalise]');
        this.salDocAttr = this.getAttribute('data-tk-saldoc-attr') || undefined;
    }
    connectedCallback() {
        if (this.personaliseElements.length === 0) return;
        if (!this.basketButton) throw new Error('DIWPersonalisationContainer: No Basketbutton found');
        if (!this.salDocAttr || !this.salDocAttr.toLowerCase().startsWith('saldocitem')) throw new Error('DIWPersonalisationElement: missing or wrong SalDocItem Attribute');
        this.checkRequired();
    }
    updateBasketButton(element, value) {
        const fraction = [
            ...this.personaliseElements
        ].indexOf(element);
        this.text[fraction] = value;
        this.basketButton.setAttribute(`data-tk-${this.salDocAttr}`, this.text.join('\n'));
        this.checkRequired();
    }
    checkRequired() {
        const check = !![
            ...this.personaliseElements
        ].filter((e)=>e.isRequired && e.textarea?.value != '').length;
        this.basketButton.button.disabled = !check;
    }
}




const $a19bf1b077ec319c$var$compareStore = new (0, $9f71fef3739216f1$export$2e2bcd8739ae039)();
(0, $f8125d35cd9a4f7a$export$7d8a5b498da695ac)({
    compareStore: $a19bf1b077ec319c$var$compareStore
});
class $a19bf1b077ec319c$export$2e2bcd8739ae039 extends (0, $e31d2de11bbf216d$export$2e2bcd8739ae039) {
    constructor(){
        super([
            {
                name: 'tk-manager',
                constructor: (0, $aa35ef9547ba682e$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-request-manager',
                constructor: (0, $d3f5c18545e5cabd$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-viewport',
                constructor: (0, $9ada6dd3e169a5cf$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tracker',
                constructor: (0, $588d148f2c9ac202$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-status-console',
                constructor: (0, $9cc5e30d1bc8a0e8$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-clipboard',
                constructor: (0, $68fa613ad09d90db$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-button-dropdown',
                constructor: (0, $87c9f038bb9cd227$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-header',
                constructor: (0, $1352bbad447b1dc9$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-nav-sidebar',
                constructor: (0, $40898dd22403025f$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-search',
                constructor: (0, $1943502441640b9f$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-carousel',
                constructor: (0, $b0d382fe358ed836$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-context-menu',
                constructor: (0, $d9484b764f1a944d$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-flag',
                constructor: (0, $0d07f57cc5d15afe$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-product-tile',
                constructor: (0, $21ae20c5af7baedb$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-product-variants',
                constructor: (0, $21611c672b0d32ce$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tooltip',
                constructor: (0, $b4b8cee06c4cfcc8$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-dialog',
                constructor: (0, $5a26c1218729bf34$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-article-list',
                constructor: (0, $6406837936bc2cfc$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-price',
                constructor: (0, $1ccb7c18f671f1de$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-static-content',
                constructor: (0, $edcef81612fbf4b7$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tabs-tab',
                constructor: (0, $237e800aa488702c$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tabs-accordion',
                constructor: (0, $59575c6d2ba9e740$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-favorite-button',
                constructor: (0, $2c226fea39ede692$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-favorite-info',
                constructor: (0, $38c77688df6cd108$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-element',
                constructor: (0, $9a3403e3213d867d$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-form-validator',
                constructor: (0, $7217ff2f9b2d295c$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-asset-gallery',
                constructor: (0, $8a0ac73f21029ce5$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-selection',
                constructor: (0, $407d2fd9d876caa3$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-art-spec-table',
                constructor: (0, $6d076883806887db$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-show-more',
                constructor: (0, $ebcc63c186c91a77$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-select-redirect',
                constructor: (0, $bacbdefa17cfec0c$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-popup',
                constructor: (0, $c380876ef7ad99ae$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-article-list-sort',
                constructor: (0, $d587f703cacf0ca0$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-article-list-layout-switch',
                constructor: (0, $aae44772e434b2fe$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-breadcrumb',
                constructor: (0, $4c4645f38df6caf9$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-compare-button',
                constructor: (0, $cc14b9b65c9c652e$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-compare-info',
                constructor: (0, $7cfc9025399237fb$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-tracking',
                constructor: (0, $0efda1b115753384$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-basket-button',
                constructor: (0, $676bf9a0b3e6a9fd$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-price',
                constructor: (0, $7cf802f14f3a63bb$export$2e2bcd8739ae039)
            },
            {
                name: 'tk-table',
                constructor: (0, $2595e2ca594d6789$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-minibasket',
                constructor: (0, $ba0287e7c80bda20$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-radio',
                constructor: (0, $853de7f3d0ffebbd$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-select-redirect',
                constructor: (0, $e7cb1307fe869e14$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-stock',
                constructor: (0, $c7b0de4494db348b$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-giftcard',
                constructor: (0, $0f7748d6531267ea$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-price-control',
                constructor: (0, $1de4bc533e624441$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-links',
                constructor: (0, $6d1c1bebccef2c7f$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-personalise',
                constructor: (0, $b30bafcd895311f5$export$2e2bcd8739ae039)
            },
            {
                name: 'diw-personalise-container',
                constructor: (0, $01fe9ec417721a32$export$2e2bcd8739ae039)
            }
        ]);
    }
}
new $a19bf1b077ec319c$export$2e2bcd8739ae039();

})();
//# sourceMappingURL=article.js.map
